import {
    Column,
    ComboColumnLine,
    EventRatesData,
    ProportionsOTData,
    RadialChartData,
    SankeyChartData,
    SeriesDataHeatMap,
    StackedChartData,
    TRIOpDateData,
} from '@interfaces-clean/panels.interface';
import { components } from 'types/rest-schema';

const stackedChartExampleCountryData = {
    series: [
        {
            name: 'Answered',
            values: [10, 11, 8, 7, 5, 1],
        },
        {
            name: 'Closed',
            values: [45, 46, 44, 43, 15, 10],
        },
        {
            name: 'Open',
            values: [25, 23, 21, 17, 7, 5],
        },
    ],
    xCategories: ['France', 'Germany', 'England', 'Austria', 'Sweden', 'Denmark'],
};

export const stackedBarChartExampleCountryData: StackedChartData = {
    plotTitle: 'Stacked Bar By Country',
    ...stackedChartExampleCountryData,
};

export const stackedColumnChartExampleCountryData: StackedChartData = {
    plotTitle: 'Stacked Column By Country',
    ...stackedChartExampleCountryData,
};

const stackedChartExampleBellCurveData = {
    series: [
        {
            name: 'Major',
            values: [2, 0, 3, 1, 2, 7, 1, 0, 8, 7, 3],
        },
        {
            name: 'Minor',
            values: [0, 7, 6, 14, 68, 352, 112, 44, 3, 0, 0],
        },
    ],
    xCategories: [
        'Blinding Issues',
        'Inadequate Source',
        'ICF/Documentation',
        'Other',
        'Lab Issues',
        'IP Dispensing/Dosing',
        'Procedures/Exams',
        'Out of Visit Window',
        'Inclusion/Exclusion',
        'Unreported SAE',
        'ConMeds',
    ],
};

export const stackedBarChartExampleBellCurveData: StackedChartData = {
    plotTitle: 'Stacked Bar By Event Bell Curve',
    ...stackedChartExampleBellCurveData,
};

export const stackedColumnChartExampleBellCurveData: StackedChartData = {
    plotTitle: 'Stacked Column By Event Bell Curve',
    ...stackedChartExampleBellCurveData,
};

const stackedChartExampleSiteData = {
    series: [
        {
            name: 'Completed',
            values: [
                97, 113, 25, 246, 178, 79, 92, 287, 256, 138, 179, 122, 95, 49, 56, 46, 38, 272, 47, 106, 96, 63, 21,
                38, 144, 12, 80, 16, 21, 11, 11, 11, 22, 11, 3,
            ],
        },
        {
            name: 'Missing',
            values: [
                15, 3, 0, 59, 118, 39, 24, 27, 16, 0, 95, 24, 9, 21, 0, 0, 20, 35, 3, 20, 25, 3, 0, 0, 2, 0, 2, 0, 1, 0,
                0, 0, 24, 0, 8,
            ],
        },
        {
            name: 'None',
            values: [
                0, 0, 0, 0, 0, 0, 0, 0, 6, 0, 7, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            ],
        },
    ],
    xCategories: [
        '15456',
        '15484',
        '15512',
        '15540',
        '15596',
        '15624',
        '15680',
        '15710',
        '15740',
        '15770',
        '15800',
        '15830',
        '15860',
        '15890',
        '15920',
        '15950',
        '15980',
        '16010',
        '16070',
        '16100',
        '104811',
        '105208',
        '124846',
        '132143',
        '255892',
        '256293',
        '295767',
        '318388',
        '318415',
        '346951',
        '584009',
        '585289',
        '586198',
        '763847',
        '764334',
    ],
};

export const stackedBarChartExampleSiteData: StackedChartData = {
    plotTitle: 'Stacked Bar By Site',
    ...stackedChartExampleSiteData,
};

export const stackedColumnChartExampleSiteData: StackedChartData = {
    plotTitle: 'Stacked Column By Site',
    ...stackedChartExampleSiteData,
};

const stackedChartExampleSubjectData = {
    series: [
        {
            name: 'Abdominal and gastrointestinal infections',
            values: [
                0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 1,
                0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            ],
        },
        {
            name: 'Anaemias NEC',
            values: [
                0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            ],
        },
        {
            name: 'Bacterial infections NEC',
            values: [
                0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 1, 0, 0, 0, 0, 0, 0,
                0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            ],
        },
        {
            name: 'Bladder infections and inflammations',
            values: [
                0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            ],
        },
        {
            name: 'Capnocytophaga infections',
            values: [
                0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            ],
        },
        {
            name: 'Central nervous system haemorrhages and cerebrovascular accidents',
            values: [
                1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            ],
        },
        {
            name: 'Clostridia infections',
            values: [
                0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0,
            ],
        },
        {
            name: 'Colitis (excl infective)',
            values: [
                0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 1,
            ],
        },
        {
            name: 'Cytomegaloviral infections',
            values: [
                0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0,
            ],
        },
        {
            name: 'Dental and oral soft tissue infections',
            values: [
                0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            ],
        },
        {
            name: 'Disturbances in consciousness NEC',
            values: [
                0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            ],
        },
        {
            name: 'Enterobacter infections',
            values: [
                0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            ],
        },
        {
            name: 'Enterococcal infections',
            values: [
                0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            ],
        },
        {
            name: 'Febrile disorders',
            values: [
                0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            ],
        },
        {
            name: 'Fungal infections NEC',
            values: [
                0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                0, 0, 1, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0,
            ],
        },
        {
            name: 'Infections NEC',
            values: [
                0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0,
            ],
        },
        {
            name: 'Intestinal haemorrhages',
            values: [
                0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            ],
        },
        {
            name: 'Lower respiratory tract and lung infections',
            values: [
                0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0,
            ],
        },
        {
            name: 'Lower respiratory tract inflammatory and immunologic conditions',
            values: [
                0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0,
            ],
        },
        {
            name: 'Marrow depression and hypoplastic anaemias',
            values: [
                0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0,
            ],
        },
        {
            name: 'Neutropenias',
            values: [
                0, 0, 0, 0, 0, 2, 0, 1, 0, 1, 0, 3, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0,
                0, 0, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0,
            ],
        },
        {
            name: 'Non-site specific gastrointestinal haemorrhages',
            values: [
                0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0,
                0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            ],
        },
        {
            name: 'Noninfectious myocarditis',
            values: [
                0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            ],
        },
        {
            name: 'Pneumocystis infections',
            values: [
                0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            ],
        },
        {
            name: 'Pseudomonal infections',
            values: [
                0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            ],
        },
        {
            name: 'Pulmonary oedemas',
            values: [
                0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0,
                0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            ],
        },
        {
            name: 'Renal failure and impairment',
            values: [
                0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            ],
        },
        {
            name: 'Respiratory failures (excl neonatal)',
            values: [
                0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            ],
        },
        {
            name: 'Seizures and seizure disorders NEC',
            values: [
                0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0,
                0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            ],
        },
        {
            name: 'Sepsis bacteraemia viraemia and fungaemia NEC',
            values: [
                0, 0, 0, 1, 1, 0, 0, 0, 1, 0, 1, 0, 0, 0, 0, 1, 0, 0, 1, 0, 1, 0, 0, 1, 1, 0, 0, 0, 0, 1, 0, 1, 0, 0, 0,
                1, 2, 0, 0, 0, 0, 1, 0, 1, 0, 0, 0, 0, 1, 1, 1, 0, 0,
            ],
        },
        {
            name: 'Thrombocytopenias',
            values: [
                0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            ],
        },
        {
            name: 'Total fluid volume increased',
            values: [
                0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0,
            ],
        },
    ],
    xCategories: [
        '21076',
        '30815',
        '35054',
        '36438',
        '38602',
        '43095',
        '53609',
        '68204',
        '97214',
        '113845',
        '117592',
        '129746',
        '131601',
        '143650',
        '150378',
        '151788',
        '152739',
        '158803',
        '171902',
        '198073',
        '236869',
        '254907',
        '303778',
        '343201',
        '343677',
        '360573',
        '360649',
        '373283',
        '380395',
        '405607',
        '443598',
        '446341',
        '467115',
        '471272',
        '474152',
        '477972',
        '481920',
        '503192',
        '517139',
        '647383',
        '654899',
        '654980',
        '655344',
        '656063',
        '657297',
        '663720',
        '672432',
        '690441',
        '702332',
        '704084',
        '711642',
        '718825',
        '833021',
    ],
};

export const stackedBarChartExampleSubjectData: StackedChartData = {
    plotTitle: 'Scrollable Stacked Bar By Subject',
    hasScrollablePlotArea: true,
    ...stackedChartExampleSubjectData,
};

export const stackedColumnChartExampleSubjectData: StackedChartData = {
    plotTitle: 'Stacked Column By Subject',
    ...stackedChartExampleSubjectData,
};

export const radialChartExample1Data: RadialChartData = {
    plotTitle: 'Radial graph',
    series: [
        {
            name: 'Open',
            type: 'column',
            data: [90, 0, 0, 0, 29, 0, 0],
        },
        {
            name: 'Close',
            type: 'column',
            data: [30, 0, 0, 0, 3, 0, 0],
        },
        {
            name: 'Reviewed',
            type: 'column',
            data: [0, 0, 0, 70, 0, 0, 0],
        },
        {
            name: 'Unreviewed',
            type: 'column',
            data: [0, 0, 0, 100, 0, 0, 0],
        },
        {
            name: 'Decision 1',
            type: 'column',
            data: [0, 30, 0, 0, 0, 45, 0],
        },
        {
            name: 'Decision 2',
            type: 'column',
            data: [0, 10, 0, 0, 0, 15, 0],
        },
        {
            name: 'Decision 3',
            type: 'column',
            data: [0, 70, 0, 0, 0, 21, 0],
        },
        {
            name: 'Decision 4',
            type: 'column',
            data: [0, 14, 0, 0, 0, 63, 0],
        },
        {
            name: 'Decision 5',
            type: 'column',
            data: [0, 54, 0, 0, 0, 12, 0],
        },
        {
            name: 'Actions',
            type: 'column',
            data: [0, 0, 41, 0, 0, 0, 76],
        },
    ],
    xCategories: [
        'Study Observation',
        'Study Review Logs',
        'Study Actions',
        'KRI Status',
        'Site Observation',
        'Site Review Logs',
        'Site Actions',
    ],
};
export const radialChartExample2Data: RadialChartData = {
    plotTitle: 'Radial graph',
    series: [
        {
            name: 'Open',
            type: 'column',
            data: [90, 0, 0, 29, 0, 0],
        },
        {
            name: 'Close',
            type: 'column',
            data: [30, 0, 0, 3, 0, 0],
        },
        {
            name: 'Decision 1',
            type: 'column',
            data: [0, 30, 0, 0, 45, 0],
        },
        {
            name: 'Decision 2',
            type: 'column',
            data: [0, 10, 0, 0, 15, 0],
        },
        {
            name: 'Decision 3',
            type: 'column',
            data: [0, 70, 0, 0, 21, 0],
        },
        {
            name: 'Decision 4',
            type: 'column',
            data: [0, 14, 0, 0, 63, 0],
        },
        {
            name: 'Decision 5',
            type: 'column',
            data: [0, 54, 0, 0, 12, 0],
        },
        {
            name: 'Actions',
            type: 'column',
            data: [0, 0, 41, 0, 0, 76],
        },
    ],
    xCategories: [
        'Study Observation',
        'Study Review Logs',
        'Study Actions',
        'Site Observation',
        'Site Review Logs',
        'Site Actions',
    ],
};
export const radialChartExample3Data: RadialChartData = {
    plotTitle: 'Radial graph',
    series: [
        {
            name: 'Open',
            type: 'column',
            data: [29, 0, 0],
        },
        {
            name: 'Close',
            type: 'column',
            data: [3, 0, 0],
        },
        {
            name: 'Decision 1',
            type: 'column',
            data: [0, 45, 0],
        },
        {
            name: 'Decision 2',
            type: 'column',
            data: [0, 15, 0],
        },
        {
            name: 'Decision 3',
            type: 'column',
            data: [0, 21, 0],
        },
        {
            name: 'Decision 4',
            type: 'column',
            data: [0, 63, 0],
        },
        {
            name: 'Decision 5',
            type: 'column',
            data: [0, 12, 0],
        },
        {
            name: 'Actions',
            type: 'column',
            data: [0, 0, 76],
        },
    ],
    xCategories: ['Site Observation', 'Site Review Logs', 'Site Actions'],
};
export const sankeyChartExample1Data: SankeyChartData = {
    title: 'Sankey Chart Example',
    data: {
        green: {
            toGreen: 10,
            toAmber: 5,
            toRed: 2,
            toGray: 0,
        },
        amber: {
            toGreen: 10,
            toAmber: 5,
            toRed: 5,
            toGray: 0,
        },
        red: {
            toGreen: 2,
            toAmber: 10,
            toRed: 13,
            toGray: 5,
        },
        gray: {
            toGreen: 0,
            toAmber: 0,
            toRed: 5,
            toGray: 0,
        },
    },
};
export const sankeyChartExample2Data: SankeyChartData = {
    title: 'Sankey Chart Example',
    data: {
        green: {
            toGreen: 1,
            toAmber: 1,
            toRed: 1,
            toGray: 1,
            toPurple: 1,
        },
        amber: {
            toGreen: 1,
            toAmber: 1,
            toRed: 1,
            toGray: 1,
            toPurple: 1,
        },
        red: {
            toGreen: 1,
            toAmber: 1,
            toRed: 1,
            toGray: 1,
            toPurple: 1,
        },
        gray: {
            toGreen: 1,
            toAmber: 1,
            toRed: 1,
            toGray: 1,
            toPurple: 1,
        },
        purple: {
            toGreen: 1,
            toAmber: 1,
            toRed: 1,
            toGray: 1,
            toPurple: 1,
        },
    },
};
export const comboColumnLineData: ComboColumnLine = {
    plotTitle: 'Combo stacked column/line graph',
    series: [
        {
            name: 'Red',
            type: 'column',
            data: [90, 28.8, 21.7, 34.1, 29.0, 28.4, 45.6, 51.7],
        },
        {
            name: 'Amber',
            type: 'column',
            data: [30, 54.9, 24.8, 20, 3.1, 13.0, 14.5, 10.8],
        },
        {
            name: 'Green',
            type: 'column',
            data: [56, 45, 23, 70, 12, 42, 54, 84],
        },
        {
            name: 'Study Mean',
            type: 'line',
            data: [98, 50, 40, 90, 40, 46, 78, 20],
        },
    ],
    xCategories: [
        '20-Jan-2024',
        '01-Feb-2024',
        '02-Mar-2024',
        '03-Apr-2024',
        '04-May-2024',
        '05-Jun-2024',
        '06-Jul-2024',
        '07-Aug-2024',
    ],
    yTitle: 'Study Rate',
    yTitleSecondary: 'Study Mean',
};
export const heatMapData: SeriesDataHeatMap = {
    plotTitle: 'Heatmap graph',
    maxValue: 20,
    order: [
        '104811',
        '105208',
        '124846',
        '132143',
        '15456',
        '15484',
        '15512',
        '15540',
        '15596',
        '15624',
        '15680',
        '15710',
        '15740',
        '15770',
        '15800',
        '15830',
        '15860',
        '15890',
        '15920',
        '15950',
        '15980',
        '16010',
        '16070',
        '16100',
        '255892',
        '256293',
        '295767',
        '318388',
        '318415',
        '346951',
        '584009',
        '585289',
        '586198',
        '763847',
        '764334',
    ],
    heatmapForIds: {
        '-2034321436': [
            {
                x: 'CA/EC/IRB',
                y: -2034321436,
                yName: '15740',
                value: 0.0,
            },
            {
                x: 'Central/Local Lab',
                y: -2034321436,
                yName: '15740',
                value: 4.0,
            },
            {
                x: 'COVID-19',
                y: -2034321436,
                yName: '15740',
                value: 1.0,
            },
            {
                x: 'Data Entry/Query Resolution',
                y: -2034321436,
                yName: '15740',
                value: 2.0,
            },
            {
                x: 'Event Reporting/Safety',
                y: -2034321436,
                yName: '15740',
                value: 2.0,
            },
            {
                x: 'Facilities & Equipment',
                y: -2034321436,
                yName: '15740',
                value: 0.0,
            },
            {
                x: 'Investigator Oversight',
                y: -2034321436,
                yName: '15740',
                value: 0.0,
            },
            {
                x: 'Investigator Site Binder',
                y: -2034321436,
                yName: '15740',
                value: 1.0,
            },
            {
                x: 'ISSC MV Doc Issue',
                y: -2034321436,
                yName: '15740',
                value: 0.0,
            },
            {
                x: 'ISSC Site File Issue',
                y: -2034321436,
                yName: '15740',
                value: 20.0,
            },
            {
                x: 'Other',
                y: -2034321436,
                yName: '15740',
                value: 6.0,
            },
            {
                x: 'Recruitment & Enrollment',
                y: -2034321436,
                yName: '15740',
                value: 0.0,
            },
            {
                x: 'Site Staff Training',
                y: -2034321436,
                yName: '15740',
                value: 0.0,
            },
            {
                x: 'Source Documentation',
                y: -2034321436,
                yName: '15740',
                value: 0.0,
            },
            {
                x: 'Study Product',
                y: -2034321436,
                yName: '15740',
                value: 0.0,
            },
            {
                x: 'Study Supplies',
                y: -2034321436,
                yName: '15740',
                value: 0.0,
            },
            {
                x: 'Systems',
                y: -2034321436,
                yName: '15740',
                value: 0.0,
            },
        ],
        '787450616': [
            {
                x: 'CA/EC/IRB',
                y: 787450616,
                yName: '15710',
                value: 0.0,
            },
            {
                x: 'Central/Local Lab',
                y: 787450616,
                yName: '15710',
                value: 0.0,
            },
            {
                x: 'COVID-19',
                y: 787450616,
                yName: '15710',
                value: 1.0,
            },
            {
                x: 'Data Entry/Query Resolution',
                y: 787450616,
                yName: '15710',
                value: 0.0,
            },
            {
                x: 'Event Reporting/Safety',
                y: 787450616,
                yName: '15710',
                value: 0.0,
            },
            {
                x: 'Facilities & Equipment',
                y: 787450616,
                yName: '15710',
                value: 0.0,
            },
            {
                x: 'Investigator Oversight',
                y: 787450616,
                yName: '15710',
                value: 1.0,
            },
            {
                x: 'Investigator Site Binder',
                y: 787450616,
                yName: '15710',
                value: 7.0,
            },
            {
                x: 'ISSC MV Doc Issue',
                y: 787450616,
                yName: '15710',
                value: 0.0,
            },
            {
                x: 'ISSC Site File Issue',
                y: 787450616,
                yName: '15710',
                value: 11.0,
            },
            {
                x: 'Other',
                y: 787450616,
                yName: '15710',
                value: 4.0,
            },
            {
                x: 'Recruitment & Enrollment',
                y: 787450616,
                yName: '15710',
                value: 1.0,
            },
            {
                x: 'Site Staff Training',
                y: 787450616,
                yName: '15710',
                value: 3.0,
            },
            {
                x: 'Source Documentation',
                y: 787450616,
                yName: '15710',
                value: 2.0,
            },
            {
                x: 'Study Product',
                y: 787450616,
                yName: '15710',
                value: 0.0,
            },
            {
                x: 'Study Supplies',
                y: 787450616,
                yName: '15710',
                value: 0.0,
            },
            {
                x: 'Systems',
                y: 787450616,
                yName: '15710',
                value: 1.0,
            },
        ],
        '43062757': [
            {
                x: 'CA/EC/IRB',
                y: 43062757,
                yName: '15540',
                value: 1.0,
            },
            {
                x: 'Central/Local Lab',
                y: 43062757,
                yName: '15540',
                value: 1.0,
            },
            {
                x: 'COVID-19',
                y: 43062757,
                yName: '15540',
                value: 1.0,
            },
            {
                x: 'Data Entry/Query Resolution',
                y: 43062757,
                yName: '15540',
                value: 3.0,
            },
            {
                x: 'Event Reporting/Safety',
                y: 43062757,
                yName: '15540',
                value: 0.0,
            },
            {
                x: 'Facilities & Equipment',
                y: 43062757,
                yName: '15540',
                value: 0.0,
            },
            {
                x: 'Investigator Oversight',
                y: 43062757,
                yName: '15540',
                value: 1.0,
            },
            {
                x: 'Investigator Site Binder',
                y: 43062757,
                yName: '15540',
                value: 6.0,
            },
            {
                x: 'ISSC MV Doc Issue',
                y: 43062757,
                yName: '15540',
                value: 1.0,
            },
            {
                x: 'ISSC Site File Issue',
                y: 43062757,
                yName: '15540',
                value: 12.0,
            },
            {
                x: 'Other',
                y: 43062757,
                yName: '15540',
                value: 2.0,
            },
            {
                x: 'Recruitment & Enrollment',
                y: 43062757,
                yName: '15540',
                value: 0.0,
            },
            {
                x: 'Site Staff Training',
                y: 43062757,
                yName: '15540',
                value: 1.0,
            },
            {
                x: 'Source Documentation',
                y: 43062757,
                yName: '15540',
                value: 4.0,
            },
            {
                x: 'Study Product',
                y: 43062757,
                yName: '15540',
                value: 1.0,
            },
            {
                x: 'Study Supplies',
                y: 43062757,
                yName: '15540',
                value: 0.0,
            },
            {
                x: 'Systems',
                y: 43062757,
                yName: '15540',
                value: 0.0,
            },
        ],
        '-1051971063': [
            {
                x: 'CA/EC/IRB',
                y: -1051971063,
                yName: '16010',
                value: 1.0,
            },
            {
                x: 'Central/Local Lab',
                y: -1051971063,
                yName: '16010',
                value: 1.0,
            },
            {
                x: 'COVID-19',
                y: -1051971063,
                yName: '16010',
                value: 1.0,
            },
            {
                x: 'Data Entry/Query Resolution',
                y: -1051971063,
                yName: '16010',
                value: 1.0,
            },
            {
                x: 'Event Reporting/Safety',
                y: -1051971063,
                yName: '16010',
                value: 0.0,
            },
            {
                x: 'Facilities & Equipment',
                y: -1051971063,
                yName: '16010',
                value: 1.0,
            },
            {
                x: 'Investigator Oversight',
                y: -1051971063,
                yName: '16010',
                value: 2.0,
            },
            {
                x: 'Investigator Site Binder',
                y: -1051971063,
                yName: '16010',
                value: 2.0,
            },
            {
                x: 'ISSC MV Doc Issue',
                y: -1051971063,
                yName: '16010',
                value: 0.0,
            },
            {
                x: 'ISSC Site File Issue',
                y: -1051971063,
                yName: '16010',
                value: 13.0,
            },
            {
                x: 'Other',
                y: -1051971063,
                yName: '16010',
                value: 7.0,
            },
            {
                x: 'Recruitment & Enrollment',
                y: -1051971063,
                yName: '16010',
                value: 0.0,
            },
            {
                x: 'Site Staff Training',
                y: -1051971063,
                yName: '16010',
                value: 5.0,
            },
            {
                x: 'Source Documentation',
                y: -1051971063,
                yName: '16010',
                value: 2.0,
            },
            {
                x: 'Study Product',
                y: -1051971063,
                yName: '16010',
                value: 0.0,
            },
            {
                x: 'Study Supplies',
                y: -1051971063,
                yName: '16010',
                value: 0.0,
            },
            {
                x: 'Systems',
                y: -1051971063,
                yName: '16010',
                value: 4.0,
            },
        ],
        '-79641240': [
            {
                x: 'CA/EC/IRB',
                y: -79641240,
                yName: '255892',
                value: 0.0,
            },
            {
                x: 'Central/Local Lab',
                y: -79641240,
                yName: '255892',
                value: 0.0,
            },
            {
                x: 'COVID-19',
                y: -79641240,
                yName: '255892',
                value: 2.0,
            },
            {
                x: 'Data Entry/Query Resolution',
                y: -79641240,
                yName: '255892',
                value: 2.0,
            },
            {
                x: 'Event Reporting/Safety',
                y: -79641240,
                yName: '255892',
                value: 1.0,
            },
            {
                x: 'Facilities & Equipment',
                y: -79641240,
                yName: '255892',
                value: 0.0,
            },
            {
                x: 'Investigator Oversight',
                y: -79641240,
                yName: '255892',
                value: 0.0,
            },
            {
                x: 'Investigator Site Binder',
                y: -79641240,
                yName: '255892',
                value: 3.0,
            },
            {
                x: 'ISSC MV Doc Issue',
                y: -79641240,
                yName: '255892',
                value: 0.0,
            },
            {
                x: 'ISSC Site File Issue',
                y: -79641240,
                yName: '255892',
                value: 5.0,
            },
            {
                x: 'Other',
                y: -79641240,
                yName: '255892',
                value: 3.0,
            },
            {
                x: 'Recruitment & Enrollment',
                y: -79641240,
                yName: '255892',
                value: 1.0,
            },
            {
                x: 'Site Staff Training',
                y: -79641240,
                yName: '255892',
                value: 2.0,
            },
            {
                x: 'Source Documentation',
                y: -79641240,
                yName: '255892',
                value: 1.0,
            },
            {
                x: 'Study Product',
                y: -79641240,
                yName: '255892',
                value: 0.0,
            },
            {
                x: 'Study Supplies',
                y: -79641240,
                yName: '255892',
                value: 0.0,
            },
            {
                x: 'Systems',
                y: -79641240,
                yName: '255892',
                value: 0.0,
            },
        ],
        '-836801192': [
            {
                x: 'CA/EC/IRB',
                y: -836801192,
                yName: '15770',
                value: 0.0,
            },
            {
                x: 'Central/Local Lab',
                y: -836801192,
                yName: '15770',
                value: 0.0,
            },
            {
                x: 'COVID-19',
                y: -836801192,
                yName: '15770',
                value: 0.0,
            },
            {
                x: 'Data Entry/Query Resolution',
                y: -836801192,
                yName: '15770',
                value: 2.0,
            },
            {
                x: 'Event Reporting/Safety',
                y: -836801192,
                yName: '15770',
                value: 0.0,
            },
            {
                x: 'Facilities & Equipment',
                y: -836801192,
                yName: '15770',
                value: 0.0,
            },
            {
                x: 'Investigator Oversight',
                y: -836801192,
                yName: '15770',
                value: 2.0,
            },
            {
                x: 'Investigator Site Binder',
                y: -836801192,
                yName: '15770',
                value: 6.0,
            },
            {
                x: 'ISSC MV Doc Issue',
                y: -836801192,
                yName: '15770',
                value: 2.0,
            },
            {
                x: 'ISSC Site File Issue',
                y: -836801192,
                yName: '15770',
                value: 14.0,
            },
            {
                x: 'Other',
                y: -836801192,
                yName: '15770',
                value: 1.0,
            },
            {
                x: 'Recruitment & Enrollment',
                y: -836801192,
                yName: '15770',
                value: 0.0,
            },
            {
                x: 'Site Staff Training',
                y: -836801192,
                yName: '15770',
                value: 0.0,
            },
            {
                x: 'Source Documentation',
                y: -836801192,
                yName: '15770',
                value: 2.0,
            },
            {
                x: 'Study Product',
                y: -836801192,
                yName: '15770',
                value: 0.0,
            },
            {
                x: 'Study Supplies',
                y: -836801192,
                yName: '15770',
                value: 0.0,
            },
            {
                x: 'Systems',
                y: -836801192,
                yName: '15770',
                value: 1.0,
            },
        ],
        '-422104744': [
            {
                x: 'CA/EC/IRB',
                y: -422104744,
                yName: '15800',
                value: 0.0,
            },
            {
                x: 'Central/Local Lab',
                y: -422104744,
                yName: '15800',
                value: 1.0,
            },
            {
                x: 'COVID-19',
                y: -422104744,
                yName: '15800',
                value: 1.0,
            },
            {
                x: 'Data Entry/Query Resolution',
                y: -422104744,
                yName: '15800',
                value: 3.0,
            },
            {
                x: 'Event Reporting/Safety',
                y: -422104744,
                yName: '15800',
                value: 0.0,
            },
            {
                x: 'Facilities & Equipment',
                y: -422104744,
                yName: '15800',
                value: 0.0,
            },
            {
                x: 'Investigator Oversight',
                y: -422104744,
                yName: '15800',
                value: 0.0,
            },
            {
                x: 'Investigator Site Binder',
                y: -422104744,
                yName: '15800',
                value: 1.0,
            },
            {
                x: 'ISSC MV Doc Issue',
                y: -422104744,
                yName: '15800',
                value: 0.0,
            },
            {
                x: 'ISSC Site File Issue',
                y: -422104744,
                yName: '15800',
                value: 11.0,
            },
            {
                x: 'Other',
                y: -422104744,
                yName: '15800',
                value: 3.0,
            },
            {
                x: 'Recruitment & Enrollment',
                y: -422104744,
                yName: '15800',
                value: 0.0,
            },
            {
                x: 'Site Staff Training',
                y: -422104744,
                yName: '15800',
                value: 1.0,
            },
            {
                x: 'Source Documentation',
                y: -422104744,
                yName: '15800',
                value: 2.0,
            },
            {
                x: 'Study Product',
                y: -422104744,
                yName: '15800',
                value: 1.0,
            },
            {
                x: 'Study Supplies',
                y: -422104744,
                yName: '15800',
                value: 0.0,
            },
            {
                x: 'Systems',
                y: -422104744,
                yName: '15800',
                value: 0.0,
            },
        ],
        '-1373001787': [
            {
                x: 'CA/EC/IRB',
                y: -1373001787,
                yName: '15596',
                value: 0.0,
            },
            {
                x: 'Central/Local Lab',
                y: -1373001787,
                yName: '15596',
                value: 0.0,
            },
            {
                x: 'COVID-19',
                y: -1373001787,
                yName: '15596',
                value: 3.0,
            },
            {
                x: 'Data Entry/Query Resolution',
                y: -1373001787,
                yName: '15596',
                value: 1.0,
            },
            {
                x: 'Event Reporting/Safety',
                y: -1373001787,
                yName: '15596',
                value: 0.0,
            },
            {
                x: 'Facilities & Equipment',
                y: -1373001787,
                yName: '15596',
                value: 0.0,
            },
            {
                x: 'Investigator Oversight',
                y: -1373001787,
                yName: '15596',
                value: 1.0,
            },
            {
                x: 'Investigator Site Binder',
                y: -1373001787,
                yName: '15596',
                value: 0.0,
            },
            {
                x: 'ISSC MV Doc Issue',
                y: -1373001787,
                yName: '15596',
                value: 0.0,
            },
            {
                x: 'ISSC Site File Issue',
                y: -1373001787,
                yName: '15596',
                value: 13.0,
            },
            {
                x: 'Other',
                y: -1373001787,
                yName: '15596',
                value: 5.0,
            },
            {
                x: 'Recruitment & Enrollment',
                y: -1373001787,
                yName: '15596',
                value: 0.0,
            },
            {
                x: 'Site Staff Training',
                y: -1373001787,
                yName: '15596',
                value: 0.0,
            },
            {
                x: 'Source Documentation',
                y: -1373001787,
                yName: '15596',
                value: 1.0,
            },
            {
                x: 'Study Product',
                y: -1373001787,
                yName: '15596',
                value: 0.0,
            },
            {
                x: 'Study Supplies',
                y: -1373001787,
                yName: '15596',
                value: 0.0,
            },
            {
                x: 'Systems',
                y: -1373001787,
                yName: '15596',
                value: 0.0,
            },
        ],
        '-1382713679': [
            {
                x: 'CA/EC/IRB',
                y: -1382713679,
                yName: '104811',
                value: 0.0,
            },
            {
                x: 'Central/Local Lab',
                y: -1382713679,
                yName: '104811',
                value: 1.0,
            },
            {
                x: 'COVID-19',
                y: -1382713679,
                yName: '104811',
                value: 1.0,
            },
            {
                x: 'Data Entry/Query Resolution',
                y: -1382713679,
                yName: '104811',
                value: 0.0,
            },
            {
                x: 'Event Reporting/Safety',
                y: -1382713679,
                yName: '104811',
                value: 0.0,
            },
            {
                x: 'Facilities & Equipment',
                y: -1382713679,
                yName: '104811',
                value: 0.0,
            },
            {
                x: 'Investigator Oversight',
                y: -1382713679,
                yName: '104811',
                value: 0.0,
            },
            {
                x: 'Investigator Site Binder',
                y: -1382713679,
                yName: '104811',
                value: 1.0,
            },
            {
                x: 'ISSC MV Doc Issue',
                y: -1382713679,
                yName: '104811',
                value: 0.0,
            },
            {
                x: 'ISSC Site File Issue',
                y: -1382713679,
                yName: '104811',
                value: 6.0,
            },
            {
                x: 'Other',
                y: -1382713679,
                yName: '104811',
                value: 3.0,
            },
            {
                x: 'Recruitment & Enrollment',
                y: -1382713679,
                yName: '104811',
                value: 0.0,
            },
            {
                x: 'Site Staff Training',
                y: -1382713679,
                yName: '104811',
                value: 0.0,
            },
            {
                x: 'Source Documentation',
                y: -1382713679,
                yName: '104811',
                value: 0.0,
            },
            {
                x: 'Study Product',
                y: -1382713679,
                yName: '104811',
                value: 1.0,
            },
            {
                x: 'Study Supplies',
                y: -1382713679,
                yName: '104811',
                value: 0.0,
            },
            {
                x: 'Systems',
                y: -1382713679,
                yName: '104811',
                value: 0.0,
            },
        ],
        '540880179': [
            {
                x: 'CA/EC/IRB',
                y: 540880179,
                yName: '16100',
                value: 0.0,
            },
            {
                x: 'Central/Local Lab',
                y: 540880179,
                yName: '16100',
                value: 0.0,
            },
            {
                x: 'COVID-19',
                y: 540880179,
                yName: '16100',
                value: 2.0,
            },
            {
                x: 'Data Entry/Query Resolution',
                y: 540880179,
                yName: '16100',
                value: 3.0,
            },
            {
                x: 'Event Reporting/Safety',
                y: 540880179,
                yName: '16100',
                value: 2.0,
            },
            {
                x: 'Facilities & Equipment',
                y: 540880179,
                yName: '16100',
                value: 0.0,
            },
            {
                x: 'Investigator Oversight',
                y: 540880179,
                yName: '16100',
                value: 1.0,
            },
            {
                x: 'Investigator Site Binder',
                y: 540880179,
                yName: '16100',
                value: 0.0,
            },
            {
                x: 'ISSC MV Doc Issue',
                y: 540880179,
                yName: '16100',
                value: 0.0,
            },
            {
                x: 'ISSC Site File Issue',
                y: 540880179,
                yName: '16100',
                value: 14.0,
            },
            {
                x: 'Other',
                y: 540880179,
                yName: '16100',
                value: 3.0,
            },
            {
                x: 'Recruitment & Enrollment',
                y: 540880179,
                yName: '16100',
                value: 1.0,
            },
            {
                x: 'Site Staff Training',
                y: 540880179,
                yName: '16100',
                value: 3.0,
            },
            {
                x: 'Source Documentation',
                y: 540880179,
                yName: '16100',
                value: 1.0,
            },
            {
                x: 'Study Product',
                y: 540880179,
                yName: '16100',
                value: 1.0,
            },
            {
                x: 'Study Supplies',
                y: 540880179,
                yName: '16100',
                value: 0.0,
            },
            {
                x: 'Systems',
                y: 540880179,
                yName: '16100',
                value: 0.0,
            },
        ],
        '-1286870229': [
            {
                x: 'CA/EC/IRB',
                y: -1286870229,
                yName: '15484',
                value: 1.0,
            },
            {
                x: 'Central/Local Lab',
                y: -1286870229,
                yName: '15484',
                value: 0.0,
            },
            {
                x: 'COVID-19',
                y: -1286870229,
                yName: '15484',
                value: 1.0,
            },
            {
                x: 'Data Entry/Query Resolution',
                y: -1286870229,
                yName: '15484',
                value: 0.0,
            },
            {
                x: 'Event Reporting/Safety',
                y: -1286870229,
                yName: '15484',
                value: 0.0,
            },
            {
                x: 'Facilities & Equipment',
                y: -1286870229,
                yName: '15484',
                value: 0.0,
            },
            {
                x: 'Investigator Oversight',
                y: -1286870229,
                yName: '15484',
                value: 2.0,
            },
            {
                x: 'Investigator Site Binder',
                y: -1286870229,
                yName: '15484',
                value: 4.0,
            },
            {
                x: 'ISSC MV Doc Issue',
                y: -1286870229,
                yName: '15484',
                value: 1.0,
            },
            {
                x: 'ISSC Site File Issue',
                y: -1286870229,
                yName: '15484',
                value: 8.0,
            },
            {
                x: 'Other',
                y: -1286870229,
                yName: '15484',
                value: 2.0,
            },
            {
                x: 'Recruitment & Enrollment',
                y: -1286870229,
                yName: '15484',
                value: 0.0,
            },
            {
                x: 'Site Staff Training',
                y: -1286870229,
                yName: '15484',
                value: 0.0,
            },
            {
                x: 'Source Documentation',
                y: -1286870229,
                yName: '15484',
                value: 0.0,
            },
            {
                x: 'Study Product',
                y: -1286870229,
                yName: '15484',
                value: 0.0,
            },
            {
                x: 'Study Supplies',
                y: -1286870229,
                yName: '15484',
                value: 0.0,
            },
            {
                x: 'Systems',
                y: -1286870229,
                yName: '15484',
                value: 0.0,
            },
        ],
        '519394498': [
            {
                x: 'CA/EC/IRB',
                y: 519394498,
                yName: '15624',
                value: 1.0,
            },
            {
                x: 'Central/Local Lab',
                y: 519394498,
                yName: '15624',
                value: 0.0,
            },
            {
                x: 'COVID-19',
                y: 519394498,
                yName: '15624',
                value: 3.0,
            },
            {
                x: 'Data Entry/Query Resolution',
                y: 519394498,
                yName: '15624',
                value: 0.0,
            },
            {
                x: 'Event Reporting/Safety',
                y: 519394498,
                yName: '15624',
                value: 0.0,
            },
            {
                x: 'Facilities & Equipment',
                y: 519394498,
                yName: '15624',
                value: 1.0,
            },
            {
                x: 'Investigator Oversight',
                y: 519394498,
                yName: '15624',
                value: 2.0,
            },
            {
                x: 'Investigator Site Binder',
                y: 519394498,
                yName: '15624',
                value: 1.0,
            },
            {
                x: 'ISSC MV Doc Issue',
                y: 519394498,
                yName: '15624',
                value: 0.0,
            },
            {
                x: 'ISSC Site File Issue',
                y: 519394498,
                yName: '15624',
                value: 15.0,
            },
            {
                x: 'Other',
                y: 519394498,
                yName: '15624',
                value: 2.0,
            },
            {
                x: 'Recruitment & Enrollment',
                y: 519394498,
                yName: '15624',
                value: 0.0,
            },
            {
                x: 'Site Staff Training',
                y: 519394498,
                yName: '15624',
                value: 3.0,
            },
            {
                x: 'Source Documentation',
                y: 519394498,
                yName: '15624',
                value: 1.0,
            },
            {
                x: 'Study Product',
                y: 519394498,
                yName: '15624',
                value: 1.0,
            },
            {
                x: 'Study Supplies',
                y: 519394498,
                yName: '15624',
                value: 0.0,
            },
            {
                x: 'Systems',
                y: 519394498,
                yName: '15624',
                value: 1.0,
            },
        ],
        '936046842': [
            {
                x: 'CA/EC/IRB',
                y: 936046842,
                yName: '15456',
                value: 1.0,
            },
            {
                x: 'Central/Local Lab',
                y: 936046842,
                yName: '15456',
                value: 0.0,
            },
            {
                x: 'COVID-19',
                y: 936046842,
                yName: '15456',
                value: 1.0,
            },
            {
                x: 'Data Entry/Query Resolution',
                y: 936046842,
                yName: '15456',
                value: 0.0,
            },
            {
                x: 'Event Reporting/Safety',
                y: 936046842,
                yName: '15456',
                value: 0.0,
            },
            {
                x: 'Facilities & Equipment',
                y: 936046842,
                yName: '15456',
                value: 0.0,
            },
            {
                x: 'Investigator Oversight',
                y: 936046842,
                yName: '15456',
                value: 0.0,
            },
            {
                x: 'Investigator Site Binder',
                y: 936046842,
                yName: '15456',
                value: 1.0,
            },
            {
                x: 'ISSC MV Doc Issue',
                y: 936046842,
                yName: '15456',
                value: 0.0,
            },
            {
                x: 'ISSC Site File Issue',
                y: 936046842,
                yName: '15456',
                value: 22.0,
            },
            {
                x: 'Other',
                y: 936046842,
                yName: '15456',
                value: 1.0,
            },
            {
                x: 'Recruitment & Enrollment',
                y: 936046842,
                yName: '15456',
                value: 1.0,
            },
            {
                x: 'Site Staff Training',
                y: 936046842,
                yName: '15456',
                value: 1.0,
            },
            {
                x: 'Source Documentation',
                y: 936046842,
                yName: '15456',
                value: 5.0,
            },
            {
                x: 'Study Product',
                y: 936046842,
                yName: '15456',
                value: 0.0,
            },
            {
                x: 'Study Supplies',
                y: 936046842,
                yName: '15456',
                value: 0.0,
            },
            {
                x: 'Systems',
                y: 936046842,
                yName: '15456',
                value: 1.0,
            },
        ],
        '10269152': [
            {
                x: 'CA/EC/IRB',
                y: 10269152,
                yName: '15680',
                value: 0.0,
            },
            {
                x: 'Central/Local Lab',
                y: 10269152,
                yName: '15680',
                value: 2.0,
            },
            {
                x: 'COVID-19',
                y: 10269152,
                yName: '15680',
                value: 1.0,
            },
            {
                x: 'Data Entry/Query Resolution',
                y: 10269152,
                yName: '15680',
                value: 1.0,
            },
            {
                x: 'Event Reporting/Safety',
                y: 10269152,
                yName: '15680',
                value: 2.0,
            },
            {
                x: 'Facilities & Equipment',
                y: 10269152,
                yName: '15680',
                value: 0.0,
            },
            {
                x: 'Investigator Oversight',
                y: 10269152,
                yName: '15680',
                value: 1.0,
            },
            {
                x: 'Investigator Site Binder',
                y: 10269152,
                yName: '15680',
                value: 0.0,
            },
            {
                x: 'ISSC MV Doc Issue',
                y: 10269152,
                yName: '15680',
                value: 1.0,
            },
            {
                x: 'ISSC Site File Issue',
                y: 10269152,
                yName: '15680',
                value: 8.0,
            },
            {
                x: 'Other',
                y: 10269152,
                yName: '15680',
                value: 0.0,
            },
            {
                x: 'Recruitment & Enrollment',
                y: 10269152,
                yName: '15680',
                value: 0.0,
            },
            {
                x: 'Site Staff Training',
                y: 10269152,
                yName: '15680',
                value: 1.0,
            },
            {
                x: 'Source Documentation',
                y: 10269152,
                yName: '15680',
                value: 0.0,
            },
            {
                x: 'Study Product',
                y: 10269152,
                yName: '15680',
                value: 2.0,
            },
            {
                x: 'Study Supplies',
                y: 10269152,
                yName: '15680',
                value: 0.0,
            },
            {
                x: 'Systems',
                y: 10269152,
                yName: '15680',
                value: 0.0,
            },
        ],
        '164482841': [
            {
                x: 'CA/EC/IRB',
                y: 164482841,
                yName: '15860',
                value: 0.0,
            },
            {
                x: 'Central/Local Lab',
                y: 164482841,
                yName: '15860',
                value: 2.0,
            },
            {
                x: 'COVID-19',
                y: 164482841,
                yName: '15860',
                value: 3.0,
            },
            {
                x: 'Data Entry/Query Resolution',
                y: 164482841,
                yName: '15860',
                value: 3.0,
            },
            {
                x: 'Event Reporting/Safety',
                y: 164482841,
                yName: '15860',
                value: 0.0,
            },
            {
                x: 'Facilities & Equipment',
                y: 164482841,
                yName: '15860',
                value: 1.0,
            },
            {
                x: 'Investigator Oversight',
                y: 164482841,
                yName: '15860',
                value: 3.0,
            },
            {
                x: 'Investigator Site Binder',
                y: 164482841,
                yName: '15860',
                value: 1.0,
            },
            {
                x: 'ISSC MV Doc Issue',
                y: 164482841,
                yName: '15860',
                value: 0.0,
            },
            {
                x: 'ISSC Site File Issue',
                y: 164482841,
                yName: '15860',
                value: 16.0,
            },
            {
                x: 'Other',
                y: 164482841,
                yName: '15860',
                value: 7.0,
            },
            {
                x: 'Recruitment & Enrollment',
                y: 164482841,
                yName: '15860',
                value: 1.0,
            },
            {
                x: 'Site Staff Training',
                y: 164482841,
                yName: '15860',
                value: 6.0,
            },
            {
                x: 'Source Documentation',
                y: 164482841,
                yName: '15860',
                value: 2.0,
            },
            {
                x: 'Study Product',
                y: 164482841,
                yName: '15860',
                value: 0.0,
            },
            {
                x: 'Study Supplies',
                y: 164482841,
                yName: '15860',
                value: 0.0,
            },
            {
                x: 'Systems',
                y: 164482841,
                yName: '15860',
                value: 2.0,
            },
        ],
        '367232014': [
            {
                x: 'CA/EC/IRB',
                y: 367232014,
                yName: '15950',
                value: 0.0,
            },
            {
                x: 'Central/Local Lab',
                y: 367232014,
                yName: '15950',
                value: 1.0,
            },
            {
                x: 'COVID-19',
                y: 367232014,
                yName: '15950',
                value: 3.0,
            },
            {
                x: 'Data Entry/Query Resolution',
                y: 367232014,
                yName: '15950',
                value: 0.0,
            },
            {
                x: 'Event Reporting/Safety',
                y: 367232014,
                yName: '15950',
                value: 0.0,
            },
            {
                x: 'Facilities & Equipment',
                y: 367232014,
                yName: '15950',
                value: 0.0,
            },
            {
                x: 'Investigator Oversight',
                y: 367232014,
                yName: '15950',
                value: 1.0,
            },
            {
                x: 'Investigator Site Binder',
                y: 367232014,
                yName: '15950',
                value: 1.0,
            },
            {
                x: 'ISSC MV Doc Issue',
                y: 367232014,
                yName: '15950',
                value: 0.0,
            },
            {
                x: 'ISSC Site File Issue',
                y: 367232014,
                yName: '15950',
                value: 13.0,
            },
            {
                x: 'Other',
                y: 367232014,
                yName: '15950',
                value: 0.0,
            },
            {
                x: 'Recruitment & Enrollment',
                y: 367232014,
                yName: '15950',
                value: 1.0,
            },
            {
                x: 'Site Staff Training',
                y: 367232014,
                yName: '15950',
                value: 1.0,
            },
            {
                x: 'Source Documentation',
                y: 367232014,
                yName: '15950',
                value: 1.0,
            },
            {
                x: 'Study Product',
                y: 367232014,
                yName: '15950',
                value: 0.0,
            },
            {
                x: 'Study Supplies',
                y: 367232014,
                yName: '15950',
                value: 0.0,
            },
            {
                x: 'Systems',
                y: 367232014,
                yName: '15950',
                value: 0.0,
            },
        ],
        '1914897443': [
            {
                x: 'CA/EC/IRB',
                y: 1914897443,
                yName: '15920',
                value: 2.0,
            },
            {
                x: 'Central/Local Lab',
                y: 1914897443,
                yName: '15920',
                value: 1.0,
            },
            {
                x: 'COVID-19',
                y: 1914897443,
                yName: '15920',
                value: 2.0,
            },
            {
                x: 'Data Entry/Query Resolution',
                y: 1914897443,
                yName: '15920',
                value: 1.0,
            },
            {
                x: 'Event Reporting/Safety',
                y: 1914897443,
                yName: '15920',
                value: 0.0,
            },
            {
                x: 'Facilities & Equipment',
                y: 1914897443,
                yName: '15920',
                value: 0.0,
            },
            {
                x: 'Investigator Oversight',
                y: 1914897443,
                yName: '15920',
                value: 0.0,
            },
            {
                x: 'Investigator Site Binder',
                y: 1914897443,
                yName: '15920',
                value: 1.0,
            },
            {
                x: 'ISSC MV Doc Issue',
                y: 1914897443,
                yName: '15920',
                value: 0.0,
            },
            {
                x: 'ISSC Site File Issue',
                y: 1914897443,
                yName: '15920',
                value: 10.0,
            },
            {
                x: 'Other',
                y: 1914897443,
                yName: '15920',
                value: 4.0,
            },
            {
                x: 'Recruitment & Enrollment',
                y: 1914897443,
                yName: '15920',
                value: 0.0,
            },
            {
                x: 'Site Staff Training',
                y: 1914897443,
                yName: '15920',
                value: 1.0,
            },
            {
                x: 'Source Documentation',
                y: 1914897443,
                yName: '15920',
                value: 1.0,
            },
            {
                x: 'Study Product',
                y: 1914897443,
                yName: '15920',
                value: 1.0,
            },
            {
                x: 'Study Supplies',
                y: 1914897443,
                yName: '15920',
                value: 0.0,
            },
            {
                x: 'Systems',
                y: 1914897443,
                yName: '15920',
                value: 0.0,
            },
        ],
        '2027291206': [
            {
                x: 'CA/EC/IRB',
                y: 2027291206,
                yName: '295767',
                value: 0.0,
            },
            {
                x: 'Central/Local Lab',
                y: 2027291206,
                yName: '295767',
                value: 0.0,
            },
            {
                x: 'COVID-19',
                y: 2027291206,
                yName: '295767',
                value: 3.0,
            },
            {
                x: 'Data Entry/Query Resolution',
                y: 2027291206,
                yName: '295767',
                value: 0.0,
            },
            {
                x: 'Event Reporting/Safety',
                y: 2027291206,
                yName: '295767',
                value: 0.0,
            },
            {
                x: 'Facilities & Equipment',
                y: 2027291206,
                yName: '295767',
                value: 0.0,
            },
            {
                x: 'Investigator Oversight',
                y: 2027291206,
                yName: '295767',
                value: 0.0,
            },
            {
                x: 'Investigator Site Binder',
                y: 2027291206,
                yName: '295767',
                value: 3.0,
            },
            {
                x: 'ISSC MV Doc Issue',
                y: 2027291206,
                yName: '295767',
                value: 0.0,
            },
            {
                x: 'ISSC Site File Issue',
                y: 2027291206,
                yName: '295767',
                value: 2.0,
            },
            {
                x: 'Other',
                y: 2027291206,
                yName: '295767',
                value: 2.0,
            },
            {
                x: 'Recruitment & Enrollment',
                y: 2027291206,
                yName: '295767',
                value: 0.0,
            },
            {
                x: 'Site Staff Training',
                y: 2027291206,
                yName: '295767',
                value: 0.0,
            },
            {
                x: 'Source Documentation',
                y: 2027291206,
                yName: '295767',
                value: 0.0,
            },
            {
                x: 'Study Product',
                y: 2027291206,
                yName: '295767',
                value: 0.0,
            },
            {
                x: 'Study Supplies',
                y: 2027291206,
                yName: '295767',
                value: 0.0,
            },
            {
                x: 'Systems',
                y: 2027291206,
                yName: '295767',
                value: 1.0,
            },
        ],
        '-834432261': [
            {
                x: 'CA/EC/IRB',
                y: -834432261,
                yName: '15830',
                value: 0.0,
            },
            {
                x: 'Central/Local Lab',
                y: -834432261,
                yName: '15830',
                value: 0.0,
            },
            {
                x: 'COVID-19',
                y: -834432261,
                yName: '15830',
                value: 1.0,
            },
            {
                x: 'Data Entry/Query Resolution',
                y: -834432261,
                yName: '15830',
                value: 0.0,
            },
            {
                x: 'Event Reporting/Safety',
                y: -834432261,
                yName: '15830',
                value: 0.0,
            },
            {
                x: 'Facilities & Equipment',
                y: -834432261,
                yName: '15830',
                value: 0.0,
            },
            {
                x: 'Investigator Oversight',
                y: -834432261,
                yName: '15830',
                value: 1.0,
            },
            {
                x: 'Investigator Site Binder',
                y: -834432261,
                yName: '15830',
                value: 0.0,
            },
            {
                x: 'ISSC MV Doc Issue',
                y: -834432261,
                yName: '15830',
                value: 0.0,
            },
            {
                x: 'ISSC Site File Issue',
                y: -834432261,
                yName: '15830',
                value: 11.0,
            },
            {
                x: 'Other',
                y: -834432261,
                yName: '15830',
                value: 2.0,
            },
            {
                x: 'Recruitment & Enrollment',
                y: -834432261,
                yName: '15830',
                value: 2.0,
            },
            {
                x: 'Site Staff Training',
                y: -834432261,
                yName: '15830',
                value: 0.0,
            },
            {
                x: 'Source Documentation',
                y: -834432261,
                yName: '15830',
                value: 0.0,
            },
            {
                x: 'Study Product',
                y: -834432261,
                yName: '15830',
                value: 0.0,
            },
            {
                x: 'Study Supplies',
                y: -834432261,
                yName: '15830',
                value: 0.0,
            },
            {
                x: 'Systems',
                y: -834432261,
                yName: '15830',
                value: 0.0,
            },
        ],
        '480563839': [
            {
                x: 'CA/EC/IRB',
                y: 480563839,
                yName: '15512',
                value: 0.0,
            },
            {
                x: 'Central/Local Lab',
                y: 480563839,
                yName: '15512',
                value: 2.0,
            },
            {
                x: 'COVID-19',
                y: 480563839,
                yName: '15512',
                value: 1.0,
            },
            {
                x: 'Data Entry/Query Resolution',
                y: 480563839,
                yName: '15512',
                value: 0.0,
            },
            {
                x: 'Event Reporting/Safety',
                y: 480563839,
                yName: '15512',
                value: 0.0,
            },
            {
                x: 'Facilities & Equipment',
                y: 480563839,
                yName: '15512',
                value: 0.0,
            },
            {
                x: 'Investigator Oversight',
                y: 480563839,
                yName: '15512',
                value: 0.0,
            },
            {
                x: 'Investigator Site Binder',
                y: 480563839,
                yName: '15512',
                value: 1.0,
            },
            {
                x: 'ISSC MV Doc Issue',
                y: 480563839,
                yName: '15512',
                value: 0.0,
            },
            {
                x: 'ISSC Site File Issue',
                y: 480563839,
                yName: '15512',
                value: 15.0,
            },
            {
                x: 'Other',
                y: 480563839,
                yName: '15512',
                value: 3.0,
            },
            {
                x: 'Recruitment & Enrollment',
                y: 480563839,
                yName: '15512',
                value: 0.0,
            },
            {
                x: 'Site Staff Training',
                y: 480563839,
                yName: '15512',
                value: 0.0,
            },
            {
                x: 'Source Documentation',
                y: 480563839,
                yName: '15512',
                value: 0.0,
            },
            {
                x: 'Study Product',
                y: 480563839,
                yName: '15512',
                value: 0.0,
            },
            {
                x: 'Study Supplies',
                y: 480563839,
                yName: '15512',
                value: 0.0,
            },
            {
                x: 'Systems',
                y: 480563839,
                yName: '15512',
                value: 0.0,
            },
        ],
        '-305355763': [
            {
                x: 'CA/EC/IRB',
                y: -305355763,
                yName: '15890',
                value: 0.0,
            },
            {
                x: 'Central/Local Lab',
                y: -305355763,
                yName: '15890',
                value: 0.0,
            },
            {
                x: 'COVID-19',
                y: -305355763,
                yName: '15890',
                value: 1.0,
            },
            {
                x: 'Data Entry/Query Resolution',
                y: -305355763,
                yName: '15890',
                value: 0.0,
            },
            {
                x: 'Event Reporting/Safety',
                y: -305355763,
                yName: '15890',
                value: 0.0,
            },
            {
                x: 'Facilities & Equipment',
                y: -305355763,
                yName: '15890',
                value: 0.0,
            },
            {
                x: 'Investigator Oversight',
                y: -305355763,
                yName: '15890',
                value: 0.0,
            },
            {
                x: 'Investigator Site Binder',
                y: -305355763,
                yName: '15890',
                value: 0.0,
            },
            {
                x: 'ISSC MV Doc Issue',
                y: -305355763,
                yName: '15890',
                value: 0.0,
            },
            {
                x: 'ISSC Site File Issue',
                y: -305355763,
                yName: '15890',
                value: 14.0,
            },
            {
                x: 'Other',
                y: -305355763,
                yName: '15890',
                value: 2.0,
            },
            {
                x: 'Recruitment & Enrollment',
                y: -305355763,
                yName: '15890',
                value: 0.0,
            },
            {
                x: 'Site Staff Training',
                y: -305355763,
                yName: '15890',
                value: 5.0,
            },
            {
                x: 'Source Documentation',
                y: -305355763,
                yName: '15890',
                value: 0.0,
            },
            {
                x: 'Study Product',
                y: -305355763,
                yName: '15890',
                value: 0.0,
            },
            {
                x: 'Study Supplies',
                y: -305355763,
                yName: '15890',
                value: 0.0,
            },
            {
                x: 'Systems',
                y: -305355763,
                yName: '15890',
                value: 0.0,
            },
        ],
        '-1601924652': [
            {
                x: 'CA/EC/IRB',
                y: -1601924652,
                yName: '132143',
                value: 1.0,
            },
            {
                x: 'Central/Local Lab',
                y: -1601924652,
                yName: '132143',
                value: 1.0,
            },
            {
                x: 'COVID-19',
                y: -1601924652,
                yName: '132143',
                value: 2.0,
            },
            {
                x: 'Data Entry/Query Resolution',
                y: -1601924652,
                yName: '132143',
                value: 1.0,
            },
            {
                x: 'Event Reporting/Safety',
                y: -1601924652,
                yName: '132143',
                value: 0.0,
            },
            {
                x: 'Facilities & Equipment',
                y: -1601924652,
                yName: '132143',
                value: 1.0,
            },
            {
                x: 'Investigator Oversight',
                y: -1601924652,
                yName: '132143',
                value: 0.0,
            },
            {
                x: 'Investigator Site Binder',
                y: -1601924652,
                yName: '132143',
                value: 0.0,
            },
            {
                x: 'ISSC MV Doc Issue',
                y: -1601924652,
                yName: '132143',
                value: 1.0,
            },
            {
                x: 'ISSC Site File Issue',
                y: -1601924652,
                yName: '132143',
                value: 10.0,
            },
            {
                x: 'Other',
                y: -1601924652,
                yName: '132143',
                value: 2.0,
            },
            {
                x: 'Recruitment & Enrollment',
                y: -1601924652,
                yName: '132143',
                value: 0.0,
            },
            {
                x: 'Site Staff Training',
                y: -1601924652,
                yName: '132143',
                value: 1.0,
            },
            {
                x: 'Source Documentation',
                y: -1601924652,
                yName: '132143',
                value: 2.0,
            },
            {
                x: 'Study Product',
                y: -1601924652,
                yName: '132143',
                value: 0.0,
            },
            {
                x: 'Study Supplies',
                y: -1601924652,
                yName: '132143',
                value: 0.0,
            },
            {
                x: 'Systems',
                y: -1601924652,
                yName: '132143',
                value: 0.0,
            },
        ],
        '1412104886': [
            {
                x: 'CA/EC/IRB',
                y: 1412104886,
                yName: '15980',
                value: 0.0,
            },
            {
                x: 'Central/Local Lab',
                y: 1412104886,
                yName: '15980',
                value: 1.0,
            },
            {
                x: 'COVID-19',
                y: 1412104886,
                yName: '15980',
                value: 0.0,
            },
            {
                x: 'Data Entry/Query Resolution',
                y: 1412104886,
                yName: '15980',
                value: 0.0,
            },
            {
                x: 'Event Reporting/Safety',
                y: 1412104886,
                yName: '15980',
                value: 0.0,
            },
            {
                x: 'Facilities & Equipment',
                y: 1412104886,
                yName: '15980',
                value: 0.0,
            },
            {
                x: 'Investigator Oversight',
                y: 1412104886,
                yName: '15980',
                value: 3.0,
            },
            {
                x: 'Investigator Site Binder',
                y: 1412104886,
                yName: '15980',
                value: 4.0,
            },
            {
                x: 'ISSC MV Doc Issue',
                y: 1412104886,
                yName: '15980',
                value: 0.0,
            },
            {
                x: 'ISSC Site File Issue',
                y: 1412104886,
                yName: '15980',
                value: 9.0,
            },
            {
                x: 'Other',
                y: 1412104886,
                yName: '15980',
                value: 1.0,
            },
            {
                x: 'Recruitment & Enrollment',
                y: 1412104886,
                yName: '15980',
                value: 0.0,
            },
            {
                x: 'Site Staff Training',
                y: 1412104886,
                yName: '15980',
                value: 4.0,
            },
            {
                x: 'Source Documentation',
                y: 1412104886,
                yName: '15980',
                value: 0.0,
            },
            {
                x: 'Study Product',
                y: 1412104886,
                yName: '15980',
                value: 0.0,
            },
            {
                x: 'Study Supplies',
                y: 1412104886,
                yName: '15980',
                value: 0.0,
            },
            {
                x: 'Systems',
                y: 1412104886,
                yName: '15980',
                value: 0.0,
            },
        ],
        '-103337990': [
            {
                x: 'CA/EC/IRB',
                y: -103337990,
                yName: '105208',
                value: 0.0,
            },
            {
                x: 'Central/Local Lab',
                y: -103337990,
                yName: '105208',
                value: 0.0,
            },
            {
                x: 'COVID-19',
                y: -103337990,
                yName: '105208',
                value: 1.0,
            },
            {
                x: 'Data Entry/Query Resolution',
                y: -103337990,
                yName: '105208',
                value: 0.0,
            },
            {
                x: 'Event Reporting/Safety',
                y: -103337990,
                yName: '105208',
                value: 0.0,
            },
            {
                x: 'Facilities & Equipment',
                y: -103337990,
                yName: '105208',
                value: 1.0,
            },
            {
                x: 'Investigator Oversight',
                y: -103337990,
                yName: '105208',
                value: 0.0,
            },
            {
                x: 'Investigator Site Binder',
                y: -103337990,
                yName: '105208',
                value: 0.0,
            },
            {
                x: 'ISSC MV Doc Issue',
                y: -103337990,
                yName: '105208',
                value: 0.0,
            },
            {
                x: 'ISSC Site File Issue',
                y: -103337990,
                yName: '105208',
                value: 7.0,
            },
            {
                x: 'Other',
                y: -103337990,
                yName: '105208',
                value: 1.0,
            },
            {
                x: 'Recruitment & Enrollment',
                y: -103337990,
                yName: '105208',
                value: 0.0,
            },
            {
                x: 'Site Staff Training',
                y: -103337990,
                yName: '105208',
                value: 3.0,
            },
            {
                x: 'Source Documentation',
                y: -103337990,
                yName: '105208',
                value: 0.0,
            },
            {
                x: 'Study Product',
                y: -103337990,
                yName: '105208',
                value: 0.0,
            },
            {
                x: 'Study Supplies',
                y: -103337990,
                yName: '105208',
                value: 0.0,
            },
            {
                x: 'Systems',
                y: -103337990,
                yName: '105208',
                value: 0.0,
            },
        ],
        '1493750522': [
            {
                x: 'CA/EC/IRB',
                y: 1493750522,
                yName: '16070',
                value: 0.0,
            },
            {
                x: 'Central/Local Lab',
                y: 1493750522,
                yName: '16070',
                value: 0.0,
            },
            {
                x: 'COVID-19',
                y: 1493750522,
                yName: '16070',
                value: 1.0,
            },
            {
                x: 'Data Entry/Query Resolution',
                y: 1493750522,
                yName: '16070',
                value: 0.0,
            },
            {
                x: 'Event Reporting/Safety',
                y: 1493750522,
                yName: '16070',
                value: 0.0,
            },
            {
                x: 'Facilities & Equipment',
                y: 1493750522,
                yName: '16070',
                value: 0.0,
            },
            {
                x: 'Investigator Oversight',
                y: 1493750522,
                yName: '16070',
                value: 0.0,
            },
            {
                x: 'Investigator Site Binder',
                y: 1493750522,
                yName: '16070',
                value: 1.0,
            },
            {
                x: 'ISSC MV Doc Issue',
                y: 1493750522,
                yName: '16070',
                value: 0.0,
            },
            {
                x: 'ISSC Site File Issue',
                y: 1493750522,
                yName: '16070',
                value: 9.0,
            },
            {
                x: 'Other',
                y: 1493750522,
                yName: '16070',
                value: 2.0,
            },
            {
                x: 'Recruitment & Enrollment',
                y: 1493750522,
                yName: '16070',
                value: 0.0,
            },
            {
                x: 'Site Staff Training',
                y: 1493750522,
                yName: '16070',
                value: 2.0,
            },
            {
                x: 'Source Documentation',
                y: 1493750522,
                yName: '16070',
                value: 0.0,
            },
            {
                x: 'Study Product',
                y: 1493750522,
                yName: '16070',
                value: 0.0,
            },
            {
                x: 'Study Supplies',
                y: 1493750522,
                yName: '16070',
                value: 1.0,
            },
            {
                x: 'Systems',
                y: 1493750522,
                yName: '16070',
                value: 1.0,
            },
        ],
        '1091948434': [
            {
                x: 'CA/EC/IRB',
                y: 1091948434,
                yName: '586198',
                value: 0.0,
            },
            {
                x: 'Central/Local Lab',
                y: 1091948434,
                yName: '586198',
                value: 0.0,
            },
            {
                x: 'COVID-19',
                y: 1091948434,
                yName: '586198',
                value: 3.0,
            },
            {
                x: 'Data Entry/Query Resolution',
                y: 1091948434,
                yName: '586198',
                value: 0.0,
            },
            {
                x: 'Event Reporting/Safety',
                y: 1091948434,
                yName: '586198',
                value: 0.0,
            },
            {
                x: 'Facilities & Equipment',
                y: 1091948434,
                yName: '586198',
                value: 0.0,
            },
            {
                x: 'Investigator Oversight',
                y: 1091948434,
                yName: '586198',
                value: 0.0,
            },
            {
                x: 'Investigator Site Binder',
                y: 1091948434,
                yName: '586198',
                value: 2.0,
            },
            {
                x: 'ISSC MV Doc Issue',
                y: 1091948434,
                yName: '586198',
                value: 0.0,
            },
            {
                x: 'ISSC Site File Issue',
                y: 1091948434,
                yName: '586198',
                value: 3.0,
            },
            {
                x: 'Other',
                y: 1091948434,
                yName: '586198',
                value: 0.0,
            },
            {
                x: 'Recruitment & Enrollment',
                y: 1091948434,
                yName: '586198',
                value: 0.0,
            },
            {
                x: 'Site Staff Training',
                y: 1091948434,
                yName: '586198',
                value: 1.0,
            },
            {
                x: 'Source Documentation',
                y: 1091948434,
                yName: '586198',
                value: 1.0,
            },
            {
                x: 'Study Product',
                y: 1091948434,
                yName: '586198',
                value: 0.0,
            },
            {
                x: 'Study Supplies',
                y: 1091948434,
                yName: '586198',
                value: 0.0,
            },
            {
                x: 'Systems',
                y: 1091948434,
                yName: '586198',
                value: 1.0,
            },
        ],
        '-1322257209': [
            {
                x: 'CA/EC/IRB',
                y: -1322257209,
                yName: '124846',
                value: 0.0,
            },
            {
                x: 'Central/Local Lab',
                y: -1322257209,
                yName: '124846',
                value: 0.0,
            },
            {
                x: 'COVID-19',
                y: -1322257209,
                yName: '124846',
                value: 2.0,
            },
            {
                x: 'Data Entry/Query Resolution',
                y: -1322257209,
                yName: '124846',
                value: 0.0,
            },
            {
                x: 'Event Reporting/Safety',
                y: -1322257209,
                yName: '124846',
                value: 0.0,
            },
            {
                x: 'Facilities & Equipment',
                y: -1322257209,
                yName: '124846',
                value: 0.0,
            },
            {
                x: 'Investigator Oversight',
                y: -1322257209,
                yName: '124846',
                value: 0.0,
            },
            {
                x: 'Investigator Site Binder',
                y: -1322257209,
                yName: '124846',
                value: 0.0,
            },
            {
                x: 'ISSC MV Doc Issue',
                y: -1322257209,
                yName: '124846',
                value: 0.0,
            },
            {
                x: 'ISSC Site File Issue',
                y: -1322257209,
                yName: '124846',
                value: 2.0,
            },
            {
                x: 'Other',
                y: -1322257209,
                yName: '124846',
                value: 0.0,
            },
            {
                x: 'Recruitment & Enrollment',
                y: -1322257209,
                yName: '124846',
                value: 0.0,
            },
            {
                x: 'Site Staff Training',
                y: -1322257209,
                yName: '124846',
                value: 3.0,
            },
            {
                x: 'Source Documentation',
                y: -1322257209,
                yName: '124846',
                value: 0.0,
            },
            {
                x: 'Study Product',
                y: -1322257209,
                yName: '124846',
                value: 0.0,
            },
            {
                x: 'Study Supplies',
                y: -1322257209,
                yName: '124846',
                value: 0.0,
            },
            {
                x: 'Systems',
                y: -1322257209,
                yName: '124846',
                value: 0.0,
            },
        ],
        '-755717796': [
            {
                x: 'CA/EC/IRB',
                y: -755717796,
                yName: '318415',
                value: 0.0,
            },
            {
                x: 'Central/Local Lab',
                y: -755717796,
                yName: '318415',
                value: 0.0,
            },
            {
                x: 'COVID-19',
                y: -755717796,
                yName: '318415',
                value: 2.0,
            },
            {
                x: 'Data Entry/Query Resolution',
                y: -755717796,
                yName: '318415',
                value: 0.0,
            },
            {
                x: 'Event Reporting/Safety',
                y: -755717796,
                yName: '318415',
                value: 0.0,
            },
            {
                x: 'Facilities & Equipment',
                y: -755717796,
                yName: '318415',
                value: 0.0,
            },
            {
                x: 'Investigator Oversight',
                y: -755717796,
                yName: '318415',
                value: 0.0,
            },
            {
                x: 'Investigator Site Binder',
                y: -755717796,
                yName: '318415',
                value: 2.0,
            },
            {
                x: 'ISSC MV Doc Issue',
                y: -755717796,
                yName: '318415',
                value: 0.0,
            },
            {
                x: 'ISSC Site File Issue',
                y: -755717796,
                yName: '318415',
                value: 4.0,
            },
            {
                x: 'Other',
                y: -755717796,
                yName: '318415',
                value: 1.0,
            },
            {
                x: 'Recruitment & Enrollment',
                y: -755717796,
                yName: '318415',
                value: 0.0,
            },
            {
                x: 'Site Staff Training',
                y: -755717796,
                yName: '318415',
                value: 0.0,
            },
            {
                x: 'Source Documentation',
                y: -755717796,
                yName: '318415',
                value: 0.0,
            },
            {
                x: 'Study Product',
                y: -755717796,
                yName: '318415',
                value: 1.0,
            },
            {
                x: 'Study Supplies',
                y: -755717796,
                yName: '318415',
                value: 0.0,
            },
            {
                x: 'Systems',
                y: -755717796,
                yName: '318415',
                value: 0.0,
            },
        ],
        '842929281': [
            {
                x: 'CA/EC/IRB',
                y: 842929281,
                yName: '584009',
                value: 0.0,
            },
            {
                x: 'Central/Local Lab',
                y: 842929281,
                yName: '584009',
                value: 0.0,
            },
            {
                x: 'COVID-19',
                y: 842929281,
                yName: '584009',
                value: 3.0,
            },
            {
                x: 'Data Entry/Query Resolution',
                y: 842929281,
                yName: '584009',
                value: 0.0,
            },
            {
                x: 'Event Reporting/Safety',
                y: 842929281,
                yName: '584009',
                value: 0.0,
            },
            {
                x: 'Facilities & Equipment',
                y: 842929281,
                yName: '584009',
                value: 1.0,
            },
            {
                x: 'Investigator Oversight',
                y: 842929281,
                yName: '584009',
                value: 0.0,
            },
            {
                x: 'Investigator Site Binder',
                y: 842929281,
                yName: '584009',
                value: 3.0,
            },
            {
                x: 'ISSC MV Doc Issue',
                y: 842929281,
                yName: '584009',
                value: 0.0,
            },
            {
                x: 'ISSC Site File Issue',
                y: 842929281,
                yName: '584009',
                value: 6.0,
            },
            {
                x: 'Other',
                y: 842929281,
                yName: '584009',
                value: 0.0,
            },
            {
                x: 'Recruitment & Enrollment',
                y: 842929281,
                yName: '584009',
                value: 0.0,
            },
            {
                x: 'Site Staff Training',
                y: 842929281,
                yName: '584009',
                value: 1.0,
            },
            {
                x: 'Source Documentation',
                y: 842929281,
                yName: '584009',
                value: 0.0,
            },
            {
                x: 'Study Product',
                y: 842929281,
                yName: '584009',
                value: 0.0,
            },
            {
                x: 'Study Supplies',
                y: 842929281,
                yName: '584009',
                value: 0.0,
            },
            {
                x: 'Systems',
                y: 842929281,
                yName: '584009',
                value: 0.0,
            },
        ],
        '-122128539': [
            {
                x: 'CA/EC/IRB',
                y: -122128539,
                yName: '318388',
                value: 0.0,
            },
            {
                x: 'Central/Local Lab',
                y: -122128539,
                yName: '318388',
                value: 0.0,
            },
            {
                x: 'COVID-19',
                y: -122128539,
                yName: '318388',
                value: 1.0,
            },
            {
                x: 'Data Entry/Query Resolution',
                y: -122128539,
                yName: '318388',
                value: 0.0,
            },
            {
                x: 'Event Reporting/Safety',
                y: -122128539,
                yName: '318388',
                value: 0.0,
            },
            {
                x: 'Facilities & Equipment',
                y: -122128539,
                yName: '318388',
                value: 2.0,
            },
            {
                x: 'Investigator Oversight',
                y: -122128539,
                yName: '318388',
                value: 0.0,
            },
            {
                x: 'Investigator Site Binder',
                y: -122128539,
                yName: '318388',
                value: 0.0,
            },
            {
                x: 'ISSC MV Doc Issue',
                y: -122128539,
                yName: '318388',
                value: 0.0,
            },
            {
                x: 'ISSC Site File Issue',
                y: -122128539,
                yName: '318388',
                value: 5.0,
            },
            {
                x: 'Other',
                y: -122128539,
                yName: '318388',
                value: 2.0,
            },
            {
                x: 'Recruitment & Enrollment',
                y: -122128539,
                yName: '318388',
                value: 0.0,
            },
            {
                x: 'Site Staff Training',
                y: -122128539,
                yName: '318388',
                value: 0.0,
            },
            {
                x: 'Source Documentation',
                y: -122128539,
                yName: '318388',
                value: 0.0,
            },
            {
                x: 'Study Product',
                y: -122128539,
                yName: '318388',
                value: 0.0,
            },
            {
                x: 'Study Supplies',
                y: -122128539,
                yName: '318388',
                value: 0.0,
            },
            {
                x: 'Systems',
                y: -122128539,
                yName: '318388',
                value: 0.0,
            },
        ],
        '-948432212': [
            {
                x: 'CA/EC/IRB',
                y: -948432212,
                yName: '585289',
                value: 0.0,
            },
            {
                x: 'Central/Local Lab',
                y: -948432212,
                yName: '585289',
                value: 0.0,
            },
            {
                x: 'COVID-19',
                y: -948432212,
                yName: '585289',
                value: 1.0,
            },
            {
                x: 'Data Entry/Query Resolution',
                y: -948432212,
                yName: '585289',
                value: 0.0,
            },
            {
                x: 'Event Reporting/Safety',
                y: -948432212,
                yName: '585289',
                value: 0.0,
            },
            {
                x: 'Facilities & Equipment',
                y: -948432212,
                yName: '585289',
                value: 1.0,
            },
            {
                x: 'Investigator Oversight',
                y: -948432212,
                yName: '585289',
                value: 0.0,
            },
            {
                x: 'Investigator Site Binder',
                y: -948432212,
                yName: '585289',
                value: 1.0,
            },
            {
                x: 'ISSC MV Doc Issue',
                y: -948432212,
                yName: '585289',
                value: 0.0,
            },
            {
                x: 'ISSC Site File Issue',
                y: -948432212,
                yName: '585289',
                value: 4.0,
            },
            {
                x: 'Other',
                y: -948432212,
                yName: '585289',
                value: 0.0,
            },
            {
                x: 'Recruitment & Enrollment',
                y: -948432212,
                yName: '585289',
                value: 0.0,
            },
            {
                x: 'Site Staff Training',
                y: -948432212,
                yName: '585289',
                value: 1.0,
            },
            {
                x: 'Source Documentation',
                y: -948432212,
                yName: '585289',
                value: 2.0,
            },
            {
                x: 'Study Product',
                y: -948432212,
                yName: '585289',
                value: 1.0,
            },
            {
                x: 'Study Supplies',
                y: -948432212,
                yName: '585289',
                value: 0.0,
            },
            {
                x: 'Systems',
                y: -948432212,
                yName: '585289',
                value: 0.0,
            },
        ],
        '286942478': [
            {
                x: 'CA/EC/IRB',
                y: 286942478,
                yName: '763847',
                value: 0.0,
            },
            {
                x: 'Central/Local Lab',
                y: 286942478,
                yName: '763847',
                value: 0.0,
            },
            {
                x: 'COVID-19',
                y: 286942478,
                yName: '763847',
                value: 1.0,
            },
            {
                x: 'Data Entry/Query Resolution',
                y: 286942478,
                yName: '763847',
                value: 0.0,
            },
            {
                x: 'Event Reporting/Safety',
                y: 286942478,
                yName: '763847',
                value: 0.0,
            },
            {
                x: 'Facilities & Equipment',
                y: 286942478,
                yName: '763847',
                value: 1.0,
            },
            {
                x: 'Investigator Oversight',
                y: 286942478,
                yName: '763847',
                value: 0.0,
            },
            {
                x: 'Investigator Site Binder',
                y: 286942478,
                yName: '763847',
                value: 1.0,
            },
            {
                x: 'ISSC MV Doc Issue',
                y: 286942478,
                yName: '763847',
                value: 0.0,
            },
            {
                x: 'ISSC Site File Issue',
                y: 286942478,
                yName: '763847',
                value: 3.0,
            },
            {
                x: 'Other',
                y: 286942478,
                yName: '763847',
                value: 0.0,
            },
            {
                x: 'Recruitment & Enrollment',
                y: 286942478,
                yName: '763847',
                value: 1.0,
            },
            {
                x: 'Site Staff Training',
                y: 286942478,
                yName: '763847',
                value: 0.0,
            },
            {
                x: 'Source Documentation',
                y: 286942478,
                yName: '763847',
                value: 0.0,
            },
            {
                x: 'Study Product',
                y: 286942478,
                yName: '763847',
                value: 0.0,
            },
            {
                x: 'Study Supplies',
                y: 286942478,
                yName: '763847',
                value: 0.0,
            },
            {
                x: 'Systems',
                y: 286942478,
                yName: '763847',
                value: 0.0,
            },
        ],
        '-1470129959': [
            {
                x: 'CA/EC/IRB',
                y: -1470129959,
                yName: '256293',
                value: 0.0,
            },
            {
                x: 'Central/Local Lab',
                y: -1470129959,
                yName: '256293',
                value: 0.0,
            },
            {
                x: 'COVID-19',
                y: -1470129959,
                yName: '256293',
                value: 2.0,
            },
            {
                x: 'Data Entry/Query Resolution',
                y: -1470129959,
                yName: '256293',
                value: 0.0,
            },
            {
                x: 'Event Reporting/Safety',
                y: -1470129959,
                yName: '256293',
                value: 0.0,
            },
            {
                x: 'Facilities & Equipment',
                y: -1470129959,
                yName: '256293',
                value: 0.0,
            },
            {
                x: 'Investigator Oversight',
                y: -1470129959,
                yName: '256293',
                value: 0.0,
            },
            {
                x: 'Investigator Site Binder',
                y: -1470129959,
                yName: '256293',
                value: 0.0,
            },
            {
                x: 'ISSC MV Doc Issue',
                y: -1470129959,
                yName: '256293',
                value: 0.0,
            },
            {
                x: 'ISSC Site File Issue',
                y: -1470129959,
                yName: '256293',
                value: 2.0,
            },
            {
                x: 'Other',
                y: -1470129959,
                yName: '256293',
                value: 0.0,
            },
            {
                x: 'Recruitment & Enrollment',
                y: -1470129959,
                yName: '256293',
                value: 0.0,
            },
            {
                x: 'Site Staff Training',
                y: -1470129959,
                yName: '256293',
                value: 0.0,
            },
            {
                x: 'Source Documentation',
                y: -1470129959,
                yName: '256293',
                value: 0.0,
            },
            {
                x: 'Study Product',
                y: -1470129959,
                yName: '256293',
                value: 1.0,
            },
            {
                x: 'Study Supplies',
                y: -1470129959,
                yName: '256293',
                value: 0.0,
            },
            {
                x: 'Systems',
                y: -1470129959,
                yName: '256293',
                value: 3.0,
            },
        ],
        '-132090115': [
            {
                x: 'CA/EC/IRB',
                y: -132090115,
                yName: '764334',
                value: 0.0,
            },
            {
                x: 'Central/Local Lab',
                y: -132090115,
                yName: '764334',
                value: 0.0,
            },
            {
                x: 'COVID-19',
                y: -132090115,
                yName: '764334',
                value: 2.0,
            },
            {
                x: 'Data Entry/Query Resolution',
                y: -132090115,
                yName: '764334',
                value: 0.0,
            },
            {
                x: 'Event Reporting/Safety',
                y: -132090115,
                yName: '764334',
                value: 0.0,
            },
            {
                x: 'Facilities & Equipment',
                y: -132090115,
                yName: '764334',
                value: 2.0,
            },
            {
                x: 'Investigator Oversight',
                y: -132090115,
                yName: '764334',
                value: 0.0,
            },
            {
                x: 'Investigator Site Binder',
                y: -132090115,
                yName: '764334',
                value: 0.0,
            },
            {
                x: 'ISSC MV Doc Issue',
                y: -132090115,
                yName: '764334',
                value: 1.0,
            },
            {
                x: 'ISSC Site File Issue',
                y: -132090115,
                yName: '764334',
                value: 1.0,
            },
            {
                x: 'Other',
                y: -132090115,
                yName: '764334',
                value: 0.0,
            },
            {
                x: 'Recruitment & Enrollment',
                y: -132090115,
                yName: '764334',
                value: 0.0,
            },
            {
                x: 'Site Staff Training',
                y: -132090115,
                yName: '764334',
                value: 0.0,
            },
            {
                x: 'Source Documentation',
                y: -132090115,
                yName: '764334',
                value: 0.0,
            },
            {
                x: 'Study Product',
                y: -132090115,
                yName: '764334',
                value: 0.0,
            },
            {
                x: 'Study Supplies',
                y: -132090115,
                yName: '764334',
                value: 0.0,
            },
            {
                x: 'Systems',
                y: -132090115,
                yName: '764334',
                value: 1.0,
            },
        ],
        '775210142': [
            {
                x: 'CA/EC/IRB',
                y: 775210142,
                yName: '346951',
                value: 0.0,
            },
            {
                x: 'Central/Local Lab',
                y: 775210142,
                yName: '346951',
                value: 0.0,
            },
            {
                x: 'COVID-19',
                y: 775210142,
                yName: '346951',
                value: 2.0,
            },
            {
                x: 'Data Entry/Query Resolution',
                y: 775210142,
                yName: '346951',
                value: 0.0,
            },
            {
                x: 'Event Reporting/Safety',
                y: 775210142,
                yName: '346951',
                value: 0.0,
            },
            {
                x: 'Facilities & Equipment',
                y: 775210142,
                yName: '346951',
                value: 0.0,
            },
            {
                x: 'Investigator Oversight',
                y: 775210142,
                yName: '346951',
                value: 1.0,
            },
            {
                x: 'Investigator Site Binder',
                y: 775210142,
                yName: '346951',
                value: 2.0,
            },
            {
                x: 'ISSC MV Doc Issue',
                y: 775210142,
                yName: '346951',
                value: 0.0,
            },
            {
                x: 'ISSC Site File Issue',
                y: 775210142,
                yName: '346951',
                value: 4.0,
            },
            {
                x: 'Other',
                y: 775210142,
                yName: '346951',
                value: 1.0,
            },
            {
                x: 'Recruitment & Enrollment',
                y: 775210142,
                yName: '346951',
                value: 0.0,
            },
            {
                x: 'Site Staff Training',
                y: 775210142,
                yName: '346951',
                value: 0.0,
            },
            {
                x: 'Source Documentation',
                y: 775210142,
                yName: '346951',
                value: 0.0,
            },
            {
                x: 'Study Product',
                y: 775210142,
                yName: '346951',
                value: 0.0,
            },
            {
                x: 'Study Supplies',
                y: 775210142,
                yName: '346951',
                value: 0.0,
            },
            {
                x: 'Systems',
                y: 775210142,
                yName: '346951',
                value: 0.0,
            },
        ],
    },
};

export const donutData = [
    {
        name: 'Cycle 1 Day 1',
        count: 1720,
    },
    {
        name: 'Cycle 1 Day 2',
        count: 3270,
    },
    {
        name: 'Cycle 1 Day 3',
        count: 3260,
    },
    {
        name: 'Cycle 1 Day 4',
        count: 3240,
    },
    {
        name: 'Cycle 1 Day 5',
        count: 3230,
    },
    {
        name: 'Cycle 1 Day 6',
        count: 3250,
    },
    {
        name: 'Cycle 1 Day 7',
        count: 3240,
    },
    {
        name: 'Cycle 2 Day 1',
        count: 1720,
    },
    {
        name: 'Cycle 2 Day 2',
        count: 3270,
    },
    {
        name: 'Cycle 2 Day 3',
        count: 3260,
    },
    {
        name: 'Cycle 2 Day 4',
        count: 3240,
    },
    {
        name: 'Cycle 2 Day 5',
        count: 3230,
    },
    {
        name: 'Cycle 2 Day 6',
        count: 3250,
    },
    {
        name: 'Cycle 2 Day 7',
        count: 3240,
    },
    {
        name: 'Cycle 3 Day 1',
        count: 1720,
    },
    {
        name: 'Cycle 3 Day 2',
        count: 3270,
    },
    {
        name: 'Cycle 3 Day 3',
        count: 3260,
    },
    {
        name: 'Cycle 3 Day 4',
        count: 3240,
    },
    {
        name: 'Cycle 3 Day 5',
        count: 3230,
    },
    {
        name: 'Cycle 3 Day 6',
        count: 3250,
    },
    {
        name: 'Cycle 3 Day 7',
        count: 3240,
    },
];

export const columnChartData: Column = {
    studyData: [
        { category: '0 - 20', count: 210 },
        { category: '20 - 30', count: 742 },
        { category: '30 - 40', count: 507 },
        { category: '40 - 50', count: 570 },
        { category: '50 - 60', count: 670 },
        { category: '> 60', count: 863 },
    ],
    siteData: {
        123: [
            { category: '0 - 20', count: 50 },
            { category: '20 - 30', count: 25 },
            { category: '30 - 40', count: 272 },
            { category: '40 - 50', count: 367 },
            { category: '50 - 60', count: 333 },
            { category: '> 60', count: 300 },
        ],
    },
    plotTitle: 'Subject Assessments - Age at Enrollment',
    xTitle: 'Age groups',
    yTitle: 'Total',
    flagFieldForStudy: undefined,
    isSortFieldPercentPopulation: false,
};

export const triOpData: components['schemas']['TRIOpResultDto'] = {
    threshold1: 1,
    threshold2: 1.3706441393875386,
    points: [
        {
            x: 10,
            y: 2.9,
            trend: 0,
            color: 1,
            score: 100,
            siteId: 1747163328,
            siteName: '1024',
            yVolume: 29,
            isHighlighted: true,
        },
        {
            x: 25,
            y: 1.5599999999999996,
            trend: 0,
            color: 1,
            score: 56.19070634537045,
            siteId: -1435102131,
            siteName: '1025',
            yVolume: 39,
            isHighlighted: false,
        },
        {
            x: 35,
            y: 1.2000000000000002,
            trend: 0,
            color: 2,
            score: 38.490028490028536,
            siteId: 680143559,
            siteName: '1026',
            yVolume: 42,
            isHighlighted: false,
        },
        {
            x: 41,
            y: 0.9285714285714286,
            trend: 3,
            color: 3,
            score: 23.285714285714285,
            siteId: -298730457,
            siteName: '1027',
            yVolume: 13,
            isHighlighted: true,
        },
        {
            x: 54,
            y: 1.4736842105263155,
            trend: 4,
            color: 1,
            score: 53.36874084680044,
            siteId: 1983462224,
            siteName: '1028',
            yVolume: 28,
            isHighlighted: true,
        },
        {
            x: 60,
            y: 0.761904761904762,
            trend: 2,
            color: 3,
            score: 19.28571428571429,
            siteId: -461855092,
            siteName: '1029',
            yVolume: 16,
            isHighlighted: true,
        },
        {
            x: 70,
            y: 1.625,
            trend: 1,
            color: 1,
            score: 58.31578402264727,
            siteId: 785402935,
            siteName: '1030',
            yVolume: 39,
            isHighlighted: true,
        },
        {
            x: 71,
            y: 0.7916666666666665,
            trend: 2,
            color: 3,
            score: 19.999999999999996,
            siteId: 1693086827,
            siteName: '1031',
            yVolume: 19,
            isHighlighted: false,
        },
        {
            x: 73,
            y: 1.6400000000000001,
            trend: 1,
            color: 1,
            score: 58.806186563557304,
            siteId: -595690411,
            siteName: '1032',
            yVolume: 41,
            isHighlighted: false,
        },
        {
            x: 84,
            y: 2.344827586206896,
            trend: 1,
            color: 1,
            score: 81.84946917551373,
            siteId: -1651347517,
            siteName: '1033',
            yVolume: 68,
            isHighlighted: false,
        },
        {
            x: 95,
            y: 0.875,
            trend: 2,
            color: 3,
            score: 22,
            siteId: -1819224614,
            siteName: '1034',
            yVolume: 28,
            isHighlighted: false,
        },
        {
            x: 96,
            y: 1.242424242424243,
            trend: 1,
            color: 2,
            score: 41.35154968488311,
            siteId: 1543663447,
            siteName: '1035',
            yVolume: 41,
            isHighlighted: false,
        },
        {
            x: 100,
            y: 1.8529411764705874,
            trend: 1,
            color: 1,
            score: 65.76797949726048,
            siteId: 965375833,
            siteName: '1036',
            yVolume: 63,
            isHighlighted: false,
        },
        {
            x: 101,
            y: 2.5882352941176476,
            trend: 1,
            color: 1,
            score: 89.80731973794838,
            siteId: 1748921110,
            siteName: '1037',
            yVolume: 88,
            isHighlighted: false,
        },
        {
            x: 103,
            y: 0.942857142857143,
            trend: 1,
            color: 3,
            score: 23.62857142857143,
            siteId: -134961343,
            siteName: '1038',
            yVolume: 33,
            isHighlighted: false,
        },
        {
            x: 105,
            y: 1.333333333333333,
            trend: 1,
            color: 2,
            score: 47.48338081671419,
            siteId: 2094368946,
            siteName: '1039',
            yVolume: 48,
            isHighlighted: false,
        },
        {
            x: 108,
            y: 1.189189189189189,
            trend: 1,
            color: 2,
            score: 37.76083776083779,
            siteId: -2104066076,
            siteName: '1040',
            yVolume: 44,
            isHighlighted: false,
        },
        {
            x: 116,
            y: 2.0512820512820515,
            trend: 1,
            color: 1,
            score: 72.25243742885118,
            siteId: -1544458353,
            siteName: '1041',
            yVolume: 80,
            isHighlighted: false,
        },
        {
            x: 124,
            y: 2,
            trend: 1,
            color: 1,
            score: 70.57584754539808,
            siteId: 792688751,
            siteName: '1042',
            yVolume: 84,
            isHighlighted: false,
        },
        {
            x: 134,
            y: 1.2222222222222228,
            trend: 1,
            color: 2,
            score: 39.98892054447618,
            siteId: -1177169384,
            siteName: '1043',
            yVolume: 55,
            isHighlighted: false,
        },
        {
            x: 263,
            y: 0.6250000000000002,
            trend: 1,
            color: 3,
            score: 16.000000000000007,
            siteId: -211351795,
            siteName: '1044',
            yVolume: 55,
            isHighlighted: false,
        },
    ],
};

export const ratePoisson: components['schemas']['RateGroupResultDto'] = {
    points: [
        {
            x: 28900,
            y: 0.0003460207612456743,
            pValue: 0.6137018862555563,
            color: 3,
            score: 14.244506756952354,
            siteId: -1403213701,
            siteName: '1002',
            n: 10,
            direction: 0,
        },
        {
            x: 31700,
            y: 0.00006309148264984226,
            pValue: 0.06432929345178698,
            color: 2,
            score: 46.04202737037617,
            siteId: -2014607286,
            siteName: '1003',
            n: 2,
            direction: 1,
        },
        {
            x: 14500,
            y: 1.4214852566332503e-14,
            pValue: 0.9995528519240983,
            color: 3,
            score: 1.0153307911737741,
            siteId: -965667435,
            siteName: '1004',
            n: 0,
            direction: 1,
        },
        {
            x: 34800,
            y: 0.0004597701149425286,
            pValue: 0.22651966909790094,
            color: 2,
            score: 31.560743830544563,
            siteId: -1125183696,
            siteName: '1005',
            n: 16,
            direction: 0,
        },
        {
            x: 32600,
            y: 0.0012269938650306758,
            pValue: 0.00010166250262188823,
            color: 1,
            score: 99.74584374344528,
            siteId: -19677509,
            siteName: '1006',
            n: 40,
            direction: 0,
        },
        {
            x: 23400,
            y: 0.00004273504273504278,
            pValue: 0.08079114187411839,
            color: 2,
            score: 44.57221947552515,
            siteId: 1530503918,
            siteName: '1007',
            n: 1,
            direction: 1,
        },
        {
            x: 18600,
            y: 0.00010752688172043003,
            pValue: 0.23979593988362602,
            color: 2,
            score: 30.375362510390538,
            siteId: 1142586157,
            siteName: '1008',
            n: 2,
            direction: 1,
        },
        {
            x: 28200,
            y: 0.0004964539007092192,
            pValue: 0.17549073600325837,
            color: 2,
            score: 36.116898571137654,
            siteId: -577595628,
            siteName: '1009',
            n: 14,
            direction: 0,
        },
        {
            x: 32900,
            y: 0.00045592705167173375,
            pValue: 0.23920253036977368,
            color: 2,
            score: 30.428345502698782,
            siteId: 1694760655,
            siteName: '1010',
            n: 15,
            direction: 0,
        },
        {
            x: 33800,
            y: 0.00002958579881656811,
            pValue: 0.03636627390888323,
            color: 2,
            score: 48.538725543849715,
            siteId: 2146563712,
            siteName: '1011',
            n: 1,
            direction: 1,
        },
        {
            x: 23100,
            y: 0.0002597402597402596,
            pValue: 0.9301043697960512,
            color: 3,
            score: 3.396421606992533,
            siteId: -378187523,
            siteName: '1012',
            n: 6,
            direction: 1,
        },
        {
            x: 50000,
            y: 0.000039999999999999996,
            pValue: 0.015252867154192938,
            color: 1,
            score: 61.867832114517654,
            siteId: 1756122510,
            siteName: '1013',
            n: 2,
            direction: 1,
        },
    ],
};
export const ratePoissonHigherPurple: components['schemas']['RateGroupResultDto'] = {
    points: [
        {
            x: 9.494866529774127,
            y: 1.0532006920415227,
            pValue: 0.6137018862555714,
            color: 3,
            score: 17.876801872028217,
            siteId: -1403213701,
            siteName: '1002',
            n: 10,
            direction: 0,
        },
        {
            x: 10.414784394250514,
            y: 0.19203470031545739,
            pValue: 0.0643292934517849,
            color: 1,
            score: 74.26828261928604,
            siteId: -2014607286,
            siteName: '1003',
            n: 2,
            direction: 1,
        },
        {
            x: 4.763860369609857,
            y: 4.3266457506726074e-11,
            pValue: 0.9995528519240856,
            color: 1,
            score: 99.992,
            siteId: -965667435,
            siteName: '1004',
            n: 0,
            direction: 1,
        },
        {
            x: 11.433264887063656,
            y: 1.3994252873563215,
            pValue: 0.22651966909790922,
            color: 3,
            score: 7.2292909001925025,
            siteId: -1125183696,
            siteName: '1005',
            n: 16,
            direction: 0,
        },
        {
            x: 15.710472279260781,
            y: 3.734662576687116,
            pValue: 0.00010166250262189878,
            color: 4,
            score: 1.0027957188221066,
            siteId: -19677509,
            siteName: '1006',
            n: 40,
            direction: 0,
        },
        {
            x: 7.687885010266941,
            y: 0.13007478632478633,
            pValue: 0.08079114187411601,
            color: 1,
            score: 67.6835432503536,
            siteId: 1530503918,
            siteName: '1007',
            n: 1,
            direction: 1,
        },
        {
            x: 6.11088295687885,
            y: 0.3272849462365592,
            pValue: 0.23979593988362027,
            color: 2,
            score: 53.01020300581899,
            siteId: 1142586157,
            siteName: '1008',
            n: 2,
            direction: 1,
        },
        {
            x: 9.264887063655031,
            y: 1.5110815602836882,
            pValue: 0.17549073600326576,
            color: 3,
            score: 5.82599524008981,
            siteId: -577595628,
            siteName: '1009',
            n: 14,
            direction: 0,
        },
        {
            x: 10.809034907597535,
            y: 1.3877279635258357,
            pValue: 0.23920253036978256,
            color: 3,
            score: 7.578069585169018,
            siteId: 1694760655,
            siteName: '1010',
            n: 15,
            direction: 0,
        },
        {
            x: 11.104722792607802,
            y: 0.09005177514792895,
            pValue: 0.03636627390888244,
            color: 1,
            score: 85.45349043644703,
            siteId: 2146563712,
            siteName: '1011',
            n: 1,
            direction: 1,
        },
        {
            x: 7.5893223819301845,
            y: 0.7905844155844154,
            pValue: 0.9301043697960365,
            color: 3,
            score: 30.422129830608995,
            siteId: -378187523,
            siteName: '1012',
            n: 6,
            direction: 1,
        },
        {
            x: 16.427104722792606,
            y: 0.12175000000000005,
            pValue: 0.015252867154192381,
            color: 1,
            score: 93.89885313832305,
            siteId: 1756122510,
            siteName: '1013',
            n: 2,
            direction: 1,
        },
    ],
};
export const ratePoissonLowerPurple: components['schemas']['RateGroupResultDto'] = {
    points: [
        {
            x: 9.494866529774127,
            y: 1.0532006920415227,
            pValue: 0.6137018862555714,
            color: 3,
            score: 39.12319812797179,
            siteId: -1403213701,
            siteName: '1002',
            n: 10,
            direction: 0,
        },
        {
            x: 10.414784394250514,
            y: 0.19203470031545739,
            pValue: 0.0643292934517849,
            color: 3,
            score: 2.7690555699240846,
            siteId: -2014607286,
            siteName: '1003',
            n: 2,
            direction: 1,
        },
        {
            x: 4.763860369609857,
            y: 4.3266457506726074e-11,
            pValue: 0.9995528519240856,
            color: 3,
            score: 28.487703427912358,
            siteId: -965667435,
            siteName: '1004',
            n: 0,
            direction: 1,
        },
        {
            x: 11.433264887063656,
            y: 1.3994252873563215,
            pValue: 0.22651966909790922,
            color: 2,
            score: 53.67401654510454,
            siteId: -1125183696,
            siteName: '1005',
            n: 16,
            direction: 0,
        },
        {
            x: 10.710472279260781,
            y: 3.734662576687116,
            pValue: 0.00010166250262189878,
            color: 1,
            score: 99.95933499895123,
            siteId: -19677509,
            siteName: '1006',
            n: 40,
            direction: 0,
        },
        {
            x: 7.687885010266941,
            y: 0.13007478632478633,
            pValue: 0.08079114187411601,
            color: 3,
            score: 3.221756401538194,
            siteId: 1530503918,
            siteName: '1007',
            n: 1,
            direction: 1,
        },
        {
            x: 6.11088295687885,
            y: 0.3272849462365592,
            pValue: 0.23979593988362027,
            color: 3,
            score: 7.594388346799555,
            siteId: 1142586157,
            siteName: '1008',
            n: 2,
            direction: 1,
        },
        {
            x: 9.264887063655031,
            y: 1.5110815602836882,
            pValue: 0.17549073600326576,
            color: 2,
            score: 56.22546319983671,
            siteId: -577595628,
            siteName: '1009',
            n: 14,
            direction: 0,
        },
        {
            x: 10.809034907597535,
            y: 1.3877279635258357,
            pValue: 0.23920253036978256,
            color: 2,
            score: 53.039873481510874,
            siteId: 1694760655,
            siteName: '1010',
            n: 15,
            direction: 0,
        },
        {
            x: 11.104722792607802,
            y: 0.09005177514792895,
            pValue: 0.03636627390888244,
            color: 4,
            score: 2.000072532494265,
            siteId: 2146563712,
            siteName: '1011',
            n: 1,
            direction: 1,
        },
        {
            x: 7.5893223819301845,
            y: 0.7905844155844154,
            pValue: 0.9301043697960365,
            color: 3,
            score: 26.577870169391005,
            siteId: -378187523,
            siteName: '1012',
            n: 6,
            direction: 1,
        },
        {
            x: 16.427104722792606,
            y: 0.12175000000000005,
            pValue: 0.015252867154192381,
            color: 4,
            score: 1.4194538467402893,
            siteId: 1756122510,
            siteName: '1013',
            n: 2,
            direction: 1,
        },
    ],
};
export const rateNegativeBinomial: components['schemas']['RateGroupResultDto'] = {
    points: [
        {
            x: 1,
            y: 7.0,
            pValue: 1,
            color: 3,
            score: 1,
            siteId: 1,
            n: 0,
            direction: 1,
            siteName: 'Foo',
            isHighlighted: null,
        },
        {
            x: 12,
            y: 8.0,
            pValue: 1,
            color: 3,
            score: 1,
            siteId: 3,
            n: 0,
            direction: 1,
            siteName: 'Foobar',
            isHighlighted: null,
        },
        {
            x: 19,
            y: 5.0,
            pValue: 1,
            color: 3,
            score: 1,
            siteId: 4,
            n: 0,
            direction: 1,
            siteName: 'Baz',
            isHighlighted: null,
        },
        {
            x: 17,
            y: 5.7,
            pValue: 1,
            color: 3,
            score: 1,
            siteId: 5,
            n: 0,
            direction: 1,
            siteName: 'Foobarbaz',
            isHighlighted: null,
        },
        {
            x: 19,
            y: 5.0,
            pValue: 1,
            color: 3,
            score: 1,
            siteId: 6,
            n: 0,
            direction: 1,
            siteName: 'Barbaz',
            isHighlighted: null,
        },
    ],
};

export const funnelData: components['schemas']['FunnelResultDto'] = {
    benchmark: 0.8461538461538461,
    points: [
        {
            x: 13,
            y: 5,
            color: 1,
            score: 100,
            siteId: -1311143400,
            n: 5,
            direction: 1,
            siteName: '-1311143400',
        },
        {
            x: 16,
            y: 12,
            color: 1,
            score: 50,
            siteId: -468895377,
            n: 12,
            direction: 1,
            siteName: '-468895377',
        },
        {
            x: 16,
            y: 12,
            color: 1,
            score: 50,
            siteId: -701288535,
            n: 12,
            direction: 1,
            siteName: '-701288535',
        },
        {
            x: 17,
            y: 13,
            color: 1,
            score: 50,
            siteId: -344091912,
            n: 13,
            direction: 1,
            siteName: '-344091912',
        },
        {
            x: 17,
            y: 14,
            color: 3,
            score: 1,
            siteId: -1189692091,
            n: 14,
            direction: 2,
            siteName: '-1189692091',
        },
        {
            x: 17,
            y: 10,
            color: 1,
            score: 100,
            siteId: -1908833431,
            n: 10,
            direction: 1,
            siteName: '-1908833431',
        },
        {
            x: 20,
            y: 15,
            color: 1,
            score: 100,
            siteId: 1206193796,
            n: 15,
            direction: 1,
            siteName: '1206193796',
        },
        {
            x: 20,
            y: 20,
            color: 1,
            score: 100,
            siteId: -122409000,
            n: 20,
            direction: 0,
            siteName: '-122409000',
        },
        {
            x: 22,
            y: 20,
            color: 1,
            score: 50,
            siteId: -2018434025,
            n: 20,
            direction: 0,
            siteName: '-2018434025',
        },
        {
            x: 22,
            y: 20,
            color: 1,
            score: 50,
            siteId: -1509199347,
            n: 20,
            direction: 0,
            siteName: '-1509199347',
        },
        {
            x: 22,
            y: 19,
            color: 3,
            score: 13,
            siteId: -2032165223,
            n: 19,
            direction: 0,
            siteName: '-2032165223',
        },
        {
            x: 23,
            y: 21,
            color: 1,
            score: 50,
            siteId: 1908831653,
            n: 21,
            direction: 0,
            siteName: '1908831653',
        },
        {
            x: 24,
            y: 21,
            color: 3,
            score: 13,
            siteId: -1210414056,
            n: 21,
            direction: 0,
            siteName: '-1210414056',
        },
        {
            x: 26,
            y: 21,
            color: 3,
            score: 1,
            siteId: -1881783311,
            n: 21,
            direction: 2,
            siteName: '-1881783311',
        },
        {
            x: 26,
            y: 22,
            color: 3,
            score: 9,
            siteId: 286968783,
            n: 22,
            direction: 0,
            siteName: '286968783',
        },
        {
            x: 26,
            y: 22,
            color: 3,
            score: 9,
            siteId: 871666759,
            n: 22,
            direction: 0,
            siteName: '871666759',
        },
        {
            x: 28,
            y: 23,
            color: 3,
            score: 1,
            siteId: -243064209,
            n: 23,
            direction: 2,
            siteName: '-243064209',
        },
        {
            x: 27,
            y: 27,
            color: 1,
            score: 100,
            siteId: -1208744759,
            n: 27,
            direction: 0,
            siteName: '-1208744759',
        },
        {
            x: 28,
            y: 25,
            color: 2,
            score: 25,
            siteId: 800151098,
            n: 25,
            direction: 0,
            siteName: '800151098',
        },
        {
            x: 29,
            y: 15,
            color: 1,
            score: 100,
            siteId: 55004980,
            n: 15,
            direction: 1,
            siteName: '55004980',
        },
        {
            x: 29,
            y: 27,
            color: 1,
            score: 100,
            siteId: -1677111757,
            n: 27,
            direction: 0,
            siteName: '-1677111757',
        },
    ],
    lowerLimitAmberPoints: [
        {
            x: 1,
            y: 1,
        },
        {
            x: 2,
            y: 1,
        },
        {
            x: 3,
            y: 2,
        },
        {
            x: 4,
            y: 3,
        },
        {
            x: 5,
            y: 4,
        },
        {
            x: 6,
            y: 4,
        },
        {
            x: 7,
            y: 5,
        },
        {
            x: 8,
            y: 6,
        },
        {
            x: 9,
            y: 7,
        },
        {
            x: 10,
            y: 7,
        },
        {
            x: 11,
            y: 8,
        },
        {
            x: 12,
            y: 9,
        },
        {
            x: 13,
            y: 10,
        },
        {
            x: 14,
            y: 11,
        },
        {
            x: 15,
            y: 11,
        },
        {
            x: 16,
            y: 12,
        },
        {
            x: 17,
            y: 13,
        },
        {
            x: 18,
            y: 14,
        },
        {
            x: 19,
            y: 15,
        },
        {
            x: 20,
            y: 15,
        },
        {
            x: 21,
            y: 16,
        },
        {
            x: 22,
            y: 17,
        },
        {
            x: 23,
            y: 18,
        },
        {
            x: 24,
            y: 19,
        },
        {
            x: 25,
            y: 19,
        },
        {
            x: 26,
            y: 20,
        },
        {
            x: 27,
            y: 21,
        },
        {
            x: 28,
            y: 22,
        },
        {
            x: 29,
            y: 23,
        },
        {
            x: 30,
            y: 24,
        },
    ],
    upperLimitAmberPoints: [
        {
            x: 1,
            y: 1,
        },
        {
            x: 2,
            y: 2,
        },
        {
            x: 3,
            y: 3,
        },
        {
            x: 4,
            y: 4,
        },
        {
            x: 5,
            y: 5,
        },
        {
            x: 6,
            y: 6,
        },
        {
            x: 7,
            y: 7,
        },
        {
            x: 8,
            y: 8,
        },
        {
            x: 9,
            y: 9,
        },
        {
            x: 10,
            y: 10,
        },
        {
            x: 11,
            y: 10,
        },
        {
            x: 12,
            y: 11,
        },
        {
            x: 13,
            y: 12,
        },
        {
            x: 14,
            y: 13,
        },
        {
            x: 15,
            y: 14,
        },
        {
            x: 16,
            y: 15,
        },
        {
            x: 17,
            y: 16,
        },
        {
            x: 18,
            y: 17,
        },
        {
            x: 19,
            y: 18,
        },
        {
            x: 20,
            y: 18,
        },
        {
            x: 21,
            y: 19,
        },
        {
            x: 22,
            y: 20,
        },
        {
            x: 23,
            y: 21,
        },
        {
            x: 24,
            y: 22,
        },
        {
            x: 25,
            y: 23,
        },
        {
            x: 26,
            y: 24,
        },
        {
            x: 27,
            y: 25,
        },
        {
            x: 28,
            y: 25,
        },
        {
            x: 29,
            y: 26,
        },
        {
            x: 30,
            y: 27,
        },
    ],
    lowerLimitRedPoints: [
        {
            x: 1,
            y: 0,
        },
        {
            x: 2,
            y: 1,
        },
        {
            x: 3,
            y: 2,
        },
        {
            x: 4,
            y: 3,
        },
        {
            x: 5,
            y: 3,
        },
        {
            x: 6,
            y: 4,
        },
        {
            x: 7,
            y: 5,
        },
        {
            x: 8,
            y: 6,
        },
        {
            x: 9,
            y: 6,
        },
        {
            x: 10,
            y: 7,
        },
        {
            x: 11,
            y: 8,
        },
        {
            x: 12,
            y: 9,
        },
        {
            x: 13,
            y: 10,
        },
        {
            x: 14,
            y: 10,
        },
        {
            x: 15,
            y: 11,
        },
        {
            x: 16,
            y: 12,
        },
        {
            x: 17,
            y: 13,
        },
        {
            x: 18,
            y: 13,
        },
        {
            x: 19,
            y: 14,
        },
        {
            x: 20,
            y: 15,
        },
        {
            x: 21,
            y: 16,
        },
        {
            x: 22,
            y: 17,
        },
        {
            x: 23,
            y: 17,
        },
        {
            x: 24,
            y: 18,
        },
        {
            x: 25,
            y: 19,
        },
        {
            x: 26,
            y: 20,
        },
        {
            x: 27,
            y: 21,
        },
        {
            x: 28,
            y: 21,
        },
        {
            x: 29,
            y: 22,
        },
        {
            x: 30,
            y: 23,
        },
    ],
    upperLimitRedPoints: [
        {
            x: 1,
            y: 1,
        },
        {
            x: 2,
            y: 2,
        },
        {
            x: 3,
            y: 3,
        },
        {
            x: 4,
            y: 4,
        },
        {
            x: 5,
            y: 5,
        },
        {
            x: 6,
            y: 6,
        },
        {
            x: 7,
            y: 7,
        },
        {
            x: 8,
            y: 8,
        },
        {
            x: 9,
            y: 9,
        },
        {
            x: 10,
            y: 10,
        },
        {
            x: 11,
            y: 11,
        },
        {
            x: 12,
            y: 11,
        },
        {
            x: 13,
            y: 12,
        },
        {
            x: 14,
            y: 13,
        },
        {
            x: 15,
            y: 14,
        },
        {
            x: 16,
            y: 15,
        },
        {
            x: 17,
            y: 16,
        },
        {
            x: 18,
            y: 17,
        },
        {
            x: 19,
            y: 18,
        },
        {
            x: 20,
            y: 19,
        },
        {
            x: 21,
            y: 20,
        },
        {
            x: 22,
            y: 20,
        },
        {
            x: 23,
            y: 21,
        },
        {
            x: 24,
            y: 22,
        },
        {
            x: 25,
            y: 23,
        },
        {
            x: 26,
            y: 24,
        },
        {
            x: 27,
            y: 25,
        },
        {
            x: 28,
            y: 26,
        },
        {
            x: 29,
            y: 27,
        },
        {
            x: 30,
            y: 28,
        },
    ],
    lowerLimitBigRedPoints: [
        {
            x: 1,
            y: 0,
        },
        {
            x: 2,
            y: 1,
        },
        {
            x: 3,
            y: 2,
        },
        {
            x: 4,
            y: 2,
        },
        {
            x: 5,
            y: 3,
        },
        {
            x: 6,
            y: 4,
        },
        {
            x: 7,
            y: 5,
        },
        {
            x: 8,
            y: 5,
        },
        {
            x: 9,
            y: 6,
        },
        {
            x: 10,
            y: 7,
        },
        {
            x: 11,
            y: 8,
        },
        {
            x: 12,
            y: 8,
        },
        {
            x: 13,
            y: 9,
        },
        {
            x: 14,
            y: 10,
        },
        {
            x: 15,
            y: 11,
        },
        {
            x: 16,
            y: 11,
        },
        {
            x: 17,
            y: 12,
        },
        {
            x: 18,
            y: 13,
        },
        {
            x: 19,
            y: 14,
        },
        {
            x: 20,
            y: 15,
        },
        {
            x: 21,
            y: 15,
        },
        {
            x: 22,
            y: 16,
        },
        {
            x: 23,
            y: 17,
        },
        {
            x: 24,
            y: 18,
        },
        {
            x: 25,
            y: 19,
        },
        {
            x: 26,
            y: 19,
        },
        {
            x: 27,
            y: 20,
        },
        {
            x: 28,
            y: 21,
        },
        {
            x: 29,
            y: 22,
        },
        {
            x: 30,
            y: 23,
        },
    ],
    upperLimitBigRedPoints: [
        {
            x: 1,
            y: 1,
        },
        {
            x: 2,
            y: 2,
        },
        {
            x: 3,
            y: 3,
        },
        {
            x: 4,
            y: 4,
        },
        {
            x: 5,
            y: 5,
        },
        {
            x: 6,
            y: 6,
        },
        {
            x: 7,
            y: 7,
        },
        {
            x: 8,
            y: 8,
        },
        {
            x: 9,
            y: 9,
        },
        {
            x: 10,
            y: 10,
        },
        {
            x: 11,
            y: 11,
        },
        {
            x: 12,
            y: 12,
        },
        {
            x: 13,
            y: 13,
        },
        {
            x: 14,
            y: 14,
        },
        {
            x: 15,
            y: 14,
        },
        {
            x: 16,
            y: 15,
        },
        {
            x: 17,
            y: 16,
        },
        {
            x: 18,
            y: 17,
        },
        {
            x: 19,
            y: 18,
        },
        {
            x: 20,
            y: 19,
        },
        {
            x: 21,
            y: 20,
        },
        {
            x: 22,
            y: 21,
        },
        {
            x: 23,
            y: 22,
        },
        {
            x: 24,
            y: 23,
        },
        {
            x: 25,
            y: 23,
        },
        {
            x: 26,
            y: 24,
        },
        {
            x: 27,
            y: 25,
        },
        {
            x: 28,
            y: 26,
        },
        {
            x: 29,
            y: 27,
        },
        {
            x: 30,
            y: 28,
        },
    ],
    benchmarkLine: [
        {
            x: 1,
            y: 0,
        },
        {
            x: 2,
            y: 1,
        },
        {
            x: 3,
            y: 2,
        },
        {
            x: 4,
            y: 3,
        },
        {
            x: 5,
            y: 4,
        },
        {
            x: 6,
            y: 5,
        },
        {
            x: 7,
            y: 5,
        },
        {
            x: 8,
            y: 6,
        },
        {
            x: 9,
            y: 7,
        },
        {
            x: 10,
            y: 8,
        },
        {
            x: 11,
            y: 9,
        },
        {
            x: 12,
            y: 10,
        },
        {
            x: 13,
            y: 10,
        },
        {
            x: 14,
            y: 11,
        },
        {
            x: 15,
            y: 12,
        },
        {
            x: 16,
            y: 13,
        },
        {
            x: 17,
            y: 14,
        },
        {
            x: 18,
            y: 15,
        },
        {
            x: 19,
            y: 16,
        },
        {
            x: 20,
            y: 16,
        },
        {
            x: 21,
            y: 17,
        },
        {
            x: 22,
            y: 18,
        },
        {
            x: 23,
            y: 19,
        },
        {
            x: 24,
            y: 20,
        },
        {
            x: 25,
            y: 21,
        },
        {
            x: 26,
            y: 21,
        },
        {
            x: 27,
            y: 22,
        },
        {
            x: 28,
            y: 23,
        },
        {
            x: 29,
            y: 24,
        },
        {
            x: 30,
            y: 25,
        },
    ],
};

export const funnelDataAprox: components['schemas']['FunnelResultDto'] = {
    benchmark: 0.8631375741809205,
    points: [
        {
            x: 127,
            y: 0.9212598425196851,
            color: 3,
            score: 23.814812579880094,
            siteId: -1311143400,
            n: 117,
            direction: 0,
            siteName: '-1311143400',
        },
        {
            x: 162,
            y: 0.7345679012345679,
            color: 1,
            score: 100,
            siteId: -468895377,
            n: 119,
            direction: 1,
            siteName: '-468895377',
        },
        {
            x: 164,
            y: 0.7439024390243902,
            color: 1,
            score: 100,
            siteId: -701288535,
            n: 122,
            direction: 1,
            siteName: '-701288535',
        },
        {
            x: 171,
            y: 0.7719298245614035,
            color: 1,
            score: 100,
            siteId: -344091912,
            n: 132,
            direction: 1,
            siteName: '-344091912',
        },
        {
            x: 173,
            y: 0.8092485549132948,
            color: 2,
            score: 28.742701862930765,
            siteId: -1189692091,
            n: 140,
            direction: 1,
            siteName: '-1189692091',
        },
        {
            x: 175,
            y: 0.8742857142857143,
            color: 3,
            score: 6.136870559336181,
            siteId: -1908833431,
            n: 153,
            direction: 0,
            siteName: '-1908833431',
        },
        {
            x: 198,
            y: 0.9292929292929293,
            color: 1,
            score: 72.10150036949403,
            siteId: 1206193796,
            n: 184,
            direction: 0,
            siteName: '1206193796',
        },
        {
            x: 203,
            y: 0.9064039408866995,
            color: 3,
            score: 22.472239238250474,
            siteId: -122409000,
            n: 184,
            direction: 0,
            siteName: '-122409000',
        },
        {
            x: 218,
            y: 0.8944954128440367,
            color: 3,
            score: 17.12701521589981,
            siteId: -2018434025,
            n: 195,
            direction: 0,
            siteName: '-2018434025',
        },
        {
            x: 218,
            y: 0.9311926605504587,
            color: 1,
            score: 87.81626601638342,
            siteId: -1509199347,
            n: 203,
            direction: 0,
            siteName: '-1509199347',
        },
        {
            x: 221,
            y: 0.9276018099547512,
            color: 1,
            score: 77.93463951585133,
            siteId: -2032165223,
            n: 205,
            direction: 0,
            siteName: '-2032165223',
        },
        {
            x: 234,
            y: 0.8803418803418803,
            color: 3,
            score: 10.166961341831476,
            siteId: 1908831653,
            n: 206,
            direction: 0,
            siteName: '1908831653',
        },
        {
            x: 244,
            y: 0.8565573770491803,
            color: 3,
            score: 4.580259507918917,
            siteId: -1210414056,
            n: 209,
            direction: 1,
            siteName: '-1210414056',
        },
        {
            x: 259,
            y: 0.8223938223938224,
            color: 3,
            score: 23.839789866357954,
            siteId: -1881783311,
            n: 213,
            direction: 1,
            siteName: '-1881783311',
        },
        {
            x: 261,
            y: 0.8352490421455939,
            color: 3,
            score: 16.693766163600785,
            siteId: 286968783,
            n: 218,
            direction: 1,
            siteName: '286968783',
        },
        {
            x: 263,
            y: 0.8403041825095057,
            color: 3,
            score: 13.898215614698767,
            siteId: 871666759,
            n: 221,
            direction: 1,
            siteName: '871666759',
        },
        {
            x: 269,
            y: 0.8661710037174721,
            color: 3,
            score: 2.732972086010326,
            siteId: -243064209,
            n: 233,
            direction: 0,
            siteName: '-243064209',
        },
        {
            x: 271,
            y: 0.8819188191881919,
            color: 3,
            score: 11.769377470359611,
            siteId: -1208744759,
            n: 239,
            direction: 0,
            siteName: '-1208744759',
        },
        {
            x: 277,
            y: 0.8989169675090253,
            color: 3,
            score: 21.742189911903292,
            siteId: 800151098,
            n: 249,
            direction: 0,
            siteName: '800151098',
        },
        {
            x: 289,
            y: 0.8788927335640139,
            color: 3,
            score: 10.329401787562002,
            siteId: 55004980,
            n: 254,
            direction: 0,
            siteName: '55004980',
        },
        {
            x: 291,
            y: 0.9209621993127147,
            color: 1,
            score: 83.90507889577975,
            siteId: -1677111757,
            n: 268,
            direction: 0,
            siteName: '-1677111757',
        },
    ],
    lowerLimitAmberPoints: [
        {
            x: 0.26,
            y: -0.4881101609769979,
        },
        {
            x: 0.27,
            y: -0.4628509667170616,
        },
        {
            x: 0.28,
            y: -0.4389573242424475,
        },
        {
            x: 0.29,
            y: -0.41631046799228366,
        },
        {
            x: 0.3,
            y: -0.3948056079753658,
        },
        {
            x: 0.31,
            y: -0.3743498840286371,
        },
        {
            x: 0.32,
            y: -0.3548606745606945,
        },
        {
            x: 0.33,
            y: -0.3362641894016519,
        },
        {
            x: 0.34,
            y: -0.3184942920259056,
        },
        {
            x: 0.35000000000000003,
            y: -0.3014915082312134,
        },
        {
            x: 0.36,
            y: -0.2852021873637932,
        },
        {
            x: 0.37,
            y: -0.2695777891016379,
        },
        {
            x: 0.38,
            y: -0.2545742741715461,
        },
        {
            x: 0.39,
            y: -0.24015158156185346,
        },
        {
            x: 0.4,
            y: -0.22627317808385905,
        },
        {
            x: 0.41000000000000003,
            y: -0.21290566873929617,
        },
        {
            x: 0.42,
            y: -0.20001845842519417,
        },
        {
            x: 0.43,
            y: -0.1875834571689975,
        },
        {
            x: 0.44,
            y: -0.17557482242544487,
        },
        {
            x: 0.45,
            y: -0.163968733051031,
        },
        {
            x: 0.46,
            y: -0.15274319045468376,
        },
        {
            x: 0.47000000000000003,
            y: -0.14187784314556307,
        },
        {
            x: 0.48,
            y: -0.1313538314925662,
        },
        {
            x: 0.49,
            y: -0.12115365000026257,
        },
        {
            x: 0.5,
            y: -0.11126102481237143,
        },
        {
            x: 0.51,
            y: -0.10166080449220138,
        },
        {
            x: 0.52,
            y: -0.09233886241220768,
        },
        {
            x: 0.53,
            y: -0.08328200932198915,
        },
        {
            x: 0.54,
            y: -0.07447791486369837,
        },
        {
            x: 0.55,
            y: -0.06591503697250123,
        },
        {
            x: 0.56,
            y: -0.05758255824265179,
        },
        {
            x: 0.5700000000000001,
            y: -0.04947032846127741,
        },
        {
            x: 0.58,
            y: -0.04156881261560408,
        },
        {
            x: 0.59,
            y: -0.033869043767990936,
        },
        {
            x: 0.6,
            y: -0.02636258026917393,
        },
        {
            x: 0.61,
            y: -0.019041466845504895,
        },
        {
            x: 0.62,
            y: -0.011898199152362121,
        },
        {
            x: 0.63,
            y: -0.004925691434658264,
        },
        {
            x: 0.64,
            y: 0.001882753022385275,
        },
        {
            x: 0.65,
            y: 0.008533468932319654,
        },
        {
            x: 0.66,
            y: 0.01503245378457918,
        },
        {
            x: 0.67,
            y: 0.021385390579902297,
        },
        {
            x: 0.68,
            y: 0.0275976687199585,
        },
        {
            x: 0.6900000000000001,
            y: 0.033674403225705696,
        },
        {
            x: 0.7000000000000001,
            y: 0.039620452440234155,
        },
        {
            x: 0.71,
            y: 0.04544043435533884,
        },
        {
            x: 0.72,
            y: 0.05113874168651045,
        },
        {
            x: 0.73,
            y: 0.05671955580817467,
        },
        {
            x: 0.74,
            y: 0.06218685964963977,
        },
        {
            x: 0.75,
            y: 0.06754444964213124,
        },
        {
            x: 0.76,
            y: 0.07279594679834134,
        },
        {
            x: 0.77,
            y: 0.07794480699796802,
        },
        {
            x: 0.78,
            y: 0.0829943305456241,
        },
        {
            x: 0.79,
            y: 0.08794767106118084,
        },
        {
            x: 0.8,
            y: 0.09280784375695694,
        },
        {
            x: 0.81,
            y: 0.0975777331511114,
        },
        {
            x: 0.8200000000000001,
            y: 0.10226010026207177,
        },
        {
            x: 0.8300000000000001,
            y: 0.10685758932476264,
        },
        {
            x: 0.84,
            y: 0.11137273406575043,
        },
        {
            x: 0.85,
            y: 0.11580796357113687,
        },
        {
            x: 0.86,
            y: 0.12016560777807062,
        },
        {
            x: 0.87,
            y: 0.12444790261808136,
        },
        {
            x: 0.88,
            y: 0.12865699483802906,
        },
        {
            x: 0.89,
            y: 0.1327949465222773,
        },
        {
            x: 0.9,
            y: 0.1368637393377341,
        },
        {
            x: 0.91,
            y: 0.14086527852160846,
        },
        {
            x: 0.92,
            y: 0.1448013966301097,
        },
        {
            x: 0.93,
            y: 0.1486738570648466,
        },
        {
            x: 0.9400000000000001,
            y: 0.152484357392336,
        },
        {
            x: 0.9500000000000001,
            y: 0.1562345324708181,
        },
        {
            x: 0.96,
            y: 0.1599259573974563,
        },
        {
            x: 0.97,
            y: 0.16356015028799276,
        },
        {
            x: 0.98,
            y: 0.16713857489999762,
        },
        {
            x: 0.99,
            y: 0.17066264311001034,
        },
        {
            x: 1,
            y: 0.17413371725409232,
        },
        {
            x: 1.01,
            y: 0.177553112340604,
        },
        {
            x: 1.02,
            y: 0.18092209814336946,
        },
        {
            x: 1.03,
            y: 0.18424190118279504,
        },
        {
            x: 1.04,
            y: 0.18751370660196132,
        },
        {
            x: 1.05,
            y: 0.19073865994420824,
        },
        {
            x: 1.06,
            y: 0.19391786883826512,
        },
        {
            x: 1.07,
            y: 0.19705240459655793,
        },
        {
            x: 1.08,
            y: 0.20014330373192946,
        },
        {
            x: 1.09,
            y: 0.20319156939765104,
        },
        {
            x: 1.1,
            y: 0.2061981727552673,
        },
        {
            x: 1.11,
            y: 0.2091640542745108,
        },
        {
            x: 1.12,
            y: 0.21209012496923652,
        },
        {
            x: 1.1300000000000001,
            y: 0.2149772675730669,
        },
        {
            x: 1.1400000000000001,
            y: 0.21782633765818982,
        },
        {
            x: 1.1500000000000001,
            y: 0.2206381647005321,
        },
        {
            x: 1.16,
            y: 0.22341355309431843,
        },
        {
            x: 1.17,
            y: 0.22615328311883498,
        },
        {
            x: 1.18,
            y: 0.22885811186003457,
        },
        {
            x: 1.19,
            y: 0.23152877408945638,
        },
        {
            x: 1.2,
            y: 0.23416598310277736,
        },
        {
            x: 1.21,
            y: 0.23677043152016763,
        },
        {
            x: 1.22,
            y: 0.23934279205048958,
        },
        {
            x: 1.23,
            y: 0.24188371822125554,
        },
        {
            x: 1.24,
            y: 0.2443938450761417,
        },
        {
            x: 1.25,
            y: 0.24687378984174968,
        },
        {
            x: 1.26,
            y: 0.24932415256520557,
        },
        {
            x: 1.27,
            y: 0.25174551672409073,
        },
        {
            x: 1.28,
            y: 0.254138449810113,
        },
        {
            x: 1.29,
            y: 0.25650350388784415,
        },
        {
            x: 1.3,
            y: 0.25884121612977284,
        },
        {
            x: 1.31,
            y: 0.26115210932884925,
        },
        {
            x: 1.32,
            y: 0.2634366923896343,
        },
        {
            x: 1.33,
            y: 0.26569546079909745,
        },
        {
            x: 1.34,
            y: 0.26792889707805667,
        },
        {
            x: 1.35,
            y: 0.27013747121419085,
        },
        {
            x: 1.36,
            y: 0.27232164107750745,
        },
        {
            x: 1.37,
            y: 0.2744818528191013,
        },
        {
            x: 1.3800000000000001,
            y: 0.27661854125399166,
        },
        {
            x: 1.3900000000000001,
            y: 0.2787321302287823,
        },
        {
            x: 1.4000000000000001,
            y: 0.28082303297485356,
        },
        {
            x: 1.41,
            y: 0.28289165244775116,
        },
        {
            x: 1.42,
            y: 0.2849383816534071,
        },
        {
            x: 1.43,
            y: 0.28696360396179166,
        },
        {
            x: 1.44,
            y: 0.28896769340856365,
        },
        {
            x: 1.45,
            y: 0.2909510149852601,
        },
        {
            x: 1.46,
            y: 0.2929139249185341,
        },
        {
            x: 1.47,
            y: 0.29485677093892815,
        },
        {
            x: 1.48,
            y: 0.2967798925396413,
        },
        {
            x: 1.49,
            y: 0.2986836212257289,
        },
        {
            x: 1.5,
            y: 0.3005682807541492,
        },
        {
            x: 1.51,
            y: 0.30243418736505256,
        },
        {
            x: 1.52,
            y: 0.3042816500046872,
        },
        {
            x: 1.53,
            y: 0.30611097054027914,
        },
        {
            x: 1.54,
            y: 0.3079224439672247,
        },
        {
            x: 1.55,
            y: 0.3097163586089202,
        },
        {
            x: 1.56,
            y: 0.31149299630953353,
        },
        {
            x: 1.57,
            y: 0.3132526326200129,
        },
        {
            x: 1.58,
            y: 0.31499553697760985,
        },
        {
            x: 1.59,
            y: 0.31672197287918213,
        },
        {
            x: 1.6,
            y: 0.31843219804853073,
        },
        {
            x: 1.61,
            y: 0.32012646459801075,
        },
        {
            x: 1.62,
            y: 0.3218050191846472,
        },
        {
            x: 1.6300000000000001,
            y: 0.32346810316097485,
        },
        {
            x: 1.6400000000000001,
            y: 0.3251159527208122,
        },
        {
            x: 1.6500000000000001,
            y: 0.32674879904016774,
        },
        {
            x: 1.6600000000000001,
            y: 0.32836686841347196,
        },
        {
            x: 1.67,
            y: 0.3299703823853144,
        },
        {
            x: 1.68,
            y: 0.3315595578778632,
        },
        {
            x: 1.69,
            y: 0.3331346073141297,
        },
        {
            x: 1.7,
            y: 0.33469573873724057,
        },
        {
            x: 1.71,
            y: 0.33624315592586773,
        },
        {
            x: 1.72,
            y: 0.3377770585059615,
        },
        {
            x: 1.73,
            y: 0.33929764205892654,
        },
        {
            x: 1.74,
            y: 0.3408050982263734,
        },
        {
            x: 1.75,
            y: 0.34229961481157334,
        },
        {
            x: 1.76,
            y: 0.3437813758777378,
        },
        {
            x: 1.77,
            y: 0.34525056184324077,
        },
        {
            x: 1.78,
            y: 0.34670734957389204,
        },
        {
            x: 1.79,
            y: 0.3481519124723751,
        },
        {
            x: 1.8,
            y: 0.34958442056494476,
        },
        {
            x: 1.81,
            y: 0.3510050405854891,
        },
        {
            x: 1.82,
            y: 0.35241393605704596,
        },
        {
            x: 1.83,
            y: 0.3538112673708679,
        },
        {
            x: 1.84,
            y: 0.3551971918631184,
        },
        {
            x: 1.85,
            y: 0.3565718638892865,
        },
        {
            x: 1.86,
            y: 0.35793543489639745,
        },
        {
            x: 1.87,
            y: 0.3592880534930962,
        },
        {
            x: 1.8800000000000001,
            y: 0.3606298655176787,
        },
        {
            x: 1.8900000000000001,
            y: 0.3619610141041405,
        },
        {
            x: 1.9000000000000001,
            y: 0.3632816397463102,
        },
        {
            x: 1.9100000000000001,
            y: 0.3645918803601347,
        },
        {
            x: 1.92,
            y: 0.36589187134417717,
        },
        {
            x: 1.93,
            y: 0.3671817456383895,
        },
        {
            x: 1.94,
            y: 0.3684616337812155,
        },
        {
            x: 1.95,
            y: 0.3697316639650815,
        },
        {
            x: 1.96,
            y: 0.370991962090329,
        },
        {
            x: 1.97,
            y: 0.37224265181763777,
        },
        {
            x: 1.98,
            y: 0.3734838546189929,
        },
        {
            x: 1.99,
            y: 0.37471568982723946,
        },
        {
            x: 2,
            y: 0.37593827468427454,
        },
        {
            x: 2.0100000000000002,
            y: 0.37715172438791733,
        },
        {
            x: 2.02,
            y: 0.3783561521375029,
        },
        {
            x: 2.0300000000000002,
            y: 0.3795516691782379,
        },
        {
            x: 2.04,
            y: 0.38073838484435957,
        },
        {
            x: 2.05,
            y: 0.38191640660113574,
        },
        {
            x: 2.06,
            y: 0.38308584008574104,
        },
        {
            x: 2.07,
            y: 0.3842467891470467,
        },
        {
            x: 2.08,
            y: 0.3853993558843564,
        },
        {
            x: 2.09,
            y: 0.3865436406851219,
        },
        {
            x: 2.1,
            y: 0.38767974226166946,
        },
        {
            x: 2.11,
            y: 0.38880775768696735,
        },
        {
            x: 2.12,
            y: 0.3899277824294657,
        },
        {
            x: 2.13,
            y: 0.3910399103870339,
        },
        {
            x: 2.14,
            y: 0.39214423392002623,
        },
        {
            x: 2.15,
            y: 0.3932408438834997,
        },
        {
            x: 2.16,
            y: 0.3943298296586111,
        },
        {
            x: 2.17,
            y: 0.3954112791832169,
        },
        {
            x: 2.18,
            y: 0.39648527898170094,
        },
        {
            x: 2.19,
            y: 0.3975519141940511,
        },
        {
            x: 2.2,
            y: 0.39861126860420965,
        },
        {
            x: 2.21,
            y: 0.39966342466771543,
        },
        {
            x: 2.22,
            y: 0.40070846353866246,
        },
        {
            x: 2.23,
            y: 0.40174646509599116,
        },
        {
            x: 2.24,
            y: 0.40277750796913436,
        },
        {
            x: 2.25,
            y: 0.40380166956303504,
        },
        {
            x: 2.2600000000000002,
            y: 0.40481902608255543,
        },
        {
            x: 2.27,
            y: 0.40582965255629283,
        },
        {
            x: 2.2800000000000002,
            y: 0.40683362285982155,
        },
        {
            x: 2.29,
            y: 0.407831009738375,
        },
        {
            x: 2.3000000000000003,
            y: 0.40882188482898546,
        },
        {
            x: 2.31,
            y: 0.40980631868209577,
        },
        {
            x: 2.32,
            y: 0.4107843807826582,
        },
        {
            x: 2.33,
            y: 0.4117561395707352,
        },
        {
            x: 2.34,
            y: 0.41272166246161435,
        },
        {
            x: 2.35,
            y: 0.4136810158654531,
        },
        {
            x: 2.36,
            y: 0.4146342652064648,
        },
        {
            x: 2.37,
            y: 0.4155814749416589,
        },
        {
            x: 2.38,
            y: 0.4165227085791477,
        },
        {
            x: 2.39,
            y: 0.41745802869603155,
        },
        {
            x: 2.4,
            y: 0.4183874969558733,
        },
        {
            x: 2.41,
            y: 0.4193111741257741,
        },
        {
            x: 2.42,
            y: 0.4202291200930605,
        },
        {
            x: 2.43,
            y: 0.4211413938815931,
        },
        {
            x: 2.44,
            y: 0.4220480536677078,
        },
        {
            x: 2.45,
            y: 0.4229491567957985,
        },
        {
            x: 2.46,
            y: 0.42384475979355074,
        },
        {
            x: 2.47,
            y: 0.4247349183868369,
        },
        {
            x: 2.48,
            y: 0.4256196875142792,
        },
        {
            x: 2.49,
            y: 0.4264991213414917,
        },
        {
            x: 2.5,
            y: 0.4273732732750087,
        },
        {
            x: 2.5100000000000002,
            y: 0.428242195975907,
        },
        {
            x: 2.52,
            y: 0.42910594137313113,
        },
        {
            x: 2.5300000000000002,
            y: 0.42996456067652833,
        },
        {
            x: 2.54,
            y: 0.43081810438960094,
        },
        {
            x: 2.5500000000000003,
            y: 0.4316666223219838,
        },
        {
            x: 2.56,
            y: 0.4325101636016529,
        },
        {
            x: 2.57,
            y: 0.43334877668687294,
        },
        {
            x: 2.58,
            y: 0.4341825093778895,
        },
        {
            x: 2.59,
            y: 0.43501140882837297,
        },
        {
            x: 2.6,
            y: 0.4358355215566201,
        },
        {
            x: 2.61,
            y: 0.4366548934565191,
        },
        {
            x: 2.62,
            y: 0.43746956980828494,
        },
        {
            x: 2.63,
            y: 0.43827959528896887,
        },
        {
            x: 2.64,
            y: 0.43908501398274985,
        },
        {
            x: 2.65,
            y: 0.4398858693910116,
        },
        {
            x: 2.66,
            y: 0.44068220444221123,
        },
        {
            x: 2.67,
            y: 0.4414740615015442,
        },
        {
            x: 2.68,
            y: 0.4422614823804114,
        },
        {
            x: 2.69,
            y: 0.4430445083456915,
        },
        {
            x: 2.7,
            y: 0.44382318012882505,
        },
        {
            x: 2.71,
            y: 0.44459753793471374,
        },
        {
            x: 2.72,
            y: 0.4453676214504395,
        },
        {
            x: 2.73,
            y: 0.44613346985380775,
        },
        {
            x: 2.74,
            y: 0.44689512182171937,
        },
        {
            x: 2.75,
            y: 0.44765261553837443,
        },
        {
            x: 2.7600000000000002,
            y: 0.4484059887033131,
        },
        {
            x: 2.77,
            y: 0.449155278539296,
        },
        {
            x: 2.7800000000000002,
            y: 0.44990052180002876,
        },
        {
            x: 2.79,
            y: 0.4506417547777346,
        },
        {
            x: 3.36,
            y: 0.4872551541233355,
        },
        {
            x: 3.93,
            y: 0.5155811040003353,
        },
        {
            x: 4.5,
            y: 0.5383380411831565,
        },
        {
            x: 5.07,
            y: 0.5571402185890785,
        },
        {
            x: 5.64,
            y: 0.5730146133143359,
        },
        {
            x: 6.21,
            y: 0.5866498505291822,
        },
        {
            x: 6.78,
            y: 0.5985272370617309,
        },
        {
            x: 7.3500000000000005,
            y: 0.608994672909465,
        },
        {
            x: 7.92,
            y: 0.6183107143999567,
        },
        {
            x: 8.49,
            y: 0.6266720626447569,
        },
        {
            x: 9.06,
            y: 0.6342313750560443,
        },
        {
            x: 9.63,
            y: 0.6411091843194663,
        },
        {
            x: 10.200000000000001,
            y: 0.6474020982514521,
        },
        {
            x: 10.77,
            y: 0.6531885785487684,
        },
        {
            x: 11.34,
            y: 0.6585331003090156,
        },
        {
            x: 11.91,
            y: 0.663489202586158,
        },
        {
            x: 12.48,
            y: 0.6681017632720965,
        },
        {
            x: 13.05,
            y: 0.6724087211157004,
        },
        {
            x: 13.620000000000001,
            y: 0.676442396962084,
        },
        {
            x: 14.19,
            y: 0.6802305199801735,
        },
        {
            x: 14.76,
            y: 0.6837970336942177,
        },
        {
            x: 15.33,
            y: 0.6871627355633302,
        },
        {
            x: 15.9,
            y: 0.6903457892645246,
        },
        {
            x: 16.47,
            y: 0.6933621385775697,
        },
        {
            x: 17.04,
            y: 0.6962258444554285,
        },
        {
            x: 17.61,
            y: 0.6989493615793468,
        },
        {
            x: 18.18,
            y: 0.7015437668331146,
        },
        {
            x: 18.75,
            y: 0.7040189492731627,
        },
        {
            x: 19.32,
            y: 0.7063837690355954,
        },
        {
            x: 19.89,
            y: 0.7086461910098522,
        },
        {
            x: 20.46,
            y: 0.7108133978816813,
        },
        {
            x: 21.03,
            y: 0.7128918862058112,
        },
        {
            x: 21.6,
            y: 0.7148875484392381,
        },
        {
            x: 22.17,
            y: 0.7168057432970794,
        },
        {
            x: 22.740000000000002,
            y: 0.7186513563459962,
        },
        {
            x: 23.31,
            y: 0.720428852396738,
        },
        {
            x: 23.88,
            y: 0.7221423209760696,
        },
        {
            x: 24.45,
            y: 0.7237955159331328,
        },
        {
            x: 25.02,
            y: 0.7253918900539567,
        },
        {
            x: 25.59,
            y: 0.7269346254110188,
        },
        {
            x: 26.16,
            y: 0.7284266600553074,
        },
        {
            x: 26.73,
            y: 0.7298707115606347,
        },
        {
            x: 27.3,
            y: 0.7312692978497053,
        },
        {
            x: 27.87,
            y: 0.7326247556652059,
        },
        {
            x: 28.44,
            y: 0.7339392569942973,
        },
        {
            x: 29.01,
            y: 0.735214823709212,
        },
        {
            x: 29.580000000000002,
            y: 0.7364533406485091,
        },
        {
            x: 30.150000000000002,
            y: 0.7376565673315365,
        },
        {
            x: 30.72,
            y: 0.7388261484717347,
        },
        {
            x: 31.29,
            y: 0.7399636234316725,
        },
        {
            x: 31.86,
            y: 0.741070434743449,
        },
        {
            x: 32.43,
            y: 0.7421479358017214,
        },
        {
            x: 33,
            y: 0.7431973978226633,
        },
        {
            x: 33.57,
            y: 0.7442200161502215,
        },
        {
            x: 34.14,
            y: 0.7452169159808114,
        },
        {
            x: 34.71,
            y: 0.7461891575687858,
        },
        {
            x: 35.28,
            y: 0.7471377409674334,
        },
        {
            x: 35.85,
            y: 0.7480636103537028,
        },
        {
            x: 36.42,
            y: 0.7489676579791702,
        },
        {
            x: 36.99,
            y: 0.749850727784834,
        },
        {
            x: 37.56,
            y: 0.7507136187130266,
        },
        {
            x: 38.13,
            y: 0.7515570877459864,
        },
        {
            x: 38.7,
            y: 0.7523818526973564,
        },
        {
            x: 39.27,
            y: 0.7531885947800074,
        },
        {
            x: 39.84,
            y: 0.7539779609710633,
        },
        {
            x: 40.410000000000004,
            y: 0.7547505661927867,
        },
        {
            x: 40.980000000000004,
            y: 0.755506995326036,
        },
        {
            x: 41.550000000000004,
            y: 0.756247805071272,
        },
        {
            x: 42.12,
            y: 0.756973525670573,
        },
        {
            x: 42.69,
            y: 0.7576846625027603,
        },
        {
            x: 43.26,
            y: 0.7583816975625408,
        },
        {
            x: 43.83,
            y: 0.7590650908334999,
        },
        {
            x: 44.4,
            y: 0.7597352815638345,
        },
        {
            x: 44.97,
            y: 0.7603926894528634,
        },
        {
            x: 45.54,
            y: 0.761037715755598,
        },
        {
            x: 46.11,
            y: 0.761670744311977,
        },
        {
            x: 46.68,
            y: 0.7622921425067648,
        },
        {
            x: 47.25,
            y: 0.7629022621655646,
        },
        {
            x: 47.82,
            y: 0.7635014403919138,
        },
        {
            x: 48.39,
            y: 0.7640900003499846,
        },
        {
            x: 48.96,
            y: 0.7646682519970184,
        },
        {
            x: 49.53,
            y: 0.7652364927692646,
        },
        {
            x: 50.1,
            y: 0.7657950082248749,
        },
        {
            x: 50.67,
            y: 0.7663440726469053,
        },
        {
            x: 51.24,
            y: 0.7668839496093218,
        },
        {
            x: 51.81,
            y: 0.7674148925086618,
        },
        {
            x: 52.38,
            y: 0.7679371450637869,
        },
        {
            x: 52.95,
            y: 0.7684509417859654,
        },
        {
            x: 53.52,
            y: 0.7689565084213464,
        },
        {
            x: 54.09,
            y: 0.7694540623677184,
        },
        {
            x: 54.660000000000004,
            y: 0.7699438130673025,
        },
        {
            x: 55.230000000000004,
            y: 0.7704259623771911,
        },
        {
            x: 55.800000000000004,
            y: 0.7709007049189205,
        },
        {
            x: 56.370000000000005,
            y: 0.7713682284085523,
        },
        {
            x: 56.94,
            y: 0.771828713968535,
        },
        {
            x: 57.51,
            y: 0.7722823364225225,
        },
        {
            x: 58.08,
            y: 0.7727292645742398,
        },
        {
            x: 58.65,
            y: 0.773169661471406,
        },
        {
            x: 59.22,
            y: 0.7736036846556507,
        },
        {
            x: 59.79,
            y: 0.7740314863992962,
        },
        {
            x: 60.36,
            y: 0.7744532139298113,
        },
        {
            x: 60.93,
            y: 0.7748690096426887,
        },
        {
            x: 61.5,
            y: 0.7752790113034466,
        },
        {
            x: 62.07,
            y: 0.7756833522394028,
        },
        {
            x: 62.64,
            y: 0.7760821615218293,
        },
        {
            x: 63.21,
            y: 0.7764755641390525,
        },
        {
            x: 63.78,
            y: 0.7768636811610243,
        },
        {
            x: 64.35,
            y: 0.7772466298958598,
        },
        {
            x: 64.92,
            y: 0.7776245240387963,
        },
        {
            x: 65.49,
            y: 0.7779974738140089,
        },
        {
            x: 66.06,
            y: 0.7783655861096785,
        },
        {
            x: 66.63,
            y: 0.7787289646066934,
        },
        {
            x: 67.2,
            y: 0.7790877099013315,
        },
        {
            x: 67.77,
            y: 0.7794419196222576,
        },
        {
            x: 68.34,
            y: 0.7797916885421406,
        },
        {
            x: 68.91,
            y: 0.7801371086841827,
        },
        {
            x: 69.48,
            y: 0.780478269423832,
        },
        {
            x: 70.05,
            y: 0.7808152575859337,
        },
        {
            x: 70.62,
            y: 0.7811481575375596,
        },
        {
            x: 71.19,
            y: 0.7814770512767417,
        },
        {
            x: 71.76,
            y: 0.7818020185173208,
        },
        {
            x: 72.33,
            y: 0.7821231367701109,
        },
        {
            x: 72.9,
            y: 0.7824404814205665,
        },
        {
            x: 73.47,
            y: 0.7827541258031276,
        },
        {
            x: 74.04,
            y: 0.7830641412724135,
        },
        {
            x: 74.61,
            y: 0.7833705972714162,
        },
        {
            x: 75.18,
            y: 0.7836735613968474,
        },
        {
            x: 75.75,
            y: 0.7839730994617742,
        },
        {
            x: 76.32000000000001,
            y: 0.784269275555678,
        },
        {
            x: 76.89,
            y: 0.7845621521020594,
        },
        {
            x: 77.46000000000001,
            y: 0.7848517899137075,
        },
        {
            x: 78.03,
            y: 0.7851382482457451,
        },
        {
            x: 78.60000000000001,
            y: 0.7854215848465538,
        },
        {
            x: 79.17,
            y: 0.7857018560066786,
        },
        {
            x: 79.74,
            y: 0.7859791166058074,
        },
        {
            x: 80.31,
            y: 0.7862534201579119,
        },
        {
            x: 80.88,
            y: 0.7865248188546368,
        },
        {
            x: 81.45,
            y: 0.7867933636070152,
        },
        {
            x: 82.02,
            y: 0.7870591040855881,
        },
        {
            x: 82.59,
            y: 0.7873220887589962,
        },
        {
            x: 83.16,
            y: 0.7875823649311164,
        },
        {
            x: 83.73,
            y: 0.7878399787768041,
        },
        {
            x: 84.3,
            y: 0.788094975376305,
        },
        {
            x: 84.87,
            y: 0.7883473987483927,
        },
        {
            x: 85.44,
            y: 0.7885972918822889,
        },
        {
            x: 86.01,
            y: 0.7888446967684182,
        },
        {
            x: 86.58,
            y: 0.7890896544280473,
        },
        {
            x: 87.15,
            y: 0.7893322049418565,
        },
        {
            x: 87.72,
            y: 0.7895723874774875,
        },
        {
            x: 88.29,
            y: 0.7898102403161128,
        },
        {
            x: 88.86,
            y: 0.7900458008780652,
        },
        {
            x: 89.43,
            y: 0.790279105747568,
        },
        {
            x: 90,
            y: 0.7905101906966019,
        },
        {
            x: 90.57000000000001,
            y: 0.7907390907079446,
        },
        {
            x: 91.14,
            y: 0.7909658399974172,
        },
        {
            x: 91.71000000000001,
            y: 0.791190472035368,
        },
        {
            x: 92.28,
            y: 0.7914130195674259,
        },
        {
            x: 92.85000000000001,
            y: 0.791633514634552,
        },
        {
            x: 93.42,
            y: 0.7918519885924171,
        },
        {
            x: 93.99,
            y: 0.7920684721301319,
        },
        {
            x: 94.56,
            y: 0.7922829952883551,
        },
        {
            x: 95.13,
            y: 0.7924955874768044,
        },
        {
            x: 95.7,
            y: 0.7927062774911925,
        },
        {
            x: 96.27,
            y: 0.7929150935296108,
        },
        {
            x: 96.84,
            y: 0.7931220632083823,
        },
        {
            x: 97.41,
            y: 0.7933272135774032,
        },
        {
            x: 97.98,
            y: 0.7935305711349929,
        },
        {
            x: 98.55,
            y: 0.7937321618422709,
        },
        {
            x: 99.12,
            y: 0.7939320111370789,
        },
        {
            x: 99.69,
            y: 0.7941301439474633,
        },
        {
            x: 100.26,
            y: 0.7943265847047369,
        },
        {
            x: 100.83,
            y: 0.7945213573561328,
        },
        {
            x: 101.4,
            y: 0.7947144853770671,
        },
        {
            x: 101.97,
            y: 0.7949059917830237,
        },
        {
            x: 102.54,
            y: 0.7950958991410755,
        },
        {
            x: 103.11,
            y: 0.7952842295810552,
        },
        {
            x: 103.68,
            y: 0.7954710048063863,
        },
        {
            x: 104.25,
            y: 0.7956562461045906,
        },
        {
            x: 104.82000000000001,
            y: 0.7958399743574778,
        },
        {
            x: 105.39,
            y: 0.7960222100510347,
        },
        {
            x: 105.96000000000001,
            y: 0.7962029732850187,
        },
        {
            x: 106.53,
            y: 0.7963822837822707,
        },
        {
            x: 107.10000000000001,
            y: 0.796560160897754,
        },
        {
            x: 107.67,
            y: 0.7967366236273298,
        },
        {
            x: 108.24000000000001,
            y: 0.7969116906162776,
        },
        {
            x: 108.81,
            y: 0.7970853801675717,
        },
        {
            x: 109.38,
            y: 0.7972577102499179,
        },
        {
            x: 109.95,
            y: 0.7974286985055619,
        },
        {
            x: 110.52,
            y: 0.7975983622578762,
        },
        {
            x: 111.09,
            y: 0.7977667185187318,
        },
        {
            x: 111.66,
            y: 0.7979337839956632,
        },
        {
            x: 112.23,
            y: 0.7980995750988327,
        },
        {
            x: 112.8,
            y: 0.798264107947801,
        },
        {
            x: 113.37,
            y: 0.7984273983781112,
        },
        {
            x: 113.94,
            y: 0.7985894619476891,
        },
        {
            x: 114.51,
            y: 0.7987503139430709,
        },
        {
            x: 115.08,
            y: 0.7989099693854593,
        },
        {
            x: 115.65,
            y: 0.7990684430366151,
        },
        {
            x: 116.22,
            y: 0.7992257494045908,
        },
        {
            x: 116.79,
            y: 0.7993819027493093,
        },
        {
            x: 117.36,
            y: 0.7995369170879938,
        },
        {
            x: 117.93,
            y: 0.7996908062004524,
        },
        {
            x: 118.5,
            y: 0.7998435836342243,
        },
        {
            x: 119.07000000000001,
            y: 0.7999952627095881,
        },
        {
            x: 119.64,
            y: 0.8001458565244408,
        },
        {
            x: 120.21000000000001,
            y: 0.8002953779590488,
        },
        {
            x: 120.78,
            y: 0.8004438396806741,
        },
        {
            x: 121.35000000000001,
            y: 0.8005912541480829,
        },
        {
            x: 121.92,
            y: 0.8007376336159369,
        },
        {
            x: 122.49000000000001,
            y: 0.800882990139072,
        },
        {
            x: 123.06,
            y: 0.801027335576669,
        },
        {
            x: 123.63000000000001,
            y: 0.8011706815963169,
        },
        {
            x: 124.2,
            y: 0.8013130396779742,
        },
        {
            x: 124.77,
            y: 0.8014544211178314,
        },
        {
            x: 125.34,
            y: 0.8015948370320752,
        },
        {
            x: 125.91,
            y: 0.8017342983605602,
        },
        {
            x: 126.48,
            y: 0.8018728158703884,
        },
        {
            x: 127.05,
            y: 0.8020104001594012,
        },
        {
            x: 127.62,
            y: 0.8021470616595853,
        },
        {
            x: 128.19,
            y: 0.8022828106403945,
        },
        {
            x: 128.76,
            y: 0.8024176572119917,
        },
        {
            x: 129.33,
            y: 0.8025516113284109,
        },
        {
            x: 129.9,
            y: 0.8026846827906443,
        },
        {
            x: 130.47,
            y: 0.8028168812496538,
        },
        {
            x: 131.04,
            y: 0.8029482162093112,
        },
        {
            x: 131.61,
            y: 0.8030786970292678,
        },
        {
            x: 132.18,
            y: 0.8032083329277564,
        },
        {
            x: 132.75,
            y: 0.8033371329843264,
        },
        {
            x: 133.32,
            y: 0.8034651061425151,
        },
        {
            x: 133.89000000000001,
            y: 0.803592261212456,
        },
        {
            x: 134.46,
            y: 0.8037186068734262,
        },
        {
            x: 135.03,
            y: 0.8038441516763355,
        },
        {
            x: 135.6,
            y: 0.8039689040461562,
        },
        {
            x: 136.17000000000002,
            y: 0.8040928722842983,
        },
        {
            x: 136.74,
            y: 0.8042160645709298,
        },
        {
            x: 137.31,
            y: 0.8043384889672437,
        },
        {
            x: 137.88,
            y: 0.804460153417674,
        },
        {
            x: 138.45000000000002,
            y: 0.8045810657520605,
        },
        {
            x: 139.02,
            y: 0.8047012336877655,
        },
        {
            x: 139.59,
            y: 0.8048206648317433,
        },
        {
            x: 140.16,
            y: 0.8049393666825618,
        },
        {
            x: 140.73,
            y: 0.8050573466323809,
        },
        {
            x: 141.3,
            y: 0.8051746119688854,
        },
        {
            x: 141.87,
            y: 0.8052911698771763,
        },
        {
            x: 142.44,
            y: 0.8054070274416194,
        },
        {
            x: 143.01,
            y: 0.8055221916476547,
        },
        {
            x: 143.58,
            y: 0.8056366693835646,
        },
        {
            x: 144.15,
            y: 0.8057504674422048,
        },
        {
            x: 144.72,
            y: 0.8058635925226972,
        },
        {
            x: 145.29,
            y: 0.8059760512320869,
        },
        {
            x: 145.86,
            y: 0.8060878500869619,
        },
        {
            x: 146.43,
            y: 0.8061989955150402,
        },
        {
            x: 147,
            y: 0.8063094938567212,
        },
        {
            x: 147.57,
            y: 0.8064193513666059,
        },
        {
            x: 148.14000000000001,
            y: 0.8065285742149827,
        },
        {
            x: 148.71,
            y: 0.806637168489284,
        },
        {
            x: 149.28,
            y: 0.8067451401955107,
        },
        {
            x: 149.85,
            y: 0.8068524952596279,
        },
        {
            x: 150.42000000000002,
            y: 0.8069592395289302,
        },
        {
            x: 150.99,
            y: 0.8070653787733806,
        },
        {
            x: 151.56,
            y: 0.807170918686919,
        },
        {
            x: 152.13,
            y: 0.8072758648887466,
        },
        {
            x: 152.70000000000002,
            y: 0.8073802229245817,
        },
        {
            x: 153.27,
            y: 0.8074839982678905,
        },
        {
            x: 153.84,
            y: 0.807587196321094,
        },
        {
            x: 154.41,
            y: 0.8076898224167476,
        },
        {
            x: 154.98,
            y: 0.8077918818186997,
        },
        {
            x: 155.55,
            y: 0.8078933797232255,
        },
        {
            x: 156.12,
            y: 0.8079943212601379,
        },
        {
            x: 156.69,
            y: 0.8080947114938767,
        },
        {
            x: 157.26,
            y: 0.8081945554245756,
        },
        {
            x: 157.83,
            y: 0.808293857989109,
        },
        {
            x: 158.4,
            y: 0.8083926240621161,
        },
        {
            x: 158.97,
            y: 0.8084908584570069,
        },
        {
            x: 159.54,
            y: 0.808588565926947,
        },
        {
            x: 160.11,
            y: 0.8086857511658241,
        },
        {
            x: 160.68,
            y: 0.8087824188091945,
        },
        {
            x: 161.25,
            y: 0.8088785734352123,
        },
        {
            x: 161.82,
            y: 0.8089742195655398,
        },
        {
            x: 162.39000000000001,
            y: 0.8090693616662408,
        },
        {
            x: 162.96,
            y: 0.809164004148656,
        },
        {
            x: 163.53,
            y: 0.8092581513702628,
        },
        {
            x: 164.1,
            y: 0.8093518076355177,
        },
        {
            x: 164.67000000000002,
            y: 0.8094449771966826,
        },
        {
            x: 165.24,
            y: 0.8095376642546359,
        },
        {
            x: 165.81,
            y: 0.8096298729596685,
        },
        {
            x: 166.38,
            y: 0.8097216074122633,
        },
        {
            x: 166.95000000000002,
            y: 0.8098128716638622,
        },
        {
            x: 167.52,
            y: 0.8099036697176172,
        },
        {
            x: 168.09,
            y: 0.8099940055291278,
        },
        {
            x: 168.66,
            y: 0.8100838830071649,
        },
        {
            x: 169.23,
            y: 0.8101733060143812,
        },
        {
            x: 169.8,
            y: 0.8102622783680082,
        },
        {
            x: 170.37,
            y: 0.8103508038405415,
        },
        {
            x: 170.94,
            y: 0.810438886160411,
        },
        {
            x: 171.51,
            y: 0.8105265290126425,
        },
        {
            x: 172.08,
            y: 0.8106137360395033,
        },
        {
            x: 172.65,
            y: 0.8107005108411393,
        },
        {
            x: 173.22,
            y: 0.8107868569761985,
        },
        {
            x: 173.79,
            y: 0.8108727779624445,
        },
        {
            x: 174.36,
            y: 0.8109582772773581,
        },
        {
            x: 174.93,
            y: 0.8110433583587286,
        },
        {
            x: 175.5,
            y: 0.8111280246052341,
        },
        {
            x: 176.07,
            y: 0.8112122793770121,
        },
        {
            x: 176.64000000000001,
            y: 0.8112961259962196,
        },
        {
            x: 177.21,
            y: 0.8113795677475829,
        },
        {
            x: 177.78,
            y: 0.8114626078789385,
        },
        {
            x: 178.35,
            y: 0.8115452496017639,
        },
        {
            x: 178.92000000000002,
            y: 0.8116274960916992,
        },
        {
            x: 179.49,
            y: 0.8117093504890596,
        },
        {
            x: 180.06,
            y: 0.8117908158993393,
        },
        {
            x: 180.63,
            y: 0.8118718953937062,
        },
        {
            x: 181.20000000000002,
            y: 0.8119525920094879,
        },
        {
            x: 181.77,
            y: 0.8120329087506503,
        },
        {
            x: 182.34,
            y: 0.8121128485882663,
        },
        {
            x: 182.91,
            y: 0.8121924144609785,
        },
        {
            x: 183.48,
            y: 0.812271609275452,
        },
        {
            x: 184.05,
            y: 0.812350435906821,
        },
        {
            x: 184.62,
            y: 0.8124288971991269,
        },
        {
            x: 185.19,
            y: 0.8125069959657497,
        },
        {
            x: 185.76,
            y: 0.8125847349898309,
        },
        {
            x: 186.33,
            y: 0.8126621170246907,
        },
        {
            x: 186.9,
            y: 0.8127391447942379,
        },
        {
            x: 187.47,
            y: 0.8128158209933716,
        },
        {
            x: 188.04,
            y: 0.812892148288378,
        },
        {
            x: 188.61,
            y: 0.8129681293173198,
        },
        {
            x: 189.18,
            y: 0.8130437666904186,
        },
        {
            x: 189.75,
            y: 0.8131190629904321,
        },
        {
            x: 190.32,
            y: 0.8131940207730243,
        },
        {
            x: 190.89000000000001,
            y: 0.8132686425671298,
        },
        {
            x: 191.46,
            y: 0.8133429308753123,
        },
        {
            x: 192.03,
            y: 0.8134168881741168,
        },
        {
            x: 192.6,
            y: 0.8134905169144169,
        },
        {
            x: 193.17000000000002,
            y: 0.8135638195217552,
        },
        {
            x: 193.74,
            y: 0.8136367983966796,
        },
        {
            x: 194.31,
            y: 0.8137094559150733,
        },
        {
            x: 194.88,
            y: 0.8137817944284792,
        },
        {
            x: 195.45000000000002,
            y: 0.8138538162644203,
        },
        {
            x: 196.02,
            y: 0.8139255237267139,
        },
        {
            x: 196.59,
            y: 0.8139969190957806,
        },
        {
            x: 197.16,
            y: 0.8140680046289502,
        },
        {
            x: 197.73000000000002,
            y: 0.8141387825607601,
        },
        {
            x: 198.3,
            y: 0.814209255103251,
        },
        {
            x: 198.87,
            y: 0.8142794244462573,
        },
        {
            x: 199.44,
            y: 0.8143492927576927,
        },
        {
            x: 200.01,
            y: 0.8144188621838316,
        },
        {
            x: 200.58,
            y: 0.814488134849586,
        },
        {
            x: 201.15,
            y: 0.8145571128587783,
        },
        {
            x: 201.72,
            y: 0.814625798294409,
        },
        {
            x: 202.29,
            y: 0.8146941932189218,
        },
        {
            x: 202.86,
            y: 0.8147622996744632,
        },
        {
            x: 203.43,
            y: 0.8148301196831386,
        },
        {
            x: 204,
            y: 0.8148976552472644,
        },
        {
            x: 204.57,
            y: 0.8149649083496169,
        },
        {
            x: 205.14000000000001,
            y: 0.8150318809536758,
        },
        {
            x: 205.71,
            y: 0.8150985750038661,
        },
        {
            x: 206.28,
            y: 0.815164992425794,
        },
        {
            x: 206.85,
            y: 0.8152311351264813,
        },
        {
            x: 207.42000000000002,
            y: 0.8152970049945953,
        },
        {
            x: 207.99,
            y: 0.8153626039006748,
        },
        {
            x: 208.56,
            y: 0.8154279336973539,
        },
        {
            x: 209.13,
            y: 0.8154929962195809,
        },
        {
            x: 209.70000000000002,
            y: 0.8155577932848358,
        },
        {
            x: 210.27,
            y: 0.8156223266933424,
        },
        {
            x: 210.84,
            y: 0.8156865982282795,
        },
        {
            x: 211.41,
            y: 0.815750609655987,
        },
        {
            x: 211.98000000000002,
            y: 0.8158143627261703,
        },
        {
            x: 212.55,
            y: 0.8158778591721008,
        },
        {
            x: 213.12,
            y: 0.8159411007108139,
        },
        {
            x: 213.69,
            y: 0.8160040890433046,
        },
        {
            x: 214.26,
            y: 0.8160668258547187,
        },
        {
            x: 214.83,
            y: 0.8161293128145427,
        },
        {
            x: 215.4,
            y: 0.8161915515767907,
        },
        {
            x: 215.97,
            y: 0.8162535437801873,
        },
        {
            x: 216.54,
            y: 0.8163152910483502,
        },
        {
            x: 217.11,
            y: 0.8163767949899672,
        },
        {
            x: 217.68,
            y: 0.8164380571989737,
        },
        {
            x: 218.25,
            y: 0.8164990792547253,
        },
        {
            x: 218.82,
            y: 0.8165598627221692,
        },
        {
            x: 219.39000000000001,
            y: 0.8166204091520126,
        },
        {
            x: 219.96,
            y: 0.8166807200808888,
        },
        {
            x: 220.53,
            y: 0.8167407970315212,
        },
        {
            x: 221.1,
            y: 0.8168006415128849,
        },
        {
            x: 221.67000000000002,
            y: 0.8168602550203653,
        },
        {
            x: 222.24,
            y: 0.8169196390359157,
        },
        {
            x: 222.81,
            y: 0.8169787950282115,
        },
        {
            x: 223.38,
            y: 0.8170377244528033,
        },
        {
            x: 223.95000000000002,
            y: 0.817096428752267,
        },
        {
            x: 224.52,
            y: 0.8171549093563518,
        },
        {
            x: 225.09,
            y: 0.8172131676821273,
        },
        {
            x: 225.66,
            y: 0.8172712051341269,
        },
        {
            x: 226.23000000000002,
            y: 0.8173290231044905,
        },
        {
            x: 226.8,
            y: 0.8173866229731046,
        },
        {
            x: 227.37,
            y: 0.8174440061077406,
        },
        {
            x: 227.94,
            y: 0.8175011738641913,
        },
        {
            x: 228.51,
            y: 0.8175581275864053,
        },
        {
            x: 229.08,
            y: 0.8176148686066199,
        },
        {
            x: 229.65,
            y: 0.8176713982454918,
        },
        {
            x: 230.22,
            y: 0.8177277178122263,
        },
        {
            x: 230.79,
            y: 0.8177838286047046,
        },
        {
            x: 231.36,
            y: 0.8178397319096095,
        },
        {
            x: 231.93,
            y: 0.8178954290025493,
        },
        {
            x: 232.5,
            y: 0.8179509211481801,
        },
        {
            x: 233.07,
            y: 0.8180062096003261,
        },
        {
            x: 233.64000000000001,
            y: 0.8180612956020991,
        },
        {
            x: 234.21,
            y: 0.8181161803860154,
        },
        {
            x: 234.78,
            y: 0.818170865174112,
        },
        {
            x: 235.35,
            y: 0.8182253511780606,
        },
        {
            x: 235.92000000000002,
            y: 0.8182796395992807,
        },
        {
            x: 236.49,
            y: 0.8183337316290504,
        },
        {
            x: 237.06,
            y: 0.8183876284486166,
        },
        {
            x: 237.63,
            y: 0.8184413312293032,
        },
        {
            x: 238.20000000000002,
            y: 0.8184948411326178,
        },
        {
            x: 238.77,
            y: 0.8185481593103577,
        },
        {
            x: 239.34,
            y: 0.8186012869047138,
        },
        {
            x: 239.91,
            y: 0.8186542250483729,
        },
        {
            x: 240.48000000000002,
            y: 0.81870697486462,
        },
        {
            x: 241.05,
            y: 0.8187595374674377,
        },
        {
            x: 241.62,
            y: 0.8188119139616054,
        },
        {
            x: 242.19,
            y: 0.8188641054427965,
        },
        {
            x: 242.76,
            y: 0.8189161129976752,
        },
        {
            x: 243.33,
            y: 0.8189679377039909,
        },
        {
            x: 243.9,
            y: 0.8190195806306724,
        },
        {
            x: 244.47,
            y: 0.8190710428379204,
        },
        {
            x: 245.04,
            y: 0.8191223253772989,
        },
        {
            x: 245.61,
            y: 0.8191734292918255,
        },
        {
            x: 246.18,
            y: 0.8192243556160603,
        },
        {
            x: 246.75,
            y: 0.8192751053761944,
        },
        {
            x: 247.32,
            y: 0.8193256795901359,
        },
        {
            x: 247.89000000000001,
            y: 0.8193760792675966,
        },
        {
            x: 248.46,
            y: 0.8194263054101758,
        },
        {
            x: 249.03,
            y: 0.8194763590114447,
        },
        {
            x: 249.6,
            y: 0.819526241057028,
        },
        {
            x: 250.17000000000002,
            y: 0.8195759525246864,
        },
        {
            x: 250.74,
            y: 0.8196254943843968,
        },
        {
            x: 251.31,
            y: 0.8196748675984311,
        },
        {
            x: 251.88,
            y: 0.8197240731214358,
        },
        {
            x: 252.45000000000002,
            y: 0.8197731119005087,
        },
        {
            x: 253.02,
            y: 0.8198219848752758,
        },
        {
            x: 253.59,
            y: 0.8198706929779669,
        },
        {
            x: 254.16,
            y: 0.8199192371334902,
        },
        {
            x: 254.73000000000002,
            y: 0.8199676182595064,
        },
        {
            x: 255.3,
            y: 0.8200158372665007,
        },
        {
            x: 255.87,
            y: 0.820063895057856,
        },
        {
            x: 256.44,
            y: 0.820111792529923,
        },
        {
            x: 257.01,
            y: 0.8201595305720906,
        },
        {
            x: 257.58,
            y: 0.8202071100668556,
        },
        {
            x: 258.15,
            y: 0.8202545318898913,
        },
        {
            x: 258.72,
            y: 0.8203017969101144,
        },
        {
            x: 259.29,
            y: 0.8203489059897527,
        },
        {
            x: 259.86,
            y: 0.8203958599844109,
        },
        {
            x: 260.43,
            y: 0.8204426597431357,
        },
        {
            x: 261,
            y: 0.8204893061084804,
        },
        {
            x: 261.57,
            y: 0.8205357999165687,
        },
        {
            x: 262.14,
            y: 0.8205821419971575,
        },
        {
            x: 262.71,
            y: 0.8206283331736992,
        },
        {
            x: 263.28000000000003,
            y: 0.8206743742634031,
        },
        {
            x: 263.85,
            y: 0.8207202660772961,
        },
        {
            x: 264.42,
            y: 0.820766009420283,
        },
        {
            x: 264.99,
            y: 0.8208116050912051,
        },
        {
            x: 265.56,
            y: 0.8208570538828996,
        },
        {
            x: 266.13,
            y: 0.8209023565822571,
        },
        {
            x: 266.7,
            y: 0.8209475139702785,
        },
        {
            x: 267.27,
            y: 0.8209925268221324,
        },
        {
            x: 267.84000000000003,
            y: 0.8210373959072103,
        },
        {
            x: 268.41,
            y: 0.8210821219891818,
        },
        {
            x: 268.98,
            y: 0.8211267058260499,
        },
        {
            x: 269.55,
            y: 0.821171148170204,
        },
        {
            x: 270.12,
            y: 0.8212154497684739,
        },
        {
            x: 270.69,
            y: 0.8212596113621826,
        },
        {
            x: 271.26,
            y: 0.8213036336871977,
        },
        {
            x: 271.83,
            y: 0.8213475174739835,
        },
        {
            x: 272.4,
            y: 0.8213912634476517,
        },
        {
            x: 272.97,
            y: 0.8214348723280117,
        },
        {
            x: 273.54,
            y: 0.8214783448296207,
        },
        {
            x: 274.11,
            y: 0.8215216816618321,
        },
        {
            x: 274.68,
            y: 0.8215648835288449,
        },
        {
            x: 275.25,
            y: 0.8216079511297515,
        },
        {
            x: 275.82,
            y: 0.8216508851585849,
        },
        {
            x: 276.39,
            y: 0.8216936863043661,
        },
        {
            x: 276.96,
            y: 0.8217363552511504,
        },
        {
            x: 277.53000000000003,
            y: 0.8217788926780731,
        },
        {
            x: 278.1,
            y: 0.8218212992593956,
        },
        {
            x: 278.67,
            y: 0.8218635756645492,
        },
        {
            x: 279.24,
            y: 0.8219057225581803,
        },
        {
            x: 279.81,
            y: 0.821947740600194,
        },
        {
            x: 280.38,
            y: 0.821989630445798,
        },
        {
            x: 280.95,
            y: 0.8220313927455444,
        },
        {
            x: 281.52,
            y: 0.8220730281453732,
        },
        {
            x: 282.09000000000003,
            y: 0.8221145372866537,
        },
        {
            x: 282.66,
            y: 0.8221559208062262,
        },
        {
            x: 283.23,
            y: 0.8221971793364433,
        },
        {
            x: 283.8,
            y: 0.8222383135052096,
        },
        {
            x: 284.37,
            y: 0.8222793239360229,
        },
        {
            x: 284.94,
            y: 0.8223202112480132,
        },
        {
            x: 285.51,
            y: 0.8223609760559821,
        },
        {
            x: 286.08,
            y: 0.822401618970442,
        },
        {
            x: 286.65000000000003,
            y: 0.8224421405976539,
        },
        {
            x: 287.22,
            y: 0.8224825415396656,
        },
        {
            x: 287.79,
            y: 0.8225228223943497,
        },
        {
            x: 288.36,
            y: 0.8225629837554403,
        },
        {
            x: 288.93,
            y: 0.8226030262125698,
        },
        {
            x: 289.5,
            y: 0.8226429503513051,
        },
        {
            x: 290.07,
            y: 0.8226827567531843,
        },
        {
            x: 290.64,
            y: 0.8227224459957513,
        },
        {
            x: 291.21,
            y: 0.8227620186525917,
        },
        {
            x: 291.78000000000003,
            y: 0.8228014752933674,
        },
    ],
    upperLimitAmberPoints: [
        {
            x: 1.18,
            y: 1.4974170365018065,
        },
        {
            x: 1.19,
            y: 1.4947463742723848,
        },
        {
            x: 1.2,
            y: 1.4921091652590637,
        },
        {
            x: 1.21,
            y: 1.4895047168416733,
        },
        {
            x: 1.22,
            y: 1.4869323563113515,
        },
        {
            x: 1.23,
            y: 1.4843914301405854,
        },
        {
            x: 1.24,
            y: 1.4818813032856992,
        },
        {
            x: 1.25,
            y: 1.4794013585200914,
        },
        {
            x: 1.26,
            y: 1.4769509957966354,
        },
        {
            x: 1.27,
            y: 1.4745296316377503,
        },
        {
            x: 1.28,
            y: 1.472136698551728,
        },
        {
            x: 1.29,
            y: 1.469771644473997,
        },
        {
            x: 1.3,
            y: 1.4674339322320682,
        },
        {
            x: 1.31,
            y: 1.4651230390329917,
        },
        {
            x: 1.32,
            y: 1.4628384559722067,
        },
        {
            x: 1.33,
            y: 1.4605796875627437,
        },
        {
            x: 1.34,
            y: 1.4583462512837844,
        },
        {
            x: 1.35,
            y: 1.4561376771476502,
        },
        {
            x: 1.36,
            y: 1.4539535072843335,
        },
        {
            x: 1.37,
            y: 1.4517932955427397,
        },
        {
            x: 1.3800000000000001,
            y: 1.4496566071078494,
        },
        {
            x: 1.3900000000000001,
            y: 1.4475430181330586,
        },
        {
            x: 1.4000000000000001,
            y: 1.4454521153869875,
        },
        {
            x: 1.41,
            y: 1.4433834959140899,
        },
        {
            x: 1.42,
            y: 1.4413367667084338,
        },
        {
            x: 1.43,
            y: 1.4393115444000495,
        },
        {
            x: 1.44,
            y: 1.4373074549532774,
        },
        {
            x: 1.45,
            y: 1.435324133376581,
        },
        {
            x: 1.46,
            y: 1.433361223443307,
        },
        {
            x: 1.47,
            y: 1.4314183774229128,
        },
        {
            x: 1.48,
            y: 1.4294952558221996,
        },
        {
            x: 1.49,
            y: 1.4275915271361121,
        },
        {
            x: 1.5,
            y: 1.4257068676076918,
        },
        {
            x: 1.51,
            y: 1.4238409609967886,
        },
        {
            x: 1.52,
            y: 1.4219934983571538,
        },
        {
            x: 1.53,
            y: 1.420164177821562,
        },
        {
            x: 1.54,
            y: 1.4183527043946165,
        },
        {
            x: 1.55,
            y: 1.4165587897529208,
        },
        {
            x: 1.56,
            y: 1.4147821520523074,
        },
        {
            x: 1.57,
            y: 1.4130225157418281,
        },
        {
            x: 1.58,
            y: 1.4112796113842312,
        },
        {
            x: 1.59,
            y: 1.409553175482659,
        },
        {
            x: 1.6,
            y: 1.4078429503133103,
        },
        {
            x: 1.61,
            y: 1.4061486837638304,
        },
        {
            x: 1.62,
            y: 1.4044701291771937,
        },
        {
            x: 1.6300000000000001,
            y: 1.4028070452008663,
        },
        {
            x: 1.6400000000000001,
            y: 1.401159195641029,
        },
        {
            x: 1.6500000000000001,
            y: 1.3995263493216732,
        },
        {
            x: 1.6600000000000001,
            y: 1.397908279948369,
        },
        {
            x: 1.67,
            y: 1.3963047659765266,
        },
        {
            x: 1.68,
            y: 1.3947155904839779,
        },
        {
            x: 1.69,
            y: 1.3931405410477113,
        },
        {
            x: 1.7,
            y: 1.3915794096246006,
        },
        {
            x: 1.71,
            y: 1.3900319924359734,
        },
        {
            x: 1.72,
            y: 1.3884980898558794,
        },
        {
            x: 1.73,
            y: 1.3869775063029146,
        },
        {
            x: 1.74,
            y: 1.3854700501354675,
        },
        {
            x: 1.75,
            y: 1.3839755335502677,
        },
        {
            x: 1.76,
            y: 1.382493772484103,
        },
        {
            x: 1.77,
            y: 1.3810245865186004,
        },
        {
            x: 1.78,
            y: 1.3795677987879489,
        },
        {
            x: 1.79,
            y: 1.378123235889466,
        },
        {
            x: 1.8,
            y: 1.3766907277968963,
        },
        {
            x: 1.81,
            y: 1.3752701077763518,
        },
        {
            x: 1.82,
            y: 1.373861212304795,
        },
        {
            x: 1.83,
            y: 1.3724638809909733,
        },
        {
            x: 1.84,
            y: 1.3710779564987225,
        },
        {
            x: 1.85,
            y: 1.3697032844725545,
        },
        {
            x: 1.86,
            y: 1.3683397134654436,
        },
        {
            x: 1.87,
            y: 1.3669870948687448,
        },
        {
            x: 1.8800000000000001,
            y: 1.3656452828441623,
        },
        {
            x: 1.8900000000000001,
            y: 1.3643141342577005,
        },
        {
            x: 1.9000000000000001,
            y: 1.362993508615531,
        },
        {
            x: 1.9100000000000001,
            y: 1.3616832680017064,
        },
        {
            x: 1.92,
            y: 1.3603832770176638,
        },
        {
            x: 1.93,
            y: 1.3590934027234516,
        },
        {
            x: 1.94,
            y: 1.3578135145806256,
        },
        {
            x: 1.95,
            y: 1.3565434843967594,
        },
        {
            x: 1.96,
            y: 1.355283186271512,
        },
        {
            x: 1.97,
            y: 1.3540324965442032,
        },
        {
            x: 1.98,
            y: 1.3527912937428481,
        },
        {
            x: 1.99,
            y: 1.3515594585346016,
        },
        {
            x: 2,
            y: 1.3503368736775665,
        },
        {
            x: 2.0100000000000002,
            y: 1.3491234239739236,
        },
        {
            x: 2.02,
            y: 1.347918996224338,
        },
        {
            x: 2.0300000000000002,
            y: 1.3467234791836031,
        },
        {
            x: 2.04,
            y: 1.3455367635174815,
        },
        {
            x: 2.05,
            y: 1.3443587417607052,
        },
        {
            x: 2.06,
            y: 1.3431893082761,
        },
        {
            x: 2.07,
            y: 1.3420283592147944,
        },
        {
            x: 2.08,
            y: 1.3408757924774846,
        },
        {
            x: 2.09,
            y: 1.3397315076767191,
        },
        {
            x: 2.1,
            y: 1.3385954061001715,
        },
        {
            x: 2.11,
            y: 1.3374673906748737,
        },
        {
            x: 2.12,
            y: 1.3363473659323755,
        },
        {
            x: 2.13,
            y: 1.3352352379748071,
        },
        {
            x: 2.14,
            y: 1.3341309144418148,
        },
        {
            x: 2.15,
            y: 1.3330343044783413,
        },
        {
            x: 2.16,
            y: 1.33194531870323,
        },
        {
            x: 2.17,
            y: 1.330863869178624,
        },
        {
            x: 2.18,
            y: 1.3297898693801402,
        },
        {
            x: 2.19,
            y: 1.32872323416779,
        },
        {
            x: 2.2,
            y: 1.3276638797576314,
        },
        {
            x: 2.21,
            y: 1.3266117236941257,
        },
        {
            x: 2.22,
            y: 1.3255666848231786,
        },
        {
            x: 2.23,
            y: 1.3245286832658498,
        },
        {
            x: 2.24,
            y: 1.3234976403927066,
        },
        {
            x: 2.25,
            y: 1.322473478798806,
        },
        {
            x: 2.2600000000000002,
            y: 1.3214561222792855,
        },
        {
            x: 2.27,
            y: 1.3204454958055483,
        },
        {
            x: 2.2800000000000002,
            y: 1.3194415255020195,
        },
        {
            x: 2.29,
            y: 1.318444138623466,
        },
        {
            x: 2.3000000000000003,
            y: 1.3174532635328555,
        },
        {
            x: 2.31,
            y: 1.3164688296797453,
        },
        {
            x: 2.32,
            y: 1.315490767579183,
        },
        {
            x: 2.33,
            y: 1.3145190087911058,
        },
        {
            x: 2.34,
            y: 1.3135534859002267,
        },
        {
            x: 2.35,
            y: 1.312594132496388,
        },
        {
            x: 2.36,
            y: 1.3116408831553763,
        },
        {
            x: 2.37,
            y: 1.3106936734201822,
        },
        {
            x: 2.38,
            y: 1.3097524397826934,
        },
        {
            x: 2.39,
            y: 1.3088171196658096,
        },
        {
            x: 2.4,
            y: 1.3078876514059679,
        },
        {
            x: 2.41,
            y: 1.306963974236067,
        },
        {
            x: 2.42,
            y: 1.3060460282687805,
        },
        {
            x: 2.43,
            y: 1.305133754480248,
        },
        {
            x: 2.44,
            y: 1.3042270946941332,
        },
        {
            x: 2.45,
            y: 1.3033259915660427,
        },
        {
            x: 2.46,
            y: 1.3024303885682902,
        },
        {
            x: 2.47,
            y: 1.301540229975004,
        },
        {
            x: 2.48,
            y: 1.3006554608475618,
        },
        {
            x: 2.49,
            y: 1.2997760270203493,
        },
        {
            x: 2.5,
            y: 1.2989018750868324,
        },
        {
            x: 2.5100000000000002,
            y: 1.298032952385934,
        },
        {
            x: 2.52,
            y: 1.29716920698871,
        },
        {
            x: 2.5300000000000002,
            y: 1.2963105876853127,
        },
        {
            x: 2.54,
            y: 1.2954570439722402,
        },
        {
            x: 2.5500000000000003,
            y: 1.2946085260398572,
        },
        {
            x: 2.56,
            y: 1.2937649847601882,
        },
        {
            x: 2.57,
            y: 1.2929263716749682,
        },
        {
            x: 2.58,
            y: 1.2920926389839515,
        },
        {
            x: 2.59,
            y: 1.291263739533468,
        },
        {
            x: 2.6,
            y: 1.290439626805221,
        },
        {
            x: 2.61,
            y: 1.289620254905322,
        },
        {
            x: 2.62,
            y: 1.2888055785535562,
        },
        {
            x: 2.63,
            y: 1.2879955530728722,
        },
        {
            x: 2.64,
            y: 1.2871901343790912,
        },
        {
            x: 2.65,
            y: 1.2863892789708293,
        },
        {
            x: 2.66,
            y: 1.2855929439196299,
        },
        {
            x: 2.67,
            y: 1.2848010868602968,
        },
        {
            x: 2.68,
            y: 1.2840136659814296,
        },
        {
            x: 2.69,
            y: 1.2832306400161495,
        },
        {
            x: 2.7,
            y: 1.282451968233016,
        },
        {
            x: 2.71,
            y: 1.2816776104271272,
        },
        {
            x: 2.72,
            y: 1.2809075269114016,
        },
        {
            x: 2.73,
            y: 1.2801416785080333,
        },
        {
            x: 2.74,
            y: 1.2793800265401216,
        },
        {
            x: 2.75,
            y: 1.2786225328234666,
        },
        {
            x: 2.7600000000000002,
            y: 1.2778691596585279,
        },
        {
            x: 2.77,
            y: 1.277119869822545,
        },
        {
            x: 2.7800000000000002,
            y: 1.2763746265618123,
        },
        {
            x: 2.79,
            y: 1.2756333935841064,
        },
        {
            x: 3.36,
            y: 1.2390199942385056,
        },
        {
            x: 3.93,
            y: 1.2106940443615057,
        },
        {
            x: 4.5,
            y: 1.1879371071786844,
        },
        {
            x: 5.07,
            y: 1.1691349297727625,
        },
        {
            x: 5.64,
            y: 1.1532605350475051,
        },
        {
            x: 6.21,
            y: 1.1396252978326589,
        },
        {
            x: 6.78,
            y: 1.12774791130011,
        },
        {
            x: 7.3500000000000005,
            y: 1.1172804754523762,
        },
        {
            x: 7.92,
            y: 1.1079644339618844,
        },
        {
            x: 8.49,
            y: 1.099603085717084,
        },
        {
            x: 9.06,
            y: 1.0920437733057968,
        },
        {
            x: 9.63,
            y: 1.0851659640423748,
        },
        {
            x: 10.200000000000001,
            y: 1.078873050110389,
        },
        {
            x: 10.77,
            y: 1.0730865698130727,
        },
        {
            x: 11.34,
            y: 1.0677420480528255,
        },
        {
            x: 11.91,
            y: 1.062785945775683,
        },
        {
            x: 12.48,
            y: 1.0581733850897446,
        },
        {
            x: 13.05,
            y: 1.0538664272461407,
        },
        {
            x: 13.620000000000001,
            y: 1.049832751399757,
        },
        {
            x: 14.19,
            y: 1.0460446283816676,
        },
        {
            x: 14.76,
            y: 1.0424781146676234,
        },
        {
            x: 15.33,
            y: 1.0391124127985107,
        },
        {
            x: 15.9,
            y: 1.0359293590973164,
        },
        {
            x: 16.47,
            y: 1.0329130097842714,
        },
        {
            x: 17.04,
            y: 1.0300493039064125,
        },
        {
            x: 17.61,
            y: 1.027325786782494,
        },
        {
            x: 18.18,
            y: 1.0247313815287264,
        },
        {
            x: 18.75,
            y: 1.0222561990886785,
        },
        {
            x: 19.32,
            y: 1.0198913793262456,
        },
        {
            x: 19.89,
            y: 1.0176289573519888,
        },
        {
            x: 20.46,
            y: 1.0154617504801597,
        },
        {
            x: 21.03,
            y: 1.0133832621560297,
        },
        {
            x: 21.6,
            y: 1.011387599922603,
        },
        {
            x: 22.17,
            y: 1.0094694050647617,
        },
        {
            x: 22.740000000000002,
            y: 1.0076237920158448,
        },
        {
            x: 23.31,
            y: 1.005846295965103,
        },
        {
            x: 23.88,
            y: 1.0041328273857715,
        },
        {
            x: 24.45,
            y: 1.0024796324287082,
        },
        {
            x: 25.02,
            y: 1.0008832583078844,
        },
        {
            x: 25.59,
            y: 0.9993405229508222,
        },
        {
            x: 26.16,
            y: 0.9978484883065336,
        },
        {
            x: 26.73,
            y: 0.9964044368012064,
        },
        {
            x: 27.3,
            y: 0.9950058505121357,
        },
        {
            x: 27.87,
            y: 0.9936503926966351,
        },
        {
            x: 28.44,
            y: 0.9923358913675437,
        },
        {
            x: 29.01,
            y: 0.991060324652629,
        },
        {
            x: 29.580000000000002,
            y: 0.989821807713332,
        },
        {
            x: 30.150000000000002,
            y: 0.9886185810303045,
        },
        {
            x: 30.72,
            y: 0.9874489998901064,
        },
        {
            x: 31.29,
            y: 0.9863115249301685,
        },
        {
            x: 31.86,
            y: 0.985204713618392,
        },
        {
            x: 32.43,
            y: 0.9841272125601196,
        },
        {
            x: 33,
            y: 0.9830777505391778,
        },
        {
            x: 33.57,
            y: 0.9820551322116196,
        },
        {
            x: 34.14,
            y: 0.9810582323810296,
        },
        {
            x: 34.71,
            y: 0.9800859907930553,
        },
        {
            x: 35.28,
            y: 0.9791374073944077,
        },
        {
            x: 35.85,
            y: 0.9782115380081382,
        },
        {
            x: 36.42,
            y: 0.9773074903826708,
        },
        {
            x: 36.99,
            y: 0.9764244205770071,
        },
        {
            x: 37.56,
            y: 0.9755615296488145,
        },
        {
            x: 38.13,
            y: 0.9747180606158546,
        },
        {
            x: 38.7,
            y: 0.9738932956644847,
        },
        {
            x: 39.27,
            y: 0.9730865535818336,
        },
        {
            x: 39.84,
            y: 0.9722971873907778,
        },
        {
            x: 40.410000000000004,
            y: 0.9715245821690544,
        },
        {
            x: 40.980000000000004,
            y: 0.970768153035805,
        },
        {
            x: 41.550000000000004,
            y: 0.970027343290569,
        },
        {
            x: 42.12,
            y: 0.9693016226912681,
        },
        {
            x: 42.69,
            y: 0.9685904858590807,
        },
        {
            x: 43.26,
            y: 0.9678934507993002,
        },
        {
            x: 43.83,
            y: 0.9672100575283411,
        },
        {
            x: 44.4,
            y: 0.9665398667980065,
        },
        {
            x: 44.97,
            y: 0.9658824589089776,
        },
        {
            x: 45.54,
            y: 0.9652374326062431,
        },
        {
            x: 46.11,
            y: 0.964604404049864,
        },
        {
            x: 46.68,
            y: 0.9639830058550762,
        },
        {
            x: 47.25,
            y: 0.9633728861962765,
        },
        {
            x: 47.82,
            y: 0.9627737079699272,
        },
        {
            x: 48.39,
            y: 0.9621851480118564,
        },
        {
            x: 48.96,
            y: 0.9616068963648227,
        },
        {
            x: 49.53,
            y: 0.9610386555925764,
        },
        {
            x: 50.1,
            y: 0.9604801401369661,
        },
        {
            x: 50.67,
            y: 0.9599310757149357,
        },
        {
            x: 51.24,
            y: 0.9593911987525192,
        },
        {
            x: 51.81,
            y: 0.9588602558531792,
        },
        {
            x: 52.38,
            y: 0.9583380032980542,
        },
        {
            x: 52.95,
            y: 0.9578242065758756,
        },
        {
            x: 53.52,
            y: 0.9573186399404946,
        },
        {
            x: 54.09,
            y: 0.9568210859941226,
        },
        {
            x: 54.660000000000004,
            y: 0.9563313352945385,
        },
        {
            x: 55.230000000000004,
            y: 0.95584918598465,
        },
        {
            x: 55.800000000000004,
            y: 0.9553744434429206,
        },
        {
            x: 56.370000000000005,
            y: 0.9549069199532887,
        },
        {
            x: 56.94,
            y: 0.954446434393306,
        },
        {
            x: 57.51,
            y: 0.9539928119393185,
        },
        {
            x: 58.08,
            y: 0.9535458837876012,
        },
        {
            x: 58.65,
            y: 0.9531054868904351,
        },
        {
            x: 59.22,
            y: 0.9526714637061904,
        },
        {
            x: 59.79,
            y: 0.9522436619625448,
        },
        {
            x: 60.36,
            y: 0.9518219344320298,
        },
        {
            x: 60.93,
            y: 0.9514061387191524,
        },
        {
            x: 61.5,
            y: 0.9509961370583945,
        },
        {
            x: 62.07,
            y: 0.9505917961224383,
        },
        {
            x: 62.64,
            y: 0.9501929868400117,
        },
        {
            x: 63.21,
            y: 0.9497995842227885,
        },
        {
            x: 63.78,
            y: 0.9494114672008167,
        },
        {
            x: 64.35,
            y: 0.9490285184659812,
        },
        {
            x: 64.92,
            y: 0.9486506243230447,
        },
        {
            x: 65.49,
            y: 0.9482776745478322,
        },
        {
            x: 66.06,
            y: 0.9479095622521625,
        },
        {
            x: 66.63,
            y: 0.9475461837551477,
        },
        {
            x: 67.2,
            y: 0.9471874384605096,
        },
        {
            x: 67.77,
            y: 0.9468332287395834,
        },
        {
            x: 68.34,
            y: 0.9464834598197004,
        },
        {
            x: 68.91,
            y: 0.9461380396776583,
        },
        {
            x: 69.48,
            y: 0.945796878938009,
        },
        {
            x: 70.05,
            y: 0.9454598907759073,
        },
        {
            x: 70.62,
            y: 0.9451269908242814,
        },
        {
            x: 71.19,
            y: 0.9447980970850993,
        },
        {
            x: 71.76,
            y: 0.9444731298445203,
        },
        {
            x: 72.33,
            y: 0.9441520115917301,
        },
        {
            x: 72.9,
            y: 0.9438346669412745,
        },
        {
            x: 73.47,
            y: 0.9435210225587134,
        },
        {
            x: 74.04,
            y: 0.9432110070894275,
        },
        {
            x: 74.61,
            y: 0.9429045510904248,
        },
        {
            x: 75.18,
            y: 0.9426015869649936,
        },
        {
            x: 75.75,
            y: 0.9423020489000669,
        },
        {
            x: 76.32000000000001,
            y: 0.942005872806163,
        },
        {
            x: 76.89,
            y: 0.9417129962597817,
        },
        {
            x: 77.46000000000001,
            y: 0.9414233584481335,
        },
        {
            x: 78.03,
            y: 0.941136900116096,
        },
        {
            x: 78.60000000000001,
            y: 0.9408535635152873,
        },
        {
            x: 79.17,
            y: 0.9405732923551624,
        },
        {
            x: 79.74,
            y: 0.9402960317560336,
        },
        {
            x: 80.31,
            y: 0.9400217282039292,
        },
        {
            x: 80.88,
            y: 0.9397503295072043,
        },
        {
            x: 81.45,
            y: 0.9394817847548258,
        },
        {
            x: 82.02,
            y: 0.9392160442762529,
        },
        {
            x: 82.59,
            y: 0.9389530596028448,
        },
        {
            x: 83.16,
            y: 0.9386927834307246,
        },
        {
            x: 83.73,
            y: 0.9384351695850369,
        },
        {
            x: 84.3,
            y: 0.938180172985536,
        },
        {
            x: 84.87,
            y: 0.9379277496134484,
        },
        {
            x: 85.44,
            y: 0.9376778564795522,
        },
        {
            x: 86.01,
            y: 0.9374304515934229,
        },
        {
            x: 86.58,
            y: 0.9371854939337937,
        },
        {
            x: 87.15,
            y: 0.9369429434199845,
        },
        {
            x: 87.72,
            y: 0.9367027608843536,
        },
        {
            x: 88.29,
            y: 0.9364649080457282,
        },
        {
            x: 88.86,
            y: 0.9362293474837758,
        },
        {
            x: 89.43,
            y: 0.935996042614273,
        },
        {
            x: 90,
            y: 0.9357649576652391,
        },
        {
            x: 90.57000000000001,
            y: 0.9355360576538965,
        },
        {
            x: 91.14,
            y: 0.9353093083644238,
        },
        {
            x: 91.71000000000001,
            y: 0.9350846763264731,
        },
        {
            x: 92.28,
            y: 0.9348621287944151,
        },
        {
            x: 92.85000000000001,
            y: 0.934641633727289,
        },
        {
            x: 93.42,
            y: 0.9344231597694239,
        },
        {
            x: 93.99,
            y: 0.9342066762317092,
        },
        {
            x: 94.56,
            y: 0.9339921530734859,
        },
        {
            x: 95.13,
            y: 0.9337795608850367,
        },
        {
            x: 95.7,
            y: 0.9335688708706485,
        },
        {
            x: 96.27,
            y: 0.9333600548322303,
        },
        {
            x: 96.84,
            y: 0.9331530851534587,
        },
        {
            x: 97.41,
            y: 0.9329479347844378,
        },
        {
            x: 97.98,
            y: 0.9327445772268481,
        },
        {
            x: 98.55,
            y: 0.9325429865195701,
        },
        {
            x: 99.12,
            y: 0.9323431372247621,
        },
        {
            x: 99.69,
            y: 0.9321450044143778,
        },
        {
            x: 100.26,
            y: 0.9319485636571041,
        },
        {
            x: 100.83,
            y: 0.9317537910057082,
        },
        {
            x: 101.4,
            y: 0.9315606629847739,
        },
        {
            x: 101.97,
            y: 0.9313691565788174,
        },
        {
            x: 102.54,
            y: 0.9311792492207656,
        },
        {
            x: 103.11,
            y: 0.9309909187807859,
        },
        {
            x: 103.68,
            y: 0.9308041435554547,
        },
        {
            x: 104.25,
            y: 0.9306189022572504,
        },
        {
            x: 104.82000000000001,
            y: 0.9304351740043633,
        },
        {
            x: 105.39,
            y: 0.9302529383108064,
        },
        {
            x: 105.96000000000001,
            y: 0.9300721750768224,
        },
        {
            x: 106.53,
            y: 0.9298928645795703,
        },
        {
            x: 107.10000000000001,
            y: 0.929714987464087,
        },
        {
            x: 107.67,
            y: 0.9295385247345113,
        },
        {
            x: 108.24000000000001,
            y: 0.9293634577455634,
        },
        {
            x: 108.81,
            y: 0.9291897681942693,
        },
        {
            x: 109.38,
            y: 0.9290174381119232,
        },
        {
            x: 109.95,
            y: 0.9288464498562792,
        },
        {
            x: 110.52,
            y: 0.9286767861039649,
        },
        {
            x: 111.09,
            y: 0.9285084298431092,
        },
        {
            x: 111.66,
            y: 0.9283413643661779,
        },
        {
            x: 112.23,
            y: 0.9281755732630084,
        },
        {
            x: 112.8,
            y: 0.92801104041404,
        },
        {
            x: 113.37,
            y: 0.9278477499837299,
        },
        {
            x: 113.94,
            y: 0.9276856864141519,
        },
        {
            x: 114.51,
            y: 0.9275248344187701,
        },
        {
            x: 115.08,
            y: 0.9273651789763817,
        },
        {
            x: 115.65,
            y: 0.927206705325226,
        },
        {
            x: 116.22,
            y: 0.9270493989572502,
        },
        {
            x: 116.79,
            y: 0.9268932456125317,
        },
        {
            x: 117.36,
            y: 0.9267382312738472,
        },
        {
            x: 117.93,
            y: 0.9265843421613886,
        },
        {
            x: 118.5,
            y: 0.9264315647276168,
        },
        {
            x: 119.07000000000001,
            y: 0.9262798856522529,
        },
        {
            x: 119.64,
            y: 0.9261292918374002,
        },
        {
            x: 120.21000000000001,
            y: 0.9259797704027922,
        },
        {
            x: 120.78,
            y: 0.9258313086811669,
        },
        {
            x: 121.35000000000001,
            y: 0.9256838942137582,
        },
        {
            x: 121.92,
            y: 0.9255375147459042,
        },
        {
            x: 122.49000000000001,
            y: 0.925392158222769,
        },
        {
            x: 123.06,
            y: 0.925247812785172,
        },
        {
            x: 123.63000000000001,
            y: 0.9251044667655242,
        },
        {
            x: 124.2,
            y: 0.9249621086838669,
        },
        {
            x: 124.77,
            y: 0.9248207272440097,
        },
        {
            x: 125.34,
            y: 0.9246803113297658,
        },
        {
            x: 125.91,
            y: 0.9245408500012808,
        },
        {
            x: 126.48,
            y: 0.9244023324914526,
        },
        {
            x: 127.05,
            y: 0.9242647482024399,
        },
        {
            x: 127.62,
            y: 0.9241280867022558,
        },
        {
            x: 128.19,
            y: 0.9239923377214465,
        },
        {
            x: 128.76,
            y: 0.9238574911498494,
        },
        {
            x: 129.33,
            y: 0.9237235370334301,
        },
        {
            x: 129.9,
            y: 0.9235904655711967,
        },
        {
            x: 130.47,
            y: 0.9234582671121873,
        },
        {
            x: 131.04,
            y: 0.9233269321525298,
        },
        {
            x: 131.61,
            y: 0.9231964513325732,
        },
        {
            x: 132.18,
            y: 0.9230668154340846,
        },
        {
            x: 132.75,
            y: 0.9229380153775146,
        },
        {
            x: 133.32,
            y: 0.9228100422193259,
        },
        {
            x: 133.89000000000001,
            y: 0.9226828871493851,
        },
        {
            x: 134.46,
            y: 0.9225565414884148,
        },
        {
            x: 135.03,
            y: 0.9224309966855055,
        },
        {
            x: 135.6,
            y: 0.9223062443156849,
        },
        {
            x: 136.17000000000002,
            y: 0.9221822760775428,
        },
        {
            x: 136.74,
            y: 0.9220590837909113,
        },
        {
            x: 137.31,
            y: 0.9219366593945973,
        },
        {
            x: 137.88,
            y: 0.9218149949441671,
        },
        {
            x: 138.45000000000002,
            y: 0.9216940826097806,
        },
        {
            x: 139.02,
            y: 0.9215739146740756,
        },
        {
            x: 139.59,
            y: 0.9214544835300977,
        },
        {
            x: 140.16,
            y: 0.9213357816792792,
        },
        {
            x: 140.73,
            y: 0.9212178017294601,
        },
        {
            x: 141.3,
            y: 0.9211005363929556,
        },
        {
            x: 141.87,
            y: 0.9209839784846647,
        },
        {
            x: 142.44,
            y: 0.9208681209202216,
        },
        {
            x: 143.01,
            y: 0.9207529567141863,
        },
        {
            x: 143.58,
            y: 0.9206384789782764,
        },
        {
            x: 144.15,
            y: 0.9205246809196362,
        },
        {
            x: 144.72,
            y: 0.9204115558391438,
        },
        {
            x: 145.29,
            y: 0.9202990971297541,
        },
        {
            x: 145.86,
            y: 0.9201872982748791,
        },
        {
            x: 146.43,
            y: 0.9200761528468009,
        },
        {
            x: 147,
            y: 0.9199656545051198,
        },
        {
            x: 147.57,
            y: 0.9198557969952351,
        },
        {
            x: 148.14000000000001,
            y: 0.9197465741468583,
        },
        {
            x: 148.71,
            y: 0.919637979872557,
        },
        {
            x: 149.28,
            y: 0.9195300081663303,
        },
        {
            x: 149.85,
            y: 0.9194226531022132,
        },
        {
            x: 150.42000000000002,
            y: 0.9193159088329108,
        },
        {
            x: 150.99,
            y: 0.9192097695884605,
        },
        {
            x: 151.56,
            y: 0.919104229674922,
        },
        {
            x: 152.13,
            y: 0.9189992834730945,
        },
        {
            x: 152.70000000000002,
            y: 0.9188949254372594,
        },
        {
            x: 153.27,
            y: 0.9187911500939505,
        },
        {
            x: 153.84,
            y: 0.918687952040747,
        },
        {
            x: 154.41,
            y: 0.9185853259450935,
        },
        {
            x: 154.98,
            y: 0.9184832665431414,
        },
        {
            x: 155.55,
            y: 0.9183817686386155,
        },
        {
            x: 156.12,
            y: 0.9182808271017031,
        },
        {
            x: 156.69,
            y: 0.9181804368679644,
        },
        {
            x: 157.26,
            y: 0.9180805929372654,
        },
        {
            x: 157.83,
            y: 0.917981290372732,
        },
        {
            x: 158.4,
            y: 0.917882524299725,
        },
        {
            x: 158.97,
            y: 0.9177842899048342,
        },
        {
            x: 159.54,
            y: 0.9176865824348941,
        },
        {
            x: 160.11,
            y: 0.917589397196017,
        },
        {
            x: 160.68,
            y: 0.9174927295526465,
        },
        {
            x: 161.25,
            y: 0.9173965749266287,
        },
        {
            x: 161.82,
            y: 0.9173009287963012,
        },
        {
            x: 162.39000000000001,
            y: 0.9172057866956003,
        },
        {
            x: 162.96,
            y: 0.9171111442131851,
        },
        {
            x: 163.53,
            y: 0.9170169969915782,
        },
        {
            x: 164.1,
            y: 0.9169233407263233,
        },
        {
            x: 164.67000000000002,
            y: 0.9168301711651584,
        },
        {
            x: 165.24,
            y: 0.9167374841072051,
        },
        {
            x: 165.81,
            y: 0.9166452754021726,
        },
        {
            x: 166.38,
            y: 0.9165535409495777,
        },
        {
            x: 166.95000000000002,
            y: 0.9164622766979789,
        },
        {
            x: 167.52,
            y: 0.9163714786442239,
        },
        {
            x: 168.09,
            y: 0.9162811428327132,
        },
        {
            x: 168.66,
            y: 0.9161912653546761,
        },
        {
            x: 169.23,
            y: 0.9161018423474598,
        },
        {
            x: 169.8,
            y: 0.9160128699938328,
        },
        {
            x: 170.37,
            y: 0.9159243445212996,
        },
        {
            x: 170.94,
            y: 0.91583626220143,
        },
        {
            x: 171.51,
            y: 0.9157486193491985,
        },
        {
            x: 172.08,
            y: 0.9156614123223378,
        },
        {
            x: 172.65,
            y: 0.9155746375207018,
        },
        {
            x: 173.22,
            y: 0.9154882913856426,
        },
        {
            x: 173.79,
            y: 0.9154023703993965,
        },
        {
            x: 174.36,
            y: 0.9153168710844829,
        },
        {
            x: 174.93,
            y: 0.9152317900031124,
        },
        {
            x: 175.5,
            y: 0.9151471237566069,
        },
        {
            x: 176.07,
            y: 0.9150628689848289,
        },
        {
            x: 176.64000000000001,
            y: 0.9149790223656215,
        },
        {
            x: 177.21,
            y: 0.9148955806142581,
        },
        {
            x: 177.78,
            y: 0.9148125404829025,
        },
        {
            x: 178.35,
            y: 0.9147298987600772,
        },
        {
            x: 178.92000000000002,
            y: 0.9146476522701419,
        },
        {
            x: 179.49,
            y: 0.9145657978727815,
        },
        {
            x: 180.06,
            y: 0.9144843324625017,
        },
        {
            x: 180.63,
            y: 0.9144032529681348,
        },
        {
            x: 181.20000000000002,
            y: 0.9143225563523532,
        },
        {
            x: 181.77,
            y: 0.9142422396111908,
        },
        {
            x: 182.34,
            y: 0.9141622997735748,
        },
        {
            x: 182.91,
            y: 0.9140827339008626,
        },
        {
            x: 183.48,
            y: 0.9140035390863891,
        },
        {
            x: 184.05,
            y: 0.91392471245502,
        },
        {
            x: 184.62,
            y: 0.9138462511627141,
        },
        {
            x: 185.19,
            y: 0.9137681523960913,
        },
        {
            x: 185.76,
            y: 0.9136904133720102,
        },
        {
            x: 186.33,
            y: 0.9136130313371503,
        },
        {
            x: 186.9,
            y: 0.9135360035676031,
        },
        {
            x: 187.47,
            y: 0.9134593273684695,
        },
        {
            x: 188.04,
            y: 0.9133830000734631,
        },
        {
            x: 188.61,
            y: 0.9133070190445213,
        },
        {
            x: 189.18,
            y: 0.9132313816714225,
        },
        {
            x: 189.75,
            y: 0.9131560853714089,
        },
        {
            x: 190.32,
            y: 0.9130811275888168,
        },
        {
            x: 190.89000000000001,
            y: 0.9130065057947112,
        },
        {
            x: 191.46,
            y: 0.9129322174865288,
        },
        {
            x: 192.03,
            y: 0.9128582601877242,
        },
        {
            x: 192.6,
            y: 0.9127846314474242,
        },
        {
            x: 193.17000000000002,
            y: 0.9127113288400859,
        },
        {
            x: 193.74,
            y: 0.9126383499651615,
        },
        {
            x: 194.31,
            y: 0.9125656924467678,
        },
        {
            x: 194.88,
            y: 0.9124933539333618,
        },
        {
            x: 195.45000000000002,
            y: 0.9124213320974207,
        },
        {
            x: 196.02,
            y: 0.9123496246351271,
        },
        {
            x: 196.59,
            y: 0.9122782292660604,
        },
        {
            x: 197.16,
            y: 0.9122071437328908,
        },
        {
            x: 197.73000000000002,
            y: 0.9121363658010809,
        },
        {
            x: 198.3,
            y: 0.91206589325859,
        },
        {
            x: 198.87,
            y: 0.9119957239155837,
        },
        {
            x: 199.44,
            y: 0.9119258556041483,
        },
        {
            x: 200.01,
            y: 0.9118562861780094,
        },
        {
            x: 200.58,
            y: 0.911787013512255,
        },
        {
            x: 201.15,
            y: 0.9117180355030627,
        },
        {
            x: 201.72,
            y: 0.9116493500674321,
        },
        {
            x: 202.29,
            y: 0.9115809551429193,
        },
        {
            x: 202.86,
            y: 0.9115128486873778,
        },
        {
            x: 203.43,
            y: 0.9114450286787025,
        },
        {
            x: 204,
            y: 0.9113774931145766,
        },
        {
            x: 204.57,
            y: 0.9113102400122242,
        },
        {
            x: 205.14000000000001,
            y: 0.9112432674081652,
        },
        {
            x: 205.71,
            y: 0.911176573357975,
        },
        {
            x: 206.28,
            y: 0.911110155936047,
        },
        {
            x: 206.85,
            y: 0.9110440132353598,
        },
        {
            x: 207.42000000000002,
            y: 0.9109781433672457,
        },
        {
            x: 207.99,
            y: 0.9109125444611662,
        },
        {
            x: 208.56,
            y: 0.9108472146644871,
        },
        {
            x: 209.13,
            y: 0.9107821521422601,
        },
        {
            x: 209.70000000000002,
            y: 0.9107173550770052,
        },
        {
            x: 210.27,
            y: 0.9106528216684986,
        },
        {
            x: 210.84,
            y: 0.9105885501335615,
        },
        {
            x: 211.41,
            y: 0.910524538705854,
        },
        {
            x: 211.98000000000002,
            y: 0.9104607856356708,
        },
        {
            x: 212.55,
            y: 0.9103972891897403,
        },
        {
            x: 213.12,
            y: 0.9103340476510271,
        },
        {
            x: 213.69,
            y: 0.9102710593185365,
        },
        {
            x: 214.26,
            y: 0.9102083225071224,
        },
        {
            x: 214.83,
            y: 0.9101458355472983,
        },
        {
            x: 215.4,
            y: 0.9100835967850504,
        },
        {
            x: 215.97,
            y: 0.9100216045816537,
        },
        {
            x: 216.54,
            y: 0.9099598573134908,
        },
        {
            x: 217.11,
            y: 0.9098983533718739,
        },
        {
            x: 217.68,
            y: 0.9098370911628674,
        },
        {
            x: 218.25,
            y: 0.9097760691071157,
        },
        {
            x: 218.82,
            y: 0.9097152856396719,
        },
        {
            x: 219.39000000000001,
            y: 0.9096547392098284,
        },
        {
            x: 219.96,
            y: 0.9095944282809523,
        },
        {
            x: 220.53,
            y: 0.9095343513303198,
        },
        {
            x: 221.1,
            y: 0.9094745068489561,
        },
        {
            x: 221.67000000000002,
            y: 0.9094148933414757,
        },
        {
            x: 222.24,
            y: 0.9093555093259253,
        },
        {
            x: 222.81,
            y: 0.9092963533336296,
        },
        {
            x: 223.38,
            y: 0.9092374239090377,
        },
        {
            x: 223.95000000000002,
            y: 0.9091787196095741,
        },
        {
            x: 224.52,
            y: 0.9091202390054892,
        },
        {
            x: 225.09,
            y: 0.9090619806797138,
        },
        {
            x: 225.66,
            y: 0.9090039432277142,
        },
        {
            x: 226.23000000000002,
            y: 0.9089461252573505,
        },
        {
            x: 226.8,
            y: 0.9088885253887364,
        },
        {
            x: 227.37,
            y: 0.9088311422541004,
        },
        {
            x: 227.94,
            y: 0.9087739744976497,
        },
        {
            x: 228.51,
            y: 0.9087170207754357,
        },
        {
            x: 229.08,
            y: 0.9086602797552211,
        },
        {
            x: 229.65,
            y: 0.9086037501163492,
        },
        {
            x: 230.22,
            y: 0.9085474305496147,
        },
        {
            x: 230.79,
            y: 0.9084913197571365,
        },
        {
            x: 231.36,
            y: 0.9084354164522316,
        },
        {
            x: 231.93,
            y: 0.9083797193592917,
        },
        {
            x: 232.5,
            y: 0.9083242272136609,
        },
        {
            x: 233.07,
            y: 0.9082689387615149,
        },
        {
            x: 233.64000000000001,
            y: 0.908213852759742,
        },
        {
            x: 234.21,
            y: 0.9081589679758256,
        },
        {
            x: 234.78,
            y: 0.9081042831877291,
        },
        {
            x: 235.35,
            y: 0.9080497971837804,
        },
        {
            x: 235.92000000000002,
            y: 0.9079955087625603,
        },
        {
            x: 236.49,
            y: 0.9079414167327906,
        },
        {
            x: 237.06,
            y: 0.9078875199132245,
        },
        {
            x: 237.63,
            y: 0.9078338171325379,
        },
        {
            x: 238.20000000000002,
            y: 0.9077803072292232,
        },
        {
            x: 238.77,
            y: 0.9077269890514833,
        },
        {
            x: 239.34,
            y: 0.9076738614571273,
        },
        {
            x: 239.91,
            y: 0.9076209233134681,
        },
        {
            x: 240.48000000000002,
            y: 0.9075681734972211,
        },
        {
            x: 241.05,
            y: 0.9075156108944034,
        },
        {
            x: 241.62,
            y: 0.9074632344002357,
        },
        {
            x: 242.19,
            y: 0.9074110429190445,
        },
        {
            x: 242.76,
            y: 0.9073590353641658,
        },
        {
            x: 243.33,
            y: 0.9073072106578501,
        },
        {
            x: 243.9,
            y: 0.9072555677311687,
        },
        {
            x: 244.47,
            y: 0.9072041055239206,
        },
        {
            x: 245.04,
            y: 0.9071528229845421,
        },
        {
            x: 245.61,
            y: 0.9071017190700156,
        },
        {
            x: 246.18,
            y: 0.9070507927457807,
        },
        {
            x: 246.75,
            y: 0.9070000429856466,
        },
        {
            x: 247.32,
            y: 0.9069494687717051,
        },
        {
            x: 247.89000000000001,
            y: 0.9068990690942444,
        },
        {
            x: 248.46,
            y: 0.9068488429516652,
        },
        {
            x: 249.03,
            y: 0.9067987893503964,
        },
        {
            x: 249.6,
            y: 0.9067489073048131,
        },
        {
            x: 250.17000000000002,
            y: 0.9066991958371546,
        },
        {
            x: 250.74,
            y: 0.9066496539774442,
        },
        {
            x: 251.31,
            y: 0.9066002807634099,
        },
        {
            x: 251.88,
            y: 0.9065510752404052,
        },
        {
            x: 252.45000000000002,
            y: 0.9065020364613323,
        },
        {
            x: 253.02,
            y: 0.9064531634865652,
        },
        {
            x: 253.59,
            y: 0.9064044553838742,
        },
        {
            x: 254.16,
            y: 0.9063559112283508,
        },
        {
            x: 254.73000000000002,
            y: 0.9063075301023347,
        },
        {
            x: 255.3,
            y: 0.9062593110953403,
        },
        {
            x: 255.87,
            y: 0.906211253303985,
        },
        {
            x: 256.44,
            y: 0.9061633558319181,
        },
        {
            x: 257.01,
            y: 0.9061156177897505,
        },
        {
            x: 257.58,
            y: 0.9060680382949854,
        },
        {
            x: 258.15,
            y: 0.9060206164719498,
        },
        {
            x: 258.72,
            y: 0.9059733514517266,
        },
        {
            x: 259.29,
            y: 0.9059262423720883,
        },
        {
            x: 259.86,
            y: 0.9058792883774301,
        },
        {
            x: 260.43,
            y: 0.9058324886187054,
        },
        {
            x: 261,
            y: 0.9057858422533607,
        },
        {
            x: 261.57,
            y: 0.9057393484452724,
        },
        {
            x: 262.14,
            y: 0.9056930063646835,
        },
        {
            x: 262.71,
            y: 0.9056468151881418,
        },
        {
            x: 263.28000000000003,
            y: 0.905600774098438,
        },
        {
            x: 263.85,
            y: 0.905554882284545,
        },
        {
            x: 264.42,
            y: 0.905509138941558,
        },
        {
            x: 264.99,
            y: 0.9054635432706359,
        },
        {
            x: 265.56,
            y: 0.9054180944789414,
        },
        {
            x: 266.13,
            y: 0.905372791779584,
        },
        {
            x: 266.7,
            y: 0.9053276343915625,
        },
        {
            x: 267.27,
            y: 0.9052826215397086,
        },
        {
            x: 267.84000000000003,
            y: 0.9052377524546308,
        },
        {
            x: 268.41,
            y: 0.9051930263726592,
        },
        {
            x: 268.98,
            y: 0.9051484425357912,
        },
        {
            x: 269.55,
            y: 0.9051040001916371,
        },
        {
            x: 270.12,
            y: 0.9050596985933671,
        },
        {
            x: 270.69,
            y: 0.9050155369996584,
        },
        {
            x: 271.26,
            y: 0.9049715146746433,
        },
        {
            x: 271.83,
            y: 0.9049276308878575,
        },
        {
            x: 272.4,
            y: 0.9048838849141894,
        },
        {
            x: 272.97,
            y: 0.9048402760338293,
        },
        {
            x: 273.54,
            y: 0.9047968035322204,
        },
        {
            x: 274.11,
            y: 0.9047534667000089,
        },
        {
            x: 274.68,
            y: 0.9047102648329961,
        },
        {
            x: 275.25,
            y: 0.9046671972320895,
        },
        {
            x: 275.82,
            y: 0.9046242632032562,
        },
        {
            x: 276.39,
            y: 0.9045814620574749,
        },
        {
            x: 276.96,
            y: 0.9045387931106906,
        },
        {
            x: 277.53000000000003,
            y: 0.9044962556837679,
        },
        {
            x: 278.1,
            y: 0.9044538491024454,
        },
        {
            x: 278.67,
            y: 0.9044115726972919,
        },
        {
            x: 279.24,
            y: 0.9043694258036608,
        },
        {
            x: 279.81,
            y: 0.904327407761647,
        },
        {
            x: 280.38,
            y: 0.9042855179160431,
        },
        {
            x: 280.95,
            y: 0.9042437556162967,
        },
        {
            x: 281.52,
            y: 0.9042021202164678,
        },
        {
            x: 282.09000000000003,
            y: 0.9041606110751873,
        },
        {
            x: 282.66,
            y: 0.9041192275556148,
        },
        {
            x: 283.23,
            y: 0.9040779690253977,
        },
        {
            x: 283.8,
            y: 0.9040368348566314,
        },
        {
            x: 284.37,
            y: 0.9039958244258182,
        },
        {
            x: 284.94,
            y: 0.9039549371138278,
        },
        {
            x: 285.51,
            y: 0.9039141723058589,
        },
        {
            x: 286.08,
            y: 0.9038735293913991,
        },
        {
            x: 286.65000000000003,
            y: 0.9038330077641872,
        },
        {
            x: 287.22,
            y: 0.9037926068221754,
        },
        {
            x: 287.79,
            y: 0.9037523259674913,
        },
        {
            x: 288.36,
            y: 0.9037121646064007,
        },
        {
            x: 288.93,
            y: 0.9036721221492713,
        },
        {
            x: 289.5,
            y: 0.903632198010536,
        },
        {
            x: 290.07,
            y: 0.9035923916086568,
        },
        {
            x: 290.64,
            y: 0.9035527023660898,
        },
        {
            x: 291.21,
            y: 0.9035131297092494,
        },
        {
            x: 291.78000000000003,
            y: 0.9034736730684736,
        },
    ],
    lowerLimitRedPoints: [
        {
            x: 0.42,
            y: -0.4853669389431553,
        },
        {
            x: 0.43,
            y: -0.4695944137442155,
        },
        {
            x: 0.44,
            y: -0.45436269078776126,
        },
        {
            x: 0.45,
            y: -0.4396415553935956,
        },
        {
            x: 0.46,
            y: -0.42540310460257336,
        },
        {
            x: 0.47000000000000003,
            y: -0.4116215246334568,
        },
        {
            x: 0.48,
            y: -0.39827289397625354,
        },
        {
            x: 0.49,
            y: -0.38533500870334747,
        },
        {
            x: 0.5,
            y: -0.3727872270952092,
        },
        {
            x: 0.51,
            y: -0.3606103311065739,
        },
        {
            x: 0.52,
            y: -0.34878640255759297,
        },
        {
            x: 0.53,
            y: -0.3372987122352954,
        },
        {
            x: 0.54,
            y: -0.3261316203439265,
        },
        {
            x: 0.55,
            y: -0.31527048695666215,
        },
        {
            x: 0.56,
            y: -0.3047015913024952,
        },
        {
            x: 0.5700000000000001,
            y: -0.29441205887622723,
        },
        {
            x: 0.58,
            y: -0.2843897954909623,
        },
        {
            x: 0.59,
            y: -0.27462342750491386,
        },
        {
            x: 0.6,
            y: -0.2651022475507895,
        },
        {
            x: 0.61,
            y: -0.25581616517893824,
        },
        {
            x: 0.62,
            y: -0.2467556618969845,
        },
        {
            x: 0.63,
            y: -0.23791175015049537,
        },
        {
            x: 0.64,
            y: -0.22927593584281392,
        },
        {
            x: 0.65,
            y: -0.2208401840387556,
        },
        {
            x: 0.66,
            y: -0.21259688753738104,
        },
        {
            x: 0.67,
            y: -0.20453883803444495,
        },
        {
            x: 0.68,
            y: -0.19665919962604284,
        },
        {
            x: 0.6900000000000001,
            y: -0.18895148443209353,
        },
        {
            x: 0.7000000000000001,
            y: -0.18140953014209693,
        },
        {
            x: 0.71,
            y: -0.1740274793065476,
        },
        {
            x: 0.72,
            y: -0.1667997602158543,
        },
        {
            x: 0.73,
            y: -0.1597210692249159,
        },
        {
            x: 0.74,
            y: -0.1527863543959328,
        },
        {
            x: 0.75,
            y: -0.1459908003448186,
        },
        {
            x: 0.76,
            y: -0.13932981418792478,
        },
        {
            x: 0.77,
            y: -0.13279901249588943,
        },
        {
            x: 0.78,
            y: -0.12639420917040878,
        },
        {
            x: 0.79,
            y: -0.12011140416774624,
        },
        {
            x: 0.8,
            y: -0.11394677299996658,
        },
        {
            x: 0.81,
            y: -0.1078966569512878,
        },
        {
            x: 0.8200000000000001,
            y: -0.1019575539526848,
        },
        {
            x: 0.8300000000000001,
            y: -0.09612611006304261,
        },
        {
            x: 0.84,
            y: -0.09039911150977731,
        },
        {
            x: 0.85,
            y: -0.08477347724601492,
        },
        {
            x: 0.86,
            y: -0.0792462519851711,
        },
        {
            x: 0.87,
            y: -0.07381459967715842,
        },
        {
            x: 0.88,
            y: -0.0684757973935074,
        },
        {
            x: 0.89,
            y: -0.06322722959145144,
        },
        {
            x: 0.9,
            y: -0.0580663827295278,
        },
        {
            x: 0.91,
            y: -0.05299084020951794,
        },
        {
            x: 0.92,
            y: -0.04799827762160491,
        },
        {
            x: 0.93,
            y: -0.043086458271498485,
        },
        {
            x: 0.9400000000000001,
            y: -0.03825322896997796,
        },
        {
            x: 0.9500000000000001,
            y: -0.03349651606684745,
        },
        {
            x: 0.96,
            y: -0.028814321712714808,
        },
        {
            x: 0.97,
            y: -0.02420472033328347,
        },
        {
            x: 0.98,
            y: -0.019665855302029467,
        },
        {
            x: 0.99,
            y: -0.015195935798200555,
        },
        {
            x: 1,
            y: -0.010793233838066962,
        },
        {
            x: 1.01,
            y: -0.006456081468238284,
        },
        {
            x: 1.02,
            y: -0.002182868110699676,
        },
        {
            x: 1.03,
            y: 0.002027961950034185,
        },
        {
            x: 1.04,
            y: 0.00617791194654993,
        },
        {
            x: 1.05,
            y: 0.010268434883220046,
        },
        {
            x: 1.06,
            y: 0.014300935673617565,
        },
        {
            x: 1.07,
            y: 0.01827677316780474,
        },
        {
            x: 1.08,
            y: 0.022197262076137925,
        },
        {
            x: 1.09,
            y: 0.02606367479577454,
        },
        {
            x: 1.1,
            y: 0.029877243145643995,
        },
        {
            x: 1.11,
            y: 0.033639160015256464,
        },
        {
            x: 1.12,
            y: 0.03735058093235866,
        },
        {
            x: 1.1300000000000001,
            y: 0.041012625554119664,
        },
        {
            x: 1.1400000000000001,
            y: 0.04462637908621159,
        },
        {
            x: 1.1500000000000001,
            y: 0.04819289363387225,
        },
        {
            x: 1.16,
            y: 0.05171318948877013,
        },
        {
            x: 1.17,
            y: 0.055188256355244714,
        },
        {
            x: 1.18,
            y: 0.05861905451926808,
        },
        {
            x: 1.19,
            y: 0.06200651596326434,
        },
        {
            x: 1.2,
            y: 0.06535154542972688,
        },
        {
            x: 1.21,
            y: 0.06865502143638647,
        },
        {
            x: 1.22,
            y: 0.07191779724551983,
        },
        {
            x: 1.23,
            y: 0.07514070178982613,
        },
        {
            x: 1.24,
            y: 0.07832454055715221,
        },
        {
            x: 1.25,
            y: 0.08147009643621073,
        },
        {
            x: 1.26,
            y: 0.08457813052530994,
        },
        {
            x: 1.27,
            y: 0.0876493829059879,
        },
        {
            x: 1.28,
            y: 0.09068457338333935,
        },
        {
            x: 1.29,
            y: 0.09368440219471807,
        },
        {
            x: 1.3,
            y: 0.09664955068839576,
        },
        {
            x: 1.31,
            y: 0.09958068197367231,
        },
        {
            x: 1.32,
            y: 0.10247844154384889,
        },
        {
            x: 1.33,
            y: 0.10534345787338673,
        },
        {
            x: 1.34,
            y: 0.10817634299051182,
        },
        {
            x: 1.35,
            y: 0.11097769302644711,
        },
        {
            x: 1.36,
            y: 0.11374808874239117,
        },
        {
            x: 1.37,
            y: 0.11648809603530208,
        },
        {
            x: 1.3800000000000001,
            y: 0.1191982664234873,
        },
        {
            x: 1.3900000000000001,
            y: 0.12187913751294333,
        },
        {
            x: 1.4000000000000001,
            y: 0.12453123344534278,
        },
        {
            x: 1.41,
            y: 0.12715506532851495,
        },
        {
            x: 1.42,
            y: 0.12975113165022345,
        },
        {
            x: 1.43,
            y: 0.13231991867600135,
        },
        {
            x: 1.44,
            y: 0.1348619008317642,
        },
        {
            x: 1.45,
            y: 0.13737754107188538,
        },
        {
            x: 1.46,
            y: 0.13986729123338093,
        },
        {
            x: 1.47,
            y: 0.14233159237682103,
        },
        {
            x: 1.48,
            y: 0.14477087511454967,
        },
        {
            x: 1.49,
            y: 0.14718555992676852,
        },
        {
            x: 1.5,
            y: 0.1495760574660122,
        },
        {
            x: 1.51,
            y: 0.1519427688505146,
        },
        {
            x: 1.52,
            y: 0.1542860859469416,
        },
        {
            x: 1.53,
            y: 0.1566063916429451,
        },
        {
            x: 1.54,
            y: 0.15890406010996438,
        },
        {
            x: 1.55,
            y: 0.1611794570566908,
        },
        {
            x: 1.56,
            y: 0.163432939973578,
        },
        {
            x: 1.57,
            y: 0.1656648583687752,
        },
        {
            x: 1.58,
            y: 0.16787555399583354,
        },
        {
            x: 1.59,
            y: 0.17006536107352355,
        },
        {
            x: 1.6,
            y: 0.1722346064980843,
        },
        {
            x: 1.61,
            y: 0.1743836100482108,
        },
        {
            x: 1.62,
            y: 0.17651268458307068,
        },
        {
            x: 1.6300000000000001,
            y: 0.1786221362336291,
        },
        {
            x: 1.6400000000000001,
            y: 0.1807122645875482,
        },
        {
            x: 1.6500000000000001,
            y: 0.18278336286791208,
        },
        {
            x: 1.6600000000000001,
            y: 0.18483571810602317,
        },
        {
            x: 1.67,
            y: 0.18686961130849744,
        },
        {
            x: 1.68,
            y: 0.1888853176188826,
        },
        {
            x: 1.69,
            y: 0.19088310647400708,
        },
        {
            x: 1.7,
            y: 0.19286324175526437,
        },
        {
            x: 1.71,
            y: 0.19482598193502376,
        },
        {
            x: 1.72,
            y: 0.1967715802183525,
        },
        {
            x: 1.73,
            y: 0.1987002846802265,
        },
        {
            x: 1.74,
            y: 0.20061233839839587,
        },
        {
            x: 1.75,
            y: 0.202507979582071,
        },
        {
            x: 1.76,
            y: 0.20438744169657963,
        },
        {
            x: 1.77,
            y: 0.2062509535841458,
        },
        {
            x: 1.78,
            y: 0.20809873958093084,
        },
        {
            x: 1.79,
            y: 0.20993101963047422,
        },
        {
            x: 1.8,
            y: 0.21174800939366245,
        },
        {
            x: 1.81,
            y: 0.21354992035535103,
        },
        {
            x: 1.82,
            y: 0.21533695992776203,
        },
        {
            x: 1.83,
            y: 0.21710933155076773,
        },
        {
            x: 1.84,
            y: 0.21886723478917358,
        },
        {
            x: 1.85,
            y: 0.22061086542710462,
        },
        {
            x: 1.86,
            y: 0.22234041555959705,
        },
        {
            x: 1.87,
            y: 0.2240560736814935,
        },
        {
            x: 1.8800000000000001,
            y: 0.22575802477373186,
        },
        {
            x: 1.8900000000000001,
            y: 0.22744645038712197,
        },
        {
            x: 1.9000000000000001,
            y: 0.22912152872369296,
        },
        {
            x: 1.9100000000000001,
            y: 0.23078343471569462,
        },
        {
            x: 1.92,
            y: 0.2324323401023335,
        },
        {
            x: 1.93,
            y: 0.23406841350431973,
        },
        {
            x: 1.94,
            y: 0.23569182049629622,
        },
        {
            x: 1.95,
            y: 0.2373027236772235,
        },
        {
            x: 1.96,
            y: 0.23890128273878652,
        },
        {
            x: 1.97,
            y: 0.2404876545318898,
        },
        {
            x: 1.98,
            y: 0.24206199313130183,
        },
        {
            x: 1.99,
            y: 0.24362444989851195,
        },
        {
            x: 2,
            y: 0.24517517354285567,
        },
        {
            x: 2.0100000000000002,
            y: 0.24671431018096535,
        },
        {
            x: 2.02,
            y: 0.2482420033946009,
        },
        {
            x: 2.0300000000000002,
            y: 0.24975839428691038,
        },
        {
            x: 2.04,
            y: 0.2512636215371733,
        },
        {
            x: 2.05,
            y: 0.25275782145407255,
        },
        {
            x: 2.06,
            y: 0.2542411280275423,
        },
        {
            x: 2.07,
            y: 0.255713672979237,
        },
        {
            x: 2.08,
            y: 0.2571755858116638,
        },
        {
            x: 2.09,
            y: 0.25862699385602106,
        },
        {
            x: 2.1,
            y: 0.26006802231878234,
        },
        {
            x: 2.11,
            y: 0.26149879432706324,
        },
        {
            x: 2.12,
            y: 0.26291943097281256,
        },
        {
            x: 2.13,
            y: 0.2643300513558582,
        },
        {
            x: 2.14,
            y: 0.265730772625848,
        },
        {
            x: 2.15,
            y: 0.2671217100231139,
        },
        {
            x: 2.16,
            y: 0.268502976918497,
        },
        {
            x: 2.17,
            y: 0.2698746848521594,
        },
        {
            x: 2.18,
            y: 0.27123694357141803,
        },
        {
            x: 2.19,
            y: 0.2725898610676254,
        },
        {
            x: 2.2,
            y: 0.2739335436121292,
        },
        {
            x: 2.21,
            y: 0.27526809579133316,
        },
        {
            x: 2.22,
            y: 0.276593620540892,
        },
        {
            x: 2.23,
            y: 0.27791021917905834,
        },
        {
            x: 2.24,
            y: 0.27921799143921266,
        },
        {
            x: 2.25,
            y: 0.28051703550159546,
        },
        {
            x: 2.2600000000000002,
            y: 0.2818074480242677,
        },
        {
            x: 2.27,
            y: 0.2830893241733188,
        },
        {
            x: 2.2800000000000002,
            y: 0.28436275765234664,
        },
        {
            x: 2.29,
            y: 0.2856278407312274,
        },
        {
            x: 2.3000000000000003,
            y: 0.2868846642741979,
        },
        {
            x: 2.31,
            y: 0.28813331776726725,
        },
        {
            x: 2.32,
            y: 0.2893738893449791,
        },
        {
            x: 2.33,
            y: 0.2906064658165415,
        },
        {
            x: 2.34,
            y: 0.2918311326913401,
        },
        {
            x: 2.35,
            y: 0.29304797420385664,
        },
        {
            x: 2.36,
            y: 0.2942570733380033,
        },
        {
            x: 2.37,
            y: 0.29545851185089334,
        },
        {
            x: 2.38,
            y: 0.29665237029606106,
        },
        {
            x: 2.39,
            y: 0.29783872804614764,
        },
        {
            x: 2.4,
            y: 0.2990176633150655,
        },
        {
            x: 2.41,
            y: 0.3001892531796573,
        },
        {
            x: 2.42,
            y: 0.30135357360086157,
        },
        {
            x: 2.43,
            y: 0.3025106994443988,
        },
        {
            x: 2.44,
            y: 0.30366070450099114,
        },
        {
            x: 2.45,
            y: 0.3048036615061278,
        },
        {
            x: 2.46,
            y: 0.30593964215938707,
        },
        {
            x: 2.47,
            y: 0.30706871714332906,
        },
        {
            x: 2.48,
            y: 0.308190956141968,
        },
        {
            x: 2.49,
            y: 0.30930642785883633,
        },
        {
            x: 2.5,
            y: 0.3104152000346515,
        },
        {
            x: 2.5100000000000002,
            y: 0.3115173394645948,
        },
        {
            x: 2.52,
            y: 0.3126129120152126,
        },
        {
            x: 2.5300000000000002,
            y: 0.31370198264094973,
        },
        {
            x: 2.54,
            y: 0.3147846154003252,
        },
        {
            x: 2.5500000000000003,
            y: 0.3158608734717582,
        },
        {
            x: 2.56,
            y: 0.3169308191690533,
        },
        {
            x: 2.57,
            y: 0.317994513956555,
        },
        {
            x: 2.58,
            y: 0.319052018463978,
        },
        {
            x: 2.59,
            y: 0.32010339250092257,
        },
        {
            x: 2.6,
            y: 0.32114869507108246,
        },
        {
            x: 2.61,
            y: 0.3221879843861536,
        },
        {
            x: 2.62,
            y: 0.32322131787944963,
        },
        {
            x: 2.63,
            y: 0.32424875221923344,
        },
        {
            x: 2.64,
            y: 0.32527034332176974,
        },
        {
            x: 2.65,
            y: 0.32628614636410724,
        },
        {
            x: 2.66,
            y: 0.32729621579659607,
        },
        {
            x: 2.67,
            y: 0.3283006053551467,
        },
        {
            x: 2.68,
            y: 0.3292993680732378,
        },
        {
            x: 2.69,
            y: 0.33029255629367715,
        },
        {
            x: 2.7,
            y: 0.3312802216801247,
        },
        {
            x: 2.71,
            y: 0.3322624152283794,
        },
        {
            x: 2.72,
            y: 0.33323918727743884,
        },
        {
            x: 2.73,
            y: 0.33421058752033583,
        },
        {
            x: 2.74,
            y: 0.33517666501475685,
        },
        {
            x: 2.75,
            y: 0.3361374681934478,
        },
        {
            x: 2.7600000000000002,
            y: 0.3370930448744135,
        },
        {
            x: 2.77,
            y: 0.3380434422709123,
        },
        {
            x: 2.7800000000000002,
            y: 0.33898870700125494,
        },
        {
            x: 2.79,
            y: 0.33992888509840824,
        },
        {
            x: 3.36,
            y: 0.3863692313355716,
        },
        {
            x: 3.93,
            y: 0.42229779692347175,
        },
        {
            x: 4.5,
            y: 0.4511626404222106,
        },
        {
            x: 5.07,
            y: 0.47501127628640544,
        },
        {
            x: 5.64,
            y: 0.49514631975471773,
        },
        {
            x: 6.21,
            y: 0.5124412213099159,
        },
        {
            x: 6.78,
            y: 0.5275064693563378,
        },
        {
            x: 7.3500000000000005,
            y: 0.540783339400432,
        },
        {
            x: 7.92,
            y: 0.5525997836561112,
        },
        {
            x: 8.49,
            y: 0.5632052973324773,
        },
        {
            x: 9.06,
            y: 0.5727935107180024,
        },
        {
            x: 9.63,
            y: 0.5815173071765486,
        },
        {
            x: 10.200000000000001,
            y: 0.5894992238263393,
        },
        {
            x: 10.77,
            y: 0.5968387812917726,
        },
        {
            x: 11.34,
            y: 0.6036177596290504,
        },
        {
            x: 11.91,
            y: 0.6099040676433578,
        },
        {
            x: 12.48,
            y: 0.6157546283430881,
        },
        {
            x: 13.05,
            y: 0.6212175631445754,
        },
        {
            x: 13.620000000000001,
            y: 0.6263338677287617,
        },
        {
            x: 14.19,
            y: 0.6311387137057355,
        },
        {
            x: 14.76,
            y: 0.6356624709831298,
        },
        {
            x: 15.33,
            y: 0.6399315190072496,
        },
        {
            x: 15.9,
            y: 0.6439688965416226,
        },
        {
            x: 16.47,
            y: 0.6477948266375363,
        },
        {
            x: 17.04,
            y: 0.6514271441733606,
        },
        {
            x: 17.61,
            y: 0.6548816466363451,
        },
        {
            x: 18.18,
            y: 0.6581723839188139,
        },
        {
            x: 18.75,
            y: 0.6613118992757727,
        },
        {
            x: 19.32,
            y: 0.6643114308821996,
        },
        {
            x: 19.89,
            y: 0.6671810813843915,
        },
        {
            x: 20.46,
            y: 0.6699299612833949,
        },
        {
            x: 21.03,
            y: 0.6725663107933479,
        },
        {
            x: 21.6,
            y: 0.6750976038923022,
        },
        {
            x: 22.17,
            y: 0.6775306375614143,
        },
        {
            x: 22.740000000000002,
            y: 0.6798716086414958,
        },
        {
            x: 23.31,
            y: 0.6821261802875879,
        },
        {
            x: 23.88,
            y: 0.6842995396454432,
        },
        {
            x: 24.45,
            y: 0.6863964480881382,
        },
        {
            x: 25.02,
            y: 0.688421285121032,
        },
        {
            x: 25.59,
            y: 0.6903780868770779,
        },
        {
            x: 26.16,
            y: 0.6922705799729678,
        },
        {
            x: 26.73,
            y: 0.6941022113726824,
        },
        {
            x: 27.3,
            y: 0.695876174803226,
        },
        {
            x: 27.87,
            y: 0.6975954341833109,
        },
        {
            x: 28.44,
            y: 0.6992627444561428,
        },
        {
            x: 29.01,
            y: 0.7008806701595195,
        },
        {
            x: 29.580000000000002,
            y: 0.702451602018062,
        },
        {
            x: 30.150000000000002,
            y: 0.703977771801811,
        },
        {
            x: 30.72,
            y: 0.7054612656612738,
        },
        {
            x: 31.29,
            y: 0.7069040361201704,
        },
        {
            x: 31.86,
            y: 0.7083079128826891,
        },
        {
            x: 32.43,
            y: 0.7096746125913054,
        },
        {
            x: 33,
            y: 0.7110057476535062,
        },
        {
            x: 33.57,
            y: 0.7123028342406323,
        },
        {
            x: 34.14,
            y: 0.7135672995490667,
        },
        {
            x: 34.71,
            y: 0.7148004884028387,
        },
        {
            x: 35.28,
            y: 0.7160036692670956,
        },
        {
            x: 35.85,
            y: 0.717178039733571,
        },
        {
            x: 36.42,
            y: 0.7183247315319831,
        },
        {
            x: 36.99,
            y: 0.7194448151150317,
        },
        {
            x: 37.56,
            y: 0.7205393038592184,
        },
        {
            x: 38.13,
            y: 0.7216091579189641,
        },
        {
            x: 38.7,
            y: 0.7226552877673388,
        },
        {
            x: 39.27,
            y: 0.7236785574530833,
        },
        {
            x: 39.84,
            y: 0.7246797876003994,
        },
        {
            x: 40.410000000000004,
            y: 0.7256597581751827,
        },
        {
            x: 40.980000000000004,
            y: 0.7266192110388839,
        },
        {
            x: 41.550000000000004,
            y: 0.7275588523090071,
        },
        {
            x: 42.12,
            y: 0.7284793545433079,
        },
        {
            x: 42.69,
            y: 0.7293813587630485,
        },
        {
            x: 43.26,
            y: 0.7302654763291367,
        },
        {
            x: 43.83,
            y: 0.7311322906836281,
        },
        {
            x: 44.4,
            y: 0.7319823589678616,
        },
        {
            x: 44.97,
            y: 0.7328162135274278,
        },
        {
            x: 45.54,
            y: 0.7336343633132021,
        },
        {
            x: 46.11,
            y: 0.7344372951868247,
        },
        {
            x: 46.68,
            y: 0.7352254751382324,
        },
        {
            x: 47.25,
            y: 0.7359993494221608,
        },
        {
            x: 47.82,
            y: 0.7367593456199127,
        },
        {
            x: 48.39,
            y: 0.7375058736321342,
        },
        {
            x: 48.96,
            y: 0.7382393266078323,
        },
        {
            x: 49.53,
            y: 0.7389600818144193,
        },
        {
            x: 50.1,
            y: 0.7396685014531564,
        },
        {
            x: 50.67,
            y: 0.7403649334240016,
        },
        {
            x: 51.24,
            y: 0.7410497120435291,
        },
        {
            x: 51.81,
            y: 0.7417231587192876,
        },
        {
            x: 52.38,
            y: 0.7423855825836854,
        },
        {
            x: 52.95,
            y: 0.7430372810902421,
        },
        {
            x: 53.52,
            y: 0.7436785405748213,
        },
        {
            x: 54.09,
            y: 0.7443096367842466,
        },
        {
            x: 54.660000000000004,
            y: 0.7449308353745192,
        },
        {
            x: 55.230000000000004,
            y: 0.7455423923806819,
        },
        {
            x: 55.800000000000004,
            y: 0.7461445546602156,
        },
        {
            x: 56.370000000000005,
            y: 0.746737560311714,
        },
        {
            x: 56.94,
            y: 0.747321639070448,
        },
        {
            x: 57.51,
            y: 0.7478970126823129,
        },
        {
            x: 58.08,
            y: 0.7484638952575411,
        },
        {
            x: 58.65,
            y: 0.7490224936054605,
        },
        {
            x: 59.22,
            y: 0.7495730075514894,
        },
        {
            x: 59.79,
            y: 0.7501156302374692,
        },
        {
            x: 60.36,
            y: 0.7506505484063613,
        },
        {
            x: 60.93,
            y: 0.7511779426722607,
        },
        {
            x: 61.5,
            y: 0.7516979877766139,
        },
        {
            x: 62.07,
            y: 0.7522108528314648,
        },
        {
            x: 62.64,
            y: 0.7527167015504997,
        },
        {
            x: 63.21,
            y: 0.7532156924686059,
        },
        {
            x: 63.78,
            y: 0.7537079791506148,
        },
        {
            x: 64.35,
            y: 0.7541937103898524,
        },
        {
            x: 64.92,
            y: 0.7546730303970802,
        },
        {
            x: 65.49,
            y: 0.7551460789803723,
        },
        {
            x: 66.06,
            y: 0.7556129917164363,
        },
        {
            x: 66.63,
            y: 0.756073900113857,
        },
        {
            x: 67.2,
            y: 0.756528931768708,
        },
        {
            x: 67.77,
            y: 0.7569782105129488,
        },
        {
            x: 68.34,
            y: 0.757421856556001,
        },
        {
            x: 68.91,
            y: 0.7578599866198693,
        },
        {
            x: 69.48,
            y: 0.7582927140681537,
        },
        {
            x: 70.05,
            y: 0.7587201490292756,
        },
        {
            x: 70.62,
            y: 0.7591423985142227,
        },
        {
            x: 71.19,
            y: 0.7595595665290983,
        },
        {
            x: 71.76,
            y: 0.7599717541827432,
        },
        {
            x: 72.33,
            y: 0.7603790597896847,
        },
        {
            x: 72.9,
            y: 0.7607815789686485,
        },
        {
            x: 73.47,
            y: 0.7611794047368596,
        },
        {
            x: 74.04,
            y: 0.7615726276003422,
        },
        {
            x: 74.61,
            y: 0.761961335640418,
        },
        {
            x: 75.18,
            y: 0.7623456145965908,
        },
        {
            x: 75.75,
            y: 0.762725547945994,
        },
        {
            x: 76.32000000000001,
            y: 0.7631012169795692,
        },
        {
            x: 76.89,
            y: 0.7634727008751317,
        },
        {
            x: 77.46000000000001,
            y: 0.7638400767674751,
        },
        {
            x: 78.03,
            y: 0.764203419815652,
        },
        {
            x: 78.60000000000001,
            y: 0.7645628032675684,
        },
        {
            x: 79.17,
            y: 0.7649182985220142,
        },
        {
            x: 79.74,
            y: 0.7652699751882512,
        },
        {
            x: 80.31,
            y: 0.7656179011432703,
        },
        {
            x: 80.88,
            y: 0.7659621425868262,
        },
        {
            x: 81.45,
            y: 0.7663027640943488,
        },
        {
            x: 82.02,
            y: 0.7666398286678309,
        },
        {
            x: 82.59,
            y: 0.7669733977847779,
        },
        {
            x: 83.16,
            y: 0.7673035314453116,
        },
        {
            x: 83.73,
            y: 0.7676302882175059,
        },
        {
            x: 84.3,
            y: 0.7679537252810339,
        },
        {
            x: 84.87,
            y: 0.7682738984692006,
        },
        {
            x: 85.44,
            y: 0.7685908623094299,
        },
        {
            x: 86.01,
            y: 0.7689046700622735,
        },
        {
            x: 86.58,
            y: 0.7692153737590062,
        },
        {
            x: 87.15,
            y: 0.7695230242378643,
        },
        {
            x: 87.72,
            y: 0.7698276711789892,
        },
        {
            x: 88.29,
            y: 0.7701293631381265,
        },
        {
            x: 88.86,
            y: 0.7704281475791349,
        },
        {
            x: 89.43,
            y: 0.7707240709053537,
        },
        {
            x: 90,
            y: 0.7710171784898757,
        },
        {
            x: 90.57000000000001,
            y: 0.7713075147047709,
        },
        {
            x: 91.14,
            y: 0.7715951229493029,
        },
        {
            x: 91.71000000000001,
            y: 0.7718800456771797,
        },
        {
            x: 92.28,
            y: 0.7721623244228771,
        },
        {
            x: 92.85000000000001,
            y: 0.772441999827072,
        },
        {
            x: 93.42,
            y: 0.7727191116612201,
        },
        {
            x: 93.99,
            y: 0.7729936988513146,
        },
        {
            x: 94.56,
            y: 0.7732657995008538,
        },
        {
            x: 95.13,
            y: 0.7735354509130515,
        },
        {
            x: 95.7,
            y: 0.7738026896123195,
        },
        {
            x: 96.27,
            y: 0.7740675513650479,
        },
        {
            x: 96.84,
            y: 0.7743300711997133,
        },
        {
            x: 97.41,
            y: 0.7745902834263378,
        },
        {
            x: 97.98,
            y: 0.7748482216553251,
        },
        {
            x: 98.55,
            y: 0.7751039188156957,
        },
        {
            x: 99.12,
            y: 0.7753574071727457,
        },
        {
            x: 99.69,
            y: 0.7756087183451486,
        },
        {
            x: 100.26,
            y: 0.7758578833215214,
        },
        {
            x: 100.83,
            y: 0.7761049324764764,
        },
        {
            x: 101.4,
            y: 0.7763498955861736,
        },
        {
            x: 101.97,
            y: 0.7765928018433967,
        },
        {
            x: 102.54,
            y: 0.7768336798721661,
        },
        {
            x: 103.11,
            y: 0.7770725577419071,
        },
        {
            x: 103.68,
            y: 0.7773094629811893,
        },
        {
            x: 104.25,
            y: 0.7775444225910529,
        },
        {
            x: 104.82000000000001,
            y: 0.7777774630579349,
        },
        {
            x: 105.39,
            y: 0.7780086103662103,
        },
        {
            x: 105.96000000000001,
            y: 0.7782378900103626,
        },
        {
            x: 106.53,
            y: 0.778465327006795,
        },
        {
            x: 107.10000000000001,
            y: 0.7786909459052956,
        },
        {
            x: 107.67,
            y: 0.7789147708001679,
        },
        {
            x: 108.24000000000001,
            y: 0.7791368253410396,
        },
        {
            x: 108.81,
            y: 0.7793571327433579,
        },
        {
            x: 109.38,
            y: 0.7795757157985856,
        },
        {
            x: 109.95,
            y: 0.7797925968841042,
        },
        {
            x: 110.52,
            y: 0.7800077979728368,
        },
        {
            x: 111.09,
            y: 0.780221340642599,
        },
        {
            x: 111.66,
            y: 0.7804332460851866,
        },
        {
            x: 112.23,
            y: 0.7806435351152097,
        },
        {
            x: 112.8,
            y: 0.7808522281786796,
        },
        {
            x: 113.37,
            y: 0.78105934536136,
        },
        {
            x: 113.94,
            y: 0.7812649063968866,
        },
        {
            x: 114.51,
            y: 0.7814689306746644,
        },
        {
            x: 115.08,
            y: 0.7816714372475497,
        },
        {
            x: 115.65,
            y: 0.7818724448393244,
        },
        {
            x: 116.22,
            y: 0.7820719718519664,
        },
        {
            x: 116.79,
            y: 0.7822700363727275,
        },
        {
            x: 117.36,
            y: 0.782466656181019,
        },
        {
            x: 117.93,
            y: 0.7826618487551161,
        },
        {
            x: 118.5,
            y: 0.7828556312786839,
        },
        {
            x: 119.07000000000001,
            y: 0.7830480206471317,
        },
        {
            x: 119.64,
            y: 0.7832390334738001,
        },
        {
            x: 120.21000000000001,
            y: 0.7834286860959869,
        },
        {
            x: 120.78,
            y: 0.7836169945808169,
        },
        {
            x: 121.35000000000001,
            y: 0.7838039747309584,
        },
        {
            x: 121.92,
            y: 0.7839896420901944,
        },
        {
            x: 122.49000000000001,
            y: 0.7841740119488495,
        },
        {
            x: 123.06,
            y: 0.7843570993490793,
        },
        {
            x: 123.63000000000001,
            y: 0.784538919090025,
        },
        {
            x: 124.2,
            y: 0.7847194857328386,
        },
        {
            x: 124.77,
            y: 0.7848988136055799,
        },
        {
            x: 125.34,
            y: 0.7850769168079933,
        },
        {
            x: 125.91,
            y: 0.7852538092161633,
        },
        {
            x: 126.48,
            y: 0.7854295044870561,
        },
        {
            x: 127.05,
            y: 0.7856040160629477,
        },
        {
            x: 127.62,
            y: 0.7857773571757445,
        },
        {
            x: 128.19,
            y: 0.7859495408511967,
        },
        {
            x: 128.76,
            y: 0.7861205799130099,
        },
        {
            x: 129.33,
            y: 0.7862904869868569,
        },
        {
            x: 129.9,
            y: 0.786459274504292,
        },
        {
            x: 130.47,
            y: 0.7866269547065718,
        },
        {
            x: 131.04,
            y: 0.7867935396483839,
        },
        {
            x: 131.61,
            y: 0.7869590412014875,
        },
        {
            x: 132.18,
            y: 0.7871234710582661,
        },
        {
            x: 132.75,
            y: 0.7872868407351983,
        },
        {
            x: 133.32,
            y: 0.7874491615762446,
        },
        {
            x: 133.89000000000001,
            y: 0.787610444756157,
        },
        {
            x: 134.46,
            y: 0.7877707012837097,
        },
        {
            x: 135.03,
            y: 0.7879299420048552,
        },
        {
            x: 135.6,
            y: 0.7880881776058081,
        },
        {
            x: 136.17000000000002,
            y: 0.7882454186160565,
        },
        {
            x: 136.74,
            y: 0.7884016754113055,
        },
        {
            x: 137.31,
            y: 0.7885569582163526,
        },
        {
            x: 137.88,
            y: 0.7887112771078983,
        },
        {
            x: 138.45000000000002,
            y: 0.7888646420172926,
        },
        {
            x: 139.02,
            y: 0.7890170627332188,
        },
        {
            x: 139.59,
            y: 0.789168548904319,
        },
        {
            x: 140.16,
            y: 0.7893191100417586,
        },
        {
            x: 140.73,
            y: 0.789468755521735,
        },
        {
            x: 141.3,
            y: 0.78961749458793,
        },
        {
            x: 141.87,
            y: 0.7897653363539079,
        },
        {
            x: 142.44,
            y: 0.7899122898054611,
        },
        {
            x: 143.01,
            y: 0.7900583638029046,
        },
        {
            x: 143.58,
            y: 0.790203567083319,
        },
        {
            x: 144.15,
            y: 0.7903479082627457,
        },
        {
            x: 144.72,
            y: 0.7904913958383349,
        },
        {
            x: 145.29,
            y: 0.790634038190446,
        },
        {
            x: 145.86,
            y: 0.7907758435847037,
        },
        {
            x: 146.43,
            y: 0.7909168201740093,
        },
        {
            x: 147,
            y: 0.7910569760005106,
        },
        {
            x: 147.57,
            y: 0.7911963189975275,
        },
        {
            x: 148.14000000000001,
            y: 0.7913348569914392,
        },
        {
            x: 148.71,
            y: 0.79147259770353,
        },
        {
            x: 149.28,
            y: 0.7916095487517967,
        },
        {
            x: 149.85,
            y: 0.7917457176527187,
        },
        {
            x: 150.42000000000002,
            y: 0.7918811118229908,
        },
        {
            x: 150.99,
            y: 0.7920157385812192,
        },
        {
            x: 151.56,
            y: 0.792149605149584,
        },
        {
            x: 152.13,
            y: 0.792282718655466,
        },
        {
            x: 152.70000000000002,
            y: 0.7924150861330406,
        },
        {
            x: 153.27,
            y: 0.7925467145248394,
        },
        {
            x: 153.84,
            y: 0.7926776106832794,
        },
        {
            x: 154.41,
            y: 0.7928077813721611,
        },
        {
            x: 154.98,
            y: 0.7929372332681371,
        },
        {
            x: 155.55,
            y: 0.7930659729621501,
        },
        {
            x: 156.12,
            y: 0.793194006960842,
        },
        {
            x: 156.69,
            y: 0.7933213416879361,
        },
        {
            x: 157.26,
            y: 0.7934479834855899,
        },
        {
            x: 157.83,
            y: 0.7935739386157223,
        },
        {
            x: 158.4,
            y: 0.7936992132613141,
        },
        {
            x: 158.97,
            y: 0.7938238135276828,
        },
        {
            x: 159.54,
            y: 0.7939477454437321,
        },
        {
            x: 160.11,
            y: 0.7940710149631774,
        },
        {
            x: 160.68,
            y: 0.7941936279657473,
        },
        {
            x: 161.25,
            y: 0.7943155902583611,
        },
        {
            x: 161.82,
            y: 0.7944369075762842,
        },
        {
            x: 162.39000000000001,
            y: 0.7945575855842608,
        },
        {
            x: 162.96,
            y: 0.7946776298776251,
        },
        {
            x: 163.53,
            y: 0.7947970459833906,
        },
        {
            x: 164.1,
            y: 0.7949158393613194,
        },
        {
            x: 164.67000000000002,
            y: 0.79503401540497,
        },
        {
            x: 165.24,
            y: 0.7951515794427264,
        },
        {
            x: 165.81,
            y: 0.7952685367388072,
        },
        {
            x: 166.38,
            y: 0.7953848924942553,
        },
        {
            x: 166.95000000000002,
            y: 0.7955006518479095,
        },
        {
            x: 167.52,
            y: 0.795615819877358,
        },
        {
            x: 168.09,
            y: 0.7957304015998735,
        },
        {
            x: 168.66,
            y: 0.7958444019733315,
        },
        {
            x: 169.23,
            y: 0.7959578258971112,
        },
        {
            x: 169.8,
            y: 0.7960706782129799,
        },
        {
            x: 170.37,
            y: 0.7961829637059614,
        },
        {
            x: 170.94,
            y: 0.7962946871051877,
        },
        {
            x: 171.51,
            y: 0.7964058530847358,
        },
        {
            x: 172.08,
            y: 0.796516466264449,
        },
        {
            x: 172.65,
            y: 0.7966265312107437,
        },
        {
            x: 173.22,
            y: 0.7967360524374001,
        },
        {
            x: 173.79,
            y: 0.796845034406341,
        },
        {
            x: 174.36,
            y: 0.7969534815283946,
        },
        {
            x: 174.93,
            y: 0.7970613981640443,
        },
        {
            x: 175.5,
            y: 0.7971687886241652,
        },
        {
            x: 176.07,
            y: 0.7972756571707477,
        },
        {
            x: 176.64000000000001,
            y: 0.7973820080176072,
        },
        {
            x: 177.21,
            y: 0.7974878453310827,
        },
        {
            x: 177.78,
            y: 0.7975931732307222,
        },
        {
            x: 178.35,
            y: 0.7976979957899558,
        },
        {
            x: 178.92000000000002,
            y: 0.7978023170367575,
        },
        {
            x: 179.49,
            y: 0.7979061409542958,
        },
        {
            x: 180.06,
            y: 0.7980094714815716,
        },
        {
            x: 180.63,
            y: 0.7981123125140469,
        },
        {
            x: 181.20000000000002,
            y: 0.7982146679042608,
        },
        {
            x: 181.77,
            y: 0.7983165414624357,
        },
        {
            x: 182.34,
            y: 0.7984179369570739,
        },
        {
            x: 182.91,
            y: 0.798518858115542,
        },
        {
            x: 183.48,
            y: 0.7986193086246473,
        },
        {
            x: 184.05,
            y: 0.7987192921312026,
        },
        {
            x: 184.62,
            y: 0.7988188122425834,
        },
        {
            x: 185.19,
            y: 0.7989178725272738,
        },
        {
            x: 185.76,
            y: 0.7990164765154036,
        },
        {
            x: 186.33,
            y: 0.7991146276992779,
        },
        {
            x: 186.9,
            y: 0.7992123295338953,
        },
        {
            x: 187.47,
            y: 0.7993095854374597,
        },
        {
            x: 188.04,
            y: 0.7994063987918818,
        },
        {
            x: 188.61,
            y: 0.7995027729432739,
        },
        {
            x: 189.18,
            y: 0.7995987112024346,
        },
        {
            x: 189.75,
            y: 0.7996942168453278,
        },
        {
            x: 190.32,
            y: 0.7997892931135512,
        },
        {
            x: 190.89000000000001,
            y: 0.7998839432147994,
        },
        {
            x: 191.46,
            y: 0.7999781703233177,
        },
        {
            x: 192.03,
            y: 0.8000719775803503,
        },
        {
            x: 192.6,
            y: 0.8001653680945788,
        },
        {
            x: 193.17000000000002,
            y: 0.8002583449425559,
        },
        {
            x: 193.74,
            y: 0.8003509111691305,
        },
        {
            x: 194.31,
            y: 0.8004430697878668,
        },
        {
            x: 194.88,
            y: 0.8005348237814566,
        },
        {
            x: 195.45000000000002,
            y: 0.8006261761021239,
        },
        {
            x: 196.02,
            y: 0.800717129672025,
        },
        {
            x: 196.59,
            y: 0.8008076873836404,
        },
        {
            x: 197.16,
            y: 0.8008978521001608,
        },
        {
            x: 197.73000000000002,
            y: 0.8009876266558685,
        },
        {
            x: 198.3,
            y: 0.8010770138565105,
        },
        {
            x: 198.87,
            y: 0.8011660164796673,
        },
        {
            x: 199.44,
            y: 0.8012546372751155,
        },
        {
            x: 200.01,
            y: 0.8013428789651841,
        },
        {
            x: 200.58,
            y: 0.8014307442451063,
        },
        {
            x: 201.15,
            y: 0.8015182357833652,
        },
        {
            x: 201.72,
            y: 0.801605356222034,
        },
        {
            x: 202.29,
            y: 0.8016921081771108,
        },
        {
            x: 202.86,
            y: 0.8017784942388494,
        },
        {
            x: 203.43,
            y: 0.8018645169720833,
        },
        {
            x: 204,
            y: 0.8019501789165459,
        },
        {
            x: 204.57,
            y: 0.8020354825871854,
        },
        {
            x: 205.14000000000001,
            y: 0.8021204304744751,
        },
        {
            x: 205.71,
            y: 0.8022050250447185,
        },
        {
            x: 206.28,
            y: 0.8022892687403501,
        },
        {
            x: 206.85,
            y: 0.8023731639802318,
        },
        {
            x: 207.42000000000002,
            y: 0.8024567131599443,
        },
        {
            x: 207.99,
            y: 0.8025399186520745,
        },
        {
            x: 208.56,
            y: 0.802622782806499,
        },
        {
            x: 209.13,
            y: 0.8027053079506619,
        },
        {
            x: 209.70000000000002,
            y: 0.8027874963898499,
        },
        {
            x: 210.27,
            y: 0.8028693504074631,
        },
        {
            x: 210.84,
            y: 0.8029508722652807,
        },
        {
            x: 211.41,
            y: 0.8030320642037242,
        },
        {
            x: 211.98000000000002,
            y: 0.8031129284421153,
        },
        {
            x: 212.55,
            y: 0.8031934671789315,
        },
        {
            x: 213.12,
            y: 0.8032736825920563,
        },
        {
            x: 213.69,
            y: 0.8033535768390273,
        },
        {
            x: 214.26,
            y: 0.8034331520572797,
        },
        {
            x: 214.83,
            y: 0.8035124103643859,
        },
        {
            x: 215.4,
            y: 0.8035913538582933,
        },
        {
            x: 215.97,
            y: 0.8036699846175563,
        },
        {
            x: 216.54,
            y: 0.8037483047015674,
        },
        {
            x: 217.11,
            y: 0.8038263161507827,
        },
        {
            x: 217.68,
            y: 0.8039040209869456,
        },
        {
            x: 218.25,
            y: 0.803981421213307,
        },
        {
            x: 218.82,
            y: 0.8040585188148419,
        },
        {
            x: 219.39000000000001,
            y: 0.8041353157584638,
        },
        {
            x: 219.96,
            y: 0.8042118139932346,
        },
        {
            x: 220.53,
            y: 0.8042880154505729,
        },
        {
            x: 221.1,
            y: 0.8043639220444588,
        },
        {
            x: 221.67000000000002,
            y: 0.8044395356716358,
        },
        {
            x: 222.24,
            y: 0.8045148582118098,
        },
        {
            x: 222.81,
            y: 0.804589891527845,
        },
        {
            x: 223.38,
            y: 0.8046646374659582,
        },
        {
            x: 223.95000000000002,
            y: 0.804739097855909,
        },
        {
            x: 224.52,
            y: 0.8048132745111883,
        },
        {
            x: 225.09,
            y: 0.8048871692292032,
        },
        {
            x: 225.66,
            y: 0.8049607837914607,
        },
        {
            x: 226.23000000000002,
            y: 0.8050341199637475,
        },
        {
            x: 226.8,
            y: 0.8051071794963085,
        },
        {
            x: 227.37,
            y: 0.8051799641240213,
        },
        {
            x: 227.94,
            y: 0.8052524755665703,
        },
        {
            x: 228.51,
            y: 0.8053247155286166,
        },
        {
            x: 229.08,
            y: 0.8053966856999668,
        },
        {
            x: 229.65,
            y: 0.8054683877557386,
        },
        {
            x: 230.22,
            y: 0.8055398233565246,
        },
        {
            x: 230.79,
            y: 0.8056109941485546,
        },
        {
            x: 231.36,
            y: 0.8056819017638536,
        },
        {
            x: 231.93,
            y: 0.8057525478204001,
        },
        {
            x: 232.5,
            y: 0.8058229339222808,
        },
        {
            x: 233.07,
            y: 0.8058930616598432,
        },
        {
            x: 233.64000000000001,
            y: 0.8059629326098473,
        },
        {
            x: 234.21,
            y: 0.8060325483356139,
        },
        {
            x: 234.78,
            y: 0.8061019103871716,
        },
        {
            x: 235.35,
            y: 0.8061710203014019,
        },
        {
            x: 235.92000000000002,
            y: 0.8062398796021822,
        },
        {
            x: 236.49,
            y: 0.8063084898005269,
        },
        {
            x: 237.06,
            y: 0.8063768523947267,
        },
        {
            x: 237.63,
            y: 0.8064449688704858,
        },
        {
            x: 238.20000000000002,
            y: 0.8065128407010578,
        },
        {
            x: 238.77,
            y: 0.8065804693473795,
        },
        {
            x: 239.34,
            y: 0.8066478562582028,
        },
        {
            x: 239.91,
            y: 0.8067150028702252,
        },
        {
            x: 240.48000000000002,
            y: 0.8067819106082186,
        },
        {
            x: 241.05,
            y: 0.8068485808851558,
        },
        {
            x: 241.62,
            y: 0.806915015102336,
        },
        {
            x: 242.19,
            y: 0.8069812146495092,
        },
        {
            x: 242.76,
            y: 0.8070471809049972,
        },
        {
            x: 243.33,
            y: 0.8071129152358147,
        },
        {
            x: 243.9,
            y: 0.8071784189977885,
        },
        {
            x: 244.47,
            y: 0.8072436935356747,
        },
        {
            x: 245.04,
            y: 0.8073087401832744,
        },
        {
            x: 245.61,
            y: 0.8073735602635485,
        },
        {
            x: 246.18,
            y: 0.8074381550887306,
        },
        {
            x: 246.75,
            y: 0.8075025259604388,
        },
        {
            x: 247.32,
            y: 0.8075666741697857,
        },
        {
            x: 247.89000000000001,
            y: 0.8076306009974866,
        },
        {
            x: 248.46,
            y: 0.8076943077139682,
        },
        {
            x: 249.03,
            y: 0.8077577955794734,
        },
        {
            x: 249.6,
            y: 0.8078210658441664,
        },
        {
            x: 250.17000000000002,
            y: 0.8078841197482365,
        },
        {
            x: 250.74,
            y: 0.8079469585219996,
        },
        {
            x: 251.31,
            y: 0.8080095833859997,
        },
        {
            x: 251.88,
            y: 0.8080719955511075,
        },
        {
            x: 252.45000000000002,
            y: 0.8081341962186199,
        },
        {
            x: 253.02,
            y: 0.8081961865803561,
        },
        {
            x: 253.59,
            y: 0.808257967818754,
        },
        {
            x: 254.16,
            y: 0.8083195411069651,
        },
        {
            x: 254.73000000000002,
            y: 0.8083809076089478,
        },
        {
            x: 255.3,
            y: 0.8084420684795595,
        },
        {
            x: 255.87,
            y: 0.8085030248646486,
        },
        {
            x: 256.44,
            y: 0.8085637779011442,
        },
        {
            x: 257.01,
            y: 0.8086243287171453,
        },
        {
            x: 257.58,
            y: 0.8086846784320084,
        },
        {
            x: 258.15,
            y: 0.8087448281564354,
        },
        {
            x: 258.72,
            y: 0.8088047789925583,
        },
        {
            x: 259.29,
            y: 0.8088645320340245,
        },
        {
            x: 259.86,
            y: 0.8089240883660811,
        },
        {
            x: 260.43,
            y: 0.8089834490656567,
        },
        {
            x: 261,
            y: 0.8090426152014438,
        },
        {
            x: 261.57,
            y: 0.8091015878339799,
        },
        {
            x: 262.14,
            y: 0.8091603680157264,
        },
        {
            x: 262.71,
            y: 0.8092189567911485,
        },
        {
            x: 263.28000000000003,
            y: 0.8092773551967924,
        },
        {
            x: 263.85,
            y: 0.8093355642613627,
        },
        {
            x: 264.42,
            y: 0.8093935850057984,
        },
        {
            x: 264.99,
            y: 0.8094514184433482,
        },
        {
            x: 265.56,
            y: 0.8095090655796447,
        },
        {
            x: 266.13,
            y: 0.8095665274127779,
        },
        {
            x: 266.7,
            y: 0.8096238049333678,
        },
        {
            x: 267.27,
            y: 0.809680899124636,
        },
        {
            x: 267.84000000000003,
            y: 0.8097378109624769,
        },
        {
            x: 268.41,
            y: 0.8097945414155273,
        },
        {
            x: 268.98,
            y: 0.809851091445236,
        },
        {
            x: 269.55,
            y: 0.8099074620059323,
        },
        {
            x: 270.12,
            y: 0.8099636540448932,
        },
        {
            x: 270.69,
            y: 0.8100196685024107,
        },
        {
            x: 271.26,
            y: 0.8100755063118577,
        },
        {
            x: 271.83,
            y: 0.8101311683997532,
        },
        {
            x: 272.4,
            y: 0.8101866556858273,
        },
        {
            x: 272.97,
            y: 0.8102419690830844,
        },
        {
            x: 273.54,
            y: 0.8102971094978669,
        },
        {
            x: 274.11,
            y: 0.8103520778299173,
        },
        {
            x: 274.68,
            y: 0.8104068749724396,
        },
        {
            x: 275.25,
            y: 0.8104615018121609,
        },
        {
            x: 275.82,
            y: 0.810515959229391,
        },
        {
            x: 276.39,
            y: 0.8105702480980826,
        },
        {
            x: 276.96,
            y: 0.8106243692858897,
        },
        {
            x: 277.53000000000003,
            y: 0.8106783236542259,
        },
        {
            x: 278.1,
            y: 0.8107321120583224,
        },
        {
            x: 278.67,
            y: 0.8107857353472845,
        },
        {
            x: 279.24,
            y: 0.8108391943641481,
        },
        {
            x: 279.81,
            y: 0.8108924899459352,
        },
        {
            x: 280.38,
            y: 0.8109456229237094,
        },
        {
            x: 280.95,
            y: 0.8109985941226296,
        },
        {
            x: 281.52,
            y: 0.8110514043620046,
        },
        {
            x: 282.09000000000003,
            y: 0.8111040544553455,
        },
        {
            x: 282.66,
            y: 0.8111565452104192,
        },
        {
            x: 283.23,
            y: 0.8112088774292997,
        },
        {
            x: 283.8,
            y: 0.8112610519084202,
        },
        {
            x: 284.37,
            y: 0.8113130694386235,
        },
        {
            x: 284.94,
            y: 0.8113649308052125,
        },
        {
            x: 285.51,
            y: 0.8114166367880005,
        },
        {
            x: 286.08,
            y: 0.8114681881613593,
        },
        {
            x: 286.65000000000003,
            y: 0.8115195856942693,
        },
        {
            x: 287.22,
            y: 0.8115708301503665,
        },
        {
            x: 287.79,
            y: 0.8116219222879908,
        },
        {
            x: 288.36,
            y: 0.8116728628602332,
        },
        {
            x: 288.93,
            y: 0.8117236526149818,
        },
        {
            x: 289.5,
            y: 0.8117742922949687,
        },
        {
            x: 290.07,
            y: 0.8118247826378148,
        },
        {
            x: 290.64,
            y: 0.8118751243760758,
        },
        {
            x: 291.21,
            y: 0.8119253182372862,
        },
        {
            x: 291.78000000000003,
            y: 0.8119753649440037,
        },
    ],
    upperLimitRedPoints: [
        {
            x: 1.8900000000000001,
            y: 1.498828697974719,
        },
        {
            x: 1.9000000000000001,
            y: 1.497153619638148,
        },
        {
            x: 1.9100000000000001,
            y: 1.4954917136461465,
        },
        {
            x: 1.92,
            y: 1.4938428082595077,
        },
        {
            x: 1.93,
            y: 1.4922067348575214,
        },
        {
            x: 1.94,
            y: 1.490583327865545,
        },
        {
            x: 1.95,
            y: 1.4889724246846177,
        },
        {
            x: 1.96,
            y: 1.4873738656230544,
        },
        {
            x: 1.97,
            y: 1.4857874938299513,
        },
        {
            x: 1.98,
            y: 1.484213155230539,
        },
        {
            x: 1.99,
            y: 1.482650698463329,
        },
        {
            x: 2,
            y: 1.4810999748189855,
        },
        {
            x: 2.0100000000000002,
            y: 1.4795608381808756,
        },
        {
            x: 2.02,
            y: 1.4780331449672401,
        },
        {
            x: 2.0300000000000002,
            y: 1.4765167540749307,
        },
        {
            x: 2.04,
            y: 1.4750115268246677,
        },
        {
            x: 2.05,
            y: 1.4735173269077686,
        },
        {
            x: 2.06,
            y: 1.4720340203342988,
        },
        {
            x: 2.07,
            y: 1.470561475382604,
        },
        {
            x: 2.08,
            y: 1.4690995625501773,
        },
        {
            x: 2.09,
            y: 1.46764815450582,
        },
        {
            x: 2.1,
            y: 1.4662071260430587,
        },
        {
            x: 2.11,
            y: 1.4647763540347778,
        },
        {
            x: 2.12,
            y: 1.4633557173890286,
        },
        {
            x: 2.13,
            y: 1.4619450970059829,
        },
        {
            x: 2.14,
            y: 1.460544375735993,
        },
        {
            x: 2.15,
            y: 1.4591534383387272,
        },
        {
            x: 2.16,
            y: 1.457772171443344,
        },
        {
            x: 2.17,
            y: 1.4564004635096817,
        },
        {
            x: 2.18,
            y: 1.455038204790423,
        },
        {
            x: 2.19,
            y: 1.4536852872942156,
        },
        {
            x: 2.2,
            y: 1.4523416047497117,
        },
        {
            x: 2.21,
            y: 1.4510070525705079,
        },
        {
            x: 2.22,
            y: 1.4496815278209492,
        },
        {
            x: 2.23,
            y: 1.4483649291827827,
        },
        {
            x: 2.24,
            y: 1.4470571569226283,
        },
        {
            x: 2.25,
            y: 1.4457581128602457,
        },
        {
            x: 2.2600000000000002,
            y: 1.4444677003375732,
        },
        {
            x: 2.27,
            y: 1.4431858241885223,
        },
        {
            x: 2.2800000000000002,
            y: 1.4419123907094944,
        },
        {
            x: 2.29,
            y: 1.4406473076306137,
        },
        {
            x: 2.3000000000000003,
            y: 1.4393904840876433,
        },
        {
            x: 2.31,
            y: 1.438141830594574,
        },
        {
            x: 2.32,
            y: 1.436901259016862,
        },
        {
            x: 2.33,
            y: 1.4356686825452996,
        },
        {
            x: 2.34,
            y: 1.434444015670501,
        },
        {
            x: 2.35,
            y: 1.4332271741579845,
        },
        {
            x: 2.36,
            y: 1.4320180750238376,
        },
        {
            x: 2.37,
            y: 1.4308166365109476,
        },
        {
            x: 2.38,
            y: 1.42962277806578,
        },
        {
            x: 2.39,
            y: 1.4284364203156934,
        },
        {
            x: 2.4,
            y: 1.4272574850467756,
        },
        {
            x: 2.41,
            y: 1.4260858951821838,
        },
        {
            x: 2.42,
            y: 1.4249215747609796,
        },
        {
            x: 2.43,
            y: 1.4237644489174421,
        },
        {
            x: 2.44,
            y: 1.42261444386085,
        },
        {
            x: 2.45,
            y: 1.4214714868557132,
        },
        {
            x: 2.46,
            y: 1.4203355062024539,
        },
        {
            x: 2.47,
            y: 1.419206431218512,
        },
        {
            x: 2.48,
            y: 1.418084192219873,
        },
        {
            x: 2.49,
            y: 1.4169687205030046,
        },
        {
            x: 2.5,
            y: 1.4158599483271894,
        },
        {
            x: 2.5100000000000002,
            y: 1.4147578088972463,
        },
        {
            x: 2.52,
            y: 1.4136622363466285,
        },
        {
            x: 2.5300000000000002,
            y: 1.4125731657208913,
        },
        {
            x: 2.54,
            y: 1.411490532961516,
        },
        {
            x: 2.5500000000000003,
            y: 1.410414274890083,
        },
        {
            x: 2.56,
            y: 1.4093443291927876,
        },
        {
            x: 2.57,
            y: 1.408280634405286,
        },
        {
            x: 2.58,
            y: 1.407223129897863,
        },
        {
            x: 2.59,
            y: 1.4061717558609184,
        },
        {
            x: 2.6,
            y: 1.4051264532907586,
        },
        {
            x: 2.61,
            y: 1.4040871639756873,
        },
        {
            x: 2.62,
            y: 1.4030538304823914,
        },
        {
            x: 2.63,
            y: 1.4020263961426076,
        },
        {
            x: 2.64,
            y: 1.4010048050400714,
        },
        {
            x: 2.65,
            y: 1.3999890019977337,
        },
        {
            x: 2.66,
            y: 1.398978932565245,
        },
        {
            x: 2.67,
            y: 1.3979745430066943,
        },
        {
            x: 2.68,
            y: 1.3969757802886034,
        },
        {
            x: 2.69,
            y: 1.3959825920681639,
        },
        {
            x: 2.7,
            y: 1.3949949266817163,
        },
        {
            x: 2.71,
            y: 1.3940127331334615,
        },
        {
            x: 2.72,
            y: 1.393035961084402,
        },
        {
            x: 2.73,
            y: 1.3920645608415052,
        },
        {
            x: 2.74,
            y: 1.391098483347084,
        },
        {
            x: 2.75,
            y: 1.3901376801683933,
        },
        {
            x: 2.7600000000000002,
            y: 1.3891821034874274,
        },
        {
            x: 2.77,
            y: 1.3882317060909286,
        },
        {
            x: 2.7800000000000002,
            y: 1.387286441360586,
        },
        {
            x: 2.79,
            y: 1.386346263263433,
        },
        {
            x: 3.36,
            y: 1.3399059170262695,
        },
        {
            x: 3.93,
            y: 1.3039773514383692,
        },
        {
            x: 4.5,
            y: 1.2751125079396304,
        },
        {
            x: 5.07,
            y: 1.2512638720754357,
        },
        {
            x: 5.64,
            y: 1.2311288286071234,
        },
        {
            x: 6.21,
            y: 1.2138339270519252,
        },
        {
            x: 6.78,
            y: 1.1987686790055032,
        },
        {
            x: 7.3500000000000005,
            y: 1.185491808961409,
        },
        {
            x: 7.92,
            y: 1.1736753647057299,
        },
        {
            x: 8.49,
            y: 1.1630698510293638,
        },
        {
            x: 9.06,
            y: 1.1534816376438386,
        },
        {
            x: 9.63,
            y: 1.1447578411852923,
        },
        {
            x: 10.200000000000001,
            y: 1.1367759245355016,
        },
        {
            x: 10.77,
            y: 1.1294363670700684,
        },
        {
            x: 11.34,
            y: 1.1226573887327906,
        },
        {
            x: 11.91,
            y: 1.1163710807184832,
        },
        {
            x: 12.48,
            y: 1.110520520018753,
        },
        {
            x: 13.05,
            y: 1.1050575852172655,
        },
        {
            x: 13.620000000000001,
            y: 1.0999412806330793,
        },
        {
            x: 14.19,
            y: 1.0951364346561057,
        },
        {
            x: 14.76,
            y: 1.0906126773787113,
        },
        {
            x: 15.33,
            y: 1.0863436293545914,
        },
        {
            x: 15.9,
            y: 1.0823062518202184,
        },
        {
            x: 16.47,
            y: 1.0784803217243049,
        },
        {
            x: 17.04,
            y: 1.0748480041884805,
        },
        {
            x: 17.61,
            y: 1.071393501725496,
        },
        {
            x: 18.18,
            y: 1.0681027644430272,
        },
        {
            x: 18.75,
            y: 1.0649632490860683,
        },
        {
            x: 19.32,
            y: 1.0619637174796415,
        },
        {
            x: 19.89,
            y: 1.0590940669774496,
        },
        {
            x: 20.46,
            y: 1.0563451870784462,
        },
        {
            x: 21.03,
            y: 1.053708837568493,
        },
        {
            x: 21.6,
            y: 1.0511775444695388,
        },
        {
            x: 22.17,
            y: 1.0487445108004267,
        },
        {
            x: 22.740000000000002,
            y: 1.0464035397203453,
        },
        {
            x: 23.31,
            y: 1.044148968074253,
        },
        {
            x: 23.88,
            y: 1.0419756087163978,
        },
        {
            x: 24.45,
            y: 1.0398787002737029,
        },
        {
            x: 25.02,
            y: 1.037853863240809,
        },
        {
            x: 25.59,
            y: 1.0358970614847631,
        },
        {
            x: 26.16,
            y: 1.0340045683888732,
        },
        {
            x: 26.73,
            y: 1.0321729369891588,
        },
        {
            x: 27.3,
            y: 1.030398973558615,
        },
        {
            x: 27.87,
            y: 1.0286797141785302,
        },
        {
            x: 28.44,
            y: 1.0270124039056983,
        },
        {
            x: 29.01,
            y: 1.0253944782023217,
        },
        {
            x: 29.580000000000002,
            y: 1.023823546343779,
        },
        {
            x: 30.150000000000002,
            y: 1.02229737656003,
        },
        {
            x: 30.72,
            y: 1.0208138827005673,
        },
        {
            x: 31.29,
            y: 1.0193711122416707,
        },
        {
            x: 31.86,
            y: 1.017967235479152,
        },
        {
            x: 32.43,
            y: 1.0166005357705357,
        },
        {
            x: 33,
            y: 1.015269400708335,
        },
        {
            x: 33.57,
            y: 1.0139723141212087,
        },
        {
            x: 34.14,
            y: 1.0127078488127743,
        },
        {
            x: 34.71,
            y: 1.0114746599590023,
        },
        {
            x: 35.28,
            y: 1.0102714790947456,
        },
        {
            x: 35.85,
            y: 1.00909710862827,
        },
        {
            x: 36.42,
            y: 1.0079504168298579,
        },
        {
            x: 36.99,
            y: 1.0068303332468094,
        },
        {
            x: 37.56,
            y: 1.0057358445026225,
        },
        {
            x: 38.13,
            y: 1.004665990442877,
        },
        {
            x: 38.7,
            y: 1.0036198605945021,
        },
        {
            x: 39.27,
            y: 1.0025965909087577,
        },
        {
            x: 39.84,
            y: 1.0015953607614416,
        },
        {
            x: 40.410000000000004,
            y: 1.0006153901866583,
        },
        {
            x: 40.980000000000004,
            y: 0.9996559373229571,
        },
        {
            x: 41.550000000000004,
            y: 0.998716296052834,
        },
        {
            x: 42.12,
            y: 0.9977957938185331,
        },
        {
            x: 42.69,
            y: 0.9968937895987925,
        },
        {
            x: 43.26,
            y: 0.9960096720327043,
        },
        {
            x: 43.83,
            y: 0.995142857678213,
        },
        {
            x: 44.4,
            y: 0.9942927893939795,
        },
        {
            x: 44.97,
            y: 0.9934589348344133,
        },
        {
            x: 45.54,
            y: 0.992640785048639,
        },
        {
            x: 46.11,
            y: 0.9918378531750164,
        },
        {
            x: 46.68,
            y: 0.9910496732236086,
        },
        {
            x: 47.25,
            y: 0.9902757989396802,
        },
        {
            x: 47.82,
            y: 0.9895158027419283,
        },
        {
            x: 48.39,
            y: 0.9887692747297069,
        },
        {
            x: 48.96,
            y: 0.9880358217540087,
        },
        {
            x: 49.53,
            y: 0.9873150665474217,
        },
        {
            x: 50.1,
            y: 0.9866066469086846,
        },
        {
            x: 50.67,
            y: 0.9859102149378395,
        },
        {
            x: 51.24,
            y: 0.9852254363183119,
        },
        {
            x: 51.81,
            y: 0.9845519896425534,
        },
        {
            x: 52.38,
            y: 0.9838895657781557,
        },
        {
            x: 52.95,
            y: 0.9832378672715989,
        },
        {
            x: 53.52,
            y: 0.9825966077870197,
        },
        {
            x: 54.09,
            y: 0.9819655115775945,
        },
        {
            x: 54.660000000000004,
            y: 0.9813443129873218,
        },
        {
            x: 55.230000000000004,
            y: 0.9807327559811592,
        },
        {
            x: 55.800000000000004,
            y: 0.9801305937016255,
        },
        {
            x: 56.370000000000005,
            y: 0.979537588050127,
        },
        {
            x: 56.94,
            y: 0.978953509291393,
        },
        {
            x: 57.51,
            y: 0.9783781356795281,
        },
        {
            x: 58.08,
            y: 0.9778112531043,
        },
        {
            x: 58.65,
            y: 0.9772526547563806,
        },
        {
            x: 59.22,
            y: 0.9767021408103517,
        },
        {
            x: 59.79,
            y: 0.9761595181243718,
        },
        {
            x: 60.36,
            y: 0.9756245999554798,
        },
        {
            x: 60.93,
            y: 0.9750972056895804,
        },
        {
            x: 61.5,
            y: 0.9745771605852271,
        },
        {
            x: 62.07,
            y: 0.9740642955303762,
        },
        {
            x: 62.64,
            y: 0.9735584468113413,
        },
        {
            x: 63.21,
            y: 0.9730594558932352,
        },
        {
            x: 63.78,
            y: 0.9725671692112262,
        },
        {
            x: 64.35,
            y: 0.9720814379719886,
        },
        {
            x: 64.92,
            y: 0.9716021179647608,
        },
        {
            x: 65.49,
            y: 0.9711290693814687,
        },
        {
            x: 66.06,
            y: 0.9706621566454048,
        },
        {
            x: 66.63,
            y: 0.970201248247984,
        },
        {
            x: 67.2,
            y: 0.9697462165931331,
        },
        {
            x: 67.77,
            y: 0.9692969378488923,
        },
        {
            x: 68.34,
            y: 0.96885329180584,
        },
        {
            x: 68.91,
            y: 0.9684151617419717,
        },
        {
            x: 69.48,
            y: 0.9679824342936874,
        },
        {
            x: 70.05,
            y: 0.9675549993325654,
        },
        {
            x: 70.62,
            y: 0.9671327498476183,
        },
        {
            x: 71.19,
            y: 0.9667155818327428,
        },
        {
            x: 71.76,
            y: 0.9663033941790978,
        },
        {
            x: 72.33,
            y: 0.9658960885721564,
        },
        {
            x: 72.9,
            y: 0.9654935693931925,
        },
        {
            x: 73.47,
            y: 0.9650957436249814,
        },
        {
            x: 74.04,
            y: 0.9647025207614989,
        },
        {
            x: 74.61,
            y: 0.964313812721423,
        },
        {
            x: 75.18,
            y: 0.9639295337652503,
        },
        {
            x: 75.75,
            y: 0.963549600415847,
        },
        {
            x: 76.32000000000001,
            y: 0.9631739313822718,
        },
        {
            x: 76.89,
            y: 0.9628024474867093,
        },
        {
            x: 77.46000000000001,
            y: 0.9624350715943659,
        },
        {
            x: 78.03,
            y: 0.962071728546189,
        },
        {
            x: 78.60000000000001,
            y: 0.9617123450942726,
        },
        {
            x: 79.17,
            y: 0.9613568498398268,
        },
        {
            x: 79.74,
            y: 0.9610051731735898,
        },
        {
            x: 80.31,
            y: 0.9606572472185707,
        },
        {
            x: 80.88,
            y: 0.9603130057750149,
        },
        {
            x: 81.45,
            y: 0.9599723842674922,
        },
        {
            x: 82.02,
            y: 0.9596353196940102,
        },
        {
            x: 82.59,
            y: 0.9593017505770631,
        },
        {
            x: 83.16,
            y: 0.9589716169165294,
        },
        {
            x: 83.73,
            y: 0.9586448601443351,
        },
        {
            x: 84.3,
            y: 0.9583214230808071,
        },
        {
            x: 84.87,
            y: 0.9580012498926405,
        },
        {
            x: 85.44,
            y: 0.9576842860524112,
        },
        {
            x: 86.01,
            y: 0.9573704782995676,
        },
        {
            x: 86.58,
            y: 0.9570597746028349,
        },
        {
            x: 87.15,
            y: 0.9567521241239767,
        },
        {
            x: 87.72,
            y: 0.9564474771828518,
        },
        {
            x: 88.29,
            y: 0.9561457852237145,
        },
        {
            x: 88.86,
            y: 0.9558470007827061,
        },
        {
            x: 89.43,
            y: 0.9555510774564874,
        },
        {
            x: 90,
            y: 0.9552579698719653,
        },
        {
            x: 90.57000000000001,
            y: 0.9549676336570702,
        },
        {
            x: 91.14,
            y: 0.9546800254125382,
        },
        {
            x: 91.71000000000001,
            y: 0.9543951026846613,
        },
        {
            x: 92.28,
            y: 0.9541128239389639,
        },
        {
            x: 92.85000000000001,
            y: 0.9538331485347691,
        },
        {
            x: 93.42,
            y: 0.953556036700621,
        },
        {
            x: 93.99,
            y: 0.9532814495105264,
        },
        {
            x: 94.56,
            y: 0.9530093488609872,
        },
        {
            x: 95.13,
            y: 0.9527396974487895,
        },
        {
            x: 95.7,
            y: 0.9524724587495216,
        },
        {
            x: 96.27,
            y: 0.9522075969967931,
        },
        {
            x: 96.84,
            y: 0.9519450771621277,
        },
        {
            x: 97.41,
            y: 0.9516848649355032,
        },
        {
            x: 97.98,
            y: 0.951426926706516,
        },
        {
            x: 98.55,
            y: 0.9511712295461453,
        },
        {
            x: 99.12,
            y: 0.9509177411890953,
        },
        {
            x: 99.69,
            y: 0.9506664300166925,
        },
        {
            x: 100.26,
            y: 0.9504172650403196,
        },
        {
            x: 100.83,
            y: 0.9501702158853647,
        },
        {
            x: 101.4,
            y: 0.9499252527756674,
        },
        {
            x: 101.97,
            y: 0.9496823465184443,
        },
        {
            x: 102.54,
            y: 0.9494414684896749,
        },
        {
            x: 103.11,
            y: 0.949202590619934,
        },
        {
            x: 103.68,
            y: 0.9489656853806517,
        },
        {
            x: 104.25,
            y: 0.9487307257707881,
        },
        {
            x: 104.82000000000001,
            y: 0.9484976853039061,
        },
        {
            x: 105.39,
            y: 0.9482665379956308,
        },
        {
            x: 105.96000000000001,
            y: 0.9480372583514785,
        },
        {
            x: 106.53,
            y: 0.947809821355046,
        },
        {
            x: 107.10000000000001,
            y: 0.9475842024565454,
        },
        {
            x: 107.67,
            y: 0.9473603775616731,
        },
        {
            x: 108.24000000000001,
            y: 0.9471383230208015,
        },
        {
            x: 108.81,
            y: 0.9469180156184831,
        },
        {
            x: 109.38,
            y: 0.9466994325632554,
        },
        {
            x: 109.95,
            y: 0.9464825514777369,
        },
        {
            x: 110.52,
            y: 0.9462673503890042,
        },
        {
            x: 111.09,
            y: 0.9460538077192421,
        },
        {
            x: 111.66,
            y: 0.9458419022766544,
        },
        {
            x: 112.23,
            y: 0.9456316132466314,
        },
        {
            x: 112.8,
            y: 0.9454229201831614,
        },
        {
            x: 113.37,
            y: 0.945215803000481,
        },
        {
            x: 113.94,
            y: 0.9450102419649544,
        },
        {
            x: 114.51,
            y: 0.9448062176871767,
        },
        {
            x: 115.08,
            y: 0.9446037111142913,
        },
        {
            x: 115.65,
            y: 0.9444027035225167,
        },
        {
            x: 116.22,
            y: 0.9442031765098746,
        },
        {
            x: 116.79,
            y: 0.9440051119891135,
        },
        {
            x: 117.36,
            y: 0.9438084921808221,
        },
        {
            x: 117.93,
            y: 0.9436132996067249,
        },
        {
            x: 118.5,
            y: 0.9434195170831572,
        },
        {
            x: 119.07000000000001,
            y: 0.9432271277147093,
        },
        {
            x: 119.64,
            y: 0.943036114888041,
        },
        {
            x: 120.21000000000001,
            y: 0.9428464622658541,
        },
        {
            x: 120.78,
            y: 0.9426581537810241,
        },
        {
            x: 121.35000000000001,
            y: 0.9424711736308826,
        },
        {
            x: 121.92,
            y: 0.9422855062716466,
        },
        {
            x: 122.49000000000001,
            y: 0.9421011364129915,
        },
        {
            x: 123.06,
            y: 0.9419180490127618,
        },
        {
            x: 123.63000000000001,
            y: 0.941736229271816,
        },
        {
            x: 124.2,
            y: 0.9415556626290025,
        },
        {
            x: 124.77,
            y: 0.9413763347562611,
        },
        {
            x: 125.34,
            y: 0.9411982315538477,
        },
        {
            x: 125.91,
            y: 0.9410213391456778,
        },
        {
            x: 126.48,
            y: 0.940845643874785,
        },
        {
            x: 127.05,
            y: 0.9406711322988933,
        },
        {
            x: 127.62,
            y: 0.9404977911860966,
        },
        {
            x: 128.19,
            y: 0.9403256075106443,
        },
        {
            x: 128.76,
            y: 0.9401545684488312,
        },
        {
            x: 129.33,
            y: 0.9399846613749842,
        },
        {
            x: 129.9,
            y: 0.9398158738575491,
        },
        {
            x: 130.47,
            y: 0.9396481936552692,
        },
        {
            x: 131.04,
            y: 0.9394816087134571,
        },
        {
            x: 131.61,
            y: 0.9393161071603535,
        },
        {
            x: 132.18,
            y: 0.939151677303575,
        },
        {
            x: 132.75,
            y: 0.9389883076266428,
        },
        {
            x: 133.32,
            y: 0.9388259867855965,
        },
        {
            x: 133.89000000000001,
            y: 0.938664703605684,
        },
        {
            x: 134.46,
            y: 0.9385044470781313,
        },
        {
            x: 135.03,
            y: 0.9383452063569858,
        },
        {
            x: 135.6,
            y: 0.938186970756033,
        },
        {
            x: 136.17000000000002,
            y: 0.9380297297457846,
        },
        {
            x: 136.74,
            y: 0.9378734729505356,
        },
        {
            x: 137.31,
            y: 0.9377181901454884,
        },
        {
            x: 137.88,
            y: 0.9375638712539427,
        },
        {
            x: 138.45000000000002,
            y: 0.9374105063445485,
        },
        {
            x: 139.02,
            y: 0.9372580856286222,
        },
        {
            x: 139.59,
            y: 0.9371065994575221,
        },
        {
            x: 140.16,
            y: 0.9369560383200825,
        },
        {
            x: 140.73,
            y: 0.936806392840106,
        },
        {
            x: 141.3,
            y: 0.9366576537739111,
        },
        {
            x: 141.87,
            y: 0.9365098120079332,
        },
        {
            x: 142.44,
            y: 0.9363628585563799,
        },
        {
            x: 143.01,
            y: 0.9362167845589364,
        },
        {
            x: 143.58,
            y: 0.9360715812785221,
        },
        {
            x: 144.15,
            y: 0.9359272400990953,
        },
        {
            x: 144.72,
            y: 0.9357837525235061,
        },
        {
            x: 145.29,
            y: 0.9356411101713951,
        },
        {
            x: 145.86,
            y: 0.9354993047771374,
        },
        {
            x: 146.43,
            y: 0.9353583281878317,
        },
        {
            x: 147,
            y: 0.9352181723613304,
        },
        {
            x: 147.57,
            y: 0.9350788293643135,
        },
        {
            x: 148.14000000000001,
            y: 0.9349402913704018,
        },
        {
            x: 148.71,
            y: 0.9348025506583111,
        },
        {
            x: 149.28,
            y: 0.9346655996100444,
        },
        {
            x: 149.85,
            y: 0.9345294307091223,
        },
        {
            x: 150.42000000000002,
            y: 0.9343940365388502,
        },
        {
            x: 150.99,
            y: 0.9342594097806218,
        },
        {
            x: 151.56,
            y: 0.934125543212257,
        },
        {
            x: 152.13,
            y: 0.9339924297063751,
        },
        {
            x: 152.70000000000002,
            y: 0.9338600622288005,
        },
        {
            x: 153.27,
            y: 0.9337284338370017,
        },
        {
            x: 153.84,
            y: 0.9335975376785617,
        },
        {
            x: 154.41,
            y: 0.9334673669896799,
        },
        {
            x: 154.98,
            y: 0.9333379150937039,
        },
        {
            x: 155.55,
            y: 0.933209175399691,
        },
        {
            x: 156.12,
            y: 0.9330811414009991,
        },
        {
            x: 156.69,
            y: 0.9329538066739049,
        },
        {
            x: 157.26,
            y: 0.9328271648762512,
        },
        {
            x: 157.83,
            y: 0.9327012097461187,
        },
        {
            x: 158.4,
            y: 0.9325759351005269,
        },
        {
            x: 158.97,
            y: 0.9324513348341582,
        },
        {
            x: 159.54,
            y: 0.9323274029181089,
        },
        {
            x: 160.11,
            y: 0.9322041333986636,
        },
        {
            x: 160.68,
            y: 0.9320815203960937,
        },
        {
            x: 161.25,
            y: 0.93195955810348,
        },
        {
            x: 161.82,
            y: 0.9318382407855569,
        },
        {
            x: 162.39000000000001,
            y: 0.9317175627775802,
        },
        {
            x: 162.96,
            y: 0.9315975184842159,
        },
        {
            x: 163.53,
            y: 0.9314781023784504,
        },
        {
            x: 164.1,
            y: 0.9313593090005217,
        },
        {
            x: 164.67000000000002,
            y: 0.931241132956871,
        },
        {
            x: 165.24,
            y: 0.9311235689191146,
        },
        {
            x: 165.81,
            y: 0.9310066116230339,
        },
        {
            x: 166.38,
            y: 0.9308902558675858,
        },
        {
            x: 166.95000000000002,
            y: 0.9307744965139315,
        },
        {
            x: 167.52,
            y: 0.9306593284844831,
        },
        {
            x: 168.09,
            y: 0.9305447467619675,
        },
        {
            x: 168.66,
            y: 0.9304307463885095,
        },
        {
            x: 169.23,
            y: 0.9303173224647299,
        },
        {
            x: 169.8,
            y: 0.9302044701488611,
        },
        {
            x: 170.37,
            y: 0.9300921846558796,
        },
        {
            x: 170.94,
            y: 0.9299804612566533,
        },
        {
            x: 171.51,
            y: 0.9298692952771053,
        },
        {
            x: 172.08,
            y: 0.929758682097392,
        },
        {
            x: 172.65,
            y: 0.9296486171510974,
        },
        {
            x: 173.22,
            y: 0.929539095924441,
        },
        {
            x: 173.79,
            y: 0.9294301139555,
        },
        {
            x: 174.36,
            y: 0.9293216668334464,
        },
        {
            x: 174.93,
            y: 0.9292137501977967,
        },
        {
            x: 175.5,
            y: 0.9291063597376759,
        },
        {
            x: 176.07,
            y: 0.9289994911910934,
        },
        {
            x: 176.64000000000001,
            y: 0.9288931403442339,
        },
        {
            x: 177.21,
            y: 0.9287873030307583,
        },
        {
            x: 177.78,
            y: 0.9286819751311188,
        },
        {
            x: 178.35,
            y: 0.9285771525718852,
        },
        {
            x: 178.92000000000002,
            y: 0.9284728313250835,
        },
        {
            x: 179.49,
            y: 0.9283690074075452,
        },
        {
            x: 180.06,
            y: 0.9282656768802694,
        },
        {
            x: 180.63,
            y: 0.9281628358477941,
        },
        {
            x: 181.20000000000002,
            y: 0.9280604804575803,
        },
        {
            x: 181.77,
            y: 0.9279586068994053,
        },
        {
            x: 182.34,
            y: 0.9278572114047672,
        },
        {
            x: 182.91,
            y: 0.927756290246299,
        },
        {
            x: 183.48,
            y: 0.9276558397371938,
        },
        {
            x: 184.05,
            y: 0.9275558562306384,
        },
        {
            x: 184.62,
            y: 0.9274563361192576,
        },
        {
            x: 185.19,
            y: 0.9273572758345673,
        },
        {
            x: 185.76,
            y: 0.9272586718464374,
        },
        {
            x: 186.33,
            y: 0.9271605206625632,
        },
        {
            x: 186.9,
            y: 0.9270628188279457,
        },
        {
            x: 187.47,
            y: 0.9269655629243814,
        },
        {
            x: 188.04,
            y: 0.9268687495699592,
        },
        {
            x: 188.61,
            y: 0.9267723754185672,
        },
        {
            x: 189.18,
            y: 0.9266764371594064,
        },
        {
            x: 189.75,
            y: 0.9265809315165132,
        },
        {
            x: 190.32,
            y: 0.9264858552482899,
        },
        {
            x: 190.89000000000001,
            y: 0.9263912051470417,
        },
        {
            x: 191.46,
            y: 0.9262969780385233,
        },
        {
            x: 192.03,
            y: 0.9262031707814907,
        },
        {
            x: 192.6,
            y: 0.9261097802672622,
        },
        {
            x: 193.17000000000002,
            y: 0.9260168034192852,
        },
        {
            x: 193.74,
            y: 0.9259242371927106,
        },
        {
            x: 194.31,
            y: 0.9258320785739742,
        },
        {
            x: 194.88,
            y: 0.9257403245803845,
        },
        {
            x: 195.45000000000002,
            y: 0.9256489722597171,
        },
        {
            x: 196.02,
            y: 0.925558018689816,
        },
        {
            x: 196.59,
            y: 0.9254674609782007,
        },
        {
            x: 197.16,
            y: 0.9253772962616802,
        },
        {
            x: 197.73000000000002,
            y: 0.9252875217059725,
        },
        {
            x: 198.3,
            y: 0.9251981345053305,
        },
        {
            x: 198.87,
            y: 0.9251091318821737,
        },
        {
            x: 199.44,
            y: 0.9250205110867256,
        },
        {
            x: 200.01,
            y: 0.924932269396657,
        },
        {
            x: 200.58,
            y: 0.9248444041167347,
        },
        {
            x: 201.15,
            y: 0.9247569125784758,
        },
        {
            x: 201.72,
            y: 0.924669792139807,
        },
        {
            x: 202.29,
            y: 0.9245830401847303,
        },
        {
            x: 202.86,
            y: 0.9244966541229916,
        },
        {
            x: 203.43,
            y: 0.9244106313897578,
        },
        {
            x: 204,
            y: 0.9243249694452952,
        },
        {
            x: 204.57,
            y: 0.9242396657746557,
        },
        {
            x: 205.14000000000001,
            y: 0.9241547178873659,
        },
        {
            x: 205.71,
            y: 0.9240701233171226,
        },
        {
            x: 206.28,
            y: 0.9239858796214909,
        },
        {
            x: 206.85,
            y: 0.9239019843816092,
        },
        {
            x: 207.42000000000002,
            y: 0.9238184352018968,
        },
        {
            x: 207.99,
            y: 0.9237352297097665,
        },
        {
            x: 208.56,
            y: 0.923652365555342,
        },
        {
            x: 209.13,
            y: 0.9235698404111792,
        },
        {
            x: 209.70000000000002,
            y: 0.9234876519719911,
        },
        {
            x: 210.27,
            y: 0.9234057979543779,
        },
        {
            x: 210.84,
            y: 0.9233242760965603,
        },
        {
            x: 211.41,
            y: 0.9232430841581168,
        },
        {
            x: 211.98000000000002,
            y: 0.9231622199197257,
        },
        {
            x: 212.55,
            y: 0.9230816811829096,
        },
        {
            x: 213.12,
            y: 0.9230014657697847,
        },
        {
            x: 213.69,
            y: 0.9229215715228137,
        },
        {
            x: 214.26,
            y: 0.9228419963045613,
        },
        {
            x: 214.83,
            y: 0.9227627379974551,
        },
        {
            x: 215.4,
            y: 0.9226837945035478,
        },
        {
            x: 215.97,
            y: 0.9226051637442847,
        },
        {
            x: 216.54,
            y: 0.9225268436602736,
        },
        {
            x: 217.11,
            y: 0.9224488322110583,
        },
        {
            x: 217.68,
            y: 0.9223711273748955,
        },
        {
            x: 218.25,
            y: 0.9222937271485341,
        },
        {
            x: 218.82,
            y: 0.9222166295469991,
        },
        {
            x: 219.39000000000001,
            y: 0.9221398326033773,
        },
        {
            x: 219.96,
            y: 0.9220633343686064,
        },
        {
            x: 220.53,
            y: 0.9219871329112681,
        },
        {
            x: 221.1,
            y: 0.9219112263173822,
        },
        {
            x: 221.67000000000002,
            y: 0.9218356126902052,
        },
        {
            x: 222.24,
            y: 0.9217602901500312,
        },
        {
            x: 222.81,
            y: 0.921685256833996,
        },
        {
            x: 223.38,
            y: 0.9216105108958829,
        },
        {
            x: 223.95000000000002,
            y: 0.921536050505932,
        },
        {
            x: 224.52,
            y: 0.9214618738506527,
        },
        {
            x: 225.09,
            y: 0.9213879791326378,
        },
        {
            x: 225.66,
            y: 0.9213143645703803,
        },
        {
            x: 226.23000000000002,
            y: 0.9212410283980935,
        },
        {
            x: 226.8,
            y: 0.9211679688655325,
        },
        {
            x: 227.37,
            y: 0.9210951842378198,
        },
        {
            x: 227.94,
            y: 0.9210226727952707,
        },
        {
            x: 228.51,
            y: 0.9209504328332244,
        },
        {
            x: 229.08,
            y: 0.9208784626618742,
        },
        {
            x: 229.65,
            y: 0.9208067606061024,
        },
        {
            x: 230.22,
            y: 0.9207353250053164,
        },
        {
            x: 230.79,
            y: 0.9206641542132864,
        },
        {
            x: 231.36,
            y: 0.9205932465979875,
        },
        {
            x: 231.93,
            y: 0.920522600541441,
        },
        {
            x: 232.5,
            y: 0.9204522144395603,
        },
        {
            x: 233.07,
            y: 0.9203820867019978,
        },
        {
            x: 233.64000000000001,
            y: 0.9203122157519937,
        },
        {
            x: 234.21,
            y: 0.9202426000262272,
        },
        {
            x: 234.78,
            y: 0.9201732379746694,
        },
        {
            x: 235.35,
            y: 0.9201041280604392,
        },
        {
            x: 235.92000000000002,
            y: 0.9200352687596588,
        },
        {
            x: 236.49,
            y: 0.9199666585613141,
        },
        {
            x: 237.06,
            y: 0.9198982959671144,
        },
        {
            x: 237.63,
            y: 0.9198301794913553,
        },
        {
            x: 238.20000000000002,
            y: 0.9197623076607833,
        },
        {
            x: 238.77,
            y: 0.9196946790144616,
        },
        {
            x: 239.34,
            y: 0.9196272921036382,
        },
        {
            x: 239.91,
            y: 0.9195601454916158,
        },
        {
            x: 240.48000000000002,
            y: 0.9194932377536225,
        },
        {
            x: 241.05,
            y: 0.9194265674766853,
        },
        {
            x: 241.62,
            y: 0.919360133259505,
        },
        {
            x: 242.19,
            y: 0.9192939337123318,
        },
        {
            x: 242.76,
            y: 0.9192279674568439,
        },
        {
            x: 243.33,
            y: 0.9191622331260263,
        },
        {
            x: 243.9,
            y: 0.9190967293640525,
        },
        {
            x: 244.47,
            y: 0.9190314548261663,
        },
        {
            x: 245.04,
            y: 0.9189664081785667,
        },
        {
            x: 245.61,
            y: 0.9189015880982926,
        },
        {
            x: 246.18,
            y: 0.9188369932731104,
        },
        {
            x: 246.75,
            y: 0.9187726224014022,
        },
        {
            x: 247.32,
            y: 0.9187084741920554,
        },
        {
            x: 247.89000000000001,
            y: 0.9186445473643544,
        },
        {
            x: 248.46,
            y: 0.9185808406478728,
        },
        {
            x: 249.03,
            y: 0.9185173527823677,
        },
        {
            x: 249.6,
            y: 0.9184540825176747,
        },
        {
            x: 250.17000000000002,
            y: 0.9183910286136046,
        },
        {
            x: 250.74,
            y: 0.9183281898398414,
        },
        {
            x: 251.31,
            y: 0.9182655649758413,
        },
        {
            x: 251.88,
            y: 0.9182031528107335,
        },
        {
            x: 252.45000000000002,
            y: 0.9181409521432211,
        },
        {
            x: 253.02,
            y: 0.918078961781485,
        },
        {
            x: 253.59,
            y: 0.918017180543087,
        },
        {
            x: 254.16,
            y: 0.9179556072548759,
        },
        {
            x: 254.73000000000002,
            y: 0.9178942407528933,
        },
        {
            x: 255.3,
            y: 0.9178330798822816,
        },
        {
            x: 255.87,
            y: 0.9177721234971924,
        },
        {
            x: 256.44,
            y: 0.9177113704606968,
        },
        {
            x: 257.01,
            y: 0.9176508196446957,
        },
        {
            x: 257.58,
            y: 0.9175904699298326,
        },
        {
            x: 258.15,
            y: 0.9175303202054056,
        },
        {
            x: 258.72,
            y: 0.9174703693692827,
        },
        {
            x: 259.29,
            y: 0.9174106163278165,
        },
        {
            x: 259.86,
            y: 0.9173510599957599,
        },
        {
            x: 260.43,
            y: 0.9172916992961844,
        },
        {
            x: 261,
            y: 0.9172325331603972,
        },
        {
            x: 261.57,
            y: 0.9171735605278611,
        },
        {
            x: 262.14,
            y: 0.9171147803461146,
        },
        {
            x: 262.71,
            y: 0.9170561915706925,
        },
        {
            x: 263.28000000000003,
            y: 0.9169977931650486,
        },
        {
            x: 263.85,
            y: 0.9169395841004784,
        },
        {
            x: 264.42,
            y: 0.9168815633560427,
        },
        {
            x: 264.99,
            y: 0.9168237299184928,
        },
        {
            x: 265.56,
            y: 0.9167660827821963,
        },
        {
            x: 266.13,
            y: 0.9167086209490631,
        },
        {
            x: 266.7,
            y: 0.9166513434284732,
        },
        {
            x: 267.27,
            y: 0.916594249237205,
        },
        {
            x: 267.84000000000003,
            y: 0.9165373373993642,
        },
        {
            x: 268.41,
            y: 0.9164806069463137,
        },
        {
            x: 268.98,
            y: 0.916424056916605,
        },
        {
            x: 269.55,
            y: 0.9163676863559087,
        },
        {
            x: 270.12,
            y: 0.9163114943169478,
        },
        {
            x: 270.69,
            y: 0.9162554798594303,
        },
        {
            x: 271.26,
            y: 0.9161996420499834,
        },
        {
            x: 271.83,
            y: 0.9161439799620879,
        },
        {
            x: 272.4,
            y: 0.9160884926760138,
        },
        {
            x: 272.97,
            y: 0.9160331792787566,
        },
        {
            x: 273.54,
            y: 0.9159780388639741,
        },
        {
            x: 274.11,
            y: 0.9159230705319238,
        },
        {
            x: 274.68,
            y: 0.9158682733894015,
        },
        {
            x: 275.25,
            y: 0.9158136465496801,
        },
        {
            x: 275.82,
            y: 0.91575918913245,
        },
        {
            x: 276.39,
            y: 0.9157049002637584,
        },
        {
            x: 276.96,
            y: 0.9156507790759514,
        },
        {
            x: 277.53000000000003,
            y: 0.9155968247076152,
        },
        {
            x: 278.1,
            y: 0.9155430363035186,
        },
        {
            x: 278.67,
            y: 0.9154894130145566,
        },
        {
            x: 279.24,
            y: 0.915435953997693,
        },
        {
            x: 279.81,
            y: 0.9153826584159058,
        },
        {
            x: 280.38,
            y: 0.9153295254381316,
        },
        {
            x: 280.95,
            y: 0.9152765542392114,
        },
        {
            x: 281.52,
            y: 0.9152237439998364,
        },
        {
            x: 282.09000000000003,
            y: 0.9151710939064955,
        },
        {
            x: 282.66,
            y: 0.9151186031514218,
        },
        {
            x: 283.23,
            y: 0.9150662709325413,
        },
        {
            x: 283.8,
            y: 0.9150140964534208,
        },
        {
            x: 284.37,
            y: 0.9149620789232176,
        },
        {
            x: 284.94,
            y: 0.9149102175566285,
        },
        {
            x: 285.51,
            y: 0.9148585115738406,
        },
        {
            x: 286.08,
            y: 0.9148069602004817,
        },
        {
            x: 286.65000000000003,
            y: 0.9147555626675717,
        },
        {
            x: 287.22,
            y: 0.9147043182114746,
        },
        {
            x: 287.79,
            y: 0.9146532260738502,
        },
        {
            x: 288.36,
            y: 0.9146022855016078,
        },
        {
            x: 288.93,
            y: 0.9145514957468592,
        },
        {
            x: 289.5,
            y: 0.9145008560668724,
        },
        {
            x: 290.07,
            y: 0.9144503657240263,
        },
        {
            x: 290.64,
            y: 0.9144000239857653,
        },
        {
            x: 291.21,
            y: 0.9143498301245548,
        },
        {
            x: 291.78000000000003,
            y: 0.9142997834178374,
        },
    ],
    lowerLimitBigRedPoints: [
        {
            x: 0.61,
            y: -0.49676670079504703,
        },
        {
            x: 0.62,
            y: -0.4857551489201576,
        },
        {
            x: 0.63,
            y: -0.475006828441385,
        },
        {
            x: 0.64,
            y: -0.4645114161809699,
        },
        {
            x: 0.65,
            y: -0.45425914699642067,
        },
        {
            x: 0.66,
            y: -0.44424077558588626,
        },
        {
            x: 0.67,
            y: -0.43444754144085385,
        },
        {
            x: 0.68,
            y: -0.42487113664418963,
        },
        {
            x: 0.6900000000000001,
            y: -0.41550367624449025,
        },
        {
            x: 0.7000000000000001,
            y: -0.40633767096664275,
        },
        {
            x: 0.71,
            y: -0.39736600204394323,
        },
        {
            x: 0.72,
            y: -0.38858189797956755,
        },
        {
            x: 0.73,
            y: -0.37997891306500076,
        },
        {
            x: 0.74,
            y: -0.3715509075005631,
        },
        {
            x: 0.75,
            y: -0.36329202897871526,
        },
        {
            x: 0.76,
            y: -0.3551966956046134,
        },
        {
            x: 0.77,
            y: -0.34725958004065827,
        },
        {
            x: 0.78,
            y: -0.3394755947727023,
        },
        {
            x: 0.79,
            y: -0.331839878405331,
        },
        {
            x: 0.8,
            y: -0.32434778290233945,
        },
        {
            x: 0.81,
            y: -0.3169948616963153,
        },
        {
            x: 0.8200000000000001,
            y: -0.3097768585982218,
        },
        {
            x: 0.8300000000000001,
            y: -0.302689697444139,
        },
        {
            x: 0.84,
            y: -0.295729472421948,
        },
        {
            x: 0.85,
            y: -0.28889243902580575,
        },
        {
            x: 0.86,
            y: -0.2821750055908213,
        },
        {
            x: 0.87,
            y: -0.2755737253644598,
        },
        {
            x: 0.88,
            y: -0.26908528907491125,
        },
        {
            x: 0.89,
            y: -0.26270651796003,
        },
        {
            x: 0.9,
            y: -0.2564343572234823,
        },
        {
            x: 0.91,
            y: -0.25026586988750676,
        },
        {
            x: 0.92,
            y: -0.24419823101418536,
        },
        {
            x: 0.93,
            y: -0.23822872226939962,
        },
        {
            x: 0.9400000000000001,
            y: -0.23235472680571145,
        },
        {
            x: 0.9500000000000001,
            y: -0.22657372444228818,
        },
        {
            x: 0.96,
            y: -0.22088328712171046,
        },
        {
            x: 0.97,
            y: -0.21528107462505275,
        },
        {
            x: 0.98,
            y: -0.20976483052806938,
        },
        {
            x: 0.99,
            y: -0.20433237838260998,
        },
        {
            x: 1,
            y: -0.19898161810859183,
        },
        {
            x: 1.01,
            y: -0.19371052258293908,
        },
        {
            x: 1.02,
            y: -0.18851713441291007,
        },
        {
            x: 1.03,
            y: -0.18339956288214665,
        },
        {
            x: 1.04,
            y: -0.17835598105862382,
        },
        {
            x: 1.05,
            y: -0.17338462305445168,
        },
        {
            x: 1.06,
            y: -0.1684837814281993,
        },
        {
            x: 1.07,
            y: -0.16365180472105856,
        },
        {
            x: 1.08,
            y: -0.15888709511877586,
        },
        {
            x: 1.09,
            y: -0.15418810623183277,
        },
        {
            x: 1.1,
            y: -0.14955334098687512,
        },
        {
            x: 1.11,
            y: -0.14498134962285592,
        },
        {
            x: 1.12,
            y: -0.1404707277858085,
        },
        {
            x: 1.1300000000000001,
            y: -0.1360201147165545,
        },
        {
            x: 1.1400000000000001,
            y: -0.13162819152604555,
        },
        {
            x: 1.1500000000000001,
            y: -0.127293679553368,
        },
        {
            x: 1.16,
            y: -0.1230153388017704,
        },
        {
            x: 1.17,
            y: -0.1187919664483702,
        },
        {
            x: 1.18,
            y: -0.11462239542347319,
        },
        {
            x: 1.19,
            y: -0.11050549305569324,
        },
        {
            x: 1.2,
            y: -0.10644015977930121,
        },
        {
            x: 1.21,
            y: -0.10242532790045433,
        },
        {
            x: 1.22,
            y: -0.0984599604191615,
        },
        {
            x: 1.23,
            y: -0.0945430499040324,
        },
        {
            x: 1.24,
            y: -0.09067361741703983,
        },
        {
            x: 1.25,
            y: -0.08685071148568757,
        },
        {
            x: 1.26,
            y: -0.08307340712013345,
        },
        {
            x: 1.27,
            y: -0.07934080487296336,
        },
        {
            x: 1.28,
            y: -0.07565202993944553,
        },
        {
            x: 1.29,
            y: -0.0720062312962203,
        },
        {
            x: 1.3,
            y: -0.06840258087650086,
        },
        {
            x: 1.31,
            y: -0.06484027277997151,
        },
        {
            x: 1.32,
            y: -0.061318522515666496,
        },
        {
            x: 1.33,
            y: -0.05783656627622147,
        },
        {
            x: 1.34,
            y: -0.05439366024196646,
        },
        {
            x: 1.35,
            y: -0.05098907991342494,
        },
        {
            x: 1.36,
            y: -0.047622119470857704,
        },
        {
            x: 1.37,
            y: -0.04429209115956534,
        },
        {
            x: 1.3800000000000001,
            y: -0.04099832469973386,
        },
        {
            x: 1.3900000000000001,
            y: -0.03774016671967617,
        },
        {
            x: 1.4000000000000001,
            y: -0.03451698021137628,
        },
        {
            x: 1.41,
            y: -0.031328144007311876,
        },
        {
            x: 1.42,
            y: -0.028173052277574828,
        },
        {
            x: 1.43,
            y: -0.02505111404636917,
        },
        {
            x: 1.44,
            y: -0.02196175272700651,
        },
        {
            x: 1.45,
            y: -0.018904405674572078,
        },
        {
            x: 1.46,
            y: -0.015878523755470608,
        },
        {
            x: 1.47,
            y: -0.012883570933104993,
        },
        {
            x: 1.48,
            y: -0.009919023868978805,
        },
        {
            x: 1.49,
            y: -0.006984371538548806,
        },
        {
            x: 1.5,
            y: -0.004079114861184396,
        },
        {
            x: 1.51,
            y: -0.0012027663436304792,
        },
        {
            x: 1.52,
            y: 0.0016451502636086746,
        },
        {
            x: 1.53,
            y: 0.004465100297513902,
        },
        {
            x: 1.54,
            y: 0.007257538501942773,
        },
        {
            x: 1.55,
            y: 0.01002290933567429,
        },
        {
            x: 1.56,
            y: 0.012761647269570742,
        },
        {
            x: 1.57,
            y: 0.01547417707331633,
        },
        {
            x: 1.58,
            y: 0.018160914092156144,
        },
        {
            x: 1.59,
            y: 0.02082226451404834,
        },
        {
            x: 1.6,
            y: 0.023458625627618468,
        },
        {
            x: 1.61,
            y: 0.02607038607128742,
        },
        {
            x: 1.62,
            y: 0.028657926073928475,
        },
        {
            x: 1.6300000000000001,
            y: 0.03122161768739118,
        },
        {
            x: 1.6400000000000001,
            y: 0.03376182501121605,
        },
        {
            x: 1.6500000000000001,
            y: 0.03627890440984549,
        },
        {
            x: 1.6600000000000001,
            y: 0.038773204722629906,
        },
        {
            x: 1.67,
            y: 0.041245067466903595,
        },
        {
            x: 1.68,
            y: 0.043694827034405415,
        },
        {
            x: 1.69,
            y: 0.04612281088129566,
        },
        {
            x: 1.7,
            y: 0.04852933971201656,
        },
        {
            x: 1.71,
            y: 0.05091472765723126,
        },
        {
            x: 1.72,
            y: 0.05327928244606317,
        },
        {
            x: 1.73,
            y: 0.05562330557285311,
        },
        {
            x: 1.74,
            y: 0.05794709245863605,
        },
        {
            x: 1.75,
            y: 0.06025093260753733,
        },
        {
            x: 1.76,
            y: 0.06253510975827259,
        },
        {
            x: 1.77,
            y: 0.06479990203093577,
        },
        {
            x: 1.78,
            y: 0.06704558206924216,
        },
        {
            x: 1.79,
            y: 0.0692724171783976,
        },
        {
            x: 1.8,
            y: 0.0714806694587472,
        },
        {
            x: 1.81,
            y: 0.07367059593535763,
        },
        {
            x: 1.82,
            y: 0.07584244868367884,
        },
        {
            x: 1.83,
            y: 0.07799647495142281,
        },
        {
            x: 1.84,
            y: 0.08013291727679528,
        },
        {
            x: 1.85,
            y: 0.08225201360320644,
        },
        {
            x: 1.86,
            y: 0.08435399739058558,
        },
        {
            x: 1.87,
            y: 0.08643909772341885,
        },
        {
            x: 1.8800000000000001,
            y: 0.08850753941561873,
        },
        {
            x: 1.8900000000000001,
            y: 0.09055954311234149,
        },
        {
            x: 1.9000000000000001,
            y: 0.09259532538885062,
        },
        {
            x: 1.9100000000000001,
            y: 0.09461509884653097,
        },
        {
            x: 1.92,
            y: 0.09661907220614818,
        },
        {
            x: 1.93,
            y: 0.0986074503984481,
        },
        {
            x: 1.94,
            y: 0.10058043465218292,
        },
        {
            x: 1.95,
            y: 0.10253822257965217,
        },
        {
            x: 1.96,
            y: 0.1044810082598403,
        },
        {
            x: 1.97,
            y: 0.10640898231922946,
        },
        {
            x: 1.98,
            y: 0.1083223320103659,
        },
        {
            x: 1.99,
            y: 0.1102212412882505,
        },
        {
            x: 2,
            y: 0.11210589088462775,
        },
        {
            x: 2.0100000000000002,
            y: 0.1139764583802374,
        },
        {
            x: 2.02,
            y: 0.1158331182750989,
        },
        {
            x: 2.0300000000000002,
            y: 0.11767604205688642,
        },
        {
            x: 2.04,
            y: 0.11950539826746032,
        },
        {
            x: 2.05,
            y: 0.1213213525676109,
        },
        {
            x: 2.06,
            y: 0.12312406780007035,
        },
        {
            x: 2.07,
            y: 0.1249137040508499,
        },
        {
            x: 2.08,
            y: 0.1266904187089526,
        },
        {
            x: 2.09,
            y: 0.12845436652451214,
        },
        {
            x: 2.1,
            y: 0.13020569966540874,
        },
        {
            x: 2.11,
            y: 0.13194456777240504,
        },
        {
            x: 2.12,
            y: 0.13367111801285303,
        },
        {
            x: 2.13,
            y: 0.13538549513300946,
        },
        {
            x: 2.14,
            y: 0.13708784150900766,
        },
        {
            x: 2.15,
            y: 0.13877829719652168,
        },
        {
            x: 2.16,
            y: 0.1404569999791665,
        },
        {
            x: 2.17,
            y: 0.14212408541566823,
        },
        {
            x: 2.18,
            y: 0.1437796868858442,
        },
        {
            x: 2.19,
            y: 0.14542393563542588,
        },
        {
            x: 2.2,
            y: 0.1470569608197616,
        },
        {
            x: 2.21,
            y: 0.1486788895464275,
        },
        {
            x: 2.22,
            y: 0.1502898469167856,
        },
        {
            x: 2.23,
            y: 0.1518899560665118,
        },
        {
            x: 2.24,
            y: 0.15347933820513016,
        },
        {
            x: 2.25,
            y: 0.15505811265457892,
        },
        {
            x: 2.2600000000000002,
            y: 0.15662639688683722,
        },
        {
            x: 2.27,
            y: 0.15818430656063798,
        },
        {
            x: 2.2800000000000002,
            y: 0.15973195555729636,
        },
        {
            x: 2.29,
            y: 0.16126945601567455,
        },
        {
            x: 2.3000000000000003,
            y: 0.16279691836631094,
        },
        {
            x: 2.31,
            y: 0.1643144513647351,
        },
        {
            x: 2.32,
            y: 0.16582216212399237,
        },
        {
            x: 2.33,
            y: 0.1673201561464006,
        },
        {
            x: 2.34,
            y: 0.1688085373545576,
        },
        {
            x: 2.35,
            y: 0.17028740812162446,
        },
        {
            x: 2.36,
            y: 0.17175686930090117,
        },
        {
            x: 2.37,
            y: 0.17321702025471497,
        },
        {
            x: 2.38,
            y: 0.1746679588826413,
        },
        {
            x: 2.39,
            y: 0.17610978164907354,
        },
        {
            x: 2.4,
            y: 0.1775425836101614,
        },
        {
            x: 2.41,
            y: 0.17896645844013281,
        },
        {
            x: 2.42,
            y: 0.180381498457018,
        },
        {
            x: 2.43,
            y: 0.1817877946477896,
        },
        {
            x: 2.44,
            y: 0.18318543669293674,
        },
        {
            x: 2.45,
            y: 0.18457451299048622,
        },
        {
            x: 2.46,
            y: 0.18595511067948545,
        },
        {
            x: 2.47,
            y: 0.18732731566296357,
        },
        {
            x: 2.48,
            y: 0.18869121263038147,
        },
        {
            x: 2.49,
            y: 0.19004688507958545,
        },
        {
            x: 2.5,
            y: 0.19139441533827883,
        },
        {
            x: 2.5100000000000002,
            y: 0.19273388458502094,
        },
        {
            x: 2.52,
            y: 0.19406537286976777,
        },
        {
            x: 2.5300000000000002,
            y: 0.1953889591339667,
        },
        {
            x: 2.54,
            y: 0.19670472123021387,
        },
        {
            x: 2.5500000000000003,
            y: 0.19801273594148905,
        },
        {
            x: 2.56,
            y: 0.1993130789999753,
        },
        {
            x: 2.57,
            y: 0.2006058251054763,
        },
        {
            x: 2.58,
            y: 0.2018910479434407,
        },
        {
            x: 2.59,
            y: 0.20316882020260263,
        },
        {
            x: 2.6,
            y: 0.20443921359224992,
        },
        {
            x: 2.61,
            y: 0.2057022988591266,
        },
        {
            x: 2.62,
            y: 0.20695814580398164,
        },
        {
            x: 2.63,
            y: 0.20820682329776996,
        },
        {
            x: 2.64,
            y: 0.20944839929751713,
        },
        {
            x: 2.65,
            y: 0.21068294086185269,
        },
        {
            x: 2.66,
            y: 0.21191051416622353,
        },
        {
            x: 2.67,
            y: 0.2131311845177929,
        },
        {
            x: 2.68,
            y: 0.21434501637003334,
        },
        {
            x: 2.69,
            y: 0.2155520733370212,
        },
        {
            x: 2.7,
            y: 0.2167524182074394,
        },
        {
            x: 2.71,
            y: 0.21794611295829602,
        },
        {
            x: 2.72,
            y: 0.21913321876836545,
        },
        {
            x: 2.73,
            y: 0.2203137960313576,
        },
        {
            x: 2.74,
            y: 0.2214879043688236,
        },
        {
            x: 2.75,
            y: 0.22265560264280226,
        },
        {
            x: 2.7600000000000002,
            y: 0.22381694896821513,
        },
        {
            x: 2.77,
            y: 0.22497200072501444,
        },
        {
            x: 2.7800000000000002,
            y: 0.22612081457009103,
        },
        {
            x: 2.79,
            y: 0.22726344644894692,
        },
        {
            x: 3.36,
            y: 0.28370405087948625,
        },
        {
            x: 3.93,
            y: 0.3273693144360402,
        },
        {
            x: 4.5,
            y: 0.36244978531672534,
        },
        {
            x: 5.07,
            y: 0.39143388065798373,
        },
        {
            x: 5.64,
            y: 0.4159047150868043,
        },
        {
            x: 6.21,
            y: 0.4369238240391169,
        },
        {
            x: 6.78,
            y: 0.4552331557847021,
        },
        {
            x: 7.3500000000000005,
            y: 0.47136900814048677,
        },
        {
            x: 7.92,
            y: 0.4857299530956432,
        },
        {
            x: 8.49,
            y: 0.49861921105107687,
        },
        {
            x: 9.06,
            y: 0.5102721077828194,
        },
        {
            x: 9.63,
            y: 0.5208744478802607,
        },
        {
            x: 10.200000000000001,
            y: 0.5305751550612048,
        },
        {
            x: 10.77,
            y: 0.5394951802799278,
        },
        {
            x: 11.34,
            y: 0.5477339137472359,
        },
        {
            x: 11.91,
            y: 0.5553738874492433,
        },
        {
            x: 12.48,
            y: 0.5624842819425149,
        },
        {
            x: 13.05,
            y: 0.5691235808957563,
        },
        {
            x: 13.620000000000001,
            y: 0.575341607818026,
        },
        {
            x: 14.19,
            y: 0.5811811080179412,
        },
        {
            x: 14.76,
            y: 0.5866789911243524,
        },
        {
            x: 15.33,
            y: 0.5918673170165376,
        },
        {
            x: 15.9,
            y: 0.5967740855231844,
        },
        {
            x: 16.47,
            y: 0.6014238744377547,
        },
        {
            x: 17.04,
            y: 0.6058383591222274,
        },
        {
            x: 17.61,
            y: 0.6100367388246941,
        },
        {
            x: 18.18,
            y: 0.61403608887898,
        },
        {
            x: 18.75,
            y: 0.6178516535489934,
        },
        {
            x: 19.32,
            y: 0.6214970909884706,
        },
        {
            x: 19.89,
            y: 0.6249846793027563,
        },
        {
            x: 20.46,
            y: 0.6283254908077867,
        },
        {
            x: 21.03,
            y: 0.6315295401288669,
        },
        {
            x: 21.6,
            y: 0.6346059106573342,
        },
        {
            x: 22.17,
            y: 0.6375628630061227,
        },
        {
            x: 22.740000000000002,
            y: 0.6404079284162614,
        },
        {
            x: 23.31,
            y: 0.6431479895214812,
        },
        {
            x: 23.88,
            y: 0.645789350444496,
        },
        {
            x: 24.45,
            y: 0.6483377978513437,
        },
        {
            x: 25.02,
            y: 0.650798654310644,
        },
        {
            x: 25.59,
            y: 0.6531768250783201,
        },
        {
            x: 26.16,
            y: 0.6554768392441741,
        },
        {
            x: 26.73,
            y: 0.6577028860261234,
        },
        {
            x: 27.3,
            y: 0.6598588468741808,
        },
        {
            x: 27.87,
            y: 0.661948323944169,
        },
        {
            x: 28.44,
            y: 0.6639746654165453,
        },
        {
            x: 29.01,
            y: 0.6659409880653031,
        },
        {
            x: 29.580000000000002,
            y: 0.6678501974231003,
        },
        {
            x: 30.150000000000002,
            y: 0.6697050058394398,
        },
        {
            x: 30.72,
            y: 0.6715079486872274,
        },
        {
            x: 31.29,
            y: 0.6732613989379812,
        },
        {
            x: 31.86,
            y: 0.6749675802962749,
        },
        {
            x: 32.43,
            y: 0.6766285790587607,
        },
        {
            x: 33,
            y: 0.6782463548416031,
        },
        {
            x: 33.57,
            y: 0.6798227503017551,
        },
        {
            x: 34.14,
            y: 0.6813594999617386,
        },
        {
            x: 34.71,
            y: 0.6828582382340257,
        },
        {
            x: 35.28,
            y: 0.6843205067294222,
        },
        {
            x: 35.85,
            y: 0.6857477609237547,
        },
        {
            x: 36.42,
            y: 0.6871413762483995,
        },
        {
            x: 36.99,
            y: 0.6885026536625933,
        },
        {
            x: 37.56,
            y: 0.6898328247588391,
        },
        {
            x: 38.13,
            y: 0.6911330564469523,
        },
        {
            x: 38.7,
            y: 0.6924044552572362,
        },
        {
            x: 39.27,
            y: 0.6936480712988549,
        },
        {
            x: 39.84,
            y: 0.6948649019055868,
        },
        {
            x: 40.410000000000004,
            y: 0.6960558949977237,
        },
        {
            x: 40.980000000000004,
            y: 0.6972219521858714,
        },
        {
            x: 41.550000000000004,
            y: 0.6983639316397452,
        },
        {
            x: 42.12,
            y: 0.6994826507427054,
        },
        {
            x: 42.69,
            y: 0.7005788885506897,
        },
        {
            x: 43.26,
            y: 0.7016533880723523,
        },
        {
            x: 43.83,
            y: 0.7027068583855732,
        },
        {
            x: 44.4,
            y: 0.703739976604037,
        },
        {
            x: 44.97,
            y: 0.704753389706272,
        },
        {
            x: 45.54,
            y: 0.7057477162383783,
        },
        {
            x: 46.11,
            y: 0.7067235479006225,
        },
        {
            x: 46.68,
            y: 0.7076814510271476,
        },
        {
            x: 47.25,
            y: 0.7086219679672048,
        },
        {
            x: 47.82,
            y: 0.7095456183755582,
        },
        {
            x: 48.39,
            y: 0.7104529004190411,
        },
        {
            x: 48.96,
            y: 0.7113442919056241,
        },
        {
            x: 49.53,
            y: 0.712220251341811,
        },
        {
            x: 50.1,
            y: 0.7130812189236762,
        },
        {
            x: 50.67,
            y: 0.7139276174664113,
        },
        {
            x: 51.24,
            y: 0.7147598532768393,
        },
        {
            x: 51.81,
            y: 0.7155783169729849,
        },
        {
            x: 52.38,
            y: 0.716383384254458,
        },
        {
            x: 52.95,
            y: 0.7171754166271,
        },
        {
            x: 53.52,
            y: 0.7179547620850696,
        },
        {
            x: 54.09,
            y: 0.7187217557532881,
        },
        {
            x: 54.660000000000004,
            y: 0.7194767204929423,
        },
        {
            x: 55.230000000000004,
            y: 0.7202199674725251,
        },
        {
            x: 55.800000000000004,
            y: 0.7209517967067128,
        },
        {
            x: 56.370000000000005,
            y: 0.7216724975651942,
        },
        {
            x: 56.94,
            y: 0.7223823492534145,
        },
        {
            x: 57.51,
            y: 0.7230816212670468,
        },
        {
            x: 58.08,
            y: 0.7237705738218709,
        },
        {
            x: 58.65,
            y: 0.7244494582606189,
        },
        {
            x: 59.22,
            y: 0.7251185174382279,
        },
        {
            x: 59.79,
            y: 0.7257779860868468,
        },
        {
            x: 60.36,
            y: 0.7264280911618384,
        },
        {
            x: 60.93,
            y: 0.7270690521699358,
        },
        {
            x: 61.5,
            y: 0.7277010814806335,
        },
        {
            x: 62.07,
            y: 0.7283243846218131,
        },
        {
            x: 62.64,
            y: 0.7289391605605398,
        },
        {
            x: 63.21,
            y: 0.7295456019699005,
        },
        {
            x: 63.78,
            y: 0.7301438954826962,
        },
        {
            x: 64.35,
            y: 0.7307342219327481,
        },
        {
            x: 64.92,
            y: 0.7313167565845234,
        },
        {
            x: 65.49,
            y: 0.7318916693517467,
        },
        {
            x: 66.06,
            y: 0.7324591250056125,
        },
        {
            x: 66.63,
            y: 0.7330192833731813,
        },
        {
            x: 67.2,
            y: 0.733572299526499,
        },
        {
            x: 67.77,
            y: 0.7341183239629502,
        },
        {
            x: 68.34,
            y: 0.7346575027773201,
        },
        {
            x: 68.91,
            y: 0.7351899778260125,
        },
        {
            x: 69.48,
            y: 0.7357158868838418,
        },
        {
            x: 70.05,
            y: 0.7362353637937955,
        },
        {
            x: 70.62,
            y: 0.7367485386101329,
        },
        {
            x: 71.19,
            y: 0.7372555377351699,
        },
        {
            x: 71.76,
            y: 0.7377564840500772,
        },
        {
            x: 72.33,
            y: 0.7382514970399962,
        },
        {
            x: 72.9,
            y: 0.7387406929137647,
        },
        {
            x: 73.47,
            y: 0.7392241847185246,
        },
        {
            x: 74.04,
            y: 0.7397020824494658,
        },
        {
            x: 74.61,
            y: 0.7401744931549512,
        },
        {
            x: 75.18,
            y: 0.7406415210372492,
        },
        {
            x: 75.75,
            y: 0.741103267549089,
        },
        {
            x: 76.32000000000001,
            y: 0.7415598314862426,
        },
        {
            x: 76.89,
            y: 0.7420113090763254,
        },
        {
            x: 77.46000000000001,
            y: 0.7424577940639948,
        },
        {
            x: 78.03,
            y: 0.742899377792721,
        },
        {
            x: 78.60000000000001,
            y: 0.7433361492832888,
        },
        {
            x: 79.17,
            y: 0.7437681953091873,
        },
        {
            x: 79.74,
            y: 0.7441956004690276,
        },
        {
            x: 80.31,
            y: 0.7446184472561309,
        },
        {
            x: 80.88,
            y: 0.7450368161254134,
        },
        {
            x: 81.45,
            y: 0.7454507855576921,
        },
        {
            x: 82.02,
            y: 0.745860432121529,
        },
        {
            x: 82.59,
            y: 0.7462658305327231,
        },
        {
            x: 83.16,
            y: 0.7466670537115563,
        },
        {
            x: 83.73,
            y: 0.7470641728378916,
        },
        {
            x: 84.3,
            y: 0.7474572574042198,
        },
        {
            x: 84.87,
            y: 0.7478463752667416,
        },
        {
            x: 85.44,
            y: 0.7482315926945748,
        },
        {
            x: 86.01,
            y: 0.7486129744171622,
        },
        {
            x: 86.58,
            y: 0.7489905836699623,
        },
        {
            x: 87.15,
            y: 0.7493644822384921,
        },
        {
            x: 87.72,
            y: 0.7497347305007939,
        },
        {
            x: 88.29,
            y: 0.7501013874683924,
        },
        {
            x: 88.86,
            y: 0.750464510825803,
        },
        {
            x: 89.43,
            y: 0.7508241569686546,
        },
        {
            x: 90,
            y: 0.7511803810404802,
        },
        {
            x: 90.57000000000001,
            y: 0.7515332369682348,
        },
        {
            x: 91.14,
            y: 0.7518827774965869,
        },
        {
            x: 91.71000000000001,
            y: 0.7522290542210378,
        },
        {
            x: 92.28,
            y: 0.7525721176199129,
        },
        {
            x: 92.85000000000001,
            y: 0.7529120170852721,
        },
        {
            x: 93.42,
            y: 0.7532488009527805,
        },
        {
            x: 93.99,
            y: 0.7535825165305816,
        },
        {
            x: 94.56,
            y: 0.7539132101272121,
        },
        {
            x: 95.13,
            y: 0.7542409270785946,
        },
        {
            x: 95.7,
            y: 0.7545657117741453,
        },
        {
            x: 96.27,
            y: 0.7548876076820308,
        },
        {
            x: 96.84,
            y: 0.7552066573736039,
        },
        {
            x: 97.41,
            y: 0.7555229025470552,
        },
        {
            x: 97.98,
            y: 0.7558363840503032,
        },
        {
            x: 98.55,
            y: 0.7561471419031579,
        },
        {
            x: 99.12,
            y: 0.7564552153187811,
        },
        {
            x: 99.69,
            y: 0.7567606427244711,
        },
        {
            x: 100.26,
            y: 0.7570634617817966,
        },
        {
            x: 100.83,
            y: 0.7573637094061038,
        },
        {
            x: 101.4,
            y: 0.7576614217854192,
        },
        {
            x: 101.97,
            y: 0.7579566343987709,
        },
        {
            x: 102.54,
            y: 0.758249382033949,
        },
        {
            x: 103.11,
            y: 0.7585396988047242,
        },
        {
            x: 103.68,
            y: 0.7588276181675465,
        },
        {
            x: 104.25,
            y: 0.7591131729377403,
        },
        {
            x: 104.82000000000001,
            y: 0.759396395305214,
        },
        {
            x: 105.39,
            y: 0.7596773168497032,
        },
        {
            x: 105.96000000000001,
            y: 0.7599559685555601,
        },
        {
            x: 106.53,
            y: 0.7602323808261096,
        },
        {
            x: 107.10000000000001,
            y: 0.7605065834975817,
        },
        {
            x: 107.67,
            y: 0.7607786058526409,
        },
        {
            x: 108.24000000000001,
            y: 0.7610484766335205,
        },
        {
            x: 108.81,
            y: 0.7613162240547795,
        },
        {
            x: 109.38,
            y: 0.7615818758156927,
        },
        {
            x: 109.95,
            y: 0.761845459112288,
        },
        {
            x: 110.52,
            y: 0.7621070006490402,
        },
        {
            x: 111.09,
            y: 0.7623665266502363,
        },
        {
            x: 111.66,
            y: 0.7626240628710192,
        },
        {
            x: 112.23,
            y: 0.7628796346081246,
        },
        {
            x: 112.8,
            y: 0.7631332667103177,
        },
        {
            x: 113.37,
            y: 0.7633849835885411,
        },
        {
            x: 113.94,
            y: 0.7636348092257842,
        },
        {
            x: 114.51,
            y: 0.7638827671866804,
        },
        {
            x: 115.08,
            y: 0.7641288806268438,
        },
        {
            x: 115.65,
            y: 0.7643731723019521,
        },
        {
            x: 116.22,
            y: 0.7646156645765839,
        },
        {
            x: 116.79,
            y: 0.7648563794328194,
        },
        {
            x: 117.36,
            y: 0.7650953384786092,
        },
        {
            x: 117.93,
            y: 0.7653325629559233,
        },
        {
            x: 118.5,
            y: 0.7655680737486807,
        },
        {
            x: 119.07000000000001,
            y: 0.7658018913904733,
        },
        {
            x: 119.64,
            y: 0.7660340360720846,
        },
        {
            x: 120.21000000000001,
            y: 0.766264527648814,
        },
        {
            x: 120.78,
            y: 0.7664933856476094,
        },
        {
            x: 121.35000000000001,
            y: 0.7667206292740159,
        },
        {
            x: 121.92,
            y: 0.7669462774189453,
        },
        {
            x: 122.49000000000001,
            y: 0.7671703486652733,
        },
        {
            x: 123.06,
            y: 0.7673928612942664,
        },
        {
            x: 123.63000000000001,
            y: 0.7676138332918476,
        },
        {
            x: 124.2,
            y: 0.7678332823547022,
        },
        {
            x: 124.77,
            y: 0.7680512258962313,
        },
        {
            x: 125.34,
            y: 0.7682676810523554,
        },
        {
            x: 125.91,
            y: 0.7684826646871739,
        },
        {
            x: 126.48,
            y: 0.768696193398483,
        },
        {
            x: 127.05,
            y: 0.7689082835231594,
        },
        {
            x: 127.62,
            y: 0.769118951142409,
        },
        {
            x: 128.19,
            y: 0.7693282120868896,
        },
        {
            x: 128.76,
            y: 0.7695360819417065,
        },
        {
            x: 129.33,
            y: 0.7697425760512892,
        },
        {
            x: 129.9,
            y: 0.7699477095241474,
        },
        {
            x: 130.47,
            y: 0.7701514972375157,
        },
        {
            x: 131.04,
            y: 0.7703539538418849,
        },
        {
            x: 131.61,
            y: 0.7705550937654257,
        },
        {
            x: 132.18,
            y: 0.7707549312183082,
        },
        {
            x: 132.75,
            y: 0.7709534801969179,
        },
        {
            x: 133.32,
            y: 0.7711507544879739,
        },
        {
            x: 133.89000000000001,
            y: 0.7713467676725495,
        },
        {
            x: 134.46,
            y: 0.7715415331299993,
        },
        {
            x: 135.03,
            y: 0.7717350640417955,
        },
        {
            x: 135.6,
            y: 0.7719273733952745,
        },
        {
            x: 136.17000000000002,
            y: 0.7721184739872977,
        },
        {
            x: 136.74,
            y: 0.7723083784278287,
        },
        {
            x: 137.31,
            y: 0.7724970991434275,
        },
        {
            x: 137.88,
            y: 0.7726846483806664,
        },
        {
            x: 138.45000000000002,
            y: 0.7728710382094682,
        },
        {
            x: 139.02,
            y: 0.7730562805263683,
        },
        {
            x: 139.59,
            y: 0.7732403870577043,
        },
        {
            x: 140.16,
            y: 0.7734233693627337,
        },
        {
            x: 140.73,
            y: 0.7736052388366828,
        },
        {
            x: 141.3,
            y: 0.7737860067137267,
        },
        {
            x: 141.87,
            y: 0.7739656840699043,
        },
        {
            x: 142.44,
            y: 0.7741442818259691,
        },
        {
            x: 143.01,
            y: 0.7743218107501763,
        },
        {
            x: 143.58,
            y: 0.7744982814610109,
        },
        {
            x: 144.15,
            y: 0.7746737044298548,
        },
        {
            x: 144.72,
            y: 0.7748480899835966,
        },
        {
            x: 145.29,
            y: 0.7750214483071851,
        },
        {
            x: 145.86,
            y: 0.7751937894461279,
        },
        {
            x: 146.43,
            y: 0.7753651233089363,
        },
        {
            x: 147,
            y: 0.775535459669518,
        },
        {
            x: 147.57,
            y: 0.7757048081695191,
        },
        {
            x: 148.14000000000001,
            y: 0.7758731783206166,
        },
        {
            x: 148.71,
            y: 0.7760405795067618,
        },
        {
            x: 149.28,
            y: 0.7762070209863773,
        },
        {
            x: 149.85,
            y: 0.7763725118945078,
        },
        {
            x: 150.42000000000002,
            y: 0.7765370612449262,
        },
        {
            x: 150.99,
            y: 0.7767006779321949,
        },
        {
            x: 151.56,
            y: 0.7768633707336862,
        },
        {
            x: 152.13,
            y: 0.7770251483115594,
        },
        {
            x: 152.70000000000002,
            y: 0.7771860192146984,
        },
        {
            x: 153.27,
            y: 0.7773459918806085,
        },
        {
            x: 153.84,
            y: 0.7775050746372756,
        },
        {
            x: 154.41,
            y: 0.7776632757049875,
        },
        {
            x: 154.98,
            y: 0.7778206031981171,
        },
        {
            x: 155.55,
            y: 0.7779770651268716,
        },
        {
            x: 156.12,
            y: 0.7781326693990045,
        },
        {
            x: 156.69,
            y: 0.7782874238214949,
        },
        {
            x: 157.26,
            y: 0.7784413361021925,
        },
        {
            x: 157.83,
            y: 0.7785944138514301,
        },
        {
            x: 158.4,
            y: 0.7787466645836042,
        },
        {
            x: 158.97,
            y: 0.7788980957187241,
        },
        {
            x: 159.54,
            y: 0.779048714583931,
        },
        {
            x: 160.11,
            y: 0.779198528414987,
        },
        {
            x: 160.68,
            y: 0.7793475443577353,
        },
        {
            x: 161.25,
            y: 0.7794957694695315,
        },
        {
            x: 161.82,
            y: 0.7796432107206475,
        },
        {
            x: 162.39000000000001,
            y: 0.7797898749956486,
        },
        {
            x: 162.96,
            y: 0.7799357690947433,
        },
        {
            x: 163.53,
            y: 0.7800808997351079,
        },
        {
            x: 164.1,
            y: 0.780225273552185,
        },
        {
            x: 164.67000000000002,
            y: 0.7803688971009584,
        },
        {
            x: 165.24,
            y: 0.7805117768572027,
        },
        {
            x: 165.81,
            y: 0.7806539192187099,
        },
        {
            x: 166.38,
            y: 0.7807953305064924,
        },
        {
            x: 166.95000000000002,
            y: 0.7809360169659638,
        },
        {
            x: 167.52,
            y: 0.7810759847680976,
        },
        {
            x: 168.09,
            y: 0.7812152400105637,
        },
        {
            x: 168.66,
            y: 0.7813537887188446,
        },
        {
            x: 169.23,
            y: 0.78149163684733,
        },
        {
            x: 169.8,
            y: 0.7816287902803922,
        },
        {
            x: 170.37,
            y: 0.7817652548334404,
        },
        {
            x: 170.94,
            y: 0.7819010362539569,
        },
        {
            x: 171.51,
            y: 0.782036140222514,
        },
        {
            x: 172.08,
            y: 0.7821705723537716,
        },
        {
            x: 172.65,
            y: 0.7823043381974575,
        },
        {
            x: 173.22,
            y: 0.7824374432393298,
        },
        {
            x: 173.79,
            y: 0.7825698929021219,
        },
        {
            x: 174.36,
            y: 0.7827016925464699,
        },
        {
            x: 174.93,
            y: 0.7828328474718246,
        },
        {
            x: 175.5,
            y: 0.7829633629173457,
        },
        {
            x: 176.07,
            y: 0.7830932440627816,
        },
        {
            x: 176.64000000000001,
            y: 0.7832224960293324,
        },
        {
            x: 177.21,
            y: 0.7833511238804978,
        },
        {
            x: 177.78,
            y: 0.783479132622911,
        },
        {
            x: 178.35,
            y: 0.7836065272071564,
        },
        {
            x: 178.92000000000002,
            y: 0.7837333125285744,
        },
        {
            x: 179.49,
            y: 0.7838594934280508,
        },
        {
            x: 180.06,
            y: 0.7839850746927941,
        },
        {
            x: 180.63,
            y: 0.7841100610570974,
        },
        {
            x: 181.20000000000002,
            y: 0.7842344572030884,
        },
        {
            x: 181.77,
            y: 0.7843582677614662,
        },
        {
            x: 182.34,
            y: 0.7844814973122255,
        },
        {
            x: 182.91,
            y: 0.7846041503853676,
        },
        {
            x: 183.48,
            y: 0.7847262314616004,
        },
        {
            x: 184.05,
            y: 0.7848477449730253,
        },
        {
            x: 184.62,
            y: 0.7849686953038142,
        },
        {
            x: 185.19,
            y: 0.7850890867908722,
        },
        {
            x: 185.76,
            y: 0.7852089237244921,
        },
        {
            x: 186.33,
            y: 0.7853282103489962,
        },
        {
            x: 186.9,
            y: 0.7854469508633675,
        },
        {
            x: 187.47,
            y: 0.7855651494218704,
        },
        {
            x: 188.04,
            y: 0.7856828101346617,
        },
        {
            x: 188.61,
            y: 0.7857999370683901,
        },
        {
            x: 189.18,
            y: 0.7859165342467875,
        },
        {
            x: 189.75,
            y: 0.7860326056512488,
        },
        {
            x: 190.32,
            y: 0.7861481552214032,
        },
        {
            x: 190.89000000000001,
            y: 0.7862631868556761,
        },
        {
            x: 191.46,
            y: 0.7863777044118407,
        },
        {
            x: 192.03,
            y: 0.7864917117075627,
        },
        {
            x: 192.6,
            y: 0.7866052125209334,
        },
        {
            x: 193.17000000000002,
            y: 0.7867182105909967,
        },
        {
            x: 193.74,
            y: 0.7868307096182658,
        },
        {
            x: 194.31,
            y: 0.7869427132652327,
        },
        {
            x: 194.88,
            y: 0.7870542251568683,
        },
        {
            x: 195.45000000000002,
            y: 0.7871652488811159,
        },
        {
            x: 196.02,
            y: 0.7872757879893758,
        },
        {
            x: 196.59,
            y: 0.7873858459969821,
        },
        {
            x: 197.16,
            y: 0.787495426383673,
        },
        {
            x: 197.73000000000002,
            y: 0.787604532594052,
        },
        {
            x: 198.3,
            y: 0.7877131680380434,
        },
        {
            x: 198.87,
            y: 0.7878213360913395,
        },
        {
            x: 199.44,
            y: 0.7879290400958416,
        },
        {
            x: 200.01,
            y: 0.7880362833600931,
        },
        {
            x: 200.58,
            y: 0.7881430691597069,
        },
        {
            x: 201.15,
            y: 0.7882494007377849,
        },
        {
            x: 201.72,
            y: 0.7883552813053329,
        },
        {
            x: 202.29,
            y: 0.7884607140416666,
        },
        {
            x: 202.86,
            y: 0.7885657020948134,
        },
        {
            x: 203.43,
            y: 0.7886702485819065,
        },
        {
            x: 204,
            y: 0.7887743565895745,
        },
        {
            x: 204.57,
            y: 0.7888780291743234,
        },
        {
            x: 205.14000000000001,
            y: 0.7889812693629138,
        },
        {
            x: 205.71,
            y: 0.7890840801527321,
        },
        {
            x: 206.28,
            y: 0.789186464512156,
        },
        {
            x: 206.85,
            y: 0.789288425380914,
        },
        {
            x: 207.42000000000002,
            y: 0.7893899656704408,
        },
        {
            x: 207.99,
            y: 0.7894910882642259,
        },
        {
            x: 208.56,
            y: 0.7895917960181572,
        },
        {
            x: 209.13,
            y: 0.7896920917608609,
        },
        {
            x: 209.70000000000002,
            y: 0.7897919782940337,
        },
        {
            x: 210.27,
            y: 0.789891458392773,
        },
        {
            x: 210.84,
            y: 0.7899905348058993,
        },
        {
            x: 211.41,
            y: 0.7900892102562768,
        },
        {
            x: 211.98000000000002,
            y: 0.790187487441126,
        },
        {
            x: 212.55,
            y: 0.7902853690323346,
        },
        {
            x: 213.12,
            y: 0.7903828576767622,
        },
        {
            x: 213.69,
            y: 0.790479955996541,
        },
        {
            x: 214.26,
            y: 0.7905766665893715,
        },
        {
            x: 214.83,
            y: 0.7906729920288154,
        },
        {
            x: 215.4,
            y: 0.7907689348645822,
        },
        {
            x: 215.97,
            y: 0.7908644976228135,
        },
        {
            x: 216.54,
            y: 0.790959682806362,
        },
        {
            x: 217.11,
            y: 0.7910544928950664,
        },
        {
            x: 217.68,
            y: 0.7911489303460236,
        },
        {
            x: 218.25,
            y: 0.7912429975938556,
        },
        {
            x: 218.82,
            y: 0.7913366970509733,
        },
        {
            x: 219.39000000000001,
            y: 0.7914300311078364,
        },
        {
            x: 219.96,
            y: 0.791523002133209,
        },
        {
            x: 220.53,
            y: 0.7916156124744131,
        },
        {
            x: 221.1,
            y: 0.7917078644575769,
        },
        {
            x: 221.67000000000002,
            y: 0.7917997603878799,
        },
        {
            x: 222.24,
            y: 0.7918913025497955,
        },
        {
            x: 222.81,
            y: 0.791982493207329,
        },
        {
            x: 223.38,
            y: 0.7920733346042534,
        },
        {
            x: 223.95000000000002,
            y: 0.7921638289643407,
        },
        {
            x: 224.52,
            y: 0.7922539784915904,
        },
        {
            x: 225.09,
            y: 0.7923437853704558,
        },
        {
            x: 225.66,
            y: 0.7924332517660654,
        },
        {
            x: 226.23000000000002,
            y: 0.7925223798244428,
        },
        {
            x: 226.8,
            y: 0.7926111716727225,
        },
        {
            x: 227.37,
            y: 0.7926996294193634,
        },
        {
            x: 227.94,
            y: 0.792787755154359,
        },
        {
            x: 228.51,
            y: 0.7928755509494445,
        },
        {
            x: 229.08,
            y: 0.7929630188583018,
        },
        {
            x: 229.65,
            y: 0.7930501609167611,
        },
        {
            x: 230.22,
            y: 0.7931369791429999,
        },
        {
            x: 230.79,
            y: 0.7932234755377394,
        },
        {
            x: 231.36,
            y: 0.7933096520844379,
        },
        {
            x: 231.93,
            y: 0.7933955107494822,
        },
        {
            x: 232.5,
            y: 0.7934810534823759,
        },
        {
            x: 233.07,
            y: 0.7935662822159248,
        },
        {
            x: 233.64000000000001,
            y: 0.7936511988664217,
        },
        {
            x: 234.21,
            y: 0.7937358053338255,
        },
        {
            x: 234.78,
            y: 0.7938201035019413,
        },
        {
            x: 235.35,
            y: 0.793904095238596,
        },
        {
            x: 235.92000000000002,
            y: 0.7939877823958117,
        },
        {
            x: 236.49,
            y: 0.7940711668099782,
        },
        {
            x: 237.06,
            y: 0.7941542503020212,
        },
        {
            x: 237.63,
            y: 0.7942370346775702,
        },
        {
            x: 238.20000000000002,
            y: 0.7943195217271225,
        },
        {
            x: 238.77,
            y: 0.7944017132262066,
        },
        {
            x: 239.34,
            y: 0.7944836109355422,
        },
        {
            x: 239.91,
            y: 0.7945652166011989,
        },
        {
            x: 240.48000000000002,
            y: 0.7946465319547524,
        },
        {
            x: 241.05,
            y: 0.794727558713439,
        },
        {
            x: 241.62,
            y: 0.7948082985803078,
        },
        {
            x: 242.19,
            y: 0.7948887532443708,
        },
        {
            x: 242.76,
            y: 0.7949689243807518,
        },
        {
            x: 243.33,
            y: 0.7950488136508325,
        },
        {
            x: 243.9,
            y: 0.7951284227023973,
        },
        {
            x: 244.47,
            y: 0.7952077531697759,
        },
        {
            x: 245.04,
            y: 0.7952868066739843,
        },
        {
            x: 245.61,
            y: 0.7953655848228642,
        },
        {
            x: 246.18,
            y: 0.7954440892112198,
        },
        {
            x: 246.75,
            y: 0.7955223214209535,
        },
        {
            x: 247.32,
            y: 0.7956002830212003,
        },
        {
            x: 247.89000000000001,
            y: 0.7956779755684598,
        },
        {
            x: 248.46,
            y: 0.7957554006067259,
        },
        {
            x: 249.03,
            y: 0.7958325596676169,
        },
        {
            x: 249.6,
            y: 0.7959094542705021,
        },
        {
            x: 250.17000000000002,
            y: 0.7959860859226272,
        },
        {
            x: 250.74,
            y: 0.7960624561192394,
        },
        {
            x: 251.31,
            y: 0.7961385663437087,
        },
        {
            x: 251.88,
            y: 0.7962144180676497,
        },
        {
            x: 252.45000000000002,
            y: 0.796290012751041,
        },
        {
            x: 253.02,
            y: 0.796365351842343,
        },
        {
            x: 253.59,
            y: 0.7964404367786145,
        },
        {
            x: 254.16,
            y: 0.7965152689856284,
        },
        {
            x: 254.73000000000002,
            y: 0.7965898498779843,
        },
        {
            x: 255.3,
            y: 0.796664180859222,
        },
        {
            x: 255.87,
            y: 0.7967382633219314,
        },
        {
            x: 256.44,
            y: 0.7968120986478632,
        },
        {
            x: 257.01,
            y: 0.7968856882080358,
        },
        {
            x: 257.58,
            y: 0.7969590333628436,
        },
        {
            x: 258.15,
            y: 0.7970321354621616,
        },
        {
            x: 258.72,
            y: 0.79710499584545,
        },
        {
            x: 259.29,
            y: 0.7971776158418578,
        },
        {
            x: 259.86,
            y: 0.7972499967703239,
        },
        {
            x: 260.43,
            y: 0.7973221399396784,
        },
        {
            x: 261,
            y: 0.7973940466487411,
        },
        {
            x: 261.57,
            y: 0.7974657181864209,
        },
        {
            x: 262.14,
            y: 0.7975371558318116,
        },
        {
            x: 262.71,
            y: 0.7976083608542888,
        },
        {
            x: 263.28000000000003,
            y: 0.7976793345136041,
        },
        {
            x: 263.85,
            y: 0.7977500780599787,
        },
        {
            x: 264.42,
            y: 0.7978205927341963,
        },
        {
            x: 264.99,
            y: 0.7978908797676938,
        },
        {
            x: 265.56,
            y: 0.7979609403826523,
        },
        {
            x: 266.13,
            y: 0.7980307757920863,
        },
        {
            x: 266.7,
            y: 0.7981003871999311,
        },
        {
            x: 267.27,
            y: 0.7981697758011314,
        },
        {
            x: 267.84000000000003,
            y: 0.7982389427817259,
        },
        {
            x: 268.41,
            y: 0.7983078893189337,
        },
        {
            x: 268.98,
            y: 0.7983766165812377,
        },
        {
            x: 269.55,
            y: 0.7984451257284679,
        },
        {
            x: 270.12,
            y: 0.798513417911884,
        },
        {
            x: 270.69,
            y: 0.7985814942742564,
        },
        {
            x: 271.26,
            y: 0.798649355949946,
        },
        {
            x: 271.83,
            y: 0.7987170040649848,
        },
        {
            x: 272.4,
            y: 0.7987844397371531,
        },
        {
            x: 272.97,
            y: 0.7988516640760577,
        },
        {
            x: 273.54,
            y: 0.7989186781832089,
        },
        {
            x: 274.11,
            y: 0.7989854831520956,
        },
        {
            x: 274.68,
            y: 0.7990520800682606,
        },
        {
            x: 275.25,
            y: 0.7991184700093745,
        },
        {
            x: 275.82,
            y: 0.7991846540453096,
        },
        {
            x: 276.39,
            y: 0.7992506332382113,
        },
        {
            x: 276.96,
            y: 0.7993164086425705,
        },
        {
            x: 277.53000000000003,
            y: 0.7993819813052938,
        },
        {
            x: 278.1,
            y: 0.7994473522657741,
        },
        {
            x: 278.67,
            y: 0.7995125225559592,
        },
        {
            x: 279.24,
            y: 0.7995774932004207,
        },
        {
            x: 279.81,
            y: 0.7996422652164212,
        },
        {
            x: 280.38,
            y: 0.7997068396139818,
        },
        {
            x: 280.95,
            y: 0.7997712173959476,
        },
        {
            x: 281.52,
            y: 0.7998353995580534,
        },
        {
            x: 282.09000000000003,
            y: 0.7998993870889884,
        },
        {
            x: 282.66,
            y: 0.7999631809704605,
        },
        {
            x: 283.23,
            y: 0.8000267821772586,
        },
        {
            x: 283.8,
            y: 0.8000901916773164,
        },
        {
            x: 284.37,
            y: 0.8001534104317732,
        },
        {
            x: 284.94,
            y: 0.8002164393950357,
        },
        {
            x: 285.51,
            y: 0.8002792795148385,
        },
        {
            x: 286.08,
            y: 0.8003419317323035,
        },
        {
            x: 286.65000000000003,
            y: 0.8004043969819995,
        },
        {
            x: 287.22,
            y: 0.8004666761920008,
        },
        {
            x: 287.79,
            y: 0.800528770283945,
        },
        {
            x: 288.36,
            y: 0.80059068017309,
        },
        {
            x: 288.93,
            y: 0.8006524067683709,
        },
        {
            x: 289.5,
            y: 0.8007139509724566,
        },
        {
            x: 290.07,
            y: 0.8007753136818039,
        },
        {
            x: 290.64,
            y: 0.8008364957867139,
        },
        {
            x: 291.21,
            y: 0.8008974981713849,
        },
        {
            x: 291.78000000000003,
            y: 0.8009583217139672,
        },
    ],
    upperLimitBigRedPoints: [
        {
            x: 2.79,
            y: 1.4990117019128941,
        },
        {
            x: 3.36,
            y: 1.4425710974823547,
        },
        {
            x: 3.93,
            y: 1.398905833925801,
        },
        {
            x: 4.5,
            y: 1.3638253630451156,
        },
        {
            x: 5.07,
            y: 1.3348412677038572,
        },
        {
            x: 5.64,
            y: 1.3103704332750368,
        },
        {
            x: 6.21,
            y: 1.2893513243227241,
        },
        {
            x: 6.78,
            y: 1.271041992577139,
        },
        {
            x: 7.3500000000000005,
            y: 1.2549061402213542,
        },
        {
            x: 7.92,
            y: 1.2405451952661979,
        },
        {
            x: 8.49,
            y: 1.227655937310764,
        },
        {
            x: 9.06,
            y: 1.2160030405790216,
        },
        {
            x: 9.63,
            y: 1.2054007004815803,
        },
        {
            x: 10.200000000000001,
            y: 1.1956999933006363,
        },
        {
            x: 10.77,
            y: 1.1867799680819133,
        },
        {
            x: 11.34,
            y: 1.1785412346146051,
        },
        {
            x: 11.91,
            y: 1.1709012609125977,
        },
        {
            x: 12.48,
            y: 1.1637908664193262,
        },
        {
            x: 13.05,
            y: 1.1571515674660846,
        },
        {
            x: 13.620000000000001,
            y: 1.150933540543815,
        },
        {
            x: 14.19,
            y: 1.1450940403438998,
        },
        {
            x: 14.76,
            y: 1.1395961572374886,
        },
        {
            x: 15.33,
            y: 1.1344078313453034,
        },
        {
            x: 15.9,
            y: 1.1295010628386566,
        },
        {
            x: 16.47,
            y: 1.1248512739240863,
        },
        {
            x: 17.04,
            y: 1.1204367892396137,
        },
        {
            x: 17.61,
            y: 1.116238409537147,
        },
        {
            x: 18.18,
            y: 1.112239059482861,
        },
        {
            x: 18.75,
            y: 1.1084234948128477,
        },
        {
            x: 19.32,
            y: 1.1047780573733703,
        },
        {
            x: 19.89,
            y: 1.1012904690590848,
        },
        {
            x: 20.46,
            y: 1.0979496575540544,
        },
        {
            x: 21.03,
            y: 1.0947456082329743,
        },
        {
            x: 21.6,
            y: 1.091669237704507,
        },
        {
            x: 22.17,
            y: 1.0887122853557183,
        },
        {
            x: 22.740000000000002,
            y: 1.0858672199455797,
        },
        {
            x: 23.31,
            y: 1.0831271588403597,
        },
        {
            x: 23.88,
            y: 1.080485797917345,
        },
        {
            x: 24.45,
            y: 1.0779373505104974,
        },
        {
            x: 25.02,
            y: 1.075476494051197,
        },
        {
            x: 25.59,
            y: 1.073098323283521,
        },
        {
            x: 26.16,
            y: 1.070798309117667,
        },
        {
            x: 26.73,
            y: 1.0685722623357177,
        },
        {
            x: 27.3,
            y: 1.0664163014876602,
        },
        {
            x: 27.87,
            y: 1.064326824417672,
        },
        {
            x: 28.44,
            y: 1.0623004829452958,
        },
        {
            x: 29.01,
            y: 1.060334160296538,
        },
        {
            x: 29.580000000000002,
            y: 1.058424950938741,
        },
        {
            x: 30.150000000000002,
            y: 1.0565701425224012,
        },
        {
            x: 30.72,
            y: 1.0547671996746135,
        },
        {
            x: 31.29,
            y: 1.0530137494238598,
        },
        {
            x: 31.86,
            y: 1.0513075680655661,
        },
        {
            x: 32.43,
            y: 1.0496465693030803,
        },
        {
            x: 33,
            y: 1.048028793520238,
        },
        {
            x: 33.57,
            y: 1.046452398060086,
        },
        {
            x: 34.14,
            y: 1.0449156484001023,
        },
        {
            x: 34.71,
            y: 1.0434169101278155,
        },
        {
            x: 35.28,
            y: 1.0419546416324188,
        },
        {
            x: 35.85,
            y: 1.0405273874380863,
        },
        {
            x: 36.42,
            y: 1.0391337721134415,
        },
        {
            x: 36.99,
            y: 1.0377724946992477,
        },
        {
            x: 37.56,
            y: 1.036442323603002,
        },
        {
            x: 38.13,
            y: 1.0351420919148888,
        },
        {
            x: 38.7,
            y: 1.0338706931046049,
        },
        {
            x: 39.27,
            y: 1.0326270770629862,
        },
        {
            x: 39.84,
            y: 1.0314102464562542,
        },
        {
            x: 40.410000000000004,
            y: 1.0302192533641175,
        },
        {
            x: 40.980000000000004,
            y: 1.0290531961759697,
        },
        {
            x: 41.550000000000004,
            y: 1.0279112167220958,
        },
        {
            x: 42.12,
            y: 1.0267924976191356,
        },
        {
            x: 42.69,
            y: 1.0256962598111512,
        },
        {
            x: 43.26,
            y: 1.0246217602894887,
        },
        {
            x: 43.83,
            y: 1.0235682899762677,
        },
        {
            x: 44.4,
            y: 1.0225351717578042,
        },
        {
            x: 44.97,
            y: 1.021521758655569,
        },
        {
            x: 45.54,
            y: 1.0205274321234628,
        },
        {
            x: 46.11,
            y: 1.0195516004612184,
        },
        {
            x: 46.68,
            y: 1.0185936973346934,
        },
        {
            x: 47.25,
            y: 1.0176531803946363,
        },
        {
            x: 47.82,
            y: 1.0167295299862829,
        },
        {
            x: 48.39,
            y: 1.0158222479428,
        },
        {
            x: 48.96,
            y: 1.014930856456217,
        },
        {
            x: 49.53,
            y: 1.01405489702003,
        },
        {
            x: 50.1,
            y: 1.0131939294381649,
        },
        {
            x: 50.67,
            y: 1.0123475308954297,
        },
        {
            x: 51.24,
            y: 1.0115152950850017,
        },
        {
            x: 51.81,
            y: 1.010696831388856,
        },
        {
            x: 52.38,
            y: 1.009891764107383,
        },
        {
            x: 52.95,
            y: 1.009099731734741,
        },
        {
            x: 53.52,
            y: 1.0083203862767713,
        },
        {
            x: 54.09,
            y: 1.007553392608553,
        },
        {
            x: 54.660000000000004,
            y: 1.0067984278688988,
        },
        {
            x: 55.230000000000004,
            y: 1.006055180889316,
        },
        {
            x: 55.800000000000004,
            y: 1.0053233516551283,
        },
        {
            x: 56.370000000000005,
            y: 1.0046026507966468,
        },
        {
            x: 56.94,
            y: 1.0038927991084265,
        },
        {
            x: 57.51,
            y: 1.0031935270947943,
        },
        {
            x: 58.08,
            y: 1.00250457453997,
        },
        {
            x: 58.65,
            y: 1.0018256901012221,
        },
        {
            x: 59.22,
            y: 1.0011566309236133,
        },
        {
            x: 59.79,
            y: 1.000497162274994,
        },
        {
            x: 60.36,
            y: 0.9998470572000027,
        },
        {
            x: 60.93,
            y: 0.9992060961919053,
        },
        {
            x: 61.5,
            y: 0.9985740668812075,
        },
        {
            x: 62.07,
            y: 0.9979507637400279,
        },
        {
            x: 62.64,
            y: 0.9973359878013013,
        },
        {
            x: 63.21,
            y: 0.9967295463919406,
        },
        {
            x: 63.78,
            y: 0.9961312528791448,
        },
        {
            x: 64.35,
            y: 0.995540926429093,
        },
        {
            x: 64.92,
            y: 0.9949583917773176,
        },
        {
            x: 65.49,
            y: 0.9943834790100944,
        },
        {
            x: 66.06,
            y: 0.9938160233562285,
        },
        {
            x: 66.63,
            y: 0.9932558649886597,
        },
        {
            x: 67.2,
            y: 0.992702848835342,
        },
        {
            x: 67.77,
            y: 0.9921568243988909,
        },
        {
            x: 68.34,
            y: 0.9916176455845209,
        },
        {
            x: 68.91,
            y: 0.9910851705358286,
        },
        {
            x: 69.48,
            y: 0.9905592614779992,
        },
        {
            x: 70.05,
            y: 0.9900397845680455,
        },
        {
            x: 70.62,
            y: 0.9895266097517081,
        },
        {
            x: 71.19,
            y: 0.9890196106266711,
        },
        {
            x: 71.76,
            y: 0.9885186643117638,
        },
        {
            x: 72.33,
            y: 0.9880236513218449,
        },
        {
            x: 72.9,
            y: 0.9875344554480764,
        },
        {
            x: 73.47,
            y: 0.9870509636433165,
        },
        {
            x: 74.04,
            y: 0.9865730659123753,
        },
        {
            x: 74.61,
            y: 0.9861006552068898,
        },
        {
            x: 75.18,
            y: 0.9856336273245918,
        },
        {
            x: 75.75,
            y: 0.9851718808127521,
        },
        {
            x: 76.32000000000001,
            y: 0.9847153168755984,
        },
        {
            x: 76.89,
            y: 0.9842638392855156,
        },
        {
            x: 77.46000000000001,
            y: 0.9838173542978462,
        },
        {
            x: 78.03,
            y: 0.9833757705691201,
        },
        {
            x: 78.60000000000001,
            y: 0.9829389990785522,
        },
        {
            x: 79.17,
            y: 0.9825069530526538,
        },
        {
            x: 79.74,
            y: 0.9820795478928135,
        },
        {
            x: 80.31,
            y: 0.9816567011057101,
        },
        {
            x: 80.88,
            y: 0.9812383322364276,
        },
        {
            x: 81.45,
            y: 0.980824362804149,
        },
        {
            x: 82.02,
            y: 0.9804147162403121,
        },
        {
            x: 82.59,
            y: 0.9800093178291179,
        },
        {
            x: 83.16,
            y: 0.9796080946502848,
        },
        {
            x: 83.73,
            y: 0.9792109755239494,
        },
        {
            x: 84.3,
            y: 0.9788178909576213,
        },
        {
            x: 84.87,
            y: 0.9784287730950995,
        },
        {
            x: 85.44,
            y: 0.9780435556672662,
        },
        {
            x: 86.01,
            y: 0.9776621739446788,
        },
        {
            x: 86.58,
            y: 0.9772845646918787,
        },
        {
            x: 87.15,
            y: 0.976910666123349,
        },
        {
            x: 87.72,
            y: 0.9765404178610472,
        },
        {
            x: 88.29,
            y: 0.9761737608934486,
        },
        {
            x: 88.86,
            y: 0.975810637536038,
        },
        {
            x: 89.43,
            y: 0.9754509913931865,
        },
        {
            x: 90,
            y: 0.9750947673213608,
        },
        {
            x: 90.57000000000001,
            y: 0.9747419113936062,
        },
        {
            x: 91.14,
            y: 0.9743923708652541,
        },
        {
            x: 91.71000000000001,
            y: 0.9740460941408032,
        },
        {
            x: 92.28,
            y: 0.9737030307419281,
        },
        {
            x: 92.85000000000001,
            y: 0.9733631312765689,
        },
        {
            x: 93.42,
            y: 0.9730263474090606,
        },
        {
            x: 93.99,
            y: 0.9726926318312594,
        },
        {
            x: 94.56,
            y: 0.9723619382346289,
        },
        {
            x: 95.13,
            y: 0.9720342212832465,
        },
        {
            x: 95.7,
            y: 0.9717094365876957,
        },
        {
            x: 96.27,
            y: 0.9713875406798103,
        },
        {
            x: 96.84,
            y: 0.9710684909882371,
        },
        {
            x: 97.41,
            y: 0.9707522458147858,
        },
        {
            x: 97.98,
            y: 0.9704387643115379,
        },
        {
            x: 98.55,
            y: 0.9701280064586831,
        },
        {
            x: 99.12,
            y: 0.9698199330430599,
        },
        {
            x: 99.69,
            y: 0.96951450563737,
        },
        {
            x: 100.26,
            y: 0.9692116865800444,
        },
        {
            x: 100.83,
            y: 0.9689114389557373,
        },
        {
            x: 101.4,
            y: 0.9686137265764219,
        },
        {
            x: 101.97,
            y: 0.9683185139630701,
        },
        {
            x: 102.54,
            y: 0.9680257663278921,
        },
        {
            x: 103.11,
            y: 0.9677354495571169,
        },
        {
            x: 103.68,
            y: 0.9674475301942945,
        },
        {
            x: 104.25,
            y: 0.9671619754241008,
        },
        {
            x: 104.82000000000001,
            y: 0.9668787530566271,
        },
        {
            x: 105.39,
            y: 0.9665978315121379,
        },
        {
            x: 105.96000000000001,
            y: 0.9663191798062809,
        },
        {
            x: 106.53,
            y: 0.9660427675357315,
        },
        {
            x: 107.10000000000001,
            y: 0.9657685648642593,
        },
        {
            x: 107.67,
            y: 0.9654965425092001,
        },
        {
            x: 108.24000000000001,
            y: 0.9652266717283206,
        },
        {
            x: 108.81,
            y: 0.9649589243070615,
        },
        {
            x: 109.38,
            y: 0.9646932725461483,
        },
        {
            x: 109.95,
            y: 0.9644296892495531,
        },
        {
            x: 110.52,
            y: 0.9641681477128008,
        },
        {
            x: 111.09,
            y: 0.9639086217116047,
        },
        {
            x: 111.66,
            y: 0.9636510854908218,
        },
        {
            x: 112.23,
            y: 0.9633955137537165,
        },
        {
            x: 112.8,
            y: 0.9631418816515234,
        },
        {
            x: 113.37,
            y: 0.9628901647732999,
        },
        {
            x: 113.94,
            y: 0.9626403391360568,
        },
        {
            x: 114.51,
            y: 0.9623923811751607,
        },
        {
            x: 115.08,
            y: 0.9621462677349972,
        },
        {
            x: 115.65,
            y: 0.9619019760598889,
        },
        {
            x: 116.22,
            y: 0.9616594837852571,
        },
        {
            x: 116.79,
            y: 0.9614187689290217,
        },
        {
            x: 117.36,
            y: 0.9611798098832318,
        },
        {
            x: 117.93,
            y: 0.9609425854059177,
        },
        {
            x: 118.5,
            y: 0.9607070746131603,
        },
        {
            x: 119.07000000000001,
            y: 0.9604732569713678,
        },
        {
            x: 119.64,
            y: 0.9602411122897564,
        },
        {
            x: 120.21000000000001,
            y: 0.960010620713027,
        },
        {
            x: 120.78,
            y: 0.9597817627142317,
        },
        {
            x: 121.35000000000001,
            y: 0.9595545190878252,
        },
        {
            x: 121.92,
            y: 0.9593288709428958,
        },
        {
            x: 122.49000000000001,
            y: 0.9591047996965677,
        },
        {
            x: 123.06,
            y: 0.9588822870675746,
        },
        {
            x: 123.63000000000001,
            y: 0.9586613150699934,
        },
        {
            x: 124.2,
            y: 0.9584418660071389,
        },
        {
            x: 124.77,
            y: 0.9582239224656097,
        },
        {
            x: 125.34,
            y: 0.9580074673094856,
        },
        {
            x: 125.91,
            y: 0.9577924836746672,
        },
        {
            x: 126.48,
            y: 0.957578954963358,
        },
        {
            x: 127.05,
            y: 0.9573668648386816,
        },
        {
            x: 127.62,
            y: 0.957156197219432,
        },
        {
            x: 128.19,
            y: 0.9569469362749514,
        },
        {
            x: 128.76,
            y: 0.9567390664201345,
        },
        {
            x: 129.33,
            y: 0.9565325723105519,
        },
        {
            x: 129.9,
            y: 0.9563274388376937,
        },
        {
            x: 130.47,
            y: 0.9561236511243253,
        },
        {
            x: 131.04,
            y: 0.9559211945199562,
        },
        {
            x: 131.61,
            y: 0.9557200545964153,
        },
        {
            x: 132.18,
            y: 0.9555202171435329,
        },
        {
            x: 132.75,
            y: 0.9553216681649231,
        },
        {
            x: 133.32,
            y: 0.9551243938738672,
        },
        {
            x: 133.89000000000001,
            y: 0.9549283806892915,
        },
        {
            x: 134.46,
            y: 0.9547336152318417,
        },
        {
            x: 135.03,
            y: 0.9545400843200456,
        },
        {
            x: 135.6,
            y: 0.9543477749665665,
        },
        {
            x: 136.17000000000002,
            y: 0.9541566743745433,
        },
        {
            x: 136.74,
            y: 0.9539667699340123,
        },
        {
            x: 137.31,
            y: 0.9537780492184136,
        },
        {
            x: 137.88,
            y: 0.9535904999811746,
        },
        {
            x: 138.45000000000002,
            y: 0.9534041101523728,
        },
        {
            x: 139.02,
            y: 0.9532188678354727,
        },
        {
            x: 139.59,
            y: 0.9530347613041368,
        },
        {
            x: 140.16,
            y: 0.9528517789991073,
        },
        {
            x: 140.73,
            y: 0.9526699095251583,
        },
        {
            x: 141.3,
            y: 0.9524891416481144,
        },
        {
            x: 141.87,
            y: 0.9523094642919367,
        },
        {
            x: 142.44,
            y: 0.952130866535872,
        },
        {
            x: 143.01,
            y: 0.9519533376116648,
        },
        {
            x: 143.58,
            y: 0.9517768669008302,
        },
        {
            x: 144.15,
            y: 0.9516014439319862,
        },
        {
            x: 144.72,
            y: 0.9514270583782445,
        },
        {
            x: 145.29,
            y: 0.9512537000546559,
        },
        {
            x: 145.86,
            y: 0.9510813589157131,
        },
        {
            x: 146.43,
            y: 0.9509100250529048,
        },
        {
            x: 147,
            y: 0.9507396886923231,
        },
        {
            x: 147.57,
            y: 0.9505703401923219,
        },
        {
            x: 148.14000000000001,
            y: 0.9504019700412244,
        },
        {
            x: 148.71,
            y: 0.9502345688550793,
        },
        {
            x: 149.28,
            y: 0.9500681273754638,
        },
        {
            x: 149.85,
            y: 0.9499026364673332,
        },
        {
            x: 150.42000000000002,
            y: 0.9497380871169149,
        },
        {
            x: 150.99,
            y: 0.9495744704296462,
        },
        {
            x: 151.56,
            y: 0.9494117776281549,
        },
        {
            x: 152.13,
            y: 0.9492500000502816,
        },
        {
            x: 152.70000000000002,
            y: 0.9490891291471426,
        },
        {
            x: 153.27,
            y: 0.9489291564812325,
        },
        {
            x: 153.84,
            y: 0.9487700737245655,
        },
        {
            x: 154.41,
            y: 0.9486118726568535,
        },
        {
            x: 154.98,
            y: 0.948454545163724,
        },
        {
            x: 155.55,
            y: 0.9482980832349694,
        },
        {
            x: 156.12,
            y: 0.9481424789628365,
        },
        {
            x: 156.69,
            y: 0.9479877245403462,
        },
        {
            x: 157.26,
            y: 0.9478338122596486,
        },
        {
            x: 157.83,
            y: 0.9476807345104109,
        },
        {
            x: 158.4,
            y: 0.9475284837782368,
        },
        {
            x: 158.97,
            y: 0.9473770526431169,
        },
        {
            x: 159.54,
            y: 0.94722643377791,
        },
        {
            x: 160.11,
            y: 0.947076619946854,
        },
        {
            x: 160.68,
            y: 0.9469276040041057,
        },
        {
            x: 161.25,
            y: 0.9467793788923096,
        },
        {
            x: 161.82,
            y: 0.9466319376411936,
        },
        {
            x: 162.39000000000001,
            y: 0.9464852733661925,
        },
        {
            x: 162.96,
            y: 0.9463393792670978,
        },
        {
            x: 163.53,
            y: 0.9461942486267332,
        },
        {
            x: 164.1,
            y: 0.9460498748096561,
        },
        {
            x: 164.67000000000002,
            y: 0.9459062512608827,
        },
        {
            x: 165.24,
            y: 0.9457633715046383,
        },
        {
            x: 165.81,
            y: 0.9456212291431312,
        },
        {
            x: 166.38,
            y: 0.9454798178553486,
        },
        {
            x: 166.95000000000002,
            y: 0.9453391313958772,
        },
        {
            x: 167.52,
            y: 0.9451991635937435,
        },
        {
            x: 168.09,
            y: 0.9450599083512773,
        },
        {
            x: 168.66,
            y: 0.9449213596429964,
        },
        {
            x: 169.23,
            y: 0.944783511514511,
        },
        {
            x: 169.8,
            y: 0.9446463580814488,
        },
        {
            x: 170.37,
            y: 0.9445098935284006,
        },
        {
            x: 170.94,
            y: 0.9443741121078841,
        },
        {
            x: 171.51,
            y: 0.944239008139327,
        },
        {
            x: 172.08,
            y: 0.9441045760080694,
        },
        {
            x: 172.65,
            y: 0.9439708101643836,
        },
        {
            x: 173.22,
            y: 0.9438377051225112,
        },
        {
            x: 173.79,
            y: 0.9437052554597192,
        },
        {
            x: 174.36,
            y: 0.9435734558153711,
        },
        {
            x: 174.93,
            y: 0.9434423008900165,
        },
        {
            x: 175.5,
            y: 0.9433117854444953,
        },
        {
            x: 176.07,
            y: 0.9431819042990595,
        },
        {
            x: 176.64000000000001,
            y: 0.9430526523325087,
        },
        {
            x: 177.21,
            y: 0.9429240244813433,
        },
        {
            x: 177.78,
            y: 0.94279601573893,
        },
        {
            x: 178.35,
            y: 0.9426686211546846,
        },
        {
            x: 178.92000000000002,
            y: 0.9425418358332667,
        },
        {
            x: 179.49,
            y: 0.9424156549337902,
        },
        {
            x: 180.06,
            y: 0.9422900736690469,
        },
        {
            x: 180.63,
            y: 0.9421650873047437,
        },
        {
            x: 181.20000000000002,
            y: 0.9420406911587527,
        },
        {
            x: 181.77,
            y: 0.9419168806003748,
        },
        {
            x: 182.34,
            y: 0.9417936510496155,
        },
        {
            x: 182.91,
            y: 0.9416709979764735,
        },
        {
            x: 183.48,
            y: 0.9415489169002407,
        },
        {
            x: 184.05,
            y: 0.9414274033888157,
        },
        {
            x: 184.62,
            y: 0.9413064530580268,
        },
        {
            x: 185.19,
            y: 0.9411860615709688,
        },
        {
            x: 185.76,
            y: 0.9410662246373489,
        },
        {
            x: 186.33,
            y: 0.9409469380128448,
        },
        {
            x: 186.9,
            y: 0.9408281974984736,
        },
        {
            x: 187.47,
            y: 0.9407099989399706,
        },
        {
            x: 188.04,
            y: 0.9405923382271794,
        },
        {
            x: 188.61,
            y: 0.9404752112934509,
        },
        {
            x: 189.18,
            y: 0.9403586141150535,
        },
        {
            x: 189.75,
            y: 0.9402425427105923,
        },
        {
            x: 190.32,
            y: 0.9401269931404378,
        },
        {
            x: 190.89000000000001,
            y: 0.940011961506165,
        },
        {
            x: 191.46,
            y: 0.9398974439500003,
        },
        {
            x: 192.03,
            y: 0.9397834366542783,
        },
        {
            x: 192.6,
            y: 0.9396699358409076,
        },
        {
            x: 193.17000000000002,
            y: 0.9395569377708444,
        },
        {
            x: 193.74,
            y: 0.9394444387435752,
        },
        {
            x: 194.31,
            y: 0.9393324350966084,
        },
        {
            x: 194.88,
            y: 0.9392209232049727,
        },
        {
            x: 195.45000000000002,
            y: 0.9391098994807251,
        },
        {
            x: 196.02,
            y: 0.9389993603724652,
        },
        {
            x: 196.59,
            y: 0.9388893023648589,
        },
        {
            x: 197.16,
            y: 0.9387797219781681,
        },
        {
            x: 197.73000000000002,
            y: 0.938670615767789,
        },
        {
            x: 198.3,
            y: 0.9385619803237977,
        },
        {
            x: 198.87,
            y: 0.9384538122705015,
        },
        {
            x: 199.44,
            y: 0.9383461082659994,
        },
        {
            x: 200.01,
            y: 0.9382388650017479,
        },
        {
            x: 200.58,
            y: 0.9381320792021342,
        },
        {
            x: 201.15,
            y: 0.9380257476240561,
        },
        {
            x: 201.72,
            y: 0.9379198670565081,
        },
        {
            x: 202.29,
            y: 0.9378144343201744,
        },
        {
            x: 202.86,
            y: 0.9377094462670277,
        },
        {
            x: 203.43,
            y: 0.9376048997799346,
        },
        {
            x: 204,
            y: 0.9375007917722665,
        },
        {
            x: 204.57,
            y: 0.9373971191875177,
        },
        {
            x: 205.14000000000001,
            y: 0.9372938789989272,
        },
        {
            x: 205.71,
            y: 0.9371910682091089,
        },
        {
            x: 206.28,
            y: 0.937088683849685,
        },
        {
            x: 206.85,
            y: 0.936986722980927,
        },
        {
            x: 207.42000000000002,
            y: 0.9368851826914002,
        },
        {
            x: 207.99,
            y: 0.9367840600976152,
        },
        {
            x: 208.56,
            y: 0.9366833523436838,
        },
        {
            x: 209.13,
            y: 0.9365830566009802,
        },
        {
            x: 209.70000000000002,
            y: 0.9364831700678073,
        },
        {
            x: 210.27,
            y: 0.9363836899690681,
        },
        {
            x: 210.84,
            y: 0.9362846135559417,
        },
        {
            x: 211.41,
            y: 0.9361859381055643,
        },
        {
            x: 211.98000000000002,
            y: 0.936087660920715,
        },
        {
            x: 212.55,
            y: 0.9359897793295064,
        },
        {
            x: 213.12,
            y: 0.9358922906850788,
        },
        {
            x: 213.69,
            y: 0.9357951923653001,
        },
        {
            x: 214.26,
            y: 0.9356984817724695,
        },
        {
            x: 214.83,
            y: 0.9356021563330257,
        },
        {
            x: 215.4,
            y: 0.9355062134972588,
        },
        {
            x: 215.97,
            y: 0.9354106507390275,
        },
        {
            x: 216.54,
            y: 0.9353154655554791,
        },
        {
            x: 217.11,
            y: 0.9352206554667747,
        },
        {
            x: 217.68,
            y: 0.9351262180158174,
        },
        {
            x: 218.25,
            y: 0.9350321507679854,
        },
        {
            x: 218.82,
            y: 0.9349384513108677,
        },
        {
            x: 219.39000000000001,
            y: 0.9348451172540047,
        },
        {
            x: 219.96,
            y: 0.934752146228632,
        },
        {
            x: 220.53,
            y: 0.9346595358874279,
        },
        {
            x: 221.1,
            y: 0.9345672839042641,
        },
        {
            x: 221.67000000000002,
            y: 0.9344753879739611,
        },
        {
            x: 222.24,
            y: 0.9343838458120456,
        },
        {
            x: 222.81,
            y: 0.934292655154512,
        },
        {
            x: 223.38,
            y: 0.9342018137575876,
        },
        {
            x: 223.95000000000002,
            y: 0.9341113193975004,
        },
        {
            x: 224.52,
            y: 0.9340211698702506,
        },
        {
            x: 225.09,
            y: 0.9339313629913852,
        },
        {
            x: 225.66,
            y: 0.9338418965957757,
        },
        {
            x: 226.23000000000002,
            y: 0.9337527685373982,
        },
        {
            x: 226.8,
            y: 0.9336639766891185,
        },
        {
            x: 227.37,
            y: 0.9335755189424776,
        },
        {
            x: 227.94,
            y: 0.9334873932074821,
        },
        {
            x: 228.51,
            y: 0.9333995974123965,
        },
        {
            x: 229.08,
            y: 0.9333121295035393,
        },
        {
            x: 229.65,
            y: 0.93322498744508,
        },
        {
            x: 230.22,
            y: 0.9331381692188412,
        },
        {
            x: 230.79,
            y: 0.9330516728241016,
        },
        {
            x: 231.36,
            y: 0.9329654962774031,
        },
        {
            x: 231.93,
            y: 0.9328796376123588,
        },
        {
            x: 232.5,
            y: 0.9327940948794652,
        },
        {
            x: 233.07,
            y: 0.9327088661459162,
        },
        {
            x: 233.64000000000001,
            y: 0.9326239494954194,
        },
        {
            x: 234.21,
            y: 0.9325393430280156,
        },
        {
            x: 234.78,
            y: 0.9324550448598997,
        },
        {
            x: 235.35,
            y: 0.9323710531232451,
        },
        {
            x: 235.92000000000002,
            y: 0.9322873659660293,
        },
        {
            x: 236.49,
            y: 0.9322039815518628,
        },
        {
            x: 237.06,
            y: 0.9321208980598198,
        },
        {
            x: 237.63,
            y: 0.9320381136842708,
        },
        {
            x: 238.20000000000002,
            y: 0.9319556266347185,
        },
        {
            x: 238.77,
            y: 0.9318734351356345,
        },
        {
            x: 239.34,
            y: 0.9317915374262988,
        },
        {
            x: 239.91,
            y: 0.9317099317606421,
        },
        {
            x: 240.48000000000002,
            y: 0.9316286164070886,
        },
        {
            x: 241.05,
            y: 0.931547589648402,
        },
        {
            x: 241.62,
            y: 0.9314668497815333,
        },
        {
            x: 242.19,
            y: 0.9313863951174702,
        },
        {
            x: 242.76,
            y: 0.9313062239810892,
        },
        {
            x: 243.33,
            y: 0.9312263347110086,
        },
        {
            x: 243.9,
            y: 0.9311467256594438,
        },
        {
            x: 244.47,
            y: 0.9310673951920652,
        },
        {
            x: 245.04,
            y: 0.9309883416878567,
        },
        {
            x: 245.61,
            y: 0.9309095635389768,
        },
        {
            x: 246.18,
            y: 0.9308310591506213,
        },
        {
            x: 246.75,
            y: 0.9307528269408876,
        },
        {
            x: 247.32,
            y: 0.9306748653406407,
        },
        {
            x: 247.89000000000001,
            y: 0.9305971727933813,
        },
        {
            x: 248.46,
            y: 0.9305197477551151,
        },
        {
            x: 249.03,
            y: 0.9304425886942241,
        },
        {
            x: 249.6,
            y: 0.930365694091339,
        },
        {
            x: 250.17000000000002,
            y: 0.9302890624392138,
        },
        {
            x: 250.74,
            y: 0.9302126922426016,
        },
        {
            x: 251.31,
            y: 0.9301365820181323,
        },
        {
            x: 251.88,
            y: 0.9300607302941913,
        },
        {
            x: 252.45000000000002,
            y: 0.9299851356108,
        },
        {
            x: 253.02,
            y: 0.929909796519498,
        },
        {
            x: 253.59,
            y: 0.9298347115832265,
        },
        {
            x: 254.16,
            y: 0.9297598793762126,
        },
        {
            x: 254.73000000000002,
            y: 0.9296852984838567,
        },
        {
            x: 255.3,
            y: 0.9296109675026191,
        },
        {
            x: 255.87,
            y: 0.9295368850399096,
        },
        {
            x: 256.44,
            y: 0.9294630497139779,
        },
        {
            x: 257.01,
            y: 0.9293894601538052,
        },
        {
            x: 257.58,
            y: 0.9293161149989975,
        },
        {
            x: 258.15,
            y: 0.9292430128996795,
        },
        {
            x: 258.72,
            y: 0.929170152516391,
        },
        {
            x: 259.29,
            y: 0.9290975325199833,
        },
        {
            x: 259.86,
            y: 0.9290251515915171,
        },
        {
            x: 260.43,
            y: 0.9289530084221627,
        },
        {
            x: 261,
            y: 0.9288811017130999,
        },
        {
            x: 261.57,
            y: 0.9288094301754202,
        },
        {
            x: 262.14,
            y: 0.9287379925300294,
        },
        {
            x: 262.71,
            y: 0.9286667875075523,
        },
        {
            x: 263.28000000000003,
            y: 0.928595813848237,
        },
        {
            x: 263.85,
            y: 0.9285250703018624,
        },
        {
            x: 264.42,
            y: 0.9284545556276448,
        },
        {
            x: 264.99,
            y: 0.9283842685941472,
        },
        {
            x: 265.56,
            y: 0.9283142079791887,
        },
        {
            x: 266.13,
            y: 0.9282443725697548,
        },
        {
            x: 266.7,
            y: 0.9281747611619099,
        },
        {
            x: 267.27,
            y: 0.9281053725607097,
        },
        {
            x: 267.84000000000003,
            y: 0.9280362055801151,
        },
        {
            x: 268.41,
            y: 0.9279672590429073,
        },
        {
            x: 268.98,
            y: 0.9278985317806033,
        },
        {
            x: 269.55,
            y: 0.9278300226333731,
        },
        {
            x: 270.12,
            y: 0.927761730449957,
        },
        {
            x: 270.69,
            y: 0.9276936540875846,
        },
        {
            x: 271.26,
            y: 0.927625792411895,
        },
        {
            x: 271.83,
            y: 0.9275581442968562,
        },
        {
            x: 272.4,
            y: 0.927490708624688,
        },
        {
            x: 272.97,
            y: 0.9274234842857834,
        },
        {
            x: 273.54,
            y: 0.9273564701786321,
        },
        {
            x: 274.11,
            y: 0.9272896652097454,
        },
        {
            x: 274.68,
            y: 0.9272230682935805,
        },
        {
            x: 275.25,
            y: 0.9271566783524665,
        },
        {
            x: 275.82,
            y: 0.9270904943165315,
        },
        {
            x: 276.39,
            y: 0.9270245151236297,
        },
        {
            x: 276.96,
            y: 0.9269587397192706,
        },
        {
            x: 277.53000000000003,
            y: 0.9268931670565472,
        },
        {
            x: 278.1,
            y: 0.9268277960960669,
        },
        {
            x: 278.67,
            y: 0.9267626258058819,
        },
        {
            x: 279.24,
            y: 0.9266976551614203,
        },
        {
            x: 279.81,
            y: 0.9266328831454198,
        },
        {
            x: 280.38,
            y: 0.9265683087478592,
        },
        {
            x: 280.95,
            y: 0.9265039309658935,
        },
        {
            x: 281.52,
            y: 0.9264397488037877,
        },
        {
            x: 282.09000000000003,
            y: 0.9263757612728526,
        },
        {
            x: 282.66,
            y: 0.9263119673913806,
        },
        {
            x: 283.23,
            y: 0.9262483661845824,
        },
        {
            x: 283.8,
            y: 0.9261849566845246,
        },
        {
            x: 284.37,
            y: 0.9261217379300678,
        },
        {
            x: 284.94,
            y: 0.9260587089668053,
        },
        {
            x: 285.51,
            y: 0.9259958688470026,
        },
        {
            x: 286.08,
            y: 0.9259332166295375,
        },
        {
            x: 286.65000000000003,
            y: 0.9258707513798415,
        },
        {
            x: 287.22,
            y: 0.9258084721698402,
        },
        {
            x: 287.79,
            y: 0.9257463780778961,
        },
        {
            x: 288.36,
            y: 0.925684468188751,
        },
        {
            x: 288.93,
            y: 0.9256227415934701,
        },
        {
            x: 289.5,
            y: 0.9255611973893845,
        },
        {
            x: 290.07,
            y: 0.9254998346800372,
        },
        {
            x: 290.64,
            y: 0.9254386525751271,
        },
        {
            x: 291.21,
            y: 0.9253776501904561,
        },
        {
            x: 291.78000000000003,
            y: 0.9253168266478738,
        },
    ],
    benchmarkLine: [],
};

export const triOpDateData: TRIOpDateData = {
    amberThresholdValue: 3,
    redThresholdValue: 10,
    modelRate: 1.23456,
    points: [
        {
            x: 13,
            y: 5,
            trend: 1,
            color: 1,
            score: 100,
            siteId: -1311143400,
            yVolume: 5,
            siteName: '-1311143400',
        },
        {
            x: 16,
            y: 12,
            trend: 1,
            color: 1,
            score: 50,
            siteId: -468895377,
            yVolume: 12,
            siteName: '-468895377',
            isHighlighted: false,
        },
        {
            x: 16,
            y: 12,
            trend: 2,
            color: 1,
            score: 50,
            siteId: -701288535,
            yVolume: 12,
            siteName: '-701288535',
        },
        {
            x: 17,
            y: 13,
            trend: 3,
            color: 1,
            score: 50,
            siteId: -344091912,
            yVolume: 13,
            siteName: '-344091912',
            isHighlighted: false,
        },
        {
            x: 17,
            y: 14,
            trend: 4,
            color: 3,
            score: 1,
            siteId: -1189692091,
            yVolume: 14,
            siteName: '-1189692091',
            isHighlighted: false,
        },
        {
            x: 17,
            y: 10,
            trend: 2,
            color: 1,
            score: 100,
            siteId: -1908833431,
            yVolume: 10,
            siteName: '-1908833431',
        },
        {
            x: 20,
            y: 15,
            trend: 4,
            color: 1,
            score: 100,
            siteId: 1206193796,
            yVolume: 15,
            siteName: '1206193796',
        },
        {
            x: 20,
            y: 20,
            trend: 3,
            color: 1,
            score: 100,
            siteId: -122409000,
            yVolume: 20,
            siteName: '-122409000',
        },
        {
            x: 22,
            y: 20,
            trend: 2,
            color: 1,
            score: 50,
            siteId: -2018434025,
            yVolume: 20,
            siteName: '-2018434025',
        },
        {
            x: 22,
            y: 20,
            trend: 1,
            color: 2,
            score: 50,
            siteId: -1509199347,
            yVolume: 20,
            siteName: '-1509199347',
        },
        {
            x: 22,
            y: 19,
            trend: 1,
            color: 3,
            score: 13,
            siteId: -2032165223,
            yVolume: 19,
            siteName: '-2032165223',
        },
        {
            x: 23,
            y: 21,
            trend: 1,
            color: 3,
            score: 50,
            siteId: 1908831653,
            yVolume: 21,
            siteName: '1908831653',
        },
        {
            x: 24,
            y: 21,
            trend: 2,
            color: 3,
            score: 13,
            siteId: -1210414056,
            yVolume: 21,
            siteName: '-1210414056',
        },
        {
            x: 26,
            y: 21,
            trend: 3,
            color: 3,
            score: 1,
            siteId: -1881783311,
            yVolume: 21,
            siteName: '-1881783311',
        },
        {
            x: 26,
            y: 22,
            trend: 4,
            color: 3,
            score: 9,
            siteId: 286968783,
            yVolume: 22,
            siteName: '286968783',
        },
        {
            x: 26,
            y: 22,
            trend: 2,
            color: 3,
            score: 9,
            siteId: 871666759,
            yVolume: 22,
            siteName: '871666759',
        },
        {
            x: 28,
            y: 23,
            trend: 3,
            color: 3,
            score: 1,
            siteId: -243064209,
            yVolume: 23,
            siteName: '-243064209',
        },
        {
            x: 27,
            y: 27,
            trend: 3,
            color: 2,
            score: 100,
            siteId: -1208744759,
            yVolume: 27,
            siteName: '-1208744759',
        },
        {
            x: 28,
            y: 25,
            trend: 2,
            color: 2,
            score: 25,
            siteId: 800151098,
            yVolume: 25,
            siteName: '800151098',
            isHighlighted: false,
        },
        {
            x: 29,
            y: 15,
            trend: 1,
            color: 2,
            score: 100,
            siteId: 55004980,
            yVolume: 15,
            siteName: '55004980',
        },
        {
            x: 29,
            y: 27,
            trend: 1,
            color: 1,
            score: 102.234,
            siteId: -1677111757,
            yVolume: 27,
            siteName: '-1677111757',
        },
        {
            x: 5,
            y: 5.25,
            trend: 5,
            color: 5,
            siteId: -1677111757,
            yVolume: 27,
            siteName: '-1677111758',
        },
        {
            x: 10,
            y: 5,
            trend: 5,
            color: 5,
            siteId: -1677111757,
            yVolume: 27,
            siteName: '-1677111759',
            isHighlighted: false,
        },
        {
            x: 6,
            y: 5.5,
            trend: 1,
            color: 5,
            siteId: 1,
            yVolume: 27,
            siteName: '1',
        },
        {
            x: 7,
            y: 5.5,
            trend: 1,
            color: 5,
            siteId: 2,
            yVolume: 27,
            siteName: '2',
            isHighlighted: false,
        },
        {
            x: 6,
            y: 8.5,
            trend: 2,
            color: 5,
            siteId: 3,
            yVolume: 27,
            siteName: '3',
        },
        {
            x: 7,
            y: 8.5,
            trend: 2,
            color: 5,
            siteId: 4,
            yVolume: 27,
            siteName: '4',
            isHighlighted: false,
        },
        {
            x: 6,
            y: 11.5,
            trend: 3,
            color: 5,
            siteId: 5,
            yVolume: 27,
            siteName: '5',
        },
        {
            x: 7,
            y: 11.5,
            trend: 3,
            color: 5,
            siteId: 6,
            yVolume: 27,
            siteName: '6',
            isHighlighted: false,
        },
        {
            x: 6,
            y: 13.5,
            trend: 4,
            color: 5,
            siteId: 7,
            yVolume: 27,
            siteName: '7',
        },
        {
            x: 7,
            y: 13.5,
            trend: 4,
            color: 5,
            siteId: 8,
            yVolume: 27,
            siteName: '8',
            isHighlighted: false,
        },
        {
            x: 6,
            y: 15.5,
            trend: 5,
            color: 5,
            siteId: 8,
            yVolume: 27,
            siteName: '8',
        },
        {
            x: 7,
            y: 15.5,
            trend: 5,
            color: 5,
            siteId: 9,
            yVolume: 27,
            siteName: '9',
            isHighlighted: false,
        },
    ],
};

export const eventRatesDataStudy: EventRatesData = {
    studyBenchmark: 2000,
    studyPoints: [
        {
            binLabelDate: '2018-11-30T00:00:00Z',
            numeratorEvents: 13,
            denominatorValue: 0.04106776180698152,
            yValue: 3853.99625,
            minDataFlag: true,
            ragStatus: 0,
            outOfTolerance: false,
            outOfToleranceValue: undefined,
            amberUpperValue: 3000,
            redUpperValue: 3500,
            amberLowerValue: 1000,
            redLowerValue: 500,
            uniqueSubjectsInBin: 1,
            colorDirectionThreshold: 0,
        },
        {
            binLabelDate: '2018-12-31T00:00:00Z',
            numeratorEvents: 45,
            denominatorValue: 0.13689253935660506,
            yValue: 3078.636057692308,
            minDataFlag: false,
            ragStatus: 0,
            outOfTolerance: false,
            outOfToleranceValue: undefined,
            amberUpperValue: 3000,
            redUpperValue: 3500,
            amberLowerValue: 1000,
            redLowerValue: 500,
            uniqueSubjectsInBin: 4,
            colorDirectionThreshold: 1,
        },
        {
            binLabelDate: '2019-01-31T00:00:00Z',
            numeratorEvents: 136,
            denominatorValue: 0.5366187542778919,
            yValue: 2317.168390804598,
            minDataFlag: false,
            ragStatus: 0,
            outOfTolerance: false,
            outOfToleranceValue: undefined,
            amberUpperValue: 3000,
            redUpperValue: 3500,
            amberLowerValue: 1000,
            redLowerValue: 500,
            uniqueSubjectsInBin: 14,
            colorDirectionThreshold: 5,
        },
        {
            binLabelDate: '2019-02-28T00:00:00Z',
            numeratorEvents: 224,
            denominatorValue: 0.758384668035592,
            yValue: 1851.505204460967,
            minDataFlag: true,
            ragStatus: 0,
            outOfTolerance: false,
            outOfToleranceValue: undefined,
            amberUpperValue: 3000,
            redUpperValue: 3500,
            amberLowerValue: 1000,
            redLowerValue: 500,
            uniqueSubjectsInBin: 25,
            colorDirectionThreshold: 5,
        },
        {
            binLabelDate: '2019-03-31T00:00:00Z',
            numeratorEvents: 283,
            denominatorValue: 0.7720739219712526,
            yValue: 1534.7292759146344,
            minDataFlag: false,
            ragStatus: 0,
            outOfTolerance: false,
            outOfToleranceValue: undefined,
            amberUpperValue: 3000,
            redUpperValue: 3500,
            amberLowerValue: 1000,
            redLowerValue: 500,
            uniqueSubjectsInBin: 37,
            colorDirectionThreshold: 5,
        },
        {
            binLabelDate: '2019-04-30T00:00:00Z',
            numeratorEvents: 346,
            denominatorValue: 0.5776865160848734,
            yValue: 1492.370404946654,
            minDataFlag: false,
            ragStatus: 0,
            outOfTolerance: false,
            outOfToleranceValue: undefined,
            amberUpperValue: 3000,
            redUpperValue: 3500,
            amberLowerValue: 1000,
            redLowerValue: 500,
            uniqueSubjectsInBin: 49,
            colorDirectionThreshold: 5,
        },
        {
            binLabelDate: '2019-05-31T00:00:00Z',
            numeratorEvents: 428,
            denominatorValue: 0.9664613278576317,
            yValue: 1375.2031972543352,
            minDataFlag: false,
            ragStatus: 0,
            outOfTolerance: false,
            outOfToleranceValue: undefined,
            amberUpperValue: 3000,
            redUpperValue: 3500,
            amberLowerValue: 1000,
            redLowerValue: 500,
            uniqueSubjectsInBin: 64,
            colorDirectionThreshold: 5,
        },
        {
            binLabelDate: '2019-06-30T00:00:00Z',
            numeratorEvents: 511,
            denominatorValue: 1.1854893908281998,
            yValue: 1250.6194173087508,
            minDataFlag: false,
            ragStatus: 0,
            outOfTolerance: false,
            outOfToleranceValue: undefined,
            amberUpperValue: 3000,
            redUpperValue: 3500,
            amberLowerValue: 1000,
            redLowerValue: 500,
            uniqueSubjectsInBin: 83,
            colorDirectionThreshold: 5,
        },
        {
            binLabelDate: '2019-07-31T00:00:00Z',
            numeratorEvents: 704,
            denominatorValue: 1.702943189596167,
            yValue: 1283.5714637146373,
            minDataFlag: false,
            ragStatus: 0,
            outOfTolerance: false,
            outOfToleranceValue: undefined,
            amberUpperValue: 3000,
            redUpperValue: 3500,
            amberLowerValue: 1000,
            redLowerValue: 500,
            uniqueSubjectsInBin: 112,
            colorDirectionThreshold: 5,
        },
        {
            binLabelDate: '2019-08-31T00:00:00Z',
            numeratorEvents: 903,
            denominatorValue: 2.3134839151266258,
            yValue: 1222.767244595006,
            minDataFlag: true,
            ragStatus: 0,
            outOfTolerance: false,
            outOfToleranceValue: undefined,
            amberUpperValue: 3000,
            redUpperValue: 3500,
            amberLowerValue: 1000,
            redLowerValue: 500,
            uniqueSubjectsInBin: 147,
            colorDirectionThreshold: 4,
        },
        {
            binLabelDate: '2019-09-30T00:00:00Z',
            numeratorEvents: 1061,
            denominatorValue: 2.5023956194387407,
            yValue: 1123.9115754525965,
            minDataFlag: false,
            ragStatus: 0,
            outOfTolerance: false,
            outOfToleranceValue: undefined,
            amberUpperValue: 3000,
            redUpperValue: 3500,
            amberLowerValue: 1000,
            redLowerValue: 500,
            uniqueSubjectsInBin: 183,
            colorDirectionThreshold: 4,
        },
        {
            binLabelDate: '2019-10-31T00:00:00Z',
            numeratorEvents: 1160,
            denominatorValue: 2.193018480492813,
            yValue: 1031.8915283056613,
            minDataFlag: false,
            ragStatus: 0,
            outOfTolerance: false,
            outOfToleranceValue: undefined,
            amberUpperValue: 3000,
            redUpperValue: 3500,
            amberLowerValue: 1000,
            redLowerValue: 500,
            uniqueSubjectsInBin: 215,
            colorDirectionThreshold: 5,
        },
        {
            binLabelDate: '2019-11-30T00:00:00Z',
            numeratorEvents: 1342,
            denominatorValue: 2.4969199178644765,
            yValue: 1009.603275672475,
            minDataFlag: false,
            ragStatus: 0,
            outOfTolerance: false,
            outOfToleranceValue: undefined,
            amberUpperValue: 3000,
            redUpperValue: 3500,
            amberLowerValue: 1000,
            redLowerValue: 500,
            uniqueSubjectsInBin: 253,
            colorDirectionThreshold: 4,
        },
        {
            binLabelDate: '2019-12-31T00:00:00Z',
            numeratorEvents: 1501,
            denominatorValue: 2.674880219028063,
            yValue: 969.0512548998256,
            minDataFlag: false,
            ragStatus: 0,
            outOfTolerance: false,
            outOfToleranceValue: undefined,
            amberUpperValue: 3000,
            redUpperValue: 3500,
            amberLowerValue: 1000,
            redLowerValue: 500,
            uniqueSubjectsInBin: 292,
            colorDirectionThreshold: 2,
        },
        {
            binLabelDate: '2020-01-31T00:00:00Z',
            numeratorEvents: 1661,
            denominatorValue: 2.8062970568104038,
            yValue: 933.4426947744217,
            minDataFlag: true,
            ragStatus: 0,
            outOfTolerance: false,
            outOfToleranceValue: undefined,
            amberUpperValue: 3000,
            redUpperValue: 3500,
            amberLowerValue: 1000,
            redLowerValue: 500,
            uniqueSubjectsInBin: 332,
            colorDirectionThreshold: 2,
        },
        {
            binLabelDate: '2020-02-29T00:00:00Z',
            numeratorEvents: 1774,
            denominatorValue: 2.8993839835728954,
            yValue: 879.2726106219347,
            minDataFlag: true,
            ragStatus: 0,
            outOfTolerance: false,
            outOfToleranceValue: undefined,
            amberUpperValue: 3000,
            redUpperValue: 3500,
            amberLowerValue: 1000,
            redLowerValue: 500,
            uniqueSubjectsInBin: 377,
            colorDirectionThreshold: 2,
        },
        {
            binLabelDate: '2020-03-31T00:00:00Z',
            numeratorEvents: 1933,
            denominatorValue: 3.6440793976728267,
            yValue: 834.3098072163447,
            minDataFlag: true,
            ragStatus: 0,
            outOfTolerance: false,
            outOfToleranceValue: undefined,
            amberUpperValue: 3000,
            redUpperValue: 3500,
            amberLowerValue: 1000,
            redLowerValue: 500,
            uniqueSubjectsInBin: 426,
            colorDirectionThreshold: 2,
        },
        {
            binLabelDate: '2020-04-31T00:00:00Z',
            numeratorEvents: 1933,
            denominatorValue: 3.6440793976728267,
            yValue: 834.3098072163447,
            minDataFlag: true,
            ragStatus: 0,
            outOfTolerance: false,
            outOfToleranceValue: undefined,
            amberUpperValue: 3000,
            redUpperValue: 3500,
            amberLowerValue: 1000,
            redLowerValue: 500,
            uniqueSubjectsInBin: 426,
            colorDirectionThreshold: 2,
        },
        {
            binLabelDate: '2020-05-31T00:00:00Z',
            numeratorEvents: 1933,
            denominatorValue: 3.6440793976728267,
            yValue: 834.3098072163447,
            minDataFlag: true,
            ragStatus: 0,
            outOfTolerance: false,
            outOfToleranceValue: undefined,
            amberUpperValue: 3000,
            redUpperValue: 3500,
            amberLowerValue: 1000,
            redLowerValue: 500,
            uniqueSubjectsInBin: 426,
            colorDirectionThreshold: 2,
        },
        {
            binLabelDate: '2020-06-31T00:00:00Z',
            numeratorEvents: 1933,
            denominatorValue: 3.6440793976728267,
            yValue: 834.3098072163447,
            minDataFlag: true,
            ragStatus: 0,
            outOfTolerance: false,
            outOfToleranceValue: undefined,
            amberUpperValue: 3000,
            redUpperValue: 3500,
            amberLowerValue: 1000,
            redLowerValue: 500,
            uniqueSubjectsInBin: 426,
            colorDirectionThreshold: 2,
        },
        {
            binLabelDate: '2020-07-31T00:00:00Z',
            numeratorEvents: 1933,
            denominatorValue: 3.6440793976728267,
            yValue: 834.3098072163447,
            minDataFlag: true,
            ragStatus: 0,
            outOfTolerance: false,
            outOfToleranceValue: undefined,
            amberUpperValue: 3000,
            redUpperValue: 3500,
            amberLowerValue: 1000,
            redLowerValue: 500,
            uniqueSubjectsInBin: 426,
            colorDirectionThreshold: 2,
        },
        {
            binLabelDate: '2020-08-31T00:00:00Z',
            numeratorEvents: 1933,
            denominatorValue: 3.6440793976728267,
            yValue: 834.3098072163447,
            minDataFlag: true,
            ragStatus: 0,
            outOfTolerance: false,
            outOfToleranceValue: undefined,
            amberUpperValue: 3000,
            redUpperValue: 3500,
            amberLowerValue: 1000,
            redLowerValue: 500,
            uniqueSubjectsInBin: 426,
            colorDirectionThreshold: 2,
        },
        {
            binLabelDate: '2020-09-31T00:00:00Z',
            numeratorEvents: 1933,
            denominatorValue: 3.6440793976728267,
            yValue: 834.3098072163447,
            minDataFlag: true,
            ragStatus: 0,
            outOfTolerance: false,
            outOfToleranceValue: undefined,
            amberUpperValue: 3000,
            redUpperValue: 3500,
            amberLowerValue: 1000,
            redLowerValue: 500,
            uniqueSubjectsInBin: 426,
            colorDirectionThreshold: 2,
        },
        {
            binLabelDate: '2020-10-31T00:00:00Z',
            numeratorEvents: 1933,
            denominatorValue: 3.6440793976728267,
            yValue: 834.3098072163447,
            minDataFlag: true,
            ragStatus: 0,
            outOfTolerance: false,
            outOfToleranceValue: undefined,
            amberUpperValue: 3000,
            redUpperValue: 3500,
            amberLowerValue: 1000,
            redLowerValue: 500,
            uniqueSubjectsInBin: 426,
            colorDirectionThreshold: 2,
        },
        // SET 2
        {
            binLabelDate: '2020-11-30T00:00:00Z',
            numeratorEvents: 13,
            denominatorValue: 0.04106776180698152,
            yValue: 3853.99625,
            minDataFlag: true,
            ragStatus: 0,
            outOfTolerance: false,
            outOfToleranceValue: undefined,
            amberUpperValue: 3000,
            redUpperValue: 3500,
            amberLowerValue: 1000,
            redLowerValue: 500,
            uniqueSubjectsInBin: 1,
            colorDirectionThreshold: 0,
        },
        {
            binLabelDate: '2020-12-31T00:00:00Z',
            numeratorEvents: 45,
            denominatorValue: 0.13689253935660506,
            yValue: 3078.636057692308,
            minDataFlag: false,
            ragStatus: 0,
            outOfTolerance: false,
            outOfToleranceValue: undefined,
            amberUpperValue: 3000,
            redUpperValue: 3500,
            amberLowerValue: 1000,
            redLowerValue: 500,
            uniqueSubjectsInBin: 4,
            colorDirectionThreshold: 1,
        },
        {
            binLabelDate: '2021-01-31T00:00:00Z',
            numeratorEvents: 136,
            denominatorValue: 0.5366187542778919,
            yValue: 2317.168390804598,
            minDataFlag: false,
            ragStatus: 0,
            outOfTolerance: false,
            outOfToleranceValue: undefined,
            amberUpperValue: 3000,
            redUpperValue: 3500,
            amberLowerValue: 1000,
            redLowerValue: 500,
            uniqueSubjectsInBin: 14,
            colorDirectionThreshold: 5,
        },
        {
            binLabelDate: '2021-02-28T00:00:00Z',
            numeratorEvents: 224,
            denominatorValue: 0.758384668035592,
            yValue: 1851.505204460967,
            minDataFlag: true,
            ragStatus: 0,
            outOfTolerance: false,
            outOfToleranceValue: undefined,
            amberUpperValue: 3000,
            redUpperValue: 3500,
            amberLowerValue: 1000,
            redLowerValue: 500,
            uniqueSubjectsInBin: 25,
            colorDirectionThreshold: 5,
        },
        {
            binLabelDate: '2021-03-31T00:00:00Z',
            numeratorEvents: 283,
            denominatorValue: 0.7720739219712526,
            yValue: 1534.7292759146344,
            minDataFlag: false,
            ragStatus: 0,
            outOfTolerance: false,
            outOfToleranceValue: undefined,
            amberUpperValue: 3000,
            redUpperValue: 3500,
            amberLowerValue: 1000,
            redLowerValue: 500,
            uniqueSubjectsInBin: 37,
            colorDirectionThreshold: 5,
        },
        {
            binLabelDate: '2021-04-30T00:00:00Z',
            numeratorEvents: 346,
            denominatorValue: 0.5776865160848734,
            yValue: 1492.370404946654,
            minDataFlag: false,
            ragStatus: 0,
            outOfTolerance: false,
            outOfToleranceValue: undefined,
            amberUpperValue: 3000,
            redUpperValue: 3500,
            amberLowerValue: 1000,
            redLowerValue: 500,
            uniqueSubjectsInBin: 49,
            colorDirectionThreshold: 5,
        },
        {
            binLabelDate: '2021-05-31T00:00:00Z',
            numeratorEvents: 428,
            denominatorValue: 0.9664613278576317,
            yValue: 1375.2031972543352,
            minDataFlag: false,
            ragStatus: 0,
            outOfTolerance: false,
            outOfToleranceValue: undefined,
            amberUpperValue: 3000,
            redUpperValue: 3500,
            amberLowerValue: 1000,
            redLowerValue: 500,
            uniqueSubjectsInBin: 64,
            colorDirectionThreshold: 5,
        },
        {
            binLabelDate: '2021-06-30T00:00:00Z',
            numeratorEvents: 511,
            denominatorValue: 1.1854893908281998,
            yValue: 1250.6194173087508,
            minDataFlag: false,
            ragStatus: 0,
            outOfTolerance: false,
            outOfToleranceValue: undefined,
            amberUpperValue: 3000,
            redUpperValue: 3500,
            amberLowerValue: 1000,
            redLowerValue: 500,
            uniqueSubjectsInBin: 83,
            colorDirectionThreshold: 5,
        },
        {
            binLabelDate: '2021-07-31T00:00:00Z',
            numeratorEvents: 704,
            denominatorValue: 1.702943189596167,
            yValue: 1283.5714637146373,
            minDataFlag: false,
            ragStatus: 0,
            outOfTolerance: false,
            outOfToleranceValue: undefined,
            amberUpperValue: 3000,
            redUpperValue: 3500,
            amberLowerValue: 1000,
            redLowerValue: 500,
            uniqueSubjectsInBin: 112,
            colorDirectionThreshold: 5,
        },
        {
            binLabelDate: '2021-08-31T00:00:00Z',
            numeratorEvents: 903,
            denominatorValue: 2.3134839151266258,
            yValue: 1222.767244595006,
            minDataFlag: true,
            ragStatus: 0,
            outOfTolerance: false,
            outOfToleranceValue: undefined,
            amberUpperValue: 3000,
            redUpperValue: 3500,
            amberLowerValue: 1000,
            redLowerValue: 500,
            uniqueSubjectsInBin: 147,
            colorDirectionThreshold: 4,
        },
        {
            binLabelDate: '2021-09-30T00:00:00Z',
            numeratorEvents: 1061,
            denominatorValue: 2.5023956194387407,
            yValue: 1123.9115754525965,
            minDataFlag: false,
            ragStatus: 0,
            outOfTolerance: false,
            outOfToleranceValue: undefined,
            amberUpperValue: 3000,
            redUpperValue: 3500,
            amberLowerValue: 1000,
            redLowerValue: 500,
            uniqueSubjectsInBin: 183,
            colorDirectionThreshold: 4,
        },
        {
            binLabelDate: '2021-10-31T00:00:00Z',
            numeratorEvents: 1160,
            denominatorValue: 2.193018480492813,
            yValue: 1031.8915283056613,
            minDataFlag: false,
            ragStatus: 0,
            outOfTolerance: false,
            outOfToleranceValue: undefined,
            amberUpperValue: 3000,
            redUpperValue: 3500,
            amberLowerValue: 1000,
            redLowerValue: 500,
            uniqueSubjectsInBin: 215,
            colorDirectionThreshold: 5,
        },
        {
            binLabelDate: '2021-11-30T00:00:00Z',
            numeratorEvents: 1342,
            denominatorValue: 2.4969199178644765,
            yValue: 1009.603275672475,
            minDataFlag: false,
            ragStatus: 0,
            outOfTolerance: false,
            outOfToleranceValue: undefined,
            amberUpperValue: 3000,
            redUpperValue: 3500,
            amberLowerValue: 1000,
            redLowerValue: 500,
            uniqueSubjectsInBin: 253,
            colorDirectionThreshold: 4,
        },
        {
            binLabelDate: '2021-12-31T00:00:00Z',
            numeratorEvents: 1501,
            denominatorValue: 2.674880219028063,
            yValue: 969.0512548998256,
            minDataFlag: false,
            ragStatus: 0,
            outOfTolerance: false,
            outOfToleranceValue: undefined,
            amberUpperValue: 3000,
            redUpperValue: 3500,
            amberLowerValue: 1000,
            redLowerValue: 500,
            uniqueSubjectsInBin: 292,
            colorDirectionThreshold: 2,
        },
        {
            binLabelDate: '2022-01-31T00:00:00Z',
            numeratorEvents: 1661,
            denominatorValue: 2.8062970568104038,
            yValue: 933.4426947744217,
            minDataFlag: true,
            ragStatus: 0,
            outOfTolerance: false,
            outOfToleranceValue: undefined,
            amberUpperValue: 3000,
            redUpperValue: 3500,
            amberLowerValue: 1000,
            redLowerValue: 500,
            uniqueSubjectsInBin: 332,
            colorDirectionThreshold: 2,
        },
        {
            binLabelDate: '2022-02-29T00:00:00Z',
            numeratorEvents: 1774,
            denominatorValue: 2.8993839835728954,
            yValue: 879.2726106219347,
            minDataFlag: true,
            ragStatus: 0,
            outOfTolerance: false,
            outOfToleranceValue: undefined,
            amberUpperValue: 3000,
            redUpperValue: 3500,
            amberLowerValue: 1000,
            redLowerValue: 500,
            uniqueSubjectsInBin: 377,
            colorDirectionThreshold: 2,
        },
        {
            binLabelDate: '2022-03-31T00:00:00Z',
            numeratorEvents: 1933,
            denominatorValue: 3.6440793976728267,
            yValue: 834.3098072163447,
            minDataFlag: true,
            ragStatus: 0,
            outOfTolerance: false,
            outOfToleranceValue: undefined,
            amberUpperValue: 3000,
            redUpperValue: 3500,
            amberLowerValue: 1000,
            redLowerValue: 500,
            uniqueSubjectsInBin: 426,
            colorDirectionThreshold: 2,
        },
        {
            binLabelDate: '2022-04-31T00:00:00Z',
            numeratorEvents: 1933,
            denominatorValue: 3.6440793976728267,
            yValue: 834.3098072163447,
            minDataFlag: true,
            ragStatus: 0,
            outOfTolerance: false,
            outOfToleranceValue: undefined,
            amberUpperValue: 3000,
            redUpperValue: 3500,
            amberLowerValue: 1000,
            redLowerValue: 500,
            uniqueSubjectsInBin: 426,
            colorDirectionThreshold: 2,
        },
        {
            binLabelDate: '2022-05-31T00:00:00Z',
            numeratorEvents: 1933,
            denominatorValue: 3.6440793976728267,
            yValue: 834.3098072163447,
            minDataFlag: true,
            ragStatus: 0,
            outOfTolerance: false,
            outOfToleranceValue: undefined,
            amberUpperValue: 3000,
            redUpperValue: 3500,
            amberLowerValue: 1000,
            redLowerValue: 500,
            uniqueSubjectsInBin: 426,
            colorDirectionThreshold: 2,
        },
        {
            binLabelDate: '2022-06-31T00:00:00Z',
            numeratorEvents: 1933,
            denominatorValue: 3.6440793976728267,
            yValue: 834.3098072163447,
            minDataFlag: true,
            ragStatus: 0,
            outOfTolerance: false,
            outOfToleranceValue: undefined,
            amberUpperValue: 3000,
            redUpperValue: 3500,
            amberLowerValue: 1000,
            redLowerValue: 500,
            uniqueSubjectsInBin: 426,
            colorDirectionThreshold: 2,
        },
        {
            binLabelDate: '2022-07-31T00:00:00Z',
            numeratorEvents: 1933,
            denominatorValue: 3.6440793976728267,
            yValue: 834.3098072163447,
            minDataFlag: true,
            ragStatus: 0,
            outOfTolerance: false,
            outOfToleranceValue: undefined,
            amberUpperValue: 3000,
            redUpperValue: 3500,
            amberLowerValue: 1000,
            redLowerValue: 500,
            uniqueSubjectsInBin: 426,
            colorDirectionThreshold: 2,
        },
        {
            binLabelDate: '2022-08-31T00:00:00Z',
            numeratorEvents: 1933,
            denominatorValue: 3.6440793976728267,
            yValue: 834.3098072163447,
            minDataFlag: true,
            ragStatus: 0,
            outOfTolerance: false,
            outOfToleranceValue: undefined,
            amberUpperValue: 3000,
            redUpperValue: 3500,
            amberLowerValue: 1000,
            redLowerValue: 500,
            uniqueSubjectsInBin: 426,
            colorDirectionThreshold: 2,
        },
        {
            binLabelDate: '2022-09-31T00:00:00Z',
            numeratorEvents: 1933,
            denominatorValue: 3.6440793976728267,
            yValue: 834.3098072163447,
            minDataFlag: true,
            ragStatus: 0,
            outOfTolerance: false,
            outOfToleranceValue: undefined,
            amberUpperValue: 3000,
            redUpperValue: 3500,
            amberLowerValue: 1000,
            redLowerValue: 500,
            uniqueSubjectsInBin: 426,
            colorDirectionThreshold: 2,
        },
        {
            binLabelDate: '2022-10-31T00:00:00Z',
            numeratorEvents: 1933,
            denominatorValue: 3.6440793976728267,
            yValue: 834.3098072163447,
            minDataFlag: true,
            ragStatus: 0,
            outOfTolerance: false,
            outOfToleranceValue: undefined,
            amberUpperValue: 3000,
            redUpperValue: 3500,
            amberLowerValue: 1000,
            redLowerValue: 500,
            uniqueSubjectsInBin: 426,
            colorDirectionThreshold: 2,
        },
        // SET 3
        {
            binLabelDate: '2022-11-30T00:00:00Z',
            numeratorEvents: 13,
            denominatorValue: 0.04106776180698152,
            yValue: 3853.99625,
            minDataFlag: true,
            ragStatus: 0,
            outOfTolerance: false,
            outOfToleranceValue: undefined,
            amberUpperValue: 3000,
            redUpperValue: 3500,
            amberLowerValue: 1000,
            redLowerValue: 500,
            uniqueSubjectsInBin: 1,
            colorDirectionThreshold: 0,
        },
        {
            binLabelDate: '2022-12-31T00:00:00Z',
            numeratorEvents: 45,
            denominatorValue: 0.13689253935660506,
            yValue: 3078.636057692308,
            minDataFlag: false,
            ragStatus: 0,
            outOfTolerance: false,
            outOfToleranceValue: undefined,
            amberUpperValue: 3000,
            redUpperValue: 3500,
            amberLowerValue: 1000,
            redLowerValue: 500,
            uniqueSubjectsInBin: 4,
            colorDirectionThreshold: 1,
        },
        {
            binLabelDate: '2023-01-31T00:00:00Z',
            numeratorEvents: 136,
            denominatorValue: 0.5366187542778919,
            yValue: 2317.168390804598,
            minDataFlag: false,
            ragStatus: 0,
            outOfTolerance: false,
            outOfToleranceValue: undefined,
            amberUpperValue: 3000,
            redUpperValue: 3500,
            amberLowerValue: 1000,
            redLowerValue: 500,
            uniqueSubjectsInBin: 14,
            colorDirectionThreshold: 5,
        },
        {
            binLabelDate: '2023-02-28T00:00:00Z',
            numeratorEvents: 224,
            denominatorValue: 0.758384668035592,
            yValue: 1851.505204460967,
            minDataFlag: true,
            ragStatus: 0,
            outOfTolerance: false,
            outOfToleranceValue: undefined,
            amberUpperValue: 3000,
            redUpperValue: 3500,
            amberLowerValue: 1000,
            redLowerValue: 500,
            uniqueSubjectsInBin: 25,
            colorDirectionThreshold: 5,
        },
        {
            binLabelDate: '2023-03-31T00:00:00Z',
            numeratorEvents: 283,
            denominatorValue: 0.7720739219712526,
            yValue: 1534.7292759146344,
            minDataFlag: false,
            ragStatus: 0,
            outOfTolerance: false,
            outOfToleranceValue: undefined,
            amberUpperValue: 3000,
            redUpperValue: 3500,
            amberLowerValue: 1000,
            redLowerValue: 500,
            uniqueSubjectsInBin: 37,
            colorDirectionThreshold: 5,
        },
        {
            binLabelDate: '2023-04-30T00:00:00Z',
            numeratorEvents: 346,
            denominatorValue: 0.5776865160848734,
            yValue: 1492.370404946654,
            minDataFlag: false,
            ragStatus: 0,
            outOfTolerance: false,
            outOfToleranceValue: undefined,
            amberUpperValue: 3000,
            redUpperValue: 3500,
            amberLowerValue: 1000,
            redLowerValue: 500,
            uniqueSubjectsInBin: 49,
            colorDirectionThreshold: 5,
        },
        {
            binLabelDate: '2023-05-31T00:00:00Z',
            numeratorEvents: 428,
            denominatorValue: 0.9664613278576317,
            yValue: 1375.2031972543352,
            minDataFlag: false,
            ragStatus: 0,
            outOfTolerance: false,
            outOfToleranceValue: undefined,
            amberUpperValue: 3000,
            redUpperValue: 3500,
            amberLowerValue: 1000,
            redLowerValue: 500,
            uniqueSubjectsInBin: 64,
            colorDirectionThreshold: 5,
            isShaded: true,
        },
        {
            binLabelDate: '2023-06-30T00:00:00Z',
            numeratorEvents: 511,
            denominatorValue: 1.1854893908281998,
            yValue: 1250.6194173087508,
            minDataFlag: false,
            ragStatus: 0,
            outOfTolerance: false,
            outOfToleranceValue: undefined,
            amberUpperValue: 3000,
            redUpperValue: 3500,
            amberLowerValue: 1000,
            redLowerValue: 500,
            uniqueSubjectsInBin: 83,
            colorDirectionThreshold: 5,
            isShaded: true,
        },
        {
            binLabelDate: '2023-07-31T00:00:00Z',
            numeratorEvents: 704,
            denominatorValue: 1.702943189596167,
            yValue: 1283.5714637146373,
            minDataFlag: false,
            ragStatus: 0,
            outOfTolerance: false,
            outOfToleranceValue: undefined,
            amberUpperValue: 3000,
            redUpperValue: 3500,
            amberLowerValue: 1000,
            redLowerValue: 500,
            uniqueSubjectsInBin: 112,
            colorDirectionThreshold: 5,
            isShaded: true,
        },
        {
            binLabelDate: '2023-08-31T00:00:00Z',
            numeratorEvents: 903,
            denominatorValue: 2.3134839151266258,
            yValue: 1222.767244595006,
            minDataFlag: true,
            ragStatus: 0,
            outOfTolerance: false,
            outOfToleranceValue: undefined,
            amberUpperValue: 3000,
            redUpperValue: 3500,
            amberLowerValue: 1000,
            redLowerValue: 500,
            uniqueSubjectsInBin: 147,
            colorDirectionThreshold: 4,
            isShaded: true,
        },
        {
            binLabelDate: '2023-09-30T00:00:00Z',
            numeratorEvents: 1061,
            denominatorValue: 2.5023956194387407,
            yValue: 1123.9115754525965,
            minDataFlag: false,
            ragStatus: 0,
            outOfTolerance: false,
            outOfToleranceValue: undefined,
            amberUpperValue: 3000,
            redUpperValue: 3500,
            amberLowerValue: 1000,
            redLowerValue: 500,
            uniqueSubjectsInBin: 183,
            colorDirectionThreshold: 4,
            isShaded: true,
        },
        {
            binLabelDate: '2023-10-31T00:00:00Z',
            numeratorEvents: 1160,
            denominatorValue: 2.193018480492813,
            yValue: 1031.8915283056613,
            minDataFlag: false,
            ragStatus: 0,
            outOfTolerance: false,
            outOfToleranceValue: undefined,
            amberUpperValue: 3000,
            redUpperValue: 3500,
            amberLowerValue: 1000,
            redLowerValue: 500,
            uniqueSubjectsInBin: 215,
            colorDirectionThreshold: 5,
            isShaded: true,
        },
        {
            binLabelDate: '2023-11-30T00:00:00Z',
            numeratorEvents: 1342,
            denominatorValue: 2.4969199178644765,
            yValue: 1009.603275672475,
            minDataFlag: false,
            ragStatus: 0,
            outOfTolerance: false,
            outOfToleranceValue: undefined,
            amberUpperValue: 3000,
            redUpperValue: 3500,
            amberLowerValue: 1000,
            redLowerValue: 500,
            uniqueSubjectsInBin: 253,
            colorDirectionThreshold: 4,
            isShaded: true,
        },
        {
            binLabelDate: '2023-12-31T00:00:00Z',
            numeratorEvents: 1501,
            denominatorValue: 2.674880219028063,
            yValue: 969.0512548998256,
            minDataFlag: false,
            ragStatus: 0,
            outOfTolerance: false,
            outOfToleranceValue: undefined,
            amberUpperValue: 3000,
            redUpperValue: 3500,
            amberLowerValue: 1000,
            redLowerValue: 500,
            uniqueSubjectsInBin: 292,
            colorDirectionThreshold: 2,

            isShaded: true,
        },
        {
            binLabelDate: '2024-01-31T00:00:00Z',
            numeratorEvents: 1661,
            denominatorValue: 2.8062970568104038,
            yValue: 933.4426947744217,
            minDataFlag: true,
            ragStatus: 0,
            outOfTolerance: false,
            outOfToleranceValue: undefined,
            amberUpperValue: 3000,
            redUpperValue: 3500,
            amberLowerValue: 1000,
            redLowerValue: 500,
            uniqueSubjectsInBin: 332,
            colorDirectionThreshold: 2,

            isShaded: true,
        },
        {
            binLabelDate: '2024-02-29T00:00:00Z',
            numeratorEvents: 1774,
            denominatorValue: 2.8993839835728954,
            yValue: 879.2726106219347,
            minDataFlag: true,
            ragStatus: 0,
            outOfTolerance: false,
            outOfToleranceValue: undefined,
            amberUpperValue: 3000,
            redUpperValue: 3500,
            amberLowerValue: 1000,
            redLowerValue: 500,
            uniqueSubjectsInBin: 377,
            colorDirectionThreshold: 2,

            isShaded: true,
        },
        {
            binLabelDate: '2024-03-31T00:00:00Z',
            numeratorEvents: 1933,
            denominatorValue: 3.6440793976728267,
            yValue: 834.3098072163447,
            minDataFlag: true,
            ragStatus: 0,
            outOfTolerance: false,
            outOfToleranceValue: undefined,
            amberUpperValue: 3000,
            redUpperValue: 3500,
            amberLowerValue: 1000,
            redLowerValue: 500,
            uniqueSubjectsInBin: 426,
            colorDirectionThreshold: 2,

            isShaded: true,
        },
    ],
    countryData: {},
    totalSubjects: 182,
    totalEvents: 2506,
};

export const eventRatesDataCountry: EventRatesData = {
    studyPoints: null,
    countryData: {
        Country: {
            benchmark: 2000,
            points: [
                {
                    binLabelDate: '2018-11-30T00:00:00Z',
                    numeratorEvents: 13,
                    denominatorValue: 0.04106776180698152,
                    yValue: 3853.99625,
                    minDataFlag: true,
                    ragStatus: 0,
                    outOfTolerance: false,
                    outOfToleranceValue: undefined,
                    amberUpperValue: 3000,
                    redUpperValue: 3500,
                    amberLowerValue: 1000,
                    redLowerValue: 500,
                    uniqueSubjectsInBin: 1,
                    colorDirectionThreshold: 0,
                },
                {
                    binLabelDate: '2018-12-31T00:00:00Z',
                    numeratorEvents: 45,
                    denominatorValue: 0.13689253935660506,
                    yValue: 3078.636057692308,
                    minDataFlag: false,
                    ragStatus: 0,
                    outOfTolerance: false,
                    outOfToleranceValue: undefined,
                    amberUpperValue: 3000,
                    redUpperValue: 3500,
                    amberLowerValue: 1000,
                    redLowerValue: 500,
                    uniqueSubjectsInBin: 4,
                    colorDirectionThreshold: 1,
                },
                {
                    binLabelDate: '2019-01-31T00:00:00Z',
                    numeratorEvents: 136,
                    denominatorValue: 0.5366187542778919,
                    yValue: 2317.168390804598,
                    minDataFlag: false,
                    ragStatus: 0,
                    outOfTolerance: false,
                    outOfToleranceValue: undefined,
                    amberUpperValue: 3000,
                    redUpperValue: 3500,
                    amberLowerValue: 1000,
                    redLowerValue: 500,
                    uniqueSubjectsInBin: 14,
                    colorDirectionThreshold: 5,
                },
                {
                    binLabelDate: '2019-02-28T00:00:00Z',
                    numeratorEvents: 224,
                    denominatorValue: 0.758384668035592,
                    yValue: 1851.505204460967,
                    minDataFlag: true,
                    ragStatus: 0,
                    outOfTolerance: false,
                    outOfToleranceValue: undefined,
                    amberUpperValue: 3000,
                    redUpperValue: 3500,
                    amberLowerValue: 1000,
                    redLowerValue: 500,
                    uniqueSubjectsInBin: 25,
                    colorDirectionThreshold: 5,
                },
                {
                    binLabelDate: '2019-03-31T00:00:00Z',
                    numeratorEvents: 283,
                    denominatorValue: 0.7720739219712526,
                    yValue: 1534.7292759146344,
                    minDataFlag: false,
                    ragStatus: 0,
                    outOfTolerance: false,
                    outOfToleranceValue: undefined,
                    amberUpperValue: 3000,
                    redUpperValue: 3500,
                    amberLowerValue: 1000,
                    redLowerValue: 500,
                    uniqueSubjectsInBin: 37,
                    colorDirectionThreshold: 5,
                },
                {
                    binLabelDate: '2019-04-30T00:00:00Z',
                    numeratorEvents: 346,
                    denominatorValue: 0.5776865160848734,
                    yValue: 1492.370404946654,
                    minDataFlag: false,
                    ragStatus: 0,
                    outOfTolerance: false,
                    outOfToleranceValue: undefined,
                    amberUpperValue: 3000,
                    redUpperValue: 3500,
                    amberLowerValue: 1000,
                    redLowerValue: 500,
                    uniqueSubjectsInBin: 49,
                    colorDirectionThreshold: 5,
                },
                {
                    binLabelDate: '2019-05-31T00:00:00Z',
                    numeratorEvents: 428,
                    denominatorValue: 0.9664613278576317,
                    yValue: 1375.2031972543352,
                    minDataFlag: false,
                    ragStatus: 0,
                    outOfTolerance: false,
                    outOfToleranceValue: undefined,
                    amberUpperValue: 3000,
                    redUpperValue: 3500,
                    amberLowerValue: 1000,
                    redLowerValue: 500,
                    uniqueSubjectsInBin: 64,
                    colorDirectionThreshold: 5,
                },
                {
                    binLabelDate: '2019-06-30T00:00:00Z',
                    numeratorEvents: 511,
                    denominatorValue: 1.1854893908281998,
                    yValue: 1250.6194173087508,
                    minDataFlag: false,
                    ragStatus: 0,
                    outOfTolerance: false,
                    outOfToleranceValue: undefined,
                    amberUpperValue: 3000,
                    redUpperValue: 3500,
                    amberLowerValue: 1000,
                    redLowerValue: 500,
                    uniqueSubjectsInBin: 83,
                    colorDirectionThreshold: 5,
                },
                {
                    binLabelDate: '2019-07-31T00:00:00Z',
                    numeratorEvents: 704,
                    denominatorValue: 1.702943189596167,
                    yValue: 1283.5714637146373,
                    minDataFlag: false,
                    ragStatus: 0,
                    outOfTolerance: false,
                    outOfToleranceValue: undefined,
                    amberUpperValue: 3000,
                    redUpperValue: 3500,
                    amberLowerValue: 1000,
                    redLowerValue: 500,
                    uniqueSubjectsInBin: 112,
                    colorDirectionThreshold: 5,
                },
                {
                    binLabelDate: '2019-08-31T00:00:00Z',
                    numeratorEvents: 903,
                    denominatorValue: 2.3134839151266258,
                    yValue: 1222.767244595006,
                    minDataFlag: true,
                    ragStatus: 0,
                    outOfTolerance: false,
                    outOfToleranceValue: undefined,
                    amberUpperValue: 3000,
                    redUpperValue: 3500,
                    amberLowerValue: 1000,
                    redLowerValue: 500,
                    uniqueSubjectsInBin: 147,
                    colorDirectionThreshold: 4,
                },
                {
                    binLabelDate: '2019-09-30T00:00:00Z',
                    numeratorEvents: 1061,
                    denominatorValue: 2.5023956194387407,
                    yValue: 1123.9115754525965,
                    minDataFlag: false,
                    ragStatus: 0,
                    outOfTolerance: false,
                    outOfToleranceValue: undefined,
                    amberUpperValue: 3000,
                    redUpperValue: 3500,
                    amberLowerValue: 1000,
                    redLowerValue: 500,
                    uniqueSubjectsInBin: 183,
                    colorDirectionThreshold: 4,
                },
                {
                    binLabelDate: '2019-10-31T00:00:00Z',
                    numeratorEvents: 1160,
                    denominatorValue: 2.193018480492813,
                    yValue: 1031.8915283056613,
                    minDataFlag: false,
                    ragStatus: 0,
                    outOfTolerance: false,
                    outOfToleranceValue: undefined,
                    amberUpperValue: 3000,
                    redUpperValue: 3500,
                    amberLowerValue: 1000,
                    redLowerValue: 500,
                    uniqueSubjectsInBin: 215,
                    colorDirectionThreshold: 5,
                },
                {
                    binLabelDate: '2019-11-30T00:00:00Z',
                    numeratorEvents: 1342,
                    denominatorValue: 2.4969199178644765,
                    yValue: 1009.603275672475,
                    minDataFlag: false,
                    ragStatus: 0,
                    outOfTolerance: false,
                    outOfToleranceValue: undefined,
                    amberUpperValue: 3000,
                    redUpperValue: 3500,
                    amberLowerValue: 1000,
                    redLowerValue: 500,
                    uniqueSubjectsInBin: 253,
                    colorDirectionThreshold: 4,
                },
                {
                    binLabelDate: '2019-12-31T00:00:00Z',
                    numeratorEvents: 1501,
                    denominatorValue: 2.674880219028063,
                    yValue: 969.0512548998256,
                    minDataFlag: false,
                    ragStatus: 0,
                    outOfTolerance: false,
                    outOfToleranceValue: undefined,
                    amberUpperValue: 3000,
                    redUpperValue: 3500,
                    amberLowerValue: 1000,
                    redLowerValue: 500,
                    uniqueSubjectsInBin: 292,
                    colorDirectionThreshold: 2,
                    isShaded: true,
                },
                {
                    binLabelDate: '2020-01-31T00:00:00Z',
                    numeratorEvents: 1661,
                    denominatorValue: 2.8062970568104038,
                    yValue: 933.4426947744217,
                    minDataFlag: true,
                    ragStatus: 0,
                    outOfTolerance: false,
                    outOfToleranceValue: undefined,
                    amberUpperValue: 3000,
                    redUpperValue: 3500,
                    amberLowerValue: 1000,
                    redLowerValue: 500,
                    uniqueSubjectsInBin: 332,
                    colorDirectionThreshold: 2,
                    isShaded: true,
                },
                {
                    binLabelDate: '2020-02-29T00:00:00Z',
                    numeratorEvents: 1774,
                    denominatorValue: 2.8993839835728954,
                    yValue: 879.2726106219347,
                    minDataFlag: true,
                    ragStatus: 0,
                    outOfTolerance: false,
                    outOfToleranceValue: undefined,
                    amberUpperValue: 3000,
                    redUpperValue: 3500,
                    amberLowerValue: 1000,
                    redLowerValue: 500,
                    uniqueSubjectsInBin: 377,
                    colorDirectionThreshold: 2,
                    isShaded: true,
                },
                {
                    binLabelDate: '2020-03-31T00:00:00Z',
                    numeratorEvents: 1933,
                    denominatorValue: 3.6440793976728267,
                    yValue: 834.3098072163447,
                    minDataFlag: true,
                    ragStatus: 0,
                    outOfTolerance: false,
                    outOfToleranceValue: undefined,
                    amberUpperValue: 3000,
                    redUpperValue: 3500,
                    amberLowerValue: 1000,
                    redLowerValue: 500,
                    uniqueSubjectsInBin: 426,
                    colorDirectionThreshold: 2,
                    isShaded: true,
                },
            ],
        },
    },
    totalSubjects: 182,
    totalEvents: 2506,
};

export const proportionsOTStudyData: ProportionsOTData = {
    study: {
        points: [
            {
                binLabelDate: '2018-11-30T00:00:00Z',
                numeratorEvents: 0,
                denominatorValue: 1,
                uniqueSubjectsInBin: 1,
                yValue: 0,
                minDataFlag: true,
                ragStatus: 5,
                amberLowerValue: 0,
                amberUpperValue: 1,
                redLowerValue: 0,
                redUpperValue: 1,
                noNewData: false,
                isShaded: false,
                colorDirectionThreshold: 4,
                outOfTolerance: false,
                outOfToleranceValue: null,
                outOfToleranceDescription: 1,
            },
            {
                binLabelDate: '2018-12-31T00:00:00Z',
                numeratorEvents: 0,
                denominatorValue: 3,
                uniqueSubjectsInBin: 3,
                yValue: 0,
                minDataFlag: true,
                ragStatus: 1,
                amberLowerValue: 0,
                amberUpperValue: 1,
                redLowerValue: 0,
                redUpperValue: 1,
                noNewData: false,
                isShaded: false,
                colorDirectionThreshold: 4,
                outOfTolerance: false,
                outOfToleranceValue: null,
                outOfToleranceDescription: 1,
            },
            {
                binLabelDate: '2019-01-31T00:00:00Z',
                numeratorEvents: 3,
                denominatorValue: 10,
                uniqueSubjectsInBin: 10,
                yValue: 0.3,
                minDataFlag: false,
                ragStatus: 3,
                amberLowerValue: 0.15956473235954632,
                amberUpperValue: 0.7912549397716011,
                redLowerValue: 0.0016421805065326422,
                redUpperValue: 0.9491774916246148,
                noNewData: false,
                isShaded: false,
                colorDirectionThreshold: 5,
                outOfTolerance: false,
                outOfToleranceValue: null,
                outOfToleranceDescription: 0,
            },
            {
                binLabelDate: '2019-02-28T00:00:00Z',
                numeratorEvents: 4,
                denominatorValue: 11,
                uniqueSubjectsInBin: 11,
                yValue: 0.36363636363636365,
                minDataFlag: false,
                ragStatus: 3,
                amberLowerValue: 0.17426334568548218,
                amberUpperValue: 0.7765563264456653,
                redLowerValue: 0.023690100495436406,
                redUpperValue: 0.9271295716357111,
                noNewData: false,
                isShaded: false,
                colorDirectionThreshold: 5,
                outOfTolerance: false,
                outOfToleranceValue: null,
                outOfToleranceDescription: 0,
            },
            {
                binLabelDate: '2019-03-31T00:00:00Z',
                numeratorEvents: 6,
                denominatorValue: 14,
                uniqueSubjectsInBin: 14,
                yValue: 0.42857142857142855,
                minDataFlag: false,
                ragStatus: 3,
                amberLowerValue: 0.20847200283325512,
                amberUpperValue: 0.7423476692978923,
                redLowerValue: 0.07500308621709584,
                redUpperValue: 0.8758165859140516,
                noNewData: false,
                isShaded: false,
                colorDirectionThreshold: 5,
                outOfTolerance: false,
                outOfToleranceValue: null,
                outOfToleranceDescription: 0,
            },
            {
                binLabelDate: '2019-04-30T00:00:00Z',
                numeratorEvents: 8,
                denominatorValue: 18,
                uniqueSubjectsInBin: 18,
                yValue: 0.42857142857142855,
                minDataFlag: false,
                ragStatus: 3,
                amberLowerValue: 0.2399927953165244,
                amberUpperValue: 0.7108268768146231,
                redLowerValue: 0.12228427494199973,
                redUpperValue: 0.8285353971891478,
                noNewData: true,
                isShaded: false,
                colorDirectionThreshold: 5,
                outOfTolerance: false,
                outOfToleranceValue: null,
                outOfToleranceDescription: 0,
            },
            {
                binLabelDate: '2019-05-31T00:00:00Z',
                numeratorEvents: 12,
                denominatorValue: 24,
                uniqueSubjectsInBin: 24,
                yValue: 0.5,
                minDataFlag: false,
                ragStatus: 3,
                amberLowerValue: 0.27153269829314064,
                amberUpperValue: 0.6792869738380068,
                redLowerValue: 0.1695941294069241,
                redUpperValue: 0.7812255427242234,
                noNewData: false,
                isShaded: false,
                colorDirectionThreshold: 5,
                outOfTolerance: false,
                outOfToleranceValue: null,
                outOfToleranceDescription: 0,
            },
            {
                binLabelDate: '2019-06-30T00:00:00Z',
                numeratorEvents: 17,
                denominatorValue: 29,
                uniqueSubjectsInBin: 29,
                yValue: 0.5862068965517241,
                minDataFlag: false,
                ragStatus: 3,
                amberLowerValue: 0.28993920493467606,
                amberUpperValue: 0.6608804671964714,
                redLowerValue: 0.19720388936922717,
                redUpperValue: 0.7536157827619203,
                noNewData: false,
                isShaded: false,
                colorDirectionThreshold: 5,
                outOfTolerance: false,
                outOfToleranceValue: null,
                outOfToleranceDescription: 0,
            },
            {
                binLabelDate: '2019-07-31T00:00:00Z',
                numeratorEvents: 27,
                denominatorValue: 42,
                uniqueSubjectsInBin: 42,
                yValue: 0.6428571428571429,
                minDataFlag: false,
                ragStatus: 5,
                amberLowerValue: 0.32129320619199914,
                amberUpperValue: 0.6295264659391484,
                redLowerValue: 0.24423489125521183,
                redUpperValue: 0.7065847808759357,
                noNewData: false,
                isShaded: false,
                colorDirectionThreshold: 1,
                outOfTolerance: true,
                outOfToleranceValue: 0.124,
                outOfToleranceDescription: 4,
            },
            {
                binLabelDate: '2019-08-31T00:00:00Z',
                numeratorEvents: 32,
                denominatorValue: 52,
                uniqueSubjectsInBin: 52,
                yValue: 0.6153846153846154,
                minDataFlag: false,
                ragStatus: 5,
                amberLowerValue: 0.3369025955334579,
                amberUpperValue: 0.6139170765976896,
                redLowerValue: 0.2676489752674,
                redUpperValue: 0.6831706968637474,
                noNewData: false,
                isShaded: false,
                colorDirectionThreshold: 1,
                outOfTolerance: true,
                outOfToleranceValue: 0.123,
                outOfToleranceDescription: 3,
            },
            {
                binLabelDate: '2019-09-30T00:00:00Z',
                numeratorEvents: 34,
                denominatorValue: 57,
                uniqueSubjectsInBin: 57,
                yValue: 0.6153846153846154,
                minDataFlag: false,
                ragStatus: 3,
                amberLowerValue: 0.34311687996350826,
                amberUpperValue: 0.6077027921676392,
                redLowerValue: 0.2769704019124756,
                redUpperValue: 0.6738492702186719,
                noNewData: true,
                isShaded: false,
                colorDirectionThreshold: 5,
                outOfTolerance: false,
                outOfToleranceValue: null,
                outOfToleranceDescription: 0,
            },
            {
                binLabelDate: '2019-10-31T00:00:00Z',
                numeratorEvents: 37,
                denominatorValue: 2,
                uniqueSubjectsInBin: 61,
                yValue: 0.6065573770491803,
                minDataFlag: true,
                ragStatus: 2,
                amberLowerValue: 0.34752789157355074,
                amberUpperValue: 0.6032917805575968,
                redLowerValue: 0.2835869193275392,
                redUpperValue: 0.6672327528036083,
                noNewData: false,
                isShaded: false,
                colorDirectionThreshold: 1,
                outOfTolerance: true,
                outOfToleranceValue: 0.123,
                outOfToleranceDescription: 3,
            },
            {
                binLabelDate: '2019-11-30T00:00:00Z',
                numeratorEvents: 45,
                denominatorValue: 72,
                uniqueSubjectsInBin: 72,
                yValue: 0.625,
                minDataFlag: false,
                ragStatus: 2,
                amberLowerValue: 0.35770131569104907,
                amberUpperValue: 0.5931183564400984,
                redLowerValue: 0.29884705550378676,
                redUpperValue: 0.6519726166273607,
                noNewData: false,
                isShaded: false,
                colorDirectionThreshold: 1,
                outOfTolerance: false,
                outOfToleranceValue: null,
                outOfToleranceDescription: 3,
            },
            {
                binLabelDate: '2019-12-31T00:00:00Z',
                numeratorEvents: 52,
                denominatorValue: 80,
                uniqueSubjectsInBin: 80,
                yValue: 0.65,
                minDataFlag: false,
                ragStatus: 1,
                amberLowerValue: 0.3637417287480236,
                amberUpperValue: 0.5870779433831239,
                redLowerValue: 0.3079076750892485,
                redUpperValue: 0.642911997041899,
                noNewData: false,
                isShaded: false,
                colorDirectionThreshold: 0,
                outOfTolerance: false,
                outOfToleranceValue: null,
                outOfToleranceDescription: 1,
            },
            {
                binLabelDate: '2020-01-31T00:00:00Z',
                numeratorEvents: 56,
                denominatorValue: 88,
                uniqueSubjectsInBin: 88,
                yValue: 0.6363636363636364,
                minDataFlag: false,
                ragStatus: 1,
                amberLowerValue: 0.3689384733264277,
                amberUpperValue: 0.5818811988047198,
                redLowerValue: 0.31570279195685463,
                redUpperValue: 0.6351168801742928,
                noNewData: false,
                isShaded: false,
                colorDirectionThreshold: 0,
                outOfTolerance: false,
                outOfToleranceValue: null,
                outOfToleranceDescription: 1,
            },
            {
                binLabelDate: '2020-02-29T00:00:00Z',
                numeratorEvents: 66,
                denominatorValue: 100,
                uniqueSubjectsInBin: 100,
                yValue: 0.66,
                minDataFlag: false,
                ragStatus: 1,
                amberLowerValue: 0.3755308445132602,
                amberUpperValue: 0.5752888276178872,
                redLowerValue: 0.32559134873710344,
                redUpperValue: 0.6252283233940441,
                noNewData: false,
                isShaded: true,
                colorDirectionThreshold: 0,
                outOfTolerance: false,
                outOfToleranceValue: null,
                outOfToleranceDescription: 1,
            },
            {
                binLabelDate: '2020-03-31T00:00:00Z',
                numeratorEvents: 72,
                denominatorValue: 110,
                uniqueSubjectsInBin: 110,
                yValue: 0.66,
                minDataFlag: false,
                ragStatus: 1,
                amberLowerValue: 0.3801789541688662,
                amberUpperValue: 0.5706407179622812,
                redLowerValue: 0.3325635132205125,
                redUpperValue: 0.618256158910635,
                noNewData: true,
                isShaded: true,
                colorDirectionThreshold: 0,
                outOfTolerance: false,
                outOfToleranceValue: null,
                outOfToleranceDescription: 1,
            },
            {
                binLabelDate: '2020-04-30T00:00:00Z',
                numeratorEvents: 73,
                denominatorValue: 112,
                uniqueSubjectsInBin: 112,
                yValue: 0.6517857142857143,
                minDataFlag: false,
                ragStatus: 1,
                amberLowerValue: 0.3810330600486656,
                amberUpperValue: 0.5697866120824818,
                redLowerValue: 0.33384467204021157,
                redUpperValue: 0.616975000090936,
                noNewData: false,
                isShaded: true,
                colorDirectionThreshold: 0,
                outOfTolerance: false,
                outOfToleranceValue: null,
                outOfToleranceDescription: 1,
            },
            {
                binLabelDate: '2020-05-31T00:00:00Z',
                numeratorEvents: 76,
                denominatorValue: 123,
                uniqueSubjectsInBin: 123,
                yValue: 0.6178861788617886,
                minDataFlag: false,
                ragStatus: 1,
                amberLowerValue: 0.38535198224164763,
                amberUpperValue: 0.5654676898894999,
                redLowerValue: 0.34032305532968454,
                redUpperValue: 0.6104966168014629,
                noNewData: false,
                isShaded: true,
                colorDirectionThreshold: 0,
                outOfTolerance: false,
                outOfToleranceValue: null,
                outOfToleranceDescription: 1,
            },
            {
                binLabelDate: '2020-06-30T00:00:00Z',
                numeratorEvents: 84,
                denominatorValue: 143,
                uniqueSubjectsInBin: 143,
                yValue: 0.5874125874125874,
                minDataFlag: false,
                ragStatus: 2,
                amberLowerValue: 0.39188682741238584,
                amberUpperValue: 0.5589328447187617,
                redLowerValue: 0.35012532308579186,
                redUpperValue: 0.6006943490453556,
                noNewData: false,
                isShaded: true,
                colorDirectionThreshold: 1,
                outOfTolerance: false,
                outOfToleranceValue: null,
                outOfToleranceDescription: 3,
            },
        ],
        benchmarkValue: 0.47540983606557374,
    },
    countries: {
        Australia: {
            points: [
                {
                    binLabelDate: '2019-02-28T00:00:00Z',
                    numeratorEvents: 1,
                    denominatorValue: 1,
                    uniqueSubjectsInBin: 1,
                    yValue: 1,
                    ragStatus: 1,
                    amberLowerValue: 0,
                    amberUpperValue: 1,
                    redLowerValue: 0,
                    redUpperValue: 1,
                    noNewData: false,
                    isShaded: false,
                    thresholdType: 1,
                    cumulativeOrTimePeriod: 1,
                    colorDirectionThreshold: 0,
                    country: 'Australia',
                    outOfTolerance: false,
                    outOfToleranceValue: null,
                    outOfToleranceDescription: 1,
                },
                {
                    binLabelDate: '2019-03-31T00:00:00Z',
                    numeratorEvents: 1,
                    denominatorValue: 1,
                    uniqueSubjectsInBin: 1,
                    yValue: 1,
                    ragStatus: 1,
                    amberLowerValue: 0,
                    amberUpperValue: 1,
                    redLowerValue: 0,
                    redUpperValue: 1,
                    noNewData: true,
                    isShaded: false,
                    thresholdType: 1,
                    cumulativeOrTimePeriod: 1,
                    colorDirectionThreshold: 0,
                    country: 'Australia',
                    outOfTolerance: false,
                    outOfToleranceValue: null,
                    outOfToleranceDescription: 1,
                },
                {
                    binLabelDate: '2019-04-30T00:00:00Z',
                    numeratorEvents: 1,
                    denominatorValue: 1,
                    uniqueSubjectsInBin: 1,
                    yValue: 1,
                    ragStatus: 1,
                    amberLowerValue: 0,
                    amberUpperValue: 1,
                    redLowerValue: 0,
                    redUpperValue: 1,
                    noNewData: true,
                    isShaded: false,
                    thresholdType: 1,
                    cumulativeOrTimePeriod: 1,
                    colorDirectionThreshold: 0,
                    country: 'Australia',
                    outOfTolerance: false,
                    outOfToleranceValue: null,
                    outOfToleranceDescription: 1,
                },
                {
                    binLabelDate: '2019-05-31T00:00:00Z',
                    numeratorEvents: 2,
                    denominatorValue: 3,
                    uniqueSubjectsInBin: 3,
                    yValue: 0.6666666666666666,
                    ragStatus: 3,
                    amberLowerValue: 0.023182000145600234,
                    amberUpperValue: 1,
                    redLowerValue: 0,
                    redUpperValue: 1,
                    noNewData: false,
                    isShaded: false,
                    thresholdType: 1,
                    cumulativeOrTimePeriod: 1,
                    colorDirectionThreshold: 5,
                    country: 'Australia',
                    outOfTolerance: false,
                    outOfToleranceValue: null,
                    outOfToleranceDescription: 0,
                },
                {
                    binLabelDate: '2019-06-30T00:00:00Z',
                    numeratorEvents: 4,
                    denominatorValue: 5,
                    uniqueSubjectsInBin: 5,
                    yValue: 0.8,
                    ragStatus: 3,
                    amberLowerValue: 0.1511495773655337,
                    amberUpperValue: 1,
                    redLowerValue: 0,
                    redUpperValue: 1,
                    noNewData: false,
                    isShaded: false,
                    thresholdType: 1,
                    cumulativeOrTimePeriod: 1,
                    colorDirectionThreshold: 5,
                    country: 'Australia',
                    outOfTolerance: false,
                    outOfToleranceValue: null,
                    outOfToleranceDescription: 0,
                },
            ],
            benchmarkValue: 0.5909090909090909,
        },
        Canada: {
            points: [
                {
                    binLabelDate: '2019-08-31T00:00:00Z',
                    numeratorEvents: 1,
                    denominatorValue: 1,
                    uniqueSubjectsInBin: 1,
                    yValue: 1,
                    ragStatus: 1,
                    amberLowerValue: 0,
                    amberUpperValue: 1,
                    redLowerValue: 0,
                    redUpperValue: 1,
                    noNewData: false,
                    isShaded: false,
                    thresholdType: 1,
                    cumulativeOrTimePeriod: 1,
                    colorDirectionThreshold: 0,
                    country: 'Canada',
                    outOfTolerance: false,
                    outOfToleranceValue: null,
                    outOfToleranceDescription: 1,
                },
                {
                    binLabelDate: '2019-09-30T00:00:00Z',
                    numeratorEvents: 1,
                    denominatorValue: 1,
                    uniqueSubjectsInBin: 1,
                    yValue: 1,
                    ragStatus: 1,
                    amberLowerValue: 0,
                    amberUpperValue: 1,
                    redLowerValue: 0,
                    redUpperValue: 1,
                    noNewData: true,
                    isShaded: false,
                    thresholdType: 1,
                    cumulativeOrTimePeriod: 1,
                    colorDirectionThreshold: 0,
                    country: 'Canada',
                    outOfTolerance: false,
                    outOfToleranceValue: null,
                    outOfToleranceDescription: 1,
                },
                {
                    binLabelDate: '2019-10-31T00:00:00Z',
                    numeratorEvents: 2,
                    denominatorValue: 2,
                    uniqueSubjectsInBin: 2,
                    yValue: 1,
                    ragStatus: 1,
                    amberLowerValue: 0,
                    amberUpperValue: 1,
                    redLowerValue: 0,
                    redUpperValue: 1,
                    noNewData: false,
                    isShaded: false,
                    thresholdType: 1,
                    cumulativeOrTimePeriod: 1,
                    colorDirectionThreshold: 0,
                    country: 'Canada',
                    outOfTolerance: false,
                    outOfToleranceValue: null,
                    outOfToleranceDescription: 1,
                },
                {
                    binLabelDate: '2019-11-30T00:00:00Z',
                    numeratorEvents: 2,
                    denominatorValue: 2,
                    uniqueSubjectsInBin: 2,
                    yValue: 1,
                    ragStatus: 1,
                    amberLowerValue: 0,
                    amberUpperValue: 1,
                    redLowerValue: 0,
                    redUpperValue: 1,
                    noNewData: true,
                    isShaded: false,
                    thresholdType: 1,
                    cumulativeOrTimePeriod: 1,
                    colorDirectionThreshold: 0,
                    country: 'Canada',
                    outOfTolerance: false,
                    outOfToleranceValue: null,
                    outOfToleranceDescription: 1,
                },
                {
                    binLabelDate: '2019-12-31T00:00:00Z',
                    numeratorEvents: 2,
                    denominatorValue: 2,
                    uniqueSubjectsInBin: 2,
                    yValue: 1,
                    ragStatus: 1,
                    amberLowerValue: 0,
                    amberUpperValue: 1,
                    redLowerValue: 0,
                    redUpperValue: 1,
                    noNewData: true,
                    isShaded: false,
                    thresholdType: 1,
                    cumulativeOrTimePeriod: 1,
                    colorDirectionThreshold: 0,
                    country: 'Canada',
                    outOfTolerance: false,
                    outOfToleranceValue: null,
                    outOfToleranceDescription: 1,
                },
            ],
            benchmarkValue: 0.4,
        },
        Ireland: {
            points: [
                {
                    binLabelDate: '2019-07-31T00:00:00Z',
                    numeratorEvents: 0,
                    denominatorValue: 1,
                    uniqueSubjectsInBin: 1,
                    yValue: 0,
                    ragStatus: 1,
                    amberLowerValue: 0,
                    amberUpperValue: 1,
                    redLowerValue: 0,
                    redUpperValue: 1,
                    noNewData: false,
                    isShaded: false,
                    thresholdType: 1,
                    cumulativeOrTimePeriod: 1,
                    colorDirectionThreshold: 0,
                    country: 'Ireland',
                    outOfTolerance: false,
                    outOfToleranceValue: null,
                    outOfToleranceDescription: 1,
                },
                {
                    binLabelDate: '2019-08-31T00:00:00Z',
                    numeratorEvents: 2,
                    denominatorValue: 3,
                    uniqueSubjectsInBin: 3,
                    yValue: 0.6666666666666666,
                    ragStatus: 3,
                    amberLowerValue: 0.12233561271484927,
                    amberUpperValue: 1,
                    redLowerValue: 0,
                    redUpperValue: 1,
                    noNewData: false,
                    isShaded: false,
                    thresholdType: 1,
                    cumulativeOrTimePeriod: 1,
                    colorDirectionThreshold: 5,
                    country: 'Ireland',
                    outOfTolerance: false,
                    outOfToleranceValue: null,
                    outOfToleranceDescription: 0,
                },
                {
                    binLabelDate: '2019-09-30T00:00:00Z',
                    numeratorEvents: 2,
                    denominatorValue: 3,
                    uniqueSubjectsInBin: 3,
                    yValue: 0.6666666666666666,
                    ragStatus: 3,
                    amberLowerValue: 0.12233561271484927,
                    amberUpperValue: 1,
                    redLowerValue: 0,
                    redUpperValue: 1,
                    noNewData: true,
                    isShaded: false,
                    thresholdType: 1,
                    cumulativeOrTimePeriod: 1,
                    colorDirectionThreshold: 5,
                    country: 'Ireland',
                    outOfTolerance: false,
                    outOfToleranceValue: null,
                    outOfToleranceDescription: 0,
                },
                {
                    binLabelDate: '2019-10-31T00:00:00Z',
                    numeratorEvents: 2,
                    denominatorValue: 3,
                    uniqueSubjectsInBin: 3,
                    yValue: 0.6666666666666666,
                    ragStatus: 3,
                    amberLowerValue: 0.12233561271484927,
                    amberUpperValue: 1,
                    redLowerValue: 0,
                    redUpperValue: 1,
                    noNewData: true,
                    isShaded: false,
                    thresholdType: 1,
                    cumulativeOrTimePeriod: 1,
                    colorDirectionThreshold: 5,
                    country: 'Ireland',
                    outOfTolerance: false,
                    outOfToleranceValue: null,
                    outOfToleranceDescription: 0,
                },
                {
                    binLabelDate: '2019-11-30T00:00:00Z',
                    numeratorEvents: 2,
                    denominatorValue: 3,
                    uniqueSubjectsInBin: 3,
                    yValue: 0.6666666666666666,
                    ragStatus: 3,
                    amberLowerValue: 0.12233561271484927,
                    amberUpperValue: 1,
                    redLowerValue: 0,
                    redUpperValue: 1,
                    noNewData: true,
                    isShaded: false,
                    thresholdType: 1,
                    cumulativeOrTimePeriod: 1,
                    colorDirectionThreshold: 5,
                    country: 'Ireland',
                    outOfTolerance: false,
                    outOfToleranceValue: null,
                    outOfToleranceDescription: 0,
                },
            ],
            benchmarkValue: 0.6666666666666666,
        },
        Italy: {
            points: [
                {
                    binLabelDate: '2020-05-31T00:00:00Z',
                    numeratorEvents: 0,
                    denominatorValue: 2,
                    uniqueSubjectsInBin: 2,
                    yValue: 0,
                    ragStatus: 1,
                    amberLowerValue: 0,
                    amberUpperValue: 0,
                    redLowerValue: 0,
                    redUpperValue: 0,
                    noNewData: false,
                    isShaded: false,
                    thresholdType: 1,
                    cumulativeOrTimePeriod: 1,
                    colorDirectionThreshold: 0,
                    country: 'Italy',
                    outOfTolerance: false,
                    outOfToleranceValue: null,
                    outOfToleranceDescription: 1,
                },
                {
                    binLabelDate: '2020-06-30T00:00:00Z',
                    numeratorEvents: 0,
                    denominatorValue: 3,
                    uniqueSubjectsInBin: 3,
                    yValue: 0,
                    ragStatus: 1,
                    amberLowerValue: 0,
                    amberUpperValue: 0,
                    redLowerValue: 0,
                    redUpperValue: 0,
                    noNewData: false,
                    isShaded: false,
                    thresholdType: 1,
                    cumulativeOrTimePeriod: 1,
                    colorDirectionThreshold: 0,
                    country: 'Italy',
                    outOfTolerance: false,
                    outOfToleranceValue: null,
                    outOfToleranceDescription: 1,
                },
                {
                    binLabelDate: '2020-07-31T00:00:00Z',
                    numeratorEvents: 0,
                    denominatorValue: 3,
                    uniqueSubjectsInBin: 3,
                    yValue: 0,
                    ragStatus: 1,
                    amberLowerValue: 0,
                    amberUpperValue: 0,
                    redLowerValue: 0,
                    redUpperValue: 0,
                    noNewData: true,
                    isShaded: false,
                    thresholdType: 1,
                    cumulativeOrTimePeriod: 1,
                    colorDirectionThreshold: 0,
                    country: 'Italy',
                    outOfTolerance: false,
                    outOfToleranceValue: null,
                    outOfToleranceDescription: 1,
                },
                {
                    binLabelDate: '2020-08-31T00:00:00Z',
                    numeratorEvents: 0,
                    denominatorValue: 3,
                    uniqueSubjectsInBin: 3,
                    yValue: 0,
                    ragStatus: 1,
                    amberLowerValue: 0,
                    amberUpperValue: 0,
                    redLowerValue: 0,
                    redUpperValue: 0,
                    noNewData: true,
                    isShaded: false,
                    thresholdType: 1,
                    cumulativeOrTimePeriod: 1,
                    colorDirectionThreshold: 0,
                    country: 'Italy',
                    outOfTolerance: false,
                    outOfToleranceValue: null,
                    outOfToleranceDescription: 1,
                },
                {
                    binLabelDate: '2020-09-30T00:00:00Z',
                    numeratorEvents: 0,
                    denominatorValue: 3,
                    uniqueSubjectsInBin: 3,
                    yValue: 0,
                    ragStatus: 1,
                    amberLowerValue: 0,
                    amberUpperValue: 0,
                    redLowerValue: 0,
                    redUpperValue: 0,
                    noNewData: true,
                    isShaded: false,
                    thresholdType: 1,
                    cumulativeOrTimePeriod: 1,
                    colorDirectionThreshold: 0,
                    country: 'Italy',
                    outOfTolerance: false,
                    outOfToleranceValue: null,
                    outOfToleranceDescription: 1,
                },
            ],
            benchmarkValue: 0,
        },
        Netherlands: {
            points: [
                {
                    binLabelDate: '2019-08-31T00:00:00Z',
                    numeratorEvents: 1,
                    denominatorValue: 1,
                    uniqueSubjectsInBin: 1,
                    yValue: 1,
                    ragStatus: 1,
                    amberLowerValue: 0,
                    amberUpperValue: 1,
                    redLowerValue: 0,
                    redUpperValue: 1,
                    noNewData: false,
                    isShaded: false,
                    thresholdType: 1,
                    cumulativeOrTimePeriod: 1,
                    colorDirectionThreshold: 0,
                    country: 'Netherlands',
                    outOfTolerance: false,
                    outOfToleranceValue: null,
                    outOfToleranceDescription: 1,
                },
                {
                    binLabelDate: '2019-09-30T00:00:00Z',
                    numeratorEvents: 1,
                    denominatorValue: 1,
                    uniqueSubjectsInBin: 1,
                    yValue: 1,
                    ragStatus: 1,
                    amberLowerValue: 0,
                    amberUpperValue: 1,
                    redLowerValue: 0,
                    redUpperValue: 1,
                    noNewData: true,
                    isShaded: false,
                    thresholdType: 1,
                    cumulativeOrTimePeriod: 1,
                    colorDirectionThreshold: 0,
                    country: 'Netherlands',
                    outOfTolerance: false,
                    outOfToleranceValue: null,
                    outOfToleranceDescription: 1,
                },
                {
                    binLabelDate: '2019-10-31T00:00:00Z',
                    numeratorEvents: 1,
                    denominatorValue: 1,
                    uniqueSubjectsInBin: 1,
                    yValue: 1,
                    ragStatus: 1,
                    amberLowerValue: 0,
                    amberUpperValue: 1,
                    redLowerValue: 0,
                    redUpperValue: 1,
                    noNewData: true,
                    isShaded: false,
                    thresholdType: 1,
                    cumulativeOrTimePeriod: 1,
                    colorDirectionThreshold: 0,
                    country: 'Netherlands',
                    outOfTolerance: false,
                    outOfToleranceValue: null,
                    outOfToleranceDescription: 1,
                },
                {
                    binLabelDate: '2019-11-30T00:00:00Z',
                    numeratorEvents: 2,
                    denominatorValue: 2,
                    uniqueSubjectsInBin: 2,
                    yValue: 1,
                    ragStatus: 1,
                    amberLowerValue: 0,
                    amberUpperValue: 1,
                    redLowerValue: 0,
                    redUpperValue: 1,
                    noNewData: false,
                    isShaded: false,
                    thresholdType: 1,
                    cumulativeOrTimePeriod: 1,
                    colorDirectionThreshold: 0,
                    country: 'Netherlands',
                    outOfTolerance: false,
                    outOfToleranceValue: null,
                    outOfToleranceDescription: 1,
                },
                {
                    binLabelDate: '2019-12-31T00:00:00Z',
                    numeratorEvents: 2,
                    denominatorValue: 2,
                    uniqueSubjectsInBin: 2,
                    yValue: 1,
                    ragStatus: 1,
                    amberLowerValue: 0,
                    amberUpperValue: 1,
                    redLowerValue: 0,
                    redUpperValue: 1,
                    noNewData: true,
                    isShaded: false,
                    thresholdType: 1,
                    cumulativeOrTimePeriod: 1,
                    colorDirectionThreshold: 0,
                    country: 'Netherlands',
                    outOfTolerance: false,
                    outOfToleranceValue: null,
                    outOfToleranceDescription: 1,
                },
            ],
            benchmarkValue: 0.6666666666666666,
        },
        Spain: {
            points: [
                {
                    binLabelDate: '2019-11-30T00:00:00Z',
                    numeratorEvents: 2,
                    denominatorValue: 3,
                    uniqueSubjectsInBin: 3,
                    yValue: 0.6666666666666666,
                    ragStatus: 3,
                    amberLowerValue: 0,
                    amberUpperValue: 1,
                    redLowerValue: 0,
                    redUpperValue: 1,
                    noNewData: false,
                    isShaded: false,
                    thresholdType: 1,
                    cumulativeOrTimePeriod: 1,
                    colorDirectionThreshold: 5,
                    country: 'Spain',
                    outOfTolerance: false,
                    outOfToleranceValue: null,
                    outOfToleranceDescription: 0,
                },
                {
                    binLabelDate: '2019-12-31T00:00:00Z',
                    numeratorEvents: 2,
                    denominatorValue: 3,
                    uniqueSubjectsInBin: 3,
                    yValue: 0.6666666666666666,
                    ragStatus: 3,
                    amberLowerValue: 0,
                    amberUpperValue: 1,
                    redLowerValue: 0,
                    redUpperValue: 1,
                    noNewData: true,
                    isShaded: false,
                    thresholdType: 1,
                    cumulativeOrTimePeriod: 1,
                    colorDirectionThreshold: 5,
                    country: 'Spain',
                    outOfTolerance: false,
                    outOfToleranceValue: null,
                    outOfToleranceDescription: 0,
                },
                {
                    binLabelDate: '2020-01-31T00:00:00Z',
                    numeratorEvents: 2,
                    denominatorValue: 3,
                    uniqueSubjectsInBin: 3,
                    yValue: 0.6666666666666666,
                    ragStatus: 3,
                    amberLowerValue: 0,
                    amberUpperValue: 1,
                    redLowerValue: 0,
                    redUpperValue: 1,
                    noNewData: true,
                    isShaded: false,
                    thresholdType: 1,
                    cumulativeOrTimePeriod: 1,
                    colorDirectionThreshold: 5,
                    country: 'Spain',
                    outOfTolerance: false,
                    outOfToleranceValue: null,
                    outOfToleranceDescription: 0,
                },
                {
                    binLabelDate: '2020-02-29T00:00:00Z',
                    numeratorEvents: 4,
                    denominatorValue: 5,
                    uniqueSubjectsInBin: 5,
                    yValue: 0.8,
                    ragStatus: 3,
                    amberLowerValue: 0.07972203293481206,
                    amberUpperValue: 0.9729095460125563,
                    redLowerValue: 0,
                    redUpperValue: 1,
                    noNewData: false,
                    isShaded: false,
                    thresholdType: 1,
                    cumulativeOrTimePeriod: 1,
                    colorDirectionThreshold: 5,
                    country: 'Spain',
                    outOfTolerance: false,
                    outOfToleranceValue: null,
                    outOfToleranceDescription: 0,
                },
                {
                    binLabelDate: '2020-03-31T00:00:00Z',
                    numeratorEvents: 4,
                    denominatorValue: 5,
                    uniqueSubjectsInBin: 5,
                    yValue: 0.8,
                    ragStatus: 3,
                    amberLowerValue: 0.07972203293481206,
                    amberUpperValue: 0.9729095460125563,
                    redLowerValue: 0,
                    redUpperValue: 1,
                    noNewData: true,
                    isShaded: false,
                    thresholdType: 1,
                    cumulativeOrTimePeriod: 1,
                    colorDirectionThreshold: 5,
                    country: 'Spain',
                    outOfTolerance: false,
                    outOfToleranceValue: null,
                    outOfToleranceDescription: 0,
                },
            ],
            benchmarkValue: 0.5263157894736842,
        },
        'United States': {
            points: [
                {
                    binLabelDate: '2018-11-30T00:00:00Z',
                    numeratorEvents: 0,
                    denominatorValue: 1,
                    uniqueSubjectsInBin: 1,
                    yValue: 0,
                    ragStatus: 1,
                    amberLowerValue: 0,
                    amberUpperValue: 1,
                    redLowerValue: 0,
                    redUpperValue: 1,
                    noNewData: false,
                    isShaded: false,
                    thresholdType: 1,
                    cumulativeOrTimePeriod: 1,
                    colorDirectionThreshold: 0,
                    country: 'United States',
                    outOfTolerance: false,
                    outOfToleranceValue: null,
                    outOfToleranceDescription: 1,
                },
                {
                    binLabelDate: '2018-12-31T00:00:00Z',
                    numeratorEvents: 0,
                    denominatorValue: 3,
                    uniqueSubjectsInBin: 3,
                    yValue: 0,
                    ragStatus: 1,
                    amberLowerValue: 0,
                    amberUpperValue: 1,
                    redLowerValue: 0,
                    redUpperValue: 1,
                    noNewData: false,
                    isShaded: false,
                    thresholdType: 1,
                    cumulativeOrTimePeriod: 1,
                    colorDirectionThreshold: 0,
                    country: 'United States',
                    outOfTolerance: false,
                    outOfToleranceValue: null,
                    outOfToleranceDescription: 1,
                },
                {
                    binLabelDate: '2019-01-31T00:00:00Z',
                    numeratorEvents: 3,
                    denominatorValue: 10,
                    uniqueSubjectsInBin: 10,
                    yValue: 0.3,
                    ragStatus: 3,
                    amberLowerValue: 0.14032390210593165,
                    amberUpperValue: 0.7702452035851253,
                    redLowerValue: 0,
                    redUpperValue: 0.9277255289549236,
                    noNewData: false,
                    isShaded: false,
                    thresholdType: 1,
                    cumulativeOrTimePeriod: 1,
                    colorDirectionThreshold: 5,
                    country: 'United States',
                    outOfTolerance: false,
                    outOfToleranceValue: null,
                    outOfToleranceDescription: 0,
                },
                {
                    binLabelDate: '2019-02-28T00:00:00Z',
                    numeratorEvents: 3,
                    denominatorValue: 10,
                    uniqueSubjectsInBin: 10,
                    yValue: 0.3,
                    ragStatus: 3,
                    amberLowerValue: 0.14032390210593165,
                    amberUpperValue: 0.7702452035851253,
                    redLowerValue: 0,
                    redUpperValue: 0.9277255289549236,
                    noNewData: true,
                    isShaded: false,
                    thresholdType: 1,
                    cumulativeOrTimePeriod: 1,
                    colorDirectionThreshold: 5,
                    country: 'United States',
                    outOfTolerance: false,
                    outOfToleranceValue: null,
                    outOfToleranceDescription: 0,
                },
                {
                    binLabelDate: '2019-03-31T00:00:00Z',
                    numeratorEvents: 5,
                    denominatorValue: 13,
                    uniqueSubjectsInBin: 13,
                    yValue: 0.38461538461538464,
                    ragStatus: 3,
                    amberLowerValue: 0.17904578834820473,
                    amberUpperValue: 0.7315233173428521,
                    redLowerValue: 0.040926406099542845,
                    redUpperValue: 0.8696426995915141,
                    noNewData: false,
                    isShaded: false,
                    thresholdType: 1,
                    cumulativeOrTimePeriod: 1,
                    colorDirectionThreshold: 5,
                    country: 'United States',
                    outOfTolerance: false,
                    outOfToleranceValue: null,
                    outOfToleranceDescription: 0,
                },
            ],
            benchmarkValue: 0.45528455284552843,
        },
    },
};
